/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Vigilant API
 * API documentation for Vigilant platform
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  Agent,
  AgentActiveContent,
  AgentBreakdown,
  AgentComment,
  AgentCommentList,
  AgentCommentRequest,
  AgentList,
  AgentMemoryCreateRequest,
  AgentMemoryDetail,
  AgentMemoryLink,
  AgentMemoryLinkValidateRequest,
  AgentMemoryList,
  AgentMemoryPropagateRequest,
  AgentMemoryVersion,
  AgentMemoryVersionCreateRequest,
  AgentRequest,
  AgentVersionActivate,
  AgentVersionCompareResponse,
  AgentVersionList,
  AgentVersionRequest,
  AuthForgotPasswordCreate200,
  AuthForgotPasswordCreate400,
  AuthForgotPasswordCreate500,
  AuthGoogleCreate400,
  AuthLoginCreate401,
  AuthLogoutCreate200,
  AuthLogoutCreate400,
  AuthLogoutCreateBody,
  AuthRegisterCreate400,
  AuthResetPasswordCreate200,
  AuthResetPasswordCreate400,
  AuthStatusResponse,
  AuthStatusRetrieve401,
  AuthTokenRefreshCreate200,
  AuthTokenRefreshCreate401,
  AuthTokenRefreshCreateBody,
  BadRequestResponse,
  Category,
  CategoryRequest,
  CategoryRuleSetCreateRequest,
  CategoryVersion,
  ChannelGate,
  ChatSlackConversationsListParams,
  ClientCostAnalytics,
  CompareAgentVersionsParams,
  ComparePublicAgentVersionsParams,
  ComplianceShadowReport,
  ComplianceShadowReportRetrieveParams,
  ComplianceStrategies,
  ComputerActionRequest,
  ComputerLeaseRequest,
  ComputerPreview,
  ComputerProfile,
  ComputerSession,
  ComputerSessionsExecuteCreate200,
  ComputerSessionsListParams,
  ComputerTakeover,
  ComputerTakeoverStatus,
  Conversation,
  ConversationRequest,
  CurrentUserResponse,
  DashboardData,
  Document,
  DocumentUploadRequestRequest,
  EnhanceOntologyFieldBody,
  EvalRunDetail,
  EvalRunList,
  EvalStudioEvalRunsComplianceReportRetrieve200,
  EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  EvalStudioRunsUsageRetrieve200,
  EvalStudioScenarioRunsTraceRetrieve200,
  Example,
  ExampleRequest,
  ExampleVersion,
  ExecutionProjection,
  ExecutionTaskTranscript,
  FeatureFlag,
  FilesKnowledgeListParams,
  FilesKnowledgePropagateCreate200,
  FilesKnowledgeSuggestedListParams,
  FilesUploadsRetrieve404,
  FilesUploadsRetrieveParams,
  ForgotPasswordRequest,
  GenerateSystemPromptBody,
  GoogleAuthRequest,
  GoogleAuthSuccessResponse,
  Guardrail,
  GuardrailBatchDecisionRequest,
  GuardrailChangeSet,
  GuardrailRequest,
  GuardrailVersion,
  GuardrailsCategoriesRollbackCreateBody,
  GuardrailsCategoriesVersionsCompareRetrieveParams,
  GuardrailsExamplesRollbackCreateBody,
  GuardrailsExamplesVersionsCompareRetrieveParams,
  GuardrailsGuardrailsRollbackCreateBody,
  GuardrailsGuardrailsVersionsCompareRetrieveParams,
  GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody,
  GuardrailsRulesetsRollbackCreateBody,
  GuardrailsRulesetsVersionsCompareRetrieveParams,
  KnowledgeDocumentCreateRequest,
  KnowledgeDocumentDetail,
  KnowledgeDocumentList,
  KnowledgeDocumentPropagateRequest,
  KnowledgeDocumentUpdate,
  KnowledgeDocumentUpdateRequest,
  KnowledgeDocumentVersion,
  KnowledgeDocumentVersionCreateRequest,
  KnowledgeVersionComplianceDecisionRequest,
  LLMModelCreateUpdateRequest,
  LLMModelDetail,
  LLMModelList,
  LLMProvider,
  LLMProviderCreateUpdateRequest,
  ListAgents2Params,
  ListAgentsParams,
  ListHybridAgentsParams,
  ListPublicAgents2Params,
  ListPublicAgentsParams,
  LlmModelsListParams,
  LlmProvidersListParams,
  LoginRequest,
  LoginSuccessResponse,
  MCPServerConfig,
  MCPServerConfigCreateUpdateRequest,
  MCPServerConfigList,
  MCPServerConfigRequest,
  ManagerActivity,
  McpServersListParams,
  McpServersOauthCallbackCreateParams,
  McpServersSecretHeadersPartialUpdate200,
  McpServersSecretHeadersPartialUpdateBodyOne,
  McpServersSecretHeadersPartialUpdateBodyThree,
  McpServersSecretHeadersPartialUpdateBodyTwo,
  McpServersSecretHeadersRetrieve200,
  MemoriesFilterOptionsRetrieve200,
  MemoriesFilterOptionsRetrieveParams,
  MemoriesListParams,
  MemoriesPropagateCreate200,
  Message,
  NotFoundResponse,
  ObservabilityLogsBatchRetrieve200,
  ObservabilityLogsBatchRetrieveParams,
  ObservabilityLogsChannelsRetrieve200,
  ObservabilityLogsChannelsRetrieveParams,
  ObservabilityLogsExecutionManagerRetrieveParams,
  ObservabilityLogsExecutionRetrieveParams,
  ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  ObservabilityLogsRetrieve200,
  ObservabilityLogsRetrieve2200,
  ObservabilityLogsRetrieve2Params,
  ObservabilityLogsRetrieveParams,
  ObservabilityLogsUsersRetrieve200,
  ObservabilityLogsUsersRetrieveParams,
  OptimisationReview,
  OptimisationReviewDetail,
  OptimisationRun,
  PasswordChangeRequest,
  PatchedAgentCommentRequest,
  PatchedAgentMemoryUpdateRequest,
  PatchedAgentMemoryVersionUpdateRequest,
  PatchedAgentRequest,
  PatchedCategoryRequest,
  PatchedChannelGateUpdateRequest,
  PatchedExampleRequest,
  PatchedFeatureFlagToggleRequest,
  PatchedGuardrailRequest,
  PatchedIsEnabledUpdateRequest,
  PatchedKnowledgeDocumentUpdateRequest,
  PatchedLLMModelCreateUpdateRequest,
  PatchedLLMProviderCreateUpdateRequest,
  PatchedMCPServerConfigCreateUpdateRequest,
  PatchedQualityBaselineConfigRequest,
  PatchedRegistrationWhitelistRequest,
  PatchedRegulationRequest,
  PatchedRoleRequest,
  PatchedRuleSetRequest,
  PatchedScenarioUpdateRequest,
  PatchedSkillUpdateRequest,
  PatchedSkillVersionUpdateRequest,
  PatchedSlackUserRequest,
  PatchedSuggestedDocumentUpdateRequest,
  PatchedTeamsUserRequest,
  PatchedTriggerEmailAddressUpdateRequest,
  PatchedTriggerUpdateRequest,
  PatchedUserUpdateRequest,
  PatchedWorkspaceMemberRequest,
  PatchedWorkspaceRequest,
  ProbationAgentBody,
  QualityBaselineConfig,
  QualityBaselineEnrollment,
  QualityBaselineEnrollmentCreateRequest,
  QualityBaselineActiveScan,
  QualityBaselineRunQueued,
  QualityBaselineScanDetail,
  QualityBaselineScenario,
  RegisterRequest,
  RegisterSuccessResponse,
  RegistrationWhitelist,
  RegistrationWhitelistRequest,
  Regulation,
  RegulationRequest,
  ResetPasswordRequest,
  Role,
  RoleRequest,
  RoleResolveDeleteRequestRequest,
  RoleUsageResponse,
  RuleSet,
  RuleSetDetail,
  RuleSetGuardrail,
  RuleSetRequest,
  RuleSetVersion,
  ScenarioDetail,
  ScenarioList,
  ScenarioPublishRequestRequest,
  ScenarioRunDetail,
  ScenarioRunSummary,
  ScenarioTags,
  ScenarioVersion,
  ScenarioWithSingleRuns,
  SearchAgentsParams,
  SelfHostedMCPPreset,
  SkillCreateRequest,
  SkillDetail,
  SkillImportRequest,
  SkillImportResult,
  SkillList,
  SkillUsageEvidence,
  SkillVersion,
  SkillVersionCreateRequest,
  SkillVersionFile,
  SkillsUsageEvidenceListParams,
  SkillsVersionsFileRetrieveParams,
  SlackConfig,
  SlackConversation,
  SlackConversationRequest,
  SlackOAuthCallbackRequest,
  SlackOAuthInitiateRequest,
  SlackOAuthStatus,
  SlackSimpleChatRequestRequest,
  SlackUser,
  SlackUserRequest,
  SourceDeletionRequest,
  SuggestedDocument,
  SuggestedDocumentCreateRequest,
  SuggestedDocumentFulfillRequest,
  TeamGraph,
  TeamGraphRetrieveParams,
  TeamsGraphConsentInitiate,
  TeamsIntegrationStatus,
  TeamsUser,
  TeamsUserRequest,
  TemporalHistoryDeletionRequestsListParams,
  TenantMemoriesCreate200,
  TenantMemoriesListParams,
  TokenUsageAdminSummaryRetrieveParams,
  TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  TokenUsageAdminWorkspacesRetrieveParams,
  TokenUsageCostAnalyticsRetrieveParams,
  TokenUsageSummary,
  TokenUsageWorkspaces,
  TriggerAPIKeyCreateRequest,
  TriggerAPIKeyCreateResponse,
  TriggerAPIKeyList,
  TriggerCreateRequest,
  TriggerDestination,
  TriggerDetail,
  TriggerDispatchCallbackRequest,
  TriggerEligibleAgent,
  TriggerEmailConfig,
  TriggerExecutionRequestRequest,
  TriggerList,
  TriggerMentionableUser,
  TriggerPlatform,
  TriggerRun,
  TriggerTestExecutionRequestRequest,
  TriggerVersion,
  TriggerVersionCreateRequest,
  UploadedFile,
  UploadedFileRequest,
  User,
  UserCreateRequest,
  UserUpdateRequest,
  UsersMeAvatarUpdateBody,
  VersionDiff,
  WebChatMessageRequestRequest,
  WebComplianceDecisionRequestRequest,
  WebComplianceDecisionResponse,
  Workspace,
  WorkspaceBreakdown,
  WorkspaceDetail,
  WorkspaceFeatureFlags,
  WorkspaceInvitation,
  WorkspaceInvitationRequest,
  WorkspaceMember,
  WorkspaceMemberRequest,
  WorkspaceRequest,
  WorkspacesSlackConfigRetrieveParams,
} from './models';

import { customInstance } from '../api/mutator/custom-instance';
const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Return the teammate categories available in the current workspace.
 *
 * Categories are free-form (the column is a plain CharField); this endpoint
 * seeds the category picker with the built-in standard categories plus any
 * custom categories already in use by teammates in the workspace. New
 * categories are created simply by saving a teammate with a new label.
 *
 * The reserved internal labels (compliance/routing/memory) are surfaced
 * separately under ``system_categories`` and only included for the
 * vigilantai (super-admin) workspace.
 */
export const categoriesRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `${import.meta.env.VITE_API_URL}/api/v1/categories/`, method: 'GET', signal });
};

export const getCategoriesRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/categories/`] as const;
};

export const getCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof categoriesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categoriesRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoriesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof categoriesRetrieve>>> = ({ signal }) =>
    categoriesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CategoriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof categoriesRetrieve>>>;
export type CategoriesRetrieveQueryError = unknown;

export function useCategoriesRetrieve<TData = Awaited<ReturnType<typeof categoriesRetrieve>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof categoriesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof categoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategoriesRetrieve<TData = Awaited<ReturnType<typeof categoriesRetrieve>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categoriesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof categoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategoriesRetrieve<TData = Awaited<ReturnType<typeof categoriesRetrieve>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categoriesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCategoriesRetrieve<TData = Awaited<ReturnType<typeof categoriesRetrieve>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categoriesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCategoriesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * policy_llm vs inhouse_policy shadow comparisons (vigilantai only).
 */
export const complianceShadowReportRetrieve = (params?: ComplianceShadowReportRetrieveParams, signal?: AbortSignal) => {
  return customInstance<ComplianceShadowReport>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/compliance/shadow-report/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getComplianceShadowReportRetrieveQueryKey = (params?: ComplianceShadowReportRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/compliance/shadow-report/`, ...(params ? [params] : [])] as const;
};

export const getComplianceShadowReportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
  TError = unknown,
>(
  params?: ComplianceShadowReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComplianceShadowReportRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>> = ({ signal }) =>
    complianceShadowReportRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComplianceShadowReportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof complianceShadowReportRetrieve>>
>;
export type ComplianceShadowReportRetrieveQueryError = unknown;

export function useComplianceShadowReportRetrieve<
  TData = Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
  TError = unknown,
>(
  params: undefined | ComplianceShadowReportRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof complianceShadowReportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComplianceShadowReportRetrieve<
  TData = Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
  TError = unknown,
>(
  params?: ComplianceShadowReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof complianceShadowReportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComplianceShadowReportRetrieve<
  TData = Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
  TError = unknown,
>(
  params?: ComplianceShadowReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComplianceShadowReportRetrieve<
  TData = Awaited<ReturnType<typeof complianceShadowReportRetrieve>>,
  TError = unknown,
>(
  params?: ComplianceShadowReportRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof complianceShadowReportRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComplianceShadowReportRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerPreviewsList = (signal?: AbortSignal) => {
  return customInstance<ComputerPreview[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-previews/`,
    method: 'GET',
    signal,
  });
};

export const getComputerPreviewsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-previews/`] as const;
};

export const getComputerPreviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof computerPreviewsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerPreviewsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerPreviewsList>>> = ({ signal }) =>
    computerPreviewsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerPreviewsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerPreviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof computerPreviewsList>>>;
export type ComputerPreviewsListQueryError = unknown;

export function useComputerPreviewsList<TData = Awaited<ReturnType<typeof computerPreviewsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsList>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsList<TData = Awaited<ReturnType<typeof computerPreviewsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsList>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsList<TData = Awaited<ReturnType<typeof computerPreviewsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerPreviewsList<TData = Awaited<ReturnType<typeof computerPreviewsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerPreviewsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerPreviewsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerPreview>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-previews/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getComputerPreviewsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-previews/${id}/`] as const;
};

export const getComputerPreviewsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerPreviewsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerPreviewsRetrieve>>> = ({ signal }) =>
    computerPreviewsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerPreviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof computerPreviewsRetrieve>>>;
export type ComputerPreviewsRetrieveQueryError = unknown;

export function useComputerPreviewsRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerPreviewsRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerPreviewsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerPreviewsImageRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-previews/${id}/image/`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getComputerPreviewsImageRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-previews/${id}/image/`] as const;
};

export const getComputerPreviewsImageRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerPreviewsImageRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>> = ({ signal }) =>
    computerPreviewsImageRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerPreviewsImageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>
>;
export type ComputerPreviewsImageRetrieveQueryError = unknown;

export function useComputerPreviewsImageRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsImageRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerPreviewsImageRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerPreviewsImageRetrieve<
  TData = Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerPreviewsImageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerPreviewsImageRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerProfilesList = (signal?: AbortSignal) => {
  return customInstance<ComputerProfile[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/`,
    method: 'GET',
    signal,
  });
};

export const getComputerProfilesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/`] as const;
};

export const getComputerProfilesListQueryOptions = <
  TData = Awaited<ReturnType<typeof computerProfilesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerProfilesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerProfilesList>>> = ({ signal }) =>
    computerProfilesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerProfilesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerProfilesListQueryResult = NonNullable<Awaited<ReturnType<typeof computerProfilesList>>>;
export type ComputerProfilesListQueryError = unknown;

export function useComputerProfilesList<TData = Awaited<ReturnType<typeof computerProfilesList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerProfilesList>>,
          TError,
          Awaited<ReturnType<typeof computerProfilesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerProfilesList<TData = Awaited<ReturnType<typeof computerProfilesList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerProfilesList>>,
          TError,
          Awaited<ReturnType<typeof computerProfilesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerProfilesList<TData = Awaited<ReturnType<typeof computerProfilesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerProfilesList<TData = Awaited<ReturnType<typeof computerProfilesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerProfilesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerProfilesRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerProfile>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getComputerProfilesRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/${id}/`] as const;
};

export const getComputerProfilesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof computerProfilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerProfilesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerProfilesRetrieve>>> = ({ signal }) =>
    computerProfilesRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerProfilesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof computerProfilesRetrieve>>>;
export type ComputerProfilesRetrieveQueryError = unknown;

export function useComputerProfilesRetrieve<
  TData = Awaited<ReturnType<typeof computerProfilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerProfilesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerProfilesRetrieve<
  TData = Awaited<ReturnType<typeof computerProfilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerProfilesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerProfilesRetrieve<
  TData = Awaited<ReturnType<typeof computerProfilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerProfilesRetrieve<
  TData = Awaited<ReturnType<typeof computerProfilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerProfilesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerProfilesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerProfilesBootCreate = (
  id: string,
  computerLeaseRequest?: ComputerLeaseRequest,
  signal?: AbortSignal
) => {
  return customInstance<ComputerSession>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/${id}/boot/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: computerLeaseRequest,
    signal,
  });
};

export const getComputerProfilesBootCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerProfilesBootCreate>>,
    TError,
    { id: string; data?: ComputerLeaseRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computerProfilesBootCreate>>,
  TError,
  { id: string; data?: ComputerLeaseRequest },
  TContext
> => {
  const mutationKey = ['computerProfilesBootCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computerProfilesBootCreate>>,
    { id: string; data?: ComputerLeaseRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return computerProfilesBootCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerProfilesBootCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerProfilesBootCreate>>
>;
export type ComputerProfilesBootCreateMutationBody = ComputerLeaseRequest | undefined;
export type ComputerProfilesBootCreateMutationError = unknown;

export const useComputerProfilesBootCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerProfilesBootCreate>>,
      TError,
      { id: string; data?: ComputerLeaseRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof computerProfilesBootCreate>>,
  TError,
  { id: string; data?: ComputerLeaseRequest },
  TContext
> => {
  return useMutation(getComputerProfilesBootCreateMutationOptions(options), queryClient);
};

export const computerProfilesStopCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerProfile>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-profiles/${id}/stop/`,
    method: 'POST',
    signal,
  });
};

export const getComputerProfilesStopCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerProfilesStopCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof computerProfilesStopCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['computerProfilesStopCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof computerProfilesStopCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return computerProfilesStopCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerProfilesStopCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerProfilesStopCreate>>
>;

export type ComputerProfilesStopCreateMutationError = unknown;

export const useComputerProfilesStopCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerProfilesStopCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof computerProfilesStopCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getComputerProfilesStopCreateMutationOptions(options), queryClient);
};

export const computerSessionsList = (params?: ComputerSessionsListParams, signal?: AbortSignal) => {
  return customInstance<ComputerSession[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getComputerSessionsListQueryKey = (params?: ComputerSessionsListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/`, ...(params ? [params] : [])] as const;
};

export const getComputerSessionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof computerSessionsList>>,
  TError = unknown,
>(
  params?: ComputerSessionsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerSessionsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerSessionsList>>> = ({ signal }) =>
    computerSessionsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerSessionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof computerSessionsList>>>;
export type ComputerSessionsListQueryError = unknown;

export function useComputerSessionsList<TData = Awaited<ReturnType<typeof computerSessionsList>>, TError = unknown>(
  params: undefined | ComputerSessionsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsList>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsList<TData = Awaited<ReturnType<typeof computerSessionsList>>, TError = unknown>(
  params?: ComputerSessionsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsList>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsList<TData = Awaited<ReturnType<typeof computerSessionsList>>, TError = unknown>(
  params?: ComputerSessionsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerSessionsList<TData = Awaited<ReturnType<typeof computerSessionsList>>, TError = unknown>(
  params?: ComputerSessionsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerSessionsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerSessionsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerSession>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getComputerSessionsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/`] as const;
};

export const getComputerSessionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof computerSessionsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerSessionsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerSessionsRetrieve>>> = ({ signal }) =>
    computerSessionsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerSessionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof computerSessionsRetrieve>>>;
export type ComputerSessionsRetrieveQueryError = unknown;

export function useComputerSessionsRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerSessionsRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerSessionsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const computerSessionsExecuteCreate = (
  id: string,
  computerActionRequest: ComputerActionRequest,
  signal?: AbortSignal
) => {
  return customInstance<ComputerSessionsExecuteCreate200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/execute/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: computerActionRequest,
    signal,
  });
};

export const getComputerSessionsExecuteCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerSessionsExecuteCreate>>,
    TError,
    { id: string; data: ComputerActionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computerSessionsExecuteCreate>>,
  TError,
  { id: string; data: ComputerActionRequest },
  TContext
> => {
  const mutationKey = ['computerSessionsExecuteCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computerSessionsExecuteCreate>>,
    { id: string; data: ComputerActionRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return computerSessionsExecuteCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerSessionsExecuteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsExecuteCreate>>
>;
export type ComputerSessionsExecuteCreateMutationBody = ComputerActionRequest;
export type ComputerSessionsExecuteCreateMutationError = unknown;

export const useComputerSessionsExecuteCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerSessionsExecuteCreate>>,
      TError,
      { id: string; data: ComputerActionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof computerSessionsExecuteCreate>>,
  TError,
  { id: string; data: ComputerActionRequest },
  TContext
> => {
  return useMutation(getComputerSessionsExecuteCreateMutationOptions(options), queryClient);
};

export const computerSessionsPreviewCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerPreview>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/preview/`,
    method: 'POST',
    signal,
  });
};

export const getComputerSessionsPreviewCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerSessionsPreviewCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof computerSessionsPreviewCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['computerSessionsPreviewCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof computerSessionsPreviewCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return computerSessionsPreviewCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerSessionsPreviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsPreviewCreate>>
>;

export type ComputerSessionsPreviewCreateMutationError = unknown;

export const useComputerSessionsPreviewCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerSessionsPreviewCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof computerSessionsPreviewCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getComputerSessionsPreviewCreateMutationOptions(options), queryClient);
};

export const computerSessionsReleaseTakeoverCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerTakeoverStatus>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/release-takeover/`,
    method: 'POST',
    signal,
  });
};

export const getComputerSessionsReleaseTakeoverCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['computerSessionsReleaseTakeoverCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return computerSessionsReleaseTakeoverCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerSessionsReleaseTakeoverCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>
>;

export type ComputerSessionsReleaseTakeoverCreateMutationError = unknown;

export const useComputerSessionsReleaseTakeoverCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof computerSessionsReleaseTakeoverCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getComputerSessionsReleaseTakeoverCreateMutationOptions(options), queryClient);
};

export const computerSessionsTakeoverCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerTakeover>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/takeover/`,
    method: 'POST',
    signal,
  });
};

export const getComputerSessionsTakeoverCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['computerSessionsTakeoverCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return computerSessionsTakeoverCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerSessionsTakeoverCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>
>;

export type ComputerSessionsTakeoverCreateMutationError = unknown;

export const useComputerSessionsTakeoverCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof computerSessionsTakeoverCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getComputerSessionsTakeoverCreateMutationOptions(options), queryClient);
};

export const computerSessionsTakeoverHeartbeatCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerTakeoverStatus>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/takeover-heartbeat/`,
    method: 'POST',
    signal,
  });
};

export const getComputerSessionsTakeoverHeartbeatCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['computerSessionsTakeoverHeartbeatCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return computerSessionsTakeoverHeartbeatCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputerSessionsTakeoverHeartbeatCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>
>;

export type ComputerSessionsTakeoverHeartbeatCreateMutationError = unknown;

export const useComputerSessionsTakeoverHeartbeatCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof computerSessionsTakeoverHeartbeatCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getComputerSessionsTakeoverHeartbeatCreateMutationOptions(options), queryClient);
};

export const computerSessionsTakeoverStatusRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ComputerTakeoverStatus>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/takeover-status/`,
    method: 'GET',
    signal,
  });
};

export const getComputerSessionsTakeoverStatusRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/computer-sessions/${id}/takeover-status/`] as const;
};

export const getComputerSessionsTakeoverStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComputerSessionsTakeoverStatusRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>> = ({ signal }) =>
    computerSessionsTakeoverStatusRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComputerSessionsTakeoverStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>
>;
export type ComputerSessionsTakeoverStatusRetrieveQueryError = unknown;

export function useComputerSessionsTakeoverStatusRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsTakeoverStatusRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComputerSessionsTakeoverStatusRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useComputerSessionsTakeoverStatusRetrieve<
  TData = Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof computerSessionsTakeoverStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComputerSessionsTakeoverStatusRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List registered compliance strategies for run-time selection.
 */
export const evalStudioComplianceStrategiesRetrieve = (signal?: AbortSignal) => {
  return customInstance<ComplianceStrategies>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/compliance-strategies/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioComplianceStrategiesRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/compliance-strategies/`] as const;
};

export const getEvalStudioComplianceStrategiesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioComplianceStrategiesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>> = ({ signal }) =>
    evalStudioComplianceStrategiesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioComplianceStrategiesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>
>;
export type EvalStudioComplianceStrategiesRetrieveQueryError = unknown;

export function useEvalStudioComplianceStrategiesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioComplianceStrategiesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioComplianceStrategiesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioComplianceStrategiesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioComplianceStrategiesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioComplianceStrategiesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped read-only eval suite run surface.
 */
export const evalStudioEvalRunsList = (signal?: AbortSignal) => {
  return customInstance<EvalRunList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioEvalRunsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/`] as const;
};

export const getEvalStudioEvalRunsListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioEvalRunsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioEvalRunsList>>> = ({ signal }) =>
    evalStudioEvalRunsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioEvalRunsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioEvalRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof evalStudioEvalRunsList>>>;
export type EvalStudioEvalRunsListQueryError = unknown;

export function useEvalStudioEvalRunsList<TData = Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsList<TData = Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsList<TData = Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioEvalRunsList<TData = Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioEvalRunsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped read-only eval suite run surface.
 */
export const evalStudioEvalRunsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<EvalRunDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioEvalRunsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/${id}/`] as const;
};

export const getEvalStudioEvalRunsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioEvalRunsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>> = ({ signal }) =>
    evalStudioEvalRunsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioEvalRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>>;
export type EvalStudioEvalRunsRetrieveQueryError = unknown;

export function useEvalStudioEvalRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioEvalRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioEvalRunsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return classifier quality, compliance cost, and latency metrics.
 */
export const evalStudioEvalRunsComplianceReportRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<EvalStudioEvalRunsComplianceReportRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/${id}/compliance-report/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioEvalRunsComplianceReportRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/${id}/compliance-report/`] as const;
};

export const getEvalStudioEvalRunsComplianceReportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioEvalRunsComplianceReportRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>> = ({ signal }) =>
    evalStudioEvalRunsComplianceReportRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioEvalRunsComplianceReportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>
>;
export type EvalStudioEvalRunsComplianceReportRetrieveQueryError = unknown;

export function useEvalStudioEvalRunsComplianceReportRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsComplianceReportRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioEvalRunsComplianceReportRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioEvalRunsComplianceReportRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioEvalRunsComplianceReportRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioEvalRunsComplianceReportRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Trigger a suite run (one EvalRun fanning out all eligible scenarios).
 */
export const evalStudioEvalRunsTriggerCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/eval-runs/trigger/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioEvalRunsTriggerCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>, TError, void, TContext> => {
  const mutationKey = ['evalStudioEvalRunsTriggerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>, void> = () => {
    return evalStudioEvalRunsTriggerCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioEvalRunsTriggerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>
>;

export type EvalStudioEvalRunsTriggerCreateMutationError = unknown;

export const useEvalStudioEvalRunsTriggerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof evalStudioEvalRunsTriggerCreate>>, TError, void, TContext> => {
  return useMutation(getEvalStudioEvalRunsTriggerCreateMutationOptions(options), queryClient);
};

export const evalStudioQualityBaselinesConfigRetrieve = (signal?: AbortSignal) => {
  return customInstance<QualityBaselineConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/config/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioQualityBaselinesConfigRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/config/`] as const;
};

export const getEvalStudioQualityBaselinesConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioQualityBaselinesConfigRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>> = ({ signal }) =>
    evalStudioQualityBaselinesConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioQualityBaselinesConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>
>;
export type EvalStudioQualityBaselinesConfigRetrieveQueryError = unknown;

export function useEvalStudioQualityBaselinesConfigRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesConfigRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesConfigRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioQualityBaselinesConfigRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioQualityBaselinesConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const evalStudioQualityBaselinesConfigPartialUpdate = (
  patchedQualityBaselineConfigRequest?: PatchedQualityBaselineConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<QualityBaselineConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/config/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedQualityBaselineConfigRequest,
    signal,
  });
};

export const getEvalStudioQualityBaselinesConfigPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>,
    TError,
    { data?: PatchedQualityBaselineConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>,
  TError,
  { data?: PatchedQualityBaselineConfigRequest },
  TContext
> => {
  const mutationKey = ['evalStudioQualityBaselinesConfigPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>,
    { data?: PatchedQualityBaselineConfigRequest }
  > = (props) => {
    const { data } = props ?? {};

    return evalStudioQualityBaselinesConfigPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioQualityBaselinesConfigPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>
>;
export type EvalStudioQualityBaselinesConfigPartialUpdateMutationBody = PatchedQualityBaselineConfigRequest | undefined;
export type EvalStudioQualityBaselinesConfigPartialUpdateMutationError = unknown;

export const useEvalStudioQualityBaselinesConfigPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>,
      TError,
      { data?: PatchedQualityBaselineConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesConfigPartialUpdate>>,
  TError,
  { data?: PatchedQualityBaselineConfigRequest },
  TContext
> => {
  return useMutation(getEvalStudioQualityBaselinesConfigPartialUpdateMutationOptions(options), queryClient);
};

export const evalStudioQualityBaselinesEnrollmentsList = (signal?: AbortSignal) => {
  return customInstance<QualityBaselineEnrollment[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioQualityBaselinesEnrollmentsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/`] as const;
};

export const getEvalStudioQualityBaselinesEnrollmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioQualityBaselinesEnrollmentsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>> = ({ signal }) =>
    evalStudioQualityBaselinesEnrollmentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioQualityBaselinesEnrollmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>
>;
export type EvalStudioQualityBaselinesEnrollmentsListQueryError = unknown;

export function useEvalStudioQualityBaselinesEnrollmentsList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesEnrollmentsList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesEnrollmentsList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioQualityBaselinesEnrollmentsList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioQualityBaselinesEnrollmentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const evalStudioQualityBaselinesEnrollmentsCreate = (
  qualityBaselineEnrollmentCreateRequest: QualityBaselineEnrollmentCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<QualityBaselineEnrollment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: qualityBaselineEnrollmentCreateRequest,
    signal,
  });
};

export const getEvalStudioQualityBaselinesEnrollmentsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>,
    TError,
    { data: QualityBaselineEnrollmentCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>,
  TError,
  { data: QualityBaselineEnrollmentCreateRequest },
  TContext
> => {
  const mutationKey = ['evalStudioQualityBaselinesEnrollmentsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>,
    { data: QualityBaselineEnrollmentCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return evalStudioQualityBaselinesEnrollmentsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioQualityBaselinesEnrollmentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>
>;
export type EvalStudioQualityBaselinesEnrollmentsCreateMutationBody = QualityBaselineEnrollmentCreateRequest;
export type EvalStudioQualityBaselinesEnrollmentsCreateMutationError = unknown;

export const useEvalStudioQualityBaselinesEnrollmentsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>,
      TError,
      { data: QualityBaselineEnrollmentCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsCreate>>,
  TError,
  { data: QualityBaselineEnrollmentCreateRequest },
  TContext
> => {
  return useMutation(getEvalStudioQualityBaselinesEnrollmentsCreateMutationOptions(options), queryClient);
};

export const evalStudioQualityBaselinesEnrollmentsDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getEvalStudioQualityBaselinesEnrollmentsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioQualityBaselinesEnrollmentsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return evalStudioQualityBaselinesEnrollmentsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioQualityBaselinesEnrollmentsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>
>;

export type EvalStudioQualityBaselinesEnrollmentsDestroyMutationError = unknown;

export const useEvalStudioQualityBaselinesEnrollmentsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEvalStudioQualityBaselinesEnrollmentsDestroyMutationOptions(options), queryClient);
};

export const evalStudioQualityBaselinesEnrollmentsRunCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<QualityBaselineRunQueued>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/${id}/run/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioQualityBaselinesEnrollmentsRunCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioQualityBaselinesEnrollmentsRunCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return evalStudioQualityBaselinesEnrollmentsRunCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioQualityBaselinesEnrollmentsRunCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>
>;

export type EvalStudioQualityBaselinesEnrollmentsRunCreateMutationError = unknown;

export const useEvalStudioQualityBaselinesEnrollmentsRunCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsRunCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEvalStudioQualityBaselinesEnrollmentsRunCreateMutationOptions(options), queryClient);
};

export const evalStudioQualityBaselinesEnrollmentsScenariosList = (
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  signal?: AbortSignal
) => {
  return customInstance<QualityBaselineScenario[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/${id}/scenarios/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getEvalStudioQualityBaselinesEnrollmentsScenariosListQueryKey = (
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/enrollments/${id}/scenarios/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEvalStudioQualityBaselinesEnrollmentsScenariosListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
  TError = unknown,
>(
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioQualityBaselinesEnrollmentsScenariosListQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>> = ({
    signal,
  }) => evalStudioQualityBaselinesEnrollmentsScenariosList(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioQualityBaselinesEnrollmentsScenariosListQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>
>;
export type EvalStudioQualityBaselinesEnrollmentsScenariosListQueryError = unknown;

export function useEvalStudioQualityBaselinesEnrollmentsScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
  TError = unknown,
>(
  id: string,
  params: undefined | EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesEnrollmentsScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
  TError = unknown,
>(
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesEnrollmentsScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
  TError = unknown,
>(
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioQualityBaselinesEnrollmentsScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>,
  TError = unknown,
>(
  id: string,
  params?: EvalStudioQualityBaselinesEnrollmentsScenariosListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesEnrollmentsScenariosList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioQualityBaselinesEnrollmentsScenariosListQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * The scan currently in progress, if one exists.
 */
export const evalStudioQualityBaselinesScanRetrieve = (signal?: AbortSignal) => {
  return customInstance<QualityBaselineActiveScan>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/scan/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioQualityBaselinesScanRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/scan/`] as const;
};

export const getEvalStudioQualityBaselinesScanRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioQualityBaselinesScanRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>> = ({ signal }) =>
    evalStudioQualityBaselinesScanRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioQualityBaselinesScanRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>
>;
export type EvalStudioQualityBaselinesScanRetrieveQueryError = unknown;

export function useEvalStudioQualityBaselinesScanRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesScanRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioQualityBaselinesScanRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioQualityBaselinesScanRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioQualityBaselinesScanRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Queue one discovery pass for every enrolled teammate, and report its progress.
 */
export const evalStudioQualityBaselinesScanCreate = (signal?: AbortSignal) => {
  return customInstance<QualityBaselineScanDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/quality-baselines/scan/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioQualityBaselinesScanCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>, TError, void, TContext> => {
  const mutationKey = ['evalStudioQualityBaselinesScanCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>, void> = () => {
    return evalStudioQualityBaselinesScanCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioQualityBaselinesScanCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>
>;

export type EvalStudioQualityBaselinesScanCreateMutationError = unknown;

export const useEvalStudioQualityBaselinesScanCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof evalStudioQualityBaselinesScanCreate>>, TError, void, TContext> => {
  return useMutation(getEvalStudioQualityBaselinesScanCreateMutationOptions(options), queryClient);
};

/**
 * Aggregate LLM token cost per scenario run (vigilantai workspace only).
 *
 * Sums the tenant's TokenUsageRecord rows stamped with
 * ``context.scenario_run_id`` (agent turns, routing, compliance, tool mocks,
 * LLM judge). Accepts either ``eval_run_id`` (all runs of a suite) or a
 * comma-separated ``scenario_run_ids`` list.
 */
export const evalStudioRunsUsageRetrieve = (signal?: AbortSignal) => {
  return customInstance<EvalStudioRunsUsageRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/runs/usage/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioRunsUsageRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/runs/usage/`] as const;
};

export const getEvalStudioRunsUsageRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioRunsUsageRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>> = ({ signal }) =>
    evalStudioRunsUsageRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioRunsUsageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>
>;
export type EvalStudioRunsUsageRetrieveQueryError = unknown;

export function useEvalStudioRunsUsageRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioRunsUsageRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioRunsUsageRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioRunsUsageRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioRunsUsageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioRunsUsageRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List and retrieve ScenarioRuns (suite members or standalone).
 */
export const evalStudioScenarioRunsList = (signal?: AbortSignal) => {
  return customInstance<ScenarioRunSummary[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenarioRunsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/`] as const;
};

export const getEvalStudioScenarioRunsListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenarioRunsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>> = ({ signal }) =>
    evalStudioScenarioRunsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenarioRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>>;
export type EvalStudioScenarioRunsListQueryError = unknown;

export function useEvalStudioScenarioRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenarioRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenarioRunsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List and retrieve ScenarioRuns (suite members or standalone).
 */
export const evalStudioScenarioRunsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioRunDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenarioRunsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/${id}/`] as const;
};

export const getEvalStudioScenarioRunsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenarioRunsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>> = ({ signal }) =>
    evalStudioScenarioRunsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenarioRunsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>
>;
export type EvalStudioScenarioRunsRetrieveQueryError = unknown;

export function useEvalStudioScenarioRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenarioRunsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenarioRunsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List and retrieve ScenarioRuns (suite members or standalone).
 */
export const evalStudioScenarioRunsTraceRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<EvalStudioScenarioRunsTraceRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/${id}/trace/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenarioRunsTraceRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenario-runs/${id}/trace/`] as const;
};

export const getEvalStudioScenarioRunsTraceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenarioRunsTraceRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>> = ({ signal }) =>
    evalStudioScenarioRunsTraceRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenarioRunsTraceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>
>;
export type EvalStudioScenarioRunsTraceRetrieveQueryError = unknown;

export function useEvalStudioScenarioRunsTraceRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsTraceRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenarioRunsTraceRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenarioRunsTraceRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenarioRunsTraceRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenarioRunsTraceRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped scenario surface: read + lifecycle/severity mutations.
 */
export const evalStudioScenariosList = (signal?: AbortSignal) => {
  return customInstance<ScenarioList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/`] as const;
};

export const getEvalStudioScenariosListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosList>>> = ({ signal }) =>
    evalStudioScenariosList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenariosList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenariosListQueryResult = NonNullable<Awaited<ReturnType<typeof evalStudioScenariosList>>>;
export type EvalStudioScenariosListQueryError = unknown;

export function useEvalStudioScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped scenario surface: read + lifecycle/severity mutations.
 */
export const evalStudioScenariosRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/`] as const;
};

export const getEvalStudioScenariosRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>> = ({ signal }) =>
    evalStudioScenariosRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenariosRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>
>;
export type EvalStudioScenariosRetrieveQueryError = unknown;

export function useEvalStudioScenariosRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Edit scenario fields (e.g. severity) by drafting a new version.
 */
export const evalStudioScenariosPartialUpdate = (
  id: string,
  patchedScenarioUpdateRequest?: PatchedScenarioUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedScenarioUpdateRequest,
    signal,
  });
};

export const getEvalStudioScenariosPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>,
    TError,
    { id: string; data?: PatchedScenarioUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>,
  TError,
  { id: string; data?: PatchedScenarioUpdateRequest },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>,
    { id: string; data?: PatchedScenarioUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return evalStudioScenariosPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>
>;
export type EvalStudioScenariosPartialUpdateMutationBody = PatchedScenarioUpdateRequest | undefined;
export type EvalStudioScenariosPartialUpdateMutationError = unknown;

export const useEvalStudioScenariosPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>,
      TError,
      { id: string; data?: PatchedScenarioUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioScenariosPartialUpdate>>,
  TError,
  { id: string; data?: PatchedScenarioUpdateRequest },
  TContext
> => {
  return useMutation(getEvalStudioScenariosPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Archive a scenario, removing it from normal use (run history preserved).
 */
export const evalStudioScenariosArchiveCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/archive/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioScenariosArchiveCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosArchiveCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return evalStudioScenariosArchiveCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosArchiveCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>
>;

export type EvalStudioScenariosArchiveCreateMutationError = unknown;

export const useEvalStudioScenariosArchiveCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioScenariosArchiveCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEvalStudioScenariosArchiveCreateMutationOptions(options), queryClient);
};

/**
 * Pause an active scenario without archiving it.
 */
export const evalStudioScenariosDisableCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/disable/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioScenariosDisableCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosDisableCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return evalStudioScenariosDisableCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosDisableCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>
>;

export type EvalStudioScenariosDisableCreateMutationError = unknown;

export const useEvalStudioScenariosDisableCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioScenariosDisableCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEvalStudioScenariosDisableCreateMutationOptions(options), queryClient);
};

/**
 * Re-activate a paused (disabled) scenario.
 */
export const evalStudioScenariosEnableCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/enable/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioScenariosEnableCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosEnableCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return evalStudioScenariosEnableCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosEnableCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>
>;

export type EvalStudioScenariosEnableCreateMutationError = unknown;

export const useEvalStudioScenariosEnableCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof evalStudioScenariosEnableCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getEvalStudioScenariosEnableCreateMutationOptions(options), queryClient);
};

/**
 * Return metadata/content for a file fixture referenced by this scenario.
 */
export const evalStudioScenariosFilesRetrieve = (id: string, uploadId: string, signal?: AbortSignal) => {
  return customInstance<UploadedFile>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/files/${uploadId}/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosFilesRetrieveQueryKey = (id: string, uploadId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/files/${uploadId}/`] as const;
};

export const getEvalStudioScenariosFilesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  uploadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosFilesRetrieveQueryKey(id, uploadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>> = ({ signal }) =>
    evalStudioScenariosFilesRetrieve(id, uploadId, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined && uploadId !== null && uploadId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type EvalStudioScenariosFilesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>
>;
export type EvalStudioScenariosFilesRetrieveQueryError = unknown;

export function useEvalStudioScenariosFilesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  uploadId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosFilesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  uploadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosFilesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  uploadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosFilesRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>,
  TError = unknown,
>(
  id: string,
  uploadId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosFilesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosFilesRetrieveQueryOptions(id, uploadId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Publish the current (or a specified) version so the scenario is active.
 */
export const evalStudioScenariosPublishCreate = (
  id: string,
  scenarioPublishRequestRequest?: ScenarioPublishRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/publish/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenarioPublishRequestRequest,
    signal,
  });
};

export const getEvalStudioScenariosPublishCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>,
    TError,
    { id: string; data?: ScenarioPublishRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>,
  TError,
  { id: string; data?: ScenarioPublishRequestRequest },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosPublishCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>,
    { id: string; data?: ScenarioPublishRequestRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return evalStudioScenariosPublishCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosPublishCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>
>;
export type EvalStudioScenariosPublishCreateMutationBody = ScenarioPublishRequestRequest | undefined;
export type EvalStudioScenariosPublishCreateMutationError = unknown;

export const useEvalStudioScenariosPublishCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>,
      TError,
      { id: string; data?: ScenarioPublishRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioScenariosPublishCreate>>,
  TError,
  { id: string; data?: ScenarioPublishRequestRequest },
  TContext
> => {
  return useMutation(getEvalStudioScenariosPublishCreateMutationOptions(options), queryClient);
};

/**
 * Restore an archived scenario to active (or draft if never published).
 *
 * Restoring returns a scenario to normal use: it becomes Active again when
 * it has a published version, or Draft when it has never been published and
 * therefore cannot be active.
 */
export const evalStudioScenariosRestoreCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/restore/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioScenariosRestoreCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['evalStudioScenariosRestoreCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return evalStudioScenariosRestoreCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosRestoreCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>
>;

export type EvalStudioScenariosRestoreCreateMutationError = unknown;

export const useEvalStudioScenariosRestoreCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof evalStudioScenariosRestoreCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEvalStudioScenariosRestoreCreateMutationOptions(options), queryClient);
};

/**
 * Trigger a standalone run of a single scenario (no EvalRun).
 */
export const evalStudioScenariosRunCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/run/`,
    method: 'POST',
    signal,
  });
};

export const getEvalStudioScenariosRunCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['evalStudioScenariosRunCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return evalStudioScenariosRunCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EvalStudioScenariosRunCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>
>;

export type EvalStudioScenariosRunCreateMutationError = unknown;

export const useEvalStudioScenariosRunCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof evalStudioScenariosRunCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getEvalStudioScenariosRunCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped scenario surface: read + lifecycle/severity mutations.
 */
export const evalStudioScenariosVersionsList = (id: string, signal?: AbortSignal) => {
  return customInstance<ScenarioVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosVersionsListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/${id}/versions/`] as const;
};

export const getEvalStudioScenariosVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>> = ({ signal }) =>
    evalStudioScenariosVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenariosVersionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>
>;
export type EvalStudioScenariosVersionsListQueryError = unknown;

export function useEvalStudioScenariosVersionsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosVersionsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosVersionsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosVersionsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Distinct scenario tags already used in this workspace.
 */
export const evalStudioScenariosTagsRetrieve = (signal?: AbortSignal) => {
  return customInstance<ScenarioTags>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/tags/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosTagsRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/tags/`] as const;
};

export const getEvalStudioScenariosTagsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosTagsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>> = ({ signal }) =>
    evalStudioScenariosTagsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenariosTagsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>
>;
export type EvalStudioScenariosTagsRetrieveQueryError = unknown;

export function useEvalStudioScenariosTagsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosTagsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosTagsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosTagsRetrieve<
  TData = Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosTagsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosTagsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Scenarios that have standalone runs, ordered by most recent single run.
 */
export const evalStudioScenariosWithSingleRunsList = (signal?: AbortSignal) => {
  return customInstance<ScenarioWithSingleRuns[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/with-single-runs/`,
    method: 'GET',
    signal,
  });
};

export const getEvalStudioScenariosWithSingleRunsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/eval-studio/scenarios/with-single-runs/`] as const;
};

export const getEvalStudioScenariosWithSingleRunsListQueryOptions = <
  TData = Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEvalStudioScenariosWithSingleRunsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>> = ({ signal }) =>
    evalStudioScenariosWithSingleRunsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EvalStudioScenariosWithSingleRunsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>
>;
export type EvalStudioScenariosWithSingleRunsListQueryError = unknown;

export function useEvalStudioScenariosWithSingleRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosWithSingleRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
          TError,
          Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEvalStudioScenariosWithSingleRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEvalStudioScenariosWithSingleRunsList<
  TData = Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof evalStudioScenariosWithSingleRunsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEvalStudioScenariosWithSingleRunsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Receives Resend ``email.received`` events for inbound email triggers.
 *
 * Verifies the Svix signature against the raw body, then hands the email id to
 * Celery. Resend retries the whole delivery on any non-2xx, so the request
 * must stay short: everything slow (fetching the body, resolving the trigger,
 * starting a run) happens in the task.
 */
export const eventsEmailResendCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/events/email/resend`,
    method: 'POST',
    signal,
  });
};

export const getEventsEmailResendCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate>>, TError, void, TContext> => {
  const mutationKey = ['eventsEmailResendCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsEmailResendCreate>>, void> = () => {
    return eventsEmailResendCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type EventsEmailResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsEmailResendCreate>>>;

export type EventsEmailResendCreateMutationError = unknown;

export const useEventsEmailResendCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof eventsEmailResendCreate>>, TError, void, TContext> => {
  return useMutation(getEventsEmailResendCreateMutationOptions(options), queryClient);
};

/**
 * Receives Resend ``email.received`` events for inbound email triggers.
 *
 * Verifies the Svix signature against the raw body, then hands the email id to
 * Celery. Resend retries the whole delivery on any non-2xx, so the request
 * must stay short: everything slow (fetching the body, resolving the trigger,
 * starting a run) happens in the task.
 */
export const eventsEmailResendCreate2 = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/events/email/resend/`,
    method: 'POST',
    signal,
  });
};

export const getEventsEmailResendCreate2MutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate2>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate2>>, TError, void, TContext> => {
  const mutationKey = ['eventsEmailResendCreate2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof eventsEmailResendCreate2>>, void> = () => {
    return eventsEmailResendCreate2();
  };

  return { mutationFn, ...mutationOptions };
};

export type EventsEmailResendCreate2MutationResult = NonNullable<Awaited<ReturnType<typeof eventsEmailResendCreate2>>>;

export type EventsEmailResendCreate2MutationError = unknown;

export const useEventsEmailResendCreate2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof eventsEmailResendCreate2>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof eventsEmailResendCreate2>>, TError, void, TContext> => {
  return useMutation(getEventsEmailResendCreate2MutationOptions(options), queryClient);
};

export const eventsInboundCreate = (
  triggerExecutionRequestRequest?: TriggerExecutionRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerRun>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/events/inbound`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerExecutionRequestRequest,
    signal,
  });
};

export const getEventsInboundCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eventsInboundCreate>>,
    TError,
    { data?: TriggerExecutionRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eventsInboundCreate>>,
  TError,
  { data?: TriggerExecutionRequestRequest },
  TContext
> => {
  const mutationKey = ['eventsInboundCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eventsInboundCreate>>,
    { data?: TriggerExecutionRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return eventsInboundCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EventsInboundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof eventsInboundCreate>>>;
export type EventsInboundCreateMutationBody = TriggerExecutionRequestRequest | undefined;
export type EventsInboundCreateMutationError = unknown;

export const useEventsInboundCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof eventsInboundCreate>>,
      TError,
      { data?: TriggerExecutionRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof eventsInboundCreate>>,
  TError,
  { data?: TriggerExecutionRequestRequest },
  TContext
> => {
  return useMutation(getEventsInboundCreateMutationOptions(options), queryClient);
};

export const eventsInboundCreate2 = (
  triggerExecutionRequestRequest?: TriggerExecutionRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerRun>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/events/inbound/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerExecutionRequestRequest,
    signal,
  });
};

export const getEventsInboundCreate2MutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eventsInboundCreate2>>,
    TError,
    { data?: TriggerExecutionRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eventsInboundCreate2>>,
  TError,
  { data?: TriggerExecutionRequestRequest },
  TContext
> => {
  const mutationKey = ['eventsInboundCreate2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eventsInboundCreate2>>,
    { data?: TriggerExecutionRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return eventsInboundCreate2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EventsInboundCreate2MutationResult = NonNullable<Awaited<ReturnType<typeof eventsInboundCreate2>>>;
export type EventsInboundCreate2MutationBody = TriggerExecutionRequestRequest | undefined;
export type EventsInboundCreate2MutationError = unknown;

export const useEventsInboundCreate2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof eventsInboundCreate2>>,
      TError,
      { data?: TriggerExecutionRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof eventsInboundCreate2>>,
  TError,
  { data?: TriggerExecutionRequestRequest },
  TContext
> => {
  return useMutation(getEventsInboundCreate2MutationOptions(options), queryClient);
};

/**
 * List all feature flags for the current workspace/tenant.
 * @summary List Feature Flags
 */
export const featureFlagsList = (signal?: AbortSignal) => {
  return customInstance<FeatureFlag[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/feature-flags/`,
    method: 'GET',
    signal,
  });
};

export const getFeatureFlagsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/feature-flags/`] as const;
};

export const getFeatureFlagsListQueryOptions = <
  TData = Awaited<ReturnType<typeof featureFlagsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeatureFlagsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsList>>> = ({ signal }) => featureFlagsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof featureFlagsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FeatureFlagsListQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsList>>>;
export type FeatureFlagsListQueryError = unknown;

export function useFeatureFlagsList<TData = Awaited<ReturnType<typeof featureFlagsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsList>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsList<TData = Awaited<ReturnType<typeof featureFlagsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsList>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsList<TData = Awaited<ReturnType<typeof featureFlagsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Feature Flags
 */

export function useFeatureFlagsList<TData = Awaited<ReturnType<typeof featureFlagsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFeatureFlagsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific feature flag by ID or name.
 * @summary Get Feature Flag
 */
export const featureFlagsRetrieve = (identifier: string, signal?: AbortSignal) => {
  return customInstance<FeatureFlag>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/feature-flags/${identifier}/`,
    method: 'GET',
    signal,
  });
};

export const getFeatureFlagsRetrieveQueryKey = (identifier: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/feature-flags/${identifier}/`] as const;
};

export const getFeatureFlagsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof featureFlagsRetrieve>>,
  TError = unknown,
>(
  identifier: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeatureFlagsRetrieveQueryKey(identifier);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsRetrieve>>> = ({ signal }) =>
    featureFlagsRetrieve(identifier, signal);

  return {
    queryKey,
    queryFn,
    enabled: identifier !== null && identifier !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FeatureFlagsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsRetrieve>>>;
export type FeatureFlagsRetrieveQueryError = unknown;

export function useFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError = unknown>(
  identifier: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError = unknown>(
  identifier: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError = unknown>(
  identifier: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Feature Flag
 */

export function useFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError = unknown>(
  identifier: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFeatureFlagsRetrieveQueryOptions(identifier, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Enable or disable a feature flag for the current workspace. Requires admin role.
 * @summary Toggle Feature Flag
 */
export const featureFlagsTogglePartialUpdate = (
  identifier: string,
  patchedFeatureFlagToggleRequest?: PatchedFeatureFlagToggleRequest,
  signal?: AbortSignal
) => {
  return customInstance<FeatureFlag>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/feature-flags/${identifier}/toggle/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedFeatureFlagToggleRequest,
    signal,
  });
};

export const getFeatureFlagsTogglePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>,
    TError,
    { identifier: string; data?: PatchedFeatureFlagToggleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>,
  TError,
  { identifier: string; data?: PatchedFeatureFlagToggleRequest },
  TContext
> => {
  const mutationKey = ['featureFlagsTogglePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>,
    { identifier: string; data?: PatchedFeatureFlagToggleRequest }
  > = (props) => {
    const { identifier, data } = props ?? {};

    return featureFlagsTogglePartialUpdate(identifier, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeatureFlagsTogglePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>
>;
export type FeatureFlagsTogglePartialUpdateMutationBody = PatchedFeatureFlagToggleRequest | undefined;
export type FeatureFlagsTogglePartialUpdateMutationError = unknown;

/**
 * @summary Toggle Feature Flag
 */
export const useFeatureFlagsTogglePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>,
      TError,
      { identifier: string; data?: PatchedFeatureFlagToggleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof featureFlagsTogglePartialUpdate>>,
  TError,
  { identifier: string; data?: PatchedFeatureFlagToggleRequest },
  TContext
> => {
  return useMutation(getFeatureFlagsTogglePartialUpdateMutationOptions(options), queryClient);
};

/**
 * List all workspaces and their feature flags. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] List All Workspaces with Feature Flags
 */
export const featureFlagsAdminWorkspacesList = (signal?: AbortSignal) => {
  return customInstance<WorkspaceFeatureFlags[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/feature-flags/admin/workspaces/`,
    method: 'GET',
    signal,
  });
};

export const getFeatureFlagsAdminWorkspacesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/feature-flags/admin/workspaces/`] as const;
};

export const getFeatureFlagsAdminWorkspacesListQueryOptions = <
  TData = Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFeatureFlagsAdminWorkspacesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>> = ({ signal }) =>
    featureFlagsAdminWorkspacesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FeatureFlagsAdminWorkspacesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>
>;
export type FeatureFlagsAdminWorkspacesListQueryError = unknown;

export function useFeatureFlagsAdminWorkspacesList<
  TData = Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsAdminWorkspacesList<
  TData = Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFeatureFlagsAdminWorkspacesList<
  TData = Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Admin] List All Workspaces with Feature Flags
 */

export function useFeatureFlagsAdminWorkspacesList<
  TData = Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsAdminWorkspacesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFeatureFlagsAdminWorkspacesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Enable or disable a feature flag for a specific workspace. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] Toggle Feature Flag for Workspace
 */
export const featureFlagsAdminWorkspacesFlagsTogglePartialUpdate = (
  workspaceId: string,
  flagIdentifier: string,
  patchedFeatureFlagToggleRequest?: PatchedFeatureFlagToggleRequest,
  signal?: AbortSignal
) => {
  return customInstance<FeatureFlag>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/feature-flags/admin/workspaces/${workspaceId}/flags/${flagIdentifier}/toggle/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedFeatureFlagToggleRequest,
    signal,
  });
};

export const getFeatureFlagsAdminWorkspacesFlagsTogglePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>,
    TError,
    { workspaceId: string; flagIdentifier: string; data?: PatchedFeatureFlagToggleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>,
  TError,
  { workspaceId: string; flagIdentifier: string; data?: PatchedFeatureFlagToggleRequest },
  TContext
> => {
  const mutationKey = ['featureFlagsAdminWorkspacesFlagsTogglePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>,
    { workspaceId: string; flagIdentifier: string; data?: PatchedFeatureFlagToggleRequest }
  > = (props) => {
    const { workspaceId, flagIdentifier, data } = props ?? {};

    return featureFlagsAdminWorkspacesFlagsTogglePartialUpdate(workspaceId, flagIdentifier, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeatureFlagsAdminWorkspacesFlagsTogglePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>
>;
export type FeatureFlagsAdminWorkspacesFlagsTogglePartialUpdateMutationBody =
  | PatchedFeatureFlagToggleRequest
  | undefined;
export type FeatureFlagsAdminWorkspacesFlagsTogglePartialUpdateMutationError = unknown;

/**
 * @summary [Admin] Toggle Feature Flag for Workspace
 */
export const useFeatureFlagsAdminWorkspacesFlagsTogglePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>,
      TError,
      { workspaceId: string; flagIdentifier: string; data?: PatchedFeatureFlagToggleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof featureFlagsAdminWorkspacesFlagsTogglePartialUpdate>>,
  TError,
  { workspaceId: string; flagIdentifier: string; data?: PatchedFeatureFlagToggleRequest },
  TContext
> => {
  return useMutation(getFeatureFlagsAdminWorkspacesFlagsTogglePartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve a combined list of public agents and tenant-specific agents. Only available in tenant schemas.
 * @summary List Hybrid Agents
 */
export const listHybridAgents = (params?: ListHybridAgentsParams, signal?: AbortSignal) => {
  return customInstance<void>({ url: `${import.meta.env.VITE_API_URL}/api/v1/hybrid/`, method: 'GET', params, signal });
};

export const getListHybridAgentsQueryKey = (params?: ListHybridAgentsParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/hybrid/`, ...(params ? [params] : [])] as const;
};

export const getListHybridAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listHybridAgents>>, TError = void>(
  params?: ListHybridAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHybridAgents>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHybridAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHybridAgents>>> = ({ signal }) =>
    listHybridAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHybridAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHybridAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listHybridAgents>>>;
export type ListHybridAgentsQueryError = void;

export function useListHybridAgents<TData = Awaited<ReturnType<typeof listHybridAgents>>, TError = void>(
  params: undefined | ListHybridAgentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHybridAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHybridAgents>>,
          TError,
          Awaited<ReturnType<typeof listHybridAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHybridAgents<TData = Awaited<ReturnType<typeof listHybridAgents>>, TError = void>(
  params?: ListHybridAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHybridAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHybridAgents>>,
          TError,
          Awaited<ReturnType<typeof listHybridAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHybridAgents<TData = Awaited<ReturnType<typeof listHybridAgents>>, TError = void>(
  params?: ListHybridAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHybridAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hybrid Agents
 */

export function useListHybridAgents<TData = Awaited<ReturnType<typeof listHybridAgents>>, TError = void>(
  params?: ListHybridAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHybridAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListHybridAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns all LLM models available to the current workspace, including both public (shared) and tenant-specific models. Use ?tenant_only=true to only return tenant-specific models.
 * @summary List all available models
 */
export const llmModelsList = (params?: LlmModelsListParams, signal?: AbortSignal) => {
  return customInstance<LLMModelList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/models/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getLlmModelsListQueryKey = (params?: LlmModelsListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/models/`, ...(params ? [params] : [])] as const;
};

export const getLlmModelsListQueryOptions = <TData = Awaited<ReturnType<typeof llmModelsList>>, TError = unknown>(
  params?: LlmModelsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmModelsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmModelsList>>> = ({ signal }) =>
    llmModelsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmModelsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmModelsListQueryResult = NonNullable<Awaited<ReturnType<typeof llmModelsList>>>;
export type LlmModelsListQueryError = unknown;

export function useLlmModelsList<TData = Awaited<ReturnType<typeof llmModelsList>>, TError = unknown>(
  params: undefined | LlmModelsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsList<TData = Awaited<ReturnType<typeof llmModelsList>>, TError = unknown>(
  params?: LlmModelsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsList<TData = Awaited<ReturnType<typeof llmModelsList>>, TError = unknown>(
  params?: LlmModelsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all available models
 */

export function useLlmModelsList<TData = Awaited<ReturnType<typeof llmModelsList>>, TError = unknown>(
  params?: LlmModelsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmModelsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns detailed information about a specific LLM model.
 * @summary Get model details
 */
export const llmModelsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/models/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmModelsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/models/${id}/`] as const;
};

export const getLlmModelsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof llmModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmModelsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmModelsRetrieve>>> = ({ signal }) =>
    llmModelsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmModelsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmModelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmModelsRetrieve>>>;
export type LlmModelsRetrieveQueryError = void;

export function useLlmModelsRetrieve<TData = Awaited<ReturnType<typeof llmModelsRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsRetrieve<TData = Awaited<ReturnType<typeof llmModelsRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsRetrieve<TData = Awaited<ReturnType<typeof llmModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get model details
 */

export function useLlmModelsRetrieve<TData = Awaited<ReturnType<typeof llmModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmModelsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the default LLM model for the workspace.
 * @summary Get default model
 */
export const llmModelsDefaultRetrieve = (signal?: AbortSignal) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/models/default/`,
    method: 'GET',
    signal,
  });
};

export const getLlmModelsDefaultRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/models/default/`] as const;
};

export const getLlmModelsDefaultRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmModelsDefaultRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>> = ({ signal }) =>
    llmModelsDefaultRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmModelsDefaultRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>>;
export type LlmModelsDefaultRetrieveQueryError = void;

export function useLlmModelsDefaultRetrieve<
  TData = Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsDefaultRetrieve<
  TData = Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmModelsDefaultRetrieve<
  TData = Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
  TError = void,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get default model
 */

export function useLlmModelsDefaultRetrieve<
  TData = Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>,
  TError = void,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmModelsDefaultRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmModelsDefaultRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns all LLM providers available to the current workspace, including both public (built-in) and tenant-specific providers. Use ?tenant_only=true to only return tenant-specific providers.
 * @summary List all available providers
 */
export const llmProvidersList = (params?: LlmProvidersListParams, signal?: AbortSignal) => {
  return customInstance<LLMProvider[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/providers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getLlmProvidersListQueryKey = (params?: LlmProvidersListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/providers/`, ...(params ? [params] : [])] as const;
};

export const getLlmProvidersListQueryOptions = <TData = Awaited<ReturnType<typeof llmProvidersList>>, TError = unknown>(
  params?: LlmProvidersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmProvidersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmProvidersList>>> = ({ signal }) =>
    llmProvidersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmProvidersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmProvidersListQueryResult = NonNullable<Awaited<ReturnType<typeof llmProvidersList>>>;
export type LlmProvidersListQueryError = unknown;

export function useLlmProvidersList<TData = Awaited<ReturnType<typeof llmProvidersList>>, TError = unknown>(
  params: undefined | LlmProvidersListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmProvidersList<TData = Awaited<ReturnType<typeof llmProvidersList>>, TError = unknown>(
  params?: LlmProvidersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmProvidersList<TData = Awaited<ReturnType<typeof llmProvidersList>>, TError = unknown>(
  params?: LlmProvidersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all available providers
 */

export function useLlmProvidersList<TData = Awaited<ReturnType<typeof llmProvidersList>>, TError = unknown>(
  params?: LlmProvidersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmProvidersListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns detailed information about a specific LLM provider.
 * @summary Get provider details
 */
export const llmProvidersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/providers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmProvidersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/providers/${id}/`] as const;
};

export const getLlmProvidersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmProvidersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmProvidersRetrieve>>> = ({ signal }) =>
    llmProvidersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmProvidersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmProvidersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmProvidersRetrieve>>>;
export type LlmProvidersRetrieveQueryError = void;

export function useLlmProvidersRetrieve<TData = Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmProvidersRetrieve<TData = Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmProvidersRetrieve<TData = Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get provider details
 */

export function useLlmProvidersRetrieve<TData = Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmProvidersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns all public (built-in) LLM models shared across all workspaces. Admin only.
 * @summary List public models (Admin)
 */
export const llmPublicModelsList = (signal?: AbortSignal) => {
  return customInstance<LLMModelDetail[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/`,
    method: 'GET',
    signal,
  });
};

export const getLlmPublicModelsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/`] as const;
};

export const getLlmPublicModelsListQueryOptions = <
  TData = Awaited<ReturnType<typeof llmPublicModelsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmPublicModelsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmPublicModelsList>>> = ({ signal }) =>
    llmPublicModelsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmPublicModelsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmPublicModelsListQueryResult = NonNullable<Awaited<ReturnType<typeof llmPublicModelsList>>>;
export type LlmPublicModelsListQueryError = unknown;

export function useLlmPublicModelsList<TData = Awaited<ReturnType<typeof llmPublicModelsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmPublicModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicModelsList<TData = Awaited<ReturnType<typeof llmPublicModelsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmPublicModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicModelsList<TData = Awaited<ReturnType<typeof llmPublicModelsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List public models (Admin)
 */

export function useLlmPublicModelsList<TData = Awaited<ReturnType<typeof llmPublicModelsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmPublicModelsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a new public LLM model shared across all workspaces. The model configuration is validated by making a test API call before saving. Admin only.
 * @summary Create public model (Admin)
 */
export const llmPublicModelsCreate = (
  lLMModelCreateUpdateRequest: LLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicModelsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicModelsCreate>>,
    TError,
    { data: LLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicModelsCreate>>,
  TError,
  { data: LLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicModelsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicModelsCreate>>,
    { data: LLMModelCreateUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return llmPublicModelsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicModelsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof llmPublicModelsCreate>>>;
export type LlmPublicModelsCreateMutationBody = LLMModelCreateUpdateRequest;
export type LlmPublicModelsCreateMutationError = void;

/**
 * @summary Create public model (Admin)
 */
export const useLlmPublicModelsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicModelsCreate>>,
      TError,
      { data: LLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicModelsCreate>>,
  TError,
  { data: LLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicModelsCreateMutationOptions(options), queryClient);
};

/**
 * Returns detailed information about a public LLM model. Admin only.
 * @summary Get public model details (Admin)
 */
export const llmPublicModelsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmPublicModelsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/${id}/`] as const;
};

export const getLlmPublicModelsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmPublicModelsRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmPublicModelsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>> = ({ signal }) =>
    llmPublicModelsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmPublicModelsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmPublicModelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>>;
export type LlmPublicModelsRetrieveQueryError = void;

export function useLlmPublicModelsRetrieve<TData = Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmPublicModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicModelsRetrieve<TData = Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmPublicModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicModelsRetrieve<TData = Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get public model details (Admin)
 */

export function useLlmPublicModelsRetrieve<TData = Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmPublicModelsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates an existing public LLM model. If model_id or provider changes, configuration is validated with a test API call. Admin only.
 * @summary Update public model (Admin)
 */
export const llmPublicModelsUpdate = (
  id: string,
  lLMModelCreateUpdateRequest: LLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: lLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicModelsUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicModelsUpdate>>,
    TError,
    { id: string; data: LLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicModelsUpdate>>,
  TError,
  { id: string; data: LLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicModelsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicModelsUpdate>>,
    { id: string; data: LLMModelCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmPublicModelsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicModelsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof llmPublicModelsUpdate>>>;
export type LlmPublicModelsUpdateMutationBody = LLMModelCreateUpdateRequest;
export type LlmPublicModelsUpdateMutationError = void;

/**
 * @summary Update public model (Admin)
 */
export const useLlmPublicModelsUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicModelsUpdate>>,
      TError,
      { id: string; data: LLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicModelsUpdate>>,
  TError,
  { id: string; data: LLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicModelsUpdateMutationOptions(options), queryClient);
};

/**
 * Partially updates an existing public LLM model. If model_id or provider changes, configuration is validated with a test API call. Admin only.
 * @summary Partially update public model (Admin)
 */
export const llmPublicModelsPartialUpdate = (
  id: string,
  patchedLLMModelCreateUpdateRequest?: PatchedLLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedLLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicModelsPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>,
    TError,
    { id: string; data?: PatchedLLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicModelsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>,
    { id: string; data?: PatchedLLMModelCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmPublicModelsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicModelsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>
>;
export type LlmPublicModelsPartialUpdateMutationBody = PatchedLLMModelCreateUpdateRequest | undefined;
export type LlmPublicModelsPartialUpdateMutationError = void;

/**
 * @summary Partially update public model (Admin)
 */
export const useLlmPublicModelsPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>,
      TError,
      { id: string; data?: PatchedLLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicModelsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicModelsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Deletes a public LLM model. Deletion is blocked only if the model is used by active agent versions across any workspace (historical/inactive versions are ignored). Admin only.
 * @summary Delete public model (Admin)
 */
export const llmPublicModelsDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/models/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getLlmPublicModelsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof llmPublicModelsDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof llmPublicModelsDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['llmPublicModelsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof llmPublicModelsDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return llmPublicModelsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicModelsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof llmPublicModelsDestroy>>>;

export type LlmPublicModelsDestroyMutationError = void;

/**
 * @summary Delete public model (Admin)
 */
export const useLlmPublicModelsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof llmPublicModelsDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof llmPublicModelsDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getLlmPublicModelsDestroyMutationOptions(options), queryClient);
};

/**
 * Returns all public (built-in) LLM providers shared across all workspaces. Admin only.
 * @summary List public providers (Admin)
 */
export const llmPublicProvidersList = (signal?: AbortSignal) => {
  return customInstance<LLMProvider[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/`,
    method: 'GET',
    signal,
  });
};

export const getLlmPublicProvidersListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/`] as const;
};

export const getLlmPublicProvidersListQueryOptions = <
  TData = Awaited<ReturnType<typeof llmPublicProvidersList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmPublicProvidersListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmPublicProvidersList>>> = ({ signal }) =>
    llmPublicProvidersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmPublicProvidersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmPublicProvidersListQueryResult = NonNullable<Awaited<ReturnType<typeof llmPublicProvidersList>>>;
export type LlmPublicProvidersListQueryError = unknown;

export function useLlmPublicProvidersList<TData = Awaited<ReturnType<typeof llmPublicProvidersList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmPublicProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicProvidersList<TData = Awaited<ReturnType<typeof llmPublicProvidersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmPublicProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicProvidersList<TData = Awaited<ReturnType<typeof llmPublicProvidersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List public providers (Admin)
 */

export function useLlmPublicProvidersList<TData = Awaited<ReturnType<typeof llmPublicProvidersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmPublicProvidersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a new public LLM provider shared across all workspaces. API key is required for creation. Admin only.
 * @summary Create public provider (Admin)
 */
export const llmPublicProvidersCreate = (
  lLMProviderCreateUpdateRequest: LLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicProvidersCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicProvidersCreate>>,
    TError,
    { data: LLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicProvidersCreate>>,
  TError,
  { data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicProvidersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicProvidersCreate>>,
    { data: LLMProviderCreateUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return llmPublicProvidersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicProvidersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof llmPublicProvidersCreate>>>;
export type LlmPublicProvidersCreateMutationBody = LLMProviderCreateUpdateRequest;
export type LlmPublicProvidersCreateMutationError = void;

/**
 * @summary Create public provider (Admin)
 */
export const useLlmPublicProvidersCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicProvidersCreate>>,
      TError,
      { data: LLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicProvidersCreate>>,
  TError,
  { data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicProvidersCreateMutationOptions(options), queryClient);
};

/**
 * Returns detailed information about a public LLM provider. Admin only.
 * @summary Get public provider details (Admin)
 */
export const llmPublicProvidersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmPublicProvidersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/${id}/`] as const;
};

export const getLlmPublicProvidersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmPublicProvidersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>> = ({ signal }) =>
    llmPublicProvidersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmPublicProvidersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>>;
export type LlmPublicProvidersRetrieveQueryError = void;

export function useLlmPublicProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmPublicProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get public provider details (Admin)
 */

export function useLlmPublicProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmPublicProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmPublicProvidersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates an existing public LLM provider. If base_url or api_key changes and the provider has models, configuration is validated with a test API call using the first model. Admin only.
 * @summary Update public provider (Admin)
 */
export const llmPublicProvidersUpdate = (
  id: string,
  lLMProviderCreateUpdateRequest: LLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: lLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicProvidersUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicProvidersUpdate>>,
    TError,
    { id: string; data: LLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicProvidersUpdate>>,
  TError,
  { id: string; data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicProvidersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicProvidersUpdate>>,
    { id: string; data: LLMProviderCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmPublicProvidersUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicProvidersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof llmPublicProvidersUpdate>>>;
export type LlmPublicProvidersUpdateMutationBody = LLMProviderCreateUpdateRequest;
export type LlmPublicProvidersUpdateMutationError = void;

/**
 * @summary Update public provider (Admin)
 */
export const useLlmPublicProvidersUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicProvidersUpdate>>,
      TError,
      { id: string; data: LLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicProvidersUpdate>>,
  TError,
  { id: string; data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicProvidersUpdateMutationOptions(options), queryClient);
};

/**
 * Partially updates an existing public LLM provider. If base_url or api_key changes and the provider has models, configuration is validated with a test API call using the first model. Admin only.
 * @summary Partially update public provider (Admin)
 */
export const llmPublicProvidersPartialUpdate = (
  id: string,
  patchedLLMProviderCreateUpdateRequest?: PatchedLLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedLLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmPublicProvidersPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>,
    TError,
    { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmPublicProvidersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>,
    { id: string; data?: PatchedLLMProviderCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmPublicProvidersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicProvidersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>
>;
export type LlmPublicProvidersPartialUpdateMutationBody = PatchedLLMProviderCreateUpdateRequest | undefined;
export type LlmPublicProvidersPartialUpdateMutationError = void;

/**
 * @summary Partially update public provider (Admin)
 */
export const useLlmPublicProvidersPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>,
      TError,
      { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmPublicProvidersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmPublicProvidersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Deletes a public LLM provider. Admin only.
 * @summary Delete public provider (Admin)
 */
export const llmPublicProvidersDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/public/providers/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getLlmPublicProvidersDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmPublicProvidersDestroy>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof llmPublicProvidersDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['llmPublicProvidersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof llmPublicProvidersDestroy>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return llmPublicProvidersDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmPublicProvidersDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmPublicProvidersDestroy>>
>;

export type LlmPublicProvidersDestroyMutationError = void;

/**
 * @summary Delete public provider (Admin)
 */
export const useLlmPublicProvidersDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmPublicProvidersDestroy>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof llmPublicProvidersDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getLlmPublicProvidersDestroyMutationOptions(options), queryClient);
};

/**
 * Returns all LLM models specific to the current workspace.
 * @summary List tenant models
 */
export const llmTenantModelsList = (signal?: AbortSignal) => {
  return customInstance<LLMModelDetail[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/`,
    method: 'GET',
    signal,
  });
};

export const getLlmTenantModelsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/`] as const;
};

export const getLlmTenantModelsListQueryOptions = <
  TData = Awaited<ReturnType<typeof llmTenantModelsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmTenantModelsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmTenantModelsList>>> = ({ signal }) =>
    llmTenantModelsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmTenantModelsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmTenantModelsListQueryResult = NonNullable<Awaited<ReturnType<typeof llmTenantModelsList>>>;
export type LlmTenantModelsListQueryError = unknown;

export function useLlmTenantModelsList<TData = Awaited<ReturnType<typeof llmTenantModelsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmTenantModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantModelsList<TData = Awaited<ReturnType<typeof llmTenantModelsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantModelsList>>,
          TError,
          Awaited<ReturnType<typeof llmTenantModelsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantModelsList<TData = Awaited<ReturnType<typeof llmTenantModelsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List tenant models
 */

export function useLlmTenantModelsList<TData = Awaited<ReturnType<typeof llmTenantModelsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmTenantModelsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a new LLM model for the current workspace. The model configuration is validated by making a test API call before saving.
 * @summary Create tenant model
 */
export const llmTenantModelsCreate = (
  lLMModelCreateUpdateRequest: LLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantModelsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantModelsCreate>>,
    TError,
    { data: LLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantModelsCreate>>,
  TError,
  { data: LLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantModelsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantModelsCreate>>,
    { data: LLMModelCreateUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return llmTenantModelsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantModelsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof llmTenantModelsCreate>>>;
export type LlmTenantModelsCreateMutationBody = LLMModelCreateUpdateRequest;
export type LlmTenantModelsCreateMutationError = void;

/**
 * @summary Create tenant model
 */
export const useLlmTenantModelsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantModelsCreate>>,
      TError,
      { data: LLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantModelsCreate>>,
  TError,
  { data: LLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantModelsCreateMutationOptions(options), queryClient);
};

/**
 * Returns detailed information about a tenant-specific LLM model.
 * @summary Get tenant model details
 */
export const llmTenantModelsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmTenantModelsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/${id}/`] as const;
};

export const getLlmTenantModelsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmTenantModelsRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmTenantModelsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>> = ({ signal }) =>
    llmTenantModelsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmTenantModelsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmTenantModelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>>;
export type LlmTenantModelsRetrieveQueryError = void;

export function useLlmTenantModelsRetrieve<TData = Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmTenantModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantModelsRetrieve<TData = Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmTenantModelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantModelsRetrieve<TData = Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get tenant model details
 */

export function useLlmTenantModelsRetrieve<TData = Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantModelsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmTenantModelsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates an existing tenant-specific LLM model. If model_id or provider changes, configuration is validated with a test API call.
 * @summary Update tenant model
 */
export const llmTenantModelsUpdate = (
  id: string,
  lLMModelCreateUpdateRequest: LLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: lLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantModelsUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantModelsUpdate>>,
    TError,
    { id: string; data: LLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantModelsUpdate>>,
  TError,
  { id: string; data: LLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantModelsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantModelsUpdate>>,
    { id: string; data: LLMModelCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmTenantModelsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantModelsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof llmTenantModelsUpdate>>>;
export type LlmTenantModelsUpdateMutationBody = LLMModelCreateUpdateRequest;
export type LlmTenantModelsUpdateMutationError = void;

/**
 * @summary Update tenant model
 */
export const useLlmTenantModelsUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantModelsUpdate>>,
      TError,
      { id: string; data: LLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantModelsUpdate>>,
  TError,
  { id: string; data: LLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantModelsUpdateMutationOptions(options), queryClient);
};

/**
 * Partially updates an existing tenant-specific LLM model. If model_id or provider changes, configuration is validated with a test API call.
 * @summary Partially update tenant model
 */
export const llmTenantModelsPartialUpdate = (
  id: string,
  patchedLLMModelCreateUpdateRequest?: PatchedLLMModelCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMModelDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedLLMModelCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantModelsPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>,
    TError,
    { id: string; data?: PatchedLLMModelCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMModelCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantModelsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>,
    { id: string; data?: PatchedLLMModelCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmTenantModelsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantModelsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>
>;
export type LlmTenantModelsPartialUpdateMutationBody = PatchedLLMModelCreateUpdateRequest | undefined;
export type LlmTenantModelsPartialUpdateMutationError = void;

/**
 * @summary Partially update tenant model
 */
export const useLlmTenantModelsPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>,
      TError,
      { id: string; data?: PatchedLLMModelCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantModelsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMModelCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantModelsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Deletes a tenant-specific LLM model. Deletion is blocked only if the model is used by an active agent version (historical/inactive versions are ignored).
 * @summary Delete tenant model
 */
export const llmTenantModelsDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/models/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getLlmTenantModelsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof llmTenantModelsDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof llmTenantModelsDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['llmTenantModelsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof llmTenantModelsDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return llmTenantModelsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantModelsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof llmTenantModelsDestroy>>>;

export type LlmTenantModelsDestroyMutationError = void;

/**
 * @summary Delete tenant model
 */
export const useLlmTenantModelsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof llmTenantModelsDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof llmTenantModelsDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getLlmTenantModelsDestroyMutationOptions(options), queryClient);
};

/**
 * Returns all LLM providers specific to the current workspace.
 * @summary List tenant providers
 */
export const llmTenantProvidersList = (signal?: AbortSignal) => {
  return customInstance<LLMProvider[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/`,
    method: 'GET',
    signal,
  });
};

export const getLlmTenantProvidersListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/`] as const;
};

export const getLlmTenantProvidersListQueryOptions = <
  TData = Awaited<ReturnType<typeof llmTenantProvidersList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmTenantProvidersListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmTenantProvidersList>>> = ({ signal }) =>
    llmTenantProvidersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmTenantProvidersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmTenantProvidersListQueryResult = NonNullable<Awaited<ReturnType<typeof llmTenantProvidersList>>>;
export type LlmTenantProvidersListQueryError = unknown;

export function useLlmTenantProvidersList<TData = Awaited<ReturnType<typeof llmTenantProvidersList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmTenantProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantProvidersList<TData = Awaited<ReturnType<typeof llmTenantProvidersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantProvidersList>>,
          TError,
          Awaited<ReturnType<typeof llmTenantProvidersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantProvidersList<TData = Awaited<ReturnType<typeof llmTenantProvidersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List tenant providers
 */

export function useLlmTenantProvidersList<TData = Awaited<ReturnType<typeof llmTenantProvidersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmTenantProvidersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a new LLM provider for the current workspace. API key is required for creation.
 * @summary Create tenant provider
 */
export const llmTenantProvidersCreate = (
  lLMProviderCreateUpdateRequest: LLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantProvidersCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantProvidersCreate>>,
    TError,
    { data: LLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantProvidersCreate>>,
  TError,
  { data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantProvidersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantProvidersCreate>>,
    { data: LLMProviderCreateUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return llmTenantProvidersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantProvidersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof llmTenantProvidersCreate>>>;
export type LlmTenantProvidersCreateMutationBody = LLMProviderCreateUpdateRequest;
export type LlmTenantProvidersCreateMutationError = void;

/**
 * @summary Create tenant provider
 */
export const useLlmTenantProvidersCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantProvidersCreate>>,
      TError,
      { data: LLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantProvidersCreate>>,
  TError,
  { data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantProvidersCreateMutationOptions(options), queryClient);
};

/**
 * Returns detailed information about a tenant-specific LLM provider.
 * @summary Get tenant provider details
 */
export const llmTenantProvidersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getLlmTenantProvidersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/${id}/`] as const;
};

export const getLlmTenantProvidersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmTenantProvidersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>> = ({ signal }) =>
    llmTenantProvidersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LlmTenantProvidersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>>;
export type LlmTenantProvidersRetrieveQueryError = void;

export function useLlmTenantProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLlmTenantProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get tenant provider details
 */

export function useLlmTenantProvidersRetrieve<
  TData = Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof llmTenantProvidersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLlmTenantProvidersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates an existing tenant-specific LLM provider. If base_url or api_key changes and the provider has models, configuration is validated with a test API call using the first model.
 * @summary Update tenant provider
 */
export const llmTenantProvidersUpdate = (
  id: string,
  lLMProviderCreateUpdateRequest: LLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: lLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantProvidersUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantProvidersUpdate>>,
    TError,
    { id: string; data: LLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantProvidersUpdate>>,
  TError,
  { id: string; data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantProvidersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantProvidersUpdate>>,
    { id: string; data: LLMProviderCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmTenantProvidersUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantProvidersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof llmTenantProvidersUpdate>>>;
export type LlmTenantProvidersUpdateMutationBody = LLMProviderCreateUpdateRequest;
export type LlmTenantProvidersUpdateMutationError = void;

/**
 * @summary Update tenant provider
 */
export const useLlmTenantProvidersUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantProvidersUpdate>>,
      TError,
      { id: string; data: LLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantProvidersUpdate>>,
  TError,
  { id: string; data: LLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantProvidersUpdateMutationOptions(options), queryClient);
};

/**
 * Partially updates an existing tenant-specific LLM provider. If base_url or api_key changes and the provider has models, configuration is validated with a test API call using the first model.
 * @summary Partially update tenant provider
 */
export const llmTenantProvidersPartialUpdate = (
  id: string,
  patchedLLMProviderCreateUpdateRequest?: PatchedLLMProviderCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<LLMProvider>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedLLMProviderCreateUpdateRequest,
    signal,
  });
};

export const getLlmTenantProvidersPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>,
    TError,
    { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['llmTenantProvidersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>,
    { id: string; data?: PatchedLLMProviderCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return llmTenantProvidersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantProvidersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>
>;
export type LlmTenantProvidersPartialUpdateMutationBody = PatchedLLMProviderCreateUpdateRequest | undefined;
export type LlmTenantProvidersPartialUpdateMutationError = void;

/**
 * @summary Partially update tenant provider
 */
export const useLlmTenantProvidersPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>,
      TError,
      { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof llmTenantProvidersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedLLMProviderCreateUpdateRequest },
  TContext
> => {
  return useMutation(getLlmTenantProvidersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Deletes a tenant-specific LLM provider.
 * @summary Delete tenant provider
 */
export const llmTenantProvidersDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/llm/tenant/providers/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getLlmTenantProvidersDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof llmTenantProvidersDestroy>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof llmTenantProvidersDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['llmTenantProvidersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof llmTenantProvidersDestroy>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return llmTenantProvidersDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LlmTenantProvidersDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof llmTenantProvidersDestroy>>
>;

export type LlmTenantProvidersDestroyMutationError = void;

/**
 * @summary Delete tenant provider
 */
export const useLlmTenantProvidersDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof llmTenantProvidersDestroy>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof llmTenantProvidersDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getLlmTenantProvidersDestroyMutationOptions(options), queryClient);
};

/**
 * Returns all MCP server configurations for the current workspace.
 * @summary List MCP servers
 */
export const mcpServersList = (params?: McpServersListParams, signal?: AbortSignal) => {
  return customInstance<MCPServerConfigList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMcpServersListQueryKey = (params?: McpServersListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/`, ...(params ? [params] : [])] as const;
};

export const getMcpServersListQueryOptions = <TData = Awaited<ReturnType<typeof mcpServersList>>, TError = unknown>(
  params?: McpServersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersList>>> = ({ signal }) =>
    mcpServersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersListQueryResult = NonNullable<Awaited<ReturnType<typeof mcpServersList>>>;
export type McpServersListQueryError = unknown;

export function useMcpServersList<TData = Awaited<ReturnType<typeof mcpServersList>>, TError = unknown>(
  params: undefined | McpServersListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersList>>,
          TError,
          Awaited<ReturnType<typeof mcpServersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersList<TData = Awaited<ReturnType<typeof mcpServersList>>, TError = unknown>(
  params?: McpServersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersList>>,
          TError,
          Awaited<ReturnType<typeof mcpServersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersList<TData = Awaited<ReturnType<typeof mcpServersList>>, TError = unknown>(
  params?: McpServersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List MCP servers
 */

export function useMcpServersList<TData = Awaited<ReturnType<typeof mcpServersList>>, TError = unknown>(
  params?: McpServersListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 *
 *         Creates a new MCP server configuration for the current workspace.
 *
 *         The `headers` field should contain authentication and custom headers as a JSON object.
 *         Common patterns:
 *         - Bearer token: `{"Authorization": "Bearer <token>"}`
 *         - API key: `{"X-API-Key": "<key>"}` or custom header name
 *         - Custom headers: Any key-value pairs
 * @summary Create MCP server
 */
export const mcpServersCreate = (
  mCPServerConfigCreateUpdateRequest: MCPServerConfigCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<MCPServerConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigCreateUpdateRequest,
    signal,
  });
};

export const getMcpServersCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersCreate>>,
    TError,
    { data: MCPServerConfigCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersCreate>>,
  TError,
  { data: MCPServerConfigCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['mcpServersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersCreate>>,
    { data: MCPServerConfigCreateUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return mcpServersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mcpServersCreate>>>;
export type McpServersCreateMutationBody = MCPServerConfigCreateUpdateRequest;
export type McpServersCreateMutationError = void;

/**
 * @summary Create MCP server
 */
export const useMcpServersCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersCreate>>,
      TError,
      { data: MCPServerConfigCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersCreate>>,
  TError,
  { data: MCPServerConfigCreateUpdateRequest },
  TContext
> => {
  return useMutation(getMcpServersCreateMutationOptions(options), queryClient);
};

/**
 * Returns detailed information about a specific MCP server configuration, including headers.
 * @summary Get MCP server details
 */
export const mcpServersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<MCPServerConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/`] as const;
};

export const getMcpServersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersRetrieve>>> = ({ signal }) =>
    mcpServersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mcpServersRetrieve>>>;
export type McpServersRetrieveQueryError = void;

export function useMcpServersRetrieve<TData = Awaited<ReturnType<typeof mcpServersRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersRetrieve<TData = Awaited<ReturnType<typeof mcpServersRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersRetrieve<TData = Awaited<ReturnType<typeof mcpServersRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get MCP server details
 */

export function useMcpServersRetrieve<TData = Awaited<ReturnType<typeof mcpServersRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates an existing MCP server configuration.
 * @summary Update MCP server
 */
export const mcpServersUpdate = (
  id: string,
  mCPServerConfigCreateUpdateRequest: MCPServerConfigCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<MCPServerConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigCreateUpdateRequest,
    signal,
  });
};

export const getMcpServersUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersUpdate>>,
    TError,
    { id: string; data: MCPServerConfigCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersUpdate>>,
  TError,
  { id: string; data: MCPServerConfigCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['mcpServersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersUpdate>>,
    { id: string; data: MCPServerConfigCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mcpServersUpdate>>>;
export type McpServersUpdateMutationBody = MCPServerConfigCreateUpdateRequest;
export type McpServersUpdateMutationError = void;

/**
 * @summary Update MCP server
 */
export const useMcpServersUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersUpdate>>,
      TError,
      { id: string; data: MCPServerConfigCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersUpdate>>,
  TError,
  { id: string; data: MCPServerConfigCreateUpdateRequest },
  TContext
> => {
  return useMutation(getMcpServersUpdateMutationOptions(options), queryClient);
};

/**
 * Partially updates an existing MCP server configuration.
 * @summary Partially update MCP server
 */
export const mcpServersPartialUpdate = (
  id: string,
  patchedMCPServerConfigCreateUpdateRequest?: PatchedMCPServerConfigCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<MCPServerConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedMCPServerConfigCreateUpdateRequest,
    signal,
  });
};

export const getMcpServersPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersPartialUpdate>>,
    TError,
    { id: string; data?: PatchedMCPServerConfigCreateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedMCPServerConfigCreateUpdateRequest },
  TContext
> => {
  const mutationKey = ['mcpServersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersPartialUpdate>>,
    { id: string; data?: PatchedMCPServerConfigCreateUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mcpServersPartialUpdate>>>;
export type McpServersPartialUpdateMutationBody = PatchedMCPServerConfigCreateUpdateRequest | undefined;
export type McpServersPartialUpdateMutationError = void;

/**
 * @summary Partially update MCP server
 */
export const useMcpServersPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersPartialUpdate>>,
      TError,
      { id: string; data?: PatchedMCPServerConfigCreateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedMCPServerConfigCreateUpdateRequest },
  TContext
> => {
  return useMutation(getMcpServersPartialUpdateMutationOptions(options), queryClient);
};

/**
 *
 *         Deletes an MCP server configuration.
 *
 *         Note: If this server is currently assigned to any agents, those agents will
 *         no longer have access to the tools from this server.
 * @summary Delete MCP server
 */
export const mcpServersDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getMcpServersDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof mcpServersDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof mcpServersDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['mcpServersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof mcpServersDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return mcpServersDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof mcpServersDestroy>>>;

export type McpServersDestroyMutationError = void;

/**
 * @summary Delete MCP server
 */
export const useMcpServersDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof mcpServersDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof mcpServersDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getMcpServersDestroyMutationOptions(options), queryClient);
};

/**
 *
 *         Connects to the MCP server and retrieves the list of available tools.
 *         This is useful for debugging and seeing what tools are exposed by the server.
 * @summary List available tools from MCP server
 */
export const mcpServersListToolsCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/list-tools/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersListToolsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersListToolsCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersListToolsCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersListToolsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersListToolsCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersListToolsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersListToolsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersListToolsCreate>>
>;
export type McpServersListToolsCreateMutationBody = MCPServerConfigRequest;
export type McpServersListToolsCreateMutationError = void;

/**
 * @summary List available tools from MCP server
 */
export const useMcpServersListToolsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersListToolsCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersListToolsCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersListToolsCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Automatically configures OAuth settings by discovering them from the MCP server.
 *
 *         This probes the server, discovers OAuth metadata, and saves the configuration.
 *         After this, you can start the OAuth flow with /oauth/start/.
 * @summary Auto-configure OAuth from discovery
 */
export const mcpServersOauthAutoConfigureCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/auto-configure/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersOauthAutoConfigureCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersOauthAutoConfigureCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersOauthAutoConfigureCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthAutoConfigureCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>
>;
export type McpServersOauthAutoConfigureCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthAutoConfigureCreateMutationError = void;

/**
 * @summary Auto-configure OAuth from discovery
 */
export const useMcpServersOauthAutoConfigureCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthAutoConfigureCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersOauthAutoConfigureCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Completes the OAuth2 authorization flow by exchanging the authorization code
 *         for access and refresh tokens.
 *
 *         This endpoint should be called after the user is redirected back from the
 *         OAuth provider with an authorization code.
 * @summary Complete OAuth2 authorization
 */
export const mcpServersOauthCallbackCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  params: McpServersOauthCallbackCreateParams,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/callback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    params,
    signal,
  });
};

export const getMcpServersOauthCallbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest; params: McpServersOauthCallbackCreateParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest; params: McpServersOauthCallbackCreateParams },
  TContext
> => {
  const mutationKey = ['mcpServersOauthCallbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>,
    { id: string; data: MCPServerConfigRequest; params: McpServersOauthCallbackCreateParams }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return mcpServersOauthCallbackCreate(id, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthCallbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>
>;
export type McpServersOauthCallbackCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthCallbackCreateMutationError = void;

/**
 * @summary Complete OAuth2 authorization
 */
export const useMcpServersOauthCallbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest; params: McpServersOauthCallbackCreateParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthCallbackCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest; params: McpServersOauthCallbackCreateParams },
  TContext
> => {
  return useMutation(getMcpServersOauthCallbackCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Disconnects the OAuth2 authorization by clearing all stored tokens.
 *
 *         The user will need to re-authorize to use this MCP server again.
 * @summary Disconnect OAuth2
 */
export const mcpServersOauthDisconnectCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/disconnect/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersOauthDisconnectCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersOauthDisconnectCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersOauthDisconnectCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthDisconnectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>
>;
export type McpServersOauthDisconnectCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthDisconnectCreateMutationError = unknown;

/**
 * @summary Disconnect OAuth2
 */
export const useMcpServersOauthDisconnectCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthDisconnectCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersOauthDisconnectCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Probes an MCP server to automatically discover its OAuth requirements.
 *
 *         This implements RFC 9728 (OAuth 2.0 Protected Resource Metadata) to
 *         automatically discover OAuth configuration from MCP servers.
 *
 *         If the server requires OAuth, returns the discovered configuration
 *         that can be used to set up the OAuth flow.
 * @summary Discover OAuth requirements
 */
export const mcpServersOauthDiscoverCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/discover/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersOauthDiscoverCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersOauthDiscoverCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersOauthDiscoverCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthDiscoverCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>
>;
export type McpServersOauthDiscoverCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthDiscoverCreateMutationError = unknown;

/**
 * @summary Discover OAuth requirements
 */
export const useMcpServersOauthDiscoverCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthDiscoverCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersOauthDiscoverCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Refreshes the OAuth2 access token using the stored refresh token.
 *
 *         This is called automatically when the access token is about to expire,
 *         but can also be called manually.
 * @summary Refresh OAuth2 access token
 */
export const mcpServersOauthRefreshCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/refresh/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersOauthRefreshCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersOauthRefreshCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersOauthRefreshCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthRefreshCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>
>;
export type McpServersOauthRefreshCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthRefreshCreateMutationError = void;

/**
 * @summary Refresh OAuth2 access token
 */
export const useMcpServersOauthRefreshCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthRefreshCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersOauthRefreshCreateMutationOptions(options), queryClient);
};

/**
 *
 *         Initiates the OAuth2 authorization flow for an MCP server.
 *
 *         Returns the authorization URL that the client should redirect to.
 *         After user authorizes, they will be redirected back to the callback URL
 *         with an authorization code.
 * @summary Start OAuth2 authorization flow
 */
export const mcpServersOauthStartCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/start/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersOauthStartCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersOauthStartCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersOauthStartCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersOauthStartCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersOauthStartCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersOauthStartCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersOauthStartCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthStartCreate>>
>;
export type McpServersOauthStartCreateMutationBody = MCPServerConfigRequest;
export type McpServersOauthStartCreateMutationError = void;

/**
 * @summary Start OAuth2 authorization flow
 */
export const useMcpServersOauthStartCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersOauthStartCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersOauthStartCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersOauthStartCreateMutationOptions(options), queryClient);
};

/**
 * Returns the current OAuth2 connection status for this MCP server.
 * @summary Get OAuth2 status
 */
export const mcpServersOauthStatusRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/status/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersOauthStatusRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/oauth/status/`] as const;
};

export const getMcpServersOauthStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersOauthStatusRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>> = ({ signal }) =>
    mcpServersOauthStatusRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersOauthStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>
>;
export type McpServersOauthStatusRetrieveQueryError = unknown;

export function useMcpServersOauthStatusRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersOauthStatusRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersOauthStatusRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get OAuth2 status
 */

export function useMcpServersOauthStatusRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersOauthStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersOauthStatusRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Encrypted per-connection request headers (for example Notion-Token on the shared Notion MCP server). Returns {header: {configured: bool}}; values are never returned.
 * @summary Secret header status
 */
export const mcpServersSecretHeadersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<McpServersSecretHeadersRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/secret-headers/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersSecretHeadersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/secret-headers/`] as const;
};

export const getMcpServersSecretHeadersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersSecretHeadersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>> = ({ signal }) =>
    mcpServersSecretHeadersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersSecretHeadersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>
>;
export type McpServersSecretHeadersRetrieveQueryError = unknown;

export function useMcpServersSecretHeadersRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersSecretHeadersRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersSecretHeadersRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Secret header status
 */

export function useMcpServersSecretHeadersRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSecretHeadersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersSecretHeadersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Body maps header names to values. A non-empty string stores the value encrypted; null or an empty string removes the header. Returns the same status shape as GET.
 * @summary Set or clear secret headers
 */
export const mcpServersSecretHeadersPartialUpdate = (
  id: string,
  mcpServersSecretHeadersPartialUpdateBody?:
    | McpServersSecretHeadersPartialUpdateBodyOne
    | McpServersSecretHeadersPartialUpdateBodyTwo
    | McpServersSecretHeadersPartialUpdateBodyThree,
  signal?: AbortSignal
) => {
  return customInstance<McpServersSecretHeadersPartialUpdate200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/secret-headers/`,
    method: 'PATCH',
    data: mcpServersSecretHeadersPartialUpdateBody,
    signal,
  });
};

export const getMcpServersSecretHeadersPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>,
    TError,
    {
      id: string;
      data?:
        | McpServersSecretHeadersPartialUpdateBodyOne
        | McpServersSecretHeadersPartialUpdateBodyTwo
        | McpServersSecretHeadersPartialUpdateBodyThree;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>,
  TError,
  {
    id: string;
    data?:
      | McpServersSecretHeadersPartialUpdateBodyOne
      | McpServersSecretHeadersPartialUpdateBodyTwo
      | McpServersSecretHeadersPartialUpdateBodyThree;
  },
  TContext
> => {
  const mutationKey = ['mcpServersSecretHeadersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>,
    {
      id: string;
      data?:
        | McpServersSecretHeadersPartialUpdateBodyOne
        | McpServersSecretHeadersPartialUpdateBodyTwo
        | McpServersSecretHeadersPartialUpdateBodyThree;
    }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersSecretHeadersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersSecretHeadersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>
>;
export type McpServersSecretHeadersPartialUpdateMutationBody =
  | McpServersSecretHeadersPartialUpdateBodyOne
  | McpServersSecretHeadersPartialUpdateBodyTwo
  | McpServersSecretHeadersPartialUpdateBodyThree
  | undefined;
export type McpServersSecretHeadersPartialUpdateMutationError = unknown;

/**
 * @summary Set or clear secret headers
 */
export const useMcpServersSecretHeadersPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>,
      TError,
      {
        id: string;
        data?:
          | McpServersSecretHeadersPartialUpdateBodyOne
          | McpServersSecretHeadersPartialUpdateBodyTwo
          | McpServersSecretHeadersPartialUpdateBodyThree;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersSecretHeadersPartialUpdate>>,
  TError,
  {
    id: string;
    data?:
      | McpServersSecretHeadersPartialUpdateBodyOne
      | McpServersSecretHeadersPartialUpdateBodyTwo
      | McpServersSecretHeadersPartialUpdateBodyThree;
  },
  TContext
> => {
  return useMutation(getMcpServersSecretHeadersPartialUpdateMutationOptions(options), queryClient);
};

/**
 *
 *         Tests the connection to an MCP server to verify it's accessible and properly configured.
 *
 *         This will attempt to connect to the server and list available tools.
 *         If OAuth2 authentication is required but not connected, returns oauth_required=true
 *         with the authorization URL.
 * @summary Test MCP server connection
 */
export const mcpServersTestConnectionCreate = (
  id: string,
  mCPServerConfigRequest: MCPServerConfigRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/${id}/test-connection/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mCPServerConfigRequest,
    signal,
  });
};

export const getMcpServersTestConnectionCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>,
    TError,
    { id: string; data: MCPServerConfigRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  const mutationKey = ['mcpServersTestConnectionCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>,
    { id: string; data: MCPServerConfigRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return mcpServersTestConnectionCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type McpServersTestConnectionCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>
>;
export type McpServersTestConnectionCreateMutationBody = MCPServerConfigRequest;
export type McpServersTestConnectionCreateMutationError = void;

/**
 * @summary Test MCP server connection
 */
export const useMcpServersTestConnectionCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>,
      TError,
      { id: string; data: MCPServerConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mcpServersTestConnectionCreate>>,
  TError,
  { id: string; data: MCPServerConfigRequest },
  TContext
> => {
  return useMutation(getMcpServersTestConnectionCreateMutationOptions(options), queryClient);
};

/**
 * Returns the available authentication types for MCP server configurations.
 * @summary Get authentication types
 */
export const mcpServersAuthTypesRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/auth-types/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersAuthTypesRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/auth-types/`] as const;
};

export const getMcpServersAuthTypesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersAuthTypesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>> = ({ signal }) =>
    mcpServersAuthTypesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersAuthTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>
>;
export type McpServersAuthTypesRetrieveQueryError = unknown;

export function useMcpServersAuthTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersAuthTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersAuthTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get authentication types
 */

export function useMcpServersAuthTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersAuthTypesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersAuthTypesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Preset ids whose hosted URL is replaced by this environment's self-hosted MCP server. Existing rows are rewritten in place by migration.
 * @summary Self-hosted MCP preset overrides
 */
export const mcpServersSelfHostedList = (signal?: AbortSignal) => {
  return customInstance<SelfHostedMCPPreset[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/self-hosted/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersSelfHostedListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/self-hosted/`] as const;
};

export const getMcpServersSelfHostedListQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSelfHostedList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersSelfHostedListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersSelfHostedList>>> = ({ signal }) =>
    mcpServersSelfHostedList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersSelfHostedListQueryResult = NonNullable<Awaited<ReturnType<typeof mcpServersSelfHostedList>>>;
export type McpServersSelfHostedListQueryError = unknown;

export function useMcpServersSelfHostedList<
  TData = Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSelfHostedList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
          TError,
          Awaited<ReturnType<typeof mcpServersSelfHostedList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersSelfHostedList<
  TData = Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSelfHostedList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
          TError,
          Awaited<ReturnType<typeof mcpServersSelfHostedList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersSelfHostedList<
  TData = Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSelfHostedList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Self-hosted MCP preset overrides
 */

export function useMcpServersSelfHostedList<
  TData = Awaited<ReturnType<typeof mcpServersSelfHostedList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersSelfHostedList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersSelfHostedListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the available transport types for MCP server configurations.
 * @summary Get transport types
 */
export const mcpServersTransportTypesRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/transport-types/`,
    method: 'GET',
    signal,
  });
};

export const getMcpServersTransportTypesRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/mcp/servers/transport-types/`] as const;
};

export const getMcpServersTransportTypesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMcpServersTransportTypesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>> = ({ signal }) =>
    mcpServersTransportTypesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type McpServersTransportTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>
>;
export type McpServersTransportTypesRetrieveQueryError = unknown;

export function useMcpServersTransportTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersTransportTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMcpServersTransportTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get transport types
 */

export function useMcpServersTransportTypesRetrieve<
  TData = Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mcpServersTransportTypesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMcpServersTransportTypesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List all memories in the workspace. Supports faceted provenance filters (AND across facets, OR within a facet). Multi-value facets accept repeated params or a comma-separated value.
 */
export const memoriesList = (params?: MemoriesListParams, signal?: AbortSignal) => {
  return customInstance<AgentMemoryList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMemoriesListQueryKey = (params?: MemoriesListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/memories/`, ...(params ? [params] : [])] as const;
};

export const getMemoriesListQueryOptions = <TData = Awaited<ReturnType<typeof memoriesList>>, TError = unknown>(
  params?: MemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMemoriesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof memoriesList>>> = ({ signal }) => memoriesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof memoriesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MemoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof memoriesList>>>;
export type MemoriesListQueryError = unknown;

export function useMemoriesList<TData = Awaited<ReturnType<typeof memoriesList>>, TError = unknown>(
  params: undefined | MemoriesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesList>>,
          TError,
          Awaited<ReturnType<typeof memoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesList<TData = Awaited<ReturnType<typeof memoriesList>>, TError = unknown>(
  params?: MemoriesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesList>>,
          TError,
          Awaited<ReturnType<typeof memoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesList<TData = Awaited<ReturnType<typeof memoriesList>>, TError = unknown>(
  params?: MemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMemoriesList<TData = Awaited<ReturnType<typeof memoriesList>>, TError = unknown>(
  params?: MemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMemoriesListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new agent memory with initial (draft) version.
 */
export const memoriesCreate = (agentMemoryCreateRequest: AgentMemoryCreateRequest, signal?: AbortSignal) => {
  return customInstance<AgentMemoryDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentMemoryCreateRequest,
    signal,
  });
};

export const getMemoriesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesCreate>>,
    TError,
    { data: AgentMemoryCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesCreate>>,
  TError,
  { data: AgentMemoryCreateRequest },
  TContext
> => {
  const mutationKey = ['memoriesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof memoriesCreate>>, { data: AgentMemoryCreateRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return memoriesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof memoriesCreate>>>;
export type MemoriesCreateMutationBody = AgentMemoryCreateRequest;
export type MemoriesCreateMutationError = unknown;

export const useMemoriesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesCreate>>,
      TError,
      { data: AgentMemoryCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesCreate>>,
  TError,
  { data: AgentMemoryCreateRequest },
  TContext
> => {
  return useMutation(getMemoriesCreateMutationOptions(options), queryClient);
};

/**
 * Get a memory with version history and linked agents.
 */
export const memoriesRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<AgentMemoryDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getMemoriesRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/`] as const;
};

export const getMemoriesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof memoriesRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMemoriesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof memoriesRetrieve>>> = ({ signal }) =>
    memoriesRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof memoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MemoriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof memoriesRetrieve>>>;
export type MemoriesRetrieveQueryError = unknown;

export function useMemoriesRetrieve<TData = Awaited<ReturnType<typeof memoriesRetrieve>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof memoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesRetrieve<TData = Awaited<ReturnType<typeof memoriesRetrieve>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof memoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesRetrieve<TData = Awaited<ReturnType<typeof memoriesRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMemoriesRetrieve<TData = Awaited<ReturnType<typeof memoriesRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMemoriesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update memory metadata (name, description, is_archived, is_global, global_is_important).
 */
export const memoriesPartialUpdate = (
  id: string,
  patchedAgentMemoryUpdateRequest?: PatchedAgentMemoryUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentMemoryDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentMemoryUpdateRequest,
    signal,
  });
};

export const getMemoriesPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesPartialUpdate>>,
    TError,
    { id: string; data?: PatchedAgentMemoryUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesPartialUpdate>>,
  TError,
  { id: string; data?: PatchedAgentMemoryUpdateRequest },
  TContext
> => {
  const mutationKey = ['memoriesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesPartialUpdate>>,
    { id: string; data?: PatchedAgentMemoryUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return memoriesPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof memoriesPartialUpdate>>>;
export type MemoriesPartialUpdateMutationBody = PatchedAgentMemoryUpdateRequest | undefined;
export type MemoriesPartialUpdateMutationError = unknown;

export const useMemoriesPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesPartialUpdate>>,
      TError,
      { id: string; data?: PatchedAgentMemoryUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesPartialUpdate>>,
  TError,
  { id: string; data?: PatchedAgentMemoryUpdateRequest },
  TContext
> => {
  return useMutation(getMemoriesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Workspace-level CRUD for ``AgentMemory``.
 *
 * Mirrors ``KnowledgeDocumentViewSet`` but adapted to the memory primitive:
 * no file upload, no extraction pipeline. Indexing in ES is gated on
 * ``is_finalised=True`` and happens on the ``finalise`` action. Like
 * documents, memories support an ``is_global`` / ``global_is_important``
 * tier toggled via ``partial_update``.
 *
 * list:
 *     List non-archived memories with version count + link count.
 *
 * create:
 *     Create a new memory + draft v1.
 *
 * retrieve:
 *     Get memory with full version history + linked agents.
 *
 * partial_update:
 *     Update memory metadata (name, description, is_archived, is_global,
 *     global_is_important).
 *
 * destroy:
 *     Hard-delete a memory, cascade versions & links, clean up ES.
 */
export const memoriesDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getMemoriesDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof memoriesDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof memoriesDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['memoriesDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof memoriesDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return memoriesDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof memoriesDestroy>>>;

export type MemoriesDestroyMutationError = unknown;

export const useMemoriesDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof memoriesDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof memoriesDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getMemoriesDestroyMutationOptions(options), queryClient);
};

/**
 * Propagate a memory version to selected agents. For each agent that already has this memory linked, swaps the linked version to the supplied version_id and bumps the agent version (PATCH, active, finalised — mirrors knowledge propagate).
 */
export const memoriesPropagateCreate = (
  id: string,
  agentMemoryPropagateRequest: AgentMemoryPropagateRequest,
  signal?: AbortSignal
) => {
  return customInstance<MemoriesPropagateCreate200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/propagate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentMemoryPropagateRequest,
    signal,
  });
};

export const getMemoriesPropagateCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesPropagateCreate>>,
    TError,
    { id: string; data: AgentMemoryPropagateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesPropagateCreate>>,
  TError,
  { id: string; data: AgentMemoryPropagateRequest },
  TContext
> => {
  const mutationKey = ['memoriesPropagateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesPropagateCreate>>,
    { id: string; data: AgentMemoryPropagateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return memoriesPropagateCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesPropagateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof memoriesPropagateCreate>>>;
export type MemoriesPropagateCreateMutationBody = AgentMemoryPropagateRequest;
export type MemoriesPropagateCreateMutationError = unknown;

export const useMemoriesPropagateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesPropagateCreate>>,
      TError,
      { id: string; data: AgentMemoryPropagateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesPropagateCreate>>,
  TError,
  { id: string; data: AgentMemoryPropagateRequest },
  TContext
> => {
  return useMutation(getMemoriesPropagateCreateMutationOptions(options), queryClient);
};

/**
 * Append a new draft version to a memory.
 */
export const memoriesVersionsCreate = (
  id: string,
  agentMemoryVersionCreateRequest: AgentMemoryVersionCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentMemoryVersion>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentMemoryVersionCreateRequest,
    signal,
  });
};

export const getMemoriesVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesVersionsCreate>>,
    TError,
    { id: string; data: AgentMemoryVersionCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesVersionsCreate>>,
  TError,
  { id: string; data: AgentMemoryVersionCreateRequest },
  TContext
> => {
  const mutationKey = ['memoriesVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesVersionsCreate>>,
    { id: string; data: AgentMemoryVersionCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return memoriesVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesVersionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof memoriesVersionsCreate>>>;
export type MemoriesVersionsCreateMutationBody = AgentMemoryVersionCreateRequest;
export type MemoriesVersionsCreateMutationError = unknown;

export const useMemoriesVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesVersionsCreate>>,
      TError,
      { id: string; data: AgentMemoryVersionCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesVersionsCreate>>,
  TError,
  { id: string; data: AgentMemoryVersionCreateRequest },
  TContext
> => {
  return useMutation(getMemoriesVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Edit a draft version's content in place. Refuses finalised versions (those are immutable — POST a new version instead). Drafts are not indexed in ES, so there is no reindex side-effect.
 */
export const memoriesVersionsPartialUpdate = (
  id: string,
  versionId: string,
  patchedAgentMemoryVersionUpdateRequest?: PatchedAgentMemoryVersionUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentMemoryVersion>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/${versionId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentMemoryVersionUpdateRequest,
    signal,
  });
};

export const getMemoriesVersionsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>,
    TError,
    { id: string; versionId: string; data?: PatchedAgentMemoryVersionUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>,
  TError,
  { id: string; versionId: string; data?: PatchedAgentMemoryVersionUpdateRequest },
  TContext
> => {
  const mutationKey = ['memoriesVersionsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>,
    { id: string; versionId: string; data?: PatchedAgentMemoryVersionUpdateRequest }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return memoriesVersionsPartialUpdate(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesVersionsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>
>;
export type MemoriesVersionsPartialUpdateMutationBody = PatchedAgentMemoryVersionUpdateRequest | undefined;
export type MemoriesVersionsPartialUpdateMutationError = unknown;

export const useMemoriesVersionsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>,
      TError,
      { id: string; versionId: string; data?: PatchedAgentMemoryVersionUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesVersionsPartialUpdate>>,
  TError,
  { id: string; versionId: string; data?: PatchedAgentMemoryVersionUpdateRequest },
  TContext
> => {
  return useMutation(getMemoriesVersionsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Finalise a draft version. Flips ``is_finalised=True`` and triggers ES indexing so the chunks become RAG-eligible.
 */
export const memoriesVersionsFinaliseCreate = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<AgentMemoryVersion>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/${versionId}/finalise/`,
    method: 'POST',
    signal,
  });
};

export const getMemoriesVersionsFinaliseCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['memoriesVersionsFinaliseCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return memoriesVersionsFinaliseCreate(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesVersionsFinaliseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>
>;

export type MemoriesVersionsFinaliseCreateMutationError = unknown;

export const useMemoriesVersionsFinaliseCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesVersionsFinaliseCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getMemoriesVersionsFinaliseCreateMutationOptions(options), queryClient);
};

/**
 * Set a specific version as the current version (no ES side-effect).
 */
export const memoriesVersionsSetCurrentCreate = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<AgentMemoryDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/${versionId}/set-current/`,
    method: 'POST',
    signal,
  });
};

export const getMemoriesVersionsSetCurrentCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['memoriesVersionsSetCurrentCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return memoriesVersionsSetCurrentCreate(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemoriesVersionsSetCurrentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>
>;

export type MemoriesVersionsSetCurrentCreateMutationError = unknown;

export const useMemoriesVersionsSetCurrentCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof memoriesVersionsSetCurrentCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getMemoriesVersionsSetCurrentCreateMutationOptions(options), queryClient);
};

/**
 * List all versions of a memory.
 */
export const memoriesVersionsListList = (id: string, signal?: AbortSignal) => {
  return customInstance<AgentMemoryVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/list/`,
    method: 'GET',
    signal,
  });
};

export const getMemoriesVersionsListListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/memories/${id}/versions/list/`] as const;
};

export const getMemoriesVersionsListListQueryOptions = <
  TData = Awaited<ReturnType<typeof memoriesVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesVersionsListList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMemoriesVersionsListListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof memoriesVersionsListList>>> = ({ signal }) =>
    memoriesVersionsListList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof memoriesVersionsListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MemoriesVersionsListListQueryResult = NonNullable<Awaited<ReturnType<typeof memoriesVersionsListList>>>;
export type MemoriesVersionsListListQueryError = unknown;

export function useMemoriesVersionsListList<
  TData = Awaited<ReturnType<typeof memoriesVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesVersionsListList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesVersionsListList>>,
          TError,
          Awaited<ReturnType<typeof memoriesVersionsListList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesVersionsListList<
  TData = Awaited<ReturnType<typeof memoriesVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesVersionsListList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesVersionsListList>>,
          TError,
          Awaited<ReturnType<typeof memoriesVersionsListList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesVersionsListList<
  TData = Awaited<ReturnType<typeof memoriesVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesVersionsListList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMemoriesVersionsListList<
  TData = Awaited<ReturnType<typeof memoriesVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesVersionsListList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMemoriesVersionsListListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Distinct facet values that appear across the workspace's memory versions, for populating the library filter dropdowns: channels, triggering users, and approvers. Respects ``show_archived``.
 */
export const memoriesFilterOptionsRetrieve = (params?: MemoriesFilterOptionsRetrieveParams, signal?: AbortSignal) => {
  return customInstance<MemoriesFilterOptionsRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/memories/filter-options/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMemoriesFilterOptionsRetrieveQueryKey = (params?: MemoriesFilterOptionsRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/memories/filter-options/`, ...(params ? [params] : [])] as const;
};

export const getMemoriesFilterOptionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
  TError = unknown,
>(
  params?: MemoriesFilterOptionsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMemoriesFilterOptionsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>> = ({ signal }) =>
    memoriesFilterOptionsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MemoriesFilterOptionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>
>;
export type MemoriesFilterOptionsRetrieveQueryError = unknown;

export function useMemoriesFilterOptionsRetrieve<
  TData = Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
  TError = unknown,
>(
  params: undefined | MemoriesFilterOptionsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesFilterOptionsRetrieve<
  TData = Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
  TError = unknown,
>(
  params?: MemoriesFilterOptionsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemoriesFilterOptionsRetrieve<
  TData = Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
  TError = unknown,
>(
  params?: MemoriesFilterOptionsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMemoriesFilterOptionsRetrieve<
  TData = Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>,
  TError = unknown,
>(
  params?: MemoriesFilterOptionsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof memoriesFilterOptionsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMemoriesFilterOptionsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * POST: dismiss a pending review without approving its draft. Admin only.
 */
export const optimisationReviewsDismissCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/optimisation/reviews/${id}/dismiss/`,
    method: 'POST',
    signal,
  });
};

export const getOptimisationReviewsDismissCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['optimisationReviewsDismissCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return optimisationReviewsDismissCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type OptimisationReviewsDismissCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>
>;

export type OptimisationReviewsDismissCreateMutationError = unknown;

export const useOptimisationReviewsDismissCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof optimisationReviewsDismissCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getOptimisationReviewsDismissCreateMutationOptions(options), queryClient);
};

/**
 * GET: one review for the review page (header + room). Admin only.
 */
export const optimisationReviewsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<OptimisationReviewDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/optimisation/reviews/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getOptimisationReviewsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/optimisation/reviews/${id}/`] as const;
};

export const getOptimisationReviewsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOptimisationReviewsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>> = ({ signal }) =>
    optimisationReviewsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OptimisationReviewsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof optimisationReviewsRetrieve>>
>;
export type OptimisationReviewsRetrieveQueryError = unknown;

export function useOptimisationReviewsRetrieve<
  TData = Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof optimisationReviewsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationReviewsRetrieve<
  TData = Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof optimisationReviewsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationReviewsRetrieve<
  TData = Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useOptimisationReviewsRetrieve<
  TData = Awaited<ReturnType<typeof optimisationReviewsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOptimisationReviewsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * GET: actionable pending reviews for the Teammate Studio inbox. Admin only.
 */
export const optimisationReviewsPendingList = (signal?: AbortSignal) => {
  return customInstance<OptimisationReview[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/optimisation/reviews/pending/`,
    method: 'GET',
    signal,
  });
};

export const getOptimisationReviewsPendingListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/optimisation/reviews/pending/`] as const;
};

export const getOptimisationReviewsPendingListQueryOptions = <
  TData = Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsPendingList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOptimisationReviewsPendingListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof optimisationReviewsPendingList>>> = ({ signal }) =>
    optimisationReviewsPendingList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OptimisationReviewsPendingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof optimisationReviewsPendingList>>
>;
export type OptimisationReviewsPendingListQueryError = unknown;

export function useOptimisationReviewsPendingList<
  TData = Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsPendingList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof optimisationReviewsPendingList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationReviewsPendingList<
  TData = Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsPendingList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof optimisationReviewsPendingList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationReviewsPendingList<
  TData = Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsPendingList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useOptimisationReviewsPendingList<
  TData = Awaited<ReturnType<typeof optimisationReviewsPendingList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationReviewsPendingList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOptimisationReviewsPendingListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * GET: run history for audit/debugging (not the inbox). Admin only.
 */
export const optimisationRunsList = (signal?: AbortSignal) => {
  return customInstance<OptimisationRun[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/optimisation/runs/`,
    method: 'GET',
    signal,
  });
};

export const getOptimisationRunsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/optimisation/runs/`] as const;
};

export const getOptimisationRunsListQueryOptions = <
  TData = Awaited<ReturnType<typeof optimisationRunsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationRunsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOptimisationRunsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof optimisationRunsList>>> = ({ signal }) =>
    optimisationRunsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof optimisationRunsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OptimisationRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof optimisationRunsList>>>;
export type OptimisationRunsListQueryError = unknown;

export function useOptimisationRunsList<TData = Awaited<ReturnType<typeof optimisationRunsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationRunsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationRunsList>>,
          TError,
          Awaited<ReturnType<typeof optimisationRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationRunsList<TData = Awaited<ReturnType<typeof optimisationRunsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationRunsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationRunsList>>,
          TError,
          Awaited<ReturnType<typeof optimisationRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationRunsList<TData = Awaited<ReturnType<typeof optimisationRunsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useOptimisationRunsList<TData = Awaited<ReturnType<typeof optimisationRunsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOptimisationRunsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * GET per-teammate optimisation scheduler state. Admin only.
 */
export const optimisationTeammatesScheduleRetrieve = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/optimisation/teammates/${agentId}/schedule/`,
    method: 'GET',
    signal,
  });
};

export const getOptimisationTeammatesScheduleRetrieveQueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/optimisation/teammates/${agentId}/schedule/`] as const;
};

export const getOptimisationTeammatesScheduleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOptimisationTeammatesScheduleRetrieveQueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>> = ({ signal }) =>
    optimisationTeammatesScheduleRetrieve(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OptimisationTeammatesScheduleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>
>;
export type OptimisationTeammatesScheduleRetrieveQueryError = unknown;

export function useOptimisationTeammatesScheduleRetrieve<
  TData = Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationTeammatesScheduleRetrieve<
  TData = Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOptimisationTeammatesScheduleRetrieve<
  TData = Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useOptimisationTeammatesScheduleRetrieve<
  TData = Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof optimisationTeammatesScheduleRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOptimisationTeammatesScheduleRetrieveQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a list of public agents shared across all tenants. Only accessible in public schema.
 * @summary List Public Agents
 */
export const listPublicAgents = (params?: ListPublicAgentsParams, signal?: AbortSignal) => {
  return customInstance<AgentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListPublicAgentsQueryKey = (params?: ListPublicAgentsParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/`, ...(params ? [params] : [])] as const;
};

export const getListPublicAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listPublicAgents>>, TError = void>(
  params?: ListPublicAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPublicAgents>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPublicAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicAgents>>> = ({ signal }) =>
    listPublicAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPublicAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPublicAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicAgents>>>;
export type ListPublicAgentsQueryError = void;

export function useListPublicAgents<TData = Awaited<ReturnType<typeof listPublicAgents>>, TError = void>(
  params: undefined | ListPublicAgentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPublicAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPublicAgents>>,
          TError,
          Awaited<ReturnType<typeof listPublicAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPublicAgents<TData = Awaited<ReturnType<typeof listPublicAgents>>, TError = void>(
  params?: ListPublicAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPublicAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPublicAgents>>,
          TError,
          Awaited<ReturnType<typeof listPublicAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPublicAgents<TData = Awaited<ReturnType<typeof listPublicAgents>>, TError = void>(
  params?: ListPublicAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPublicAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Public Agents
 */

export function useListPublicAgents<TData = Awaited<ReturnType<typeof listPublicAgents>>, TError = void>(
  params?: ListPublicAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPublicAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPublicAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a list of public agents shared across all tenants. Only accessible in public schema.
 * @summary List Public Agents
 */
export const listPublicAgents2 = (
  agentRequest?: AgentRequest,
  params?: ListPublicAgents2Params,
  signal?: AbortSignal
) => {
  return customInstance<AgentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentRequest,
    params,
    signal,
  });
};

export const getListPublicAgents2MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listPublicAgents2>>,
    TError,
    { data?: AgentRequest; params?: ListPublicAgents2Params },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listPublicAgents2>>,
  TError,
  { data?: AgentRequest; params?: ListPublicAgents2Params },
  TContext
> => {
  const mutationKey = ['listPublicAgents2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listPublicAgents2>>,
    { data?: AgentRequest; params?: ListPublicAgents2Params }
  > = (props) => {
    const { data, params } = props ?? {};

    return listPublicAgents2(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListPublicAgents2MutationResult = NonNullable<Awaited<ReturnType<typeof listPublicAgents2>>>;
export type ListPublicAgents2MutationBody = AgentRequest | undefined;
export type ListPublicAgents2MutationError = void;

/**
 * @summary List Public Agents
 */
export const useListPublicAgents2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listPublicAgents2>>,
      TError,
      { data?: AgentRequest; params?: ListPublicAgents2Params },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listPublicAgents2>>,
  TError,
  { data?: AgentRequest; params?: ListPublicAgents2Params },
  TContext
> => {
  return useMutation(getListPublicAgents2MutationOptions(options), queryClient);
};

/**
 * Knowledge documents for public agents, sourced from the vigilantai tenant schema.
 *
 * GET  – list documents attached to the active (or specified) version.
 * POST – validate that a vigilantai document exists and return its file metadata
 *        (the actual link is created by the version serializer on Save).
 *
 * Permissions mirror other public agent views: authenticated users may read,
 * only vigilantai admins may write (POST).
 */
export const publicKnowledgeRetrieve = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/knowledge/`,
    method: 'GET',
    signal,
  });
};

export const getPublicKnowledgeRetrieveQueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/knowledge/`] as const;
};

export const getPublicKnowledgeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPublicKnowledgeRetrieveQueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>> = ({ signal }) =>
    publicKnowledgeRetrieve(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PublicKnowledgeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>>;
export type PublicKnowledgeRetrieveQueryError = unknown;

export function usePublicKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePublicKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof publicKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPublicKnowledgeRetrieveQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Knowledge documents for public agents, sourced from the vigilantai tenant schema.
 *
 * GET  – list documents attached to the active (or specified) version.
 * POST – validate that a vigilantai document exists and return its file metadata
 *        (the actual link is created by the version serializer on Save).
 *
 * Permissions mirror other public agent views: authenticated users may read,
 * only vigilantai admins may write (POST).
 */
export const publicKnowledgeCreate = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/knowledge/`,
    method: 'POST',
    signal,
  });
};

export const getPublicKnowledgeCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicKnowledgeCreate>>,
    TError,
    { agentId: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof publicKnowledgeCreate>>, TError, { agentId: string }, TContext> => {
  const mutationKey = ['publicKnowledgeCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicKnowledgeCreate>>, { agentId: string }> = (
    props
  ) => {
    const { agentId } = props ?? {};

    return publicKnowledgeCreate(agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicKnowledgeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicKnowledgeCreate>>>;

export type PublicKnowledgeCreateMutationError = unknown;

export const usePublicKnowledgeCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicKnowledgeCreate>>,
      TError,
      { agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof publicKnowledgeCreate>>, TError, { agentId: string }, TContext> => {
  return useMutation(getPublicKnowledgeCreateMutationOptions(options), queryClient);
};

/**
 * No-op endpoints matching the tenant pattern (link management is via version serializer).
 */
export const publicKnowledgePartialUpdate = (agentId: string, linkId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/knowledge/${linkId}/`,
    method: 'PATCH',
    signal,
  });
};

export const getPublicKnowledgePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>,
    TError,
    { agentId: string; linkId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  const mutationKey = ['publicKnowledgePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>,
    { agentId: string; linkId: string }
  > = (props) => {
    const { agentId, linkId } = props ?? {};

    return publicKnowledgePartialUpdate(agentId, linkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicKnowledgePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>
>;

export type PublicKnowledgePartialUpdateMutationError = unknown;

export const usePublicKnowledgePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>,
      TError,
      { agentId: string; linkId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicKnowledgePartialUpdate>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  return useMutation(getPublicKnowledgePartialUpdateMutationOptions(options), queryClient);
};

/**
 * No-op endpoints matching the tenant pattern (link management is via version serializer).
 */
export const publicKnowledgeDestroy = (agentId: string, linkId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/knowledge/${linkId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getPublicKnowledgeDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicKnowledgeDestroy>>,
    TError,
    { agentId: string; linkId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicKnowledgeDestroy>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  const mutationKey = ['publicKnowledgeDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicKnowledgeDestroy>>,
    { agentId: string; linkId: string }
  > = (props) => {
    const { agentId, linkId } = props ?? {};

    return publicKnowledgeDestroy(agentId, linkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicKnowledgeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof publicKnowledgeDestroy>>>;

export type PublicKnowledgeDestroyMutationError = unknown;

export const usePublicKnowledgeDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicKnowledgeDestroy>>,
      TError,
      { agentId: string; linkId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicKnowledgeDestroy>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  return useMutation(getPublicKnowledgeDestroyMutationOptions(options), queryClient);
};

/**
 * Retrieve all versions for a specific agent.
 * @summary List Agent Versions
 */
export const listAgentVersions = (agentId: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getListAgentVersionsQueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/`] as const;
};

export const getListAgentVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentVersions>>, TError = void>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentVersionsQueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentVersions>>> = ({ signal }) =>
    listAgentVersions(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentVersions>>>;
export type ListAgentVersionsQueryError = void;

export function useListAgentVersions<TData = Awaited<ReturnType<typeof listAgentVersions>>, TError = void>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof listAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentVersions<TData = Awaited<ReturnType<typeof listAgentVersions>>, TError = void>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof listAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentVersions<TData = Awaited<ReturnType<typeof listAgentVersions>>, TError = void>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Agent Versions
 */

export function useListAgentVersions<TData = Awaited<ReturnType<typeof listAgentVersions>>, TError = void>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentVersionsQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve all versions for a specific agent.
 * @summary List Agent Versions
 */
export const listAgentVersions2 = (agentId: string, agentVersionRequest: AgentVersionRequest, signal?: AbortSignal) => {
  return customInstance<AgentVersionList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentVersionRequest,
    signal,
  });
};

export const getListAgentVersions2MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAgentVersions2>>,
    TError,
    { agentId: string; data: AgentVersionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAgentVersions2>>,
  TError,
  { agentId: string; data: AgentVersionRequest },
  TContext
> => {
  const mutationKey = ['listAgentVersions2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAgentVersions2>>,
    { agentId: string; data: AgentVersionRequest }
  > = (props) => {
    const { agentId, data } = props ?? {};

    return listAgentVersions2(agentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAgentVersions2MutationResult = NonNullable<Awaited<ReturnType<typeof listAgentVersions2>>>;
export type ListAgentVersions2MutationBody = AgentVersionRequest;
export type ListAgentVersions2MutationError = void;

/**
 * @summary List Agent Versions
 */
export const useListAgentVersions2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAgentVersions2>>,
      TError,
      { agentId: string; data: AgentVersionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAgentVersions2>>,
  TError,
  { agentId: string; data: AgentVersionRequest },
  TContext
> => {
  return useMutation(getListAgentVersions2MutationOptions(options), queryClient);
};

/**
 * Activate a specific version of an agent.
 * @summary Activate Agent Version
 */
export const activateAgentVersion2 = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionActivate>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${id}/activate/`,
    method: 'PUT',
    signal,
  });
};

export const getActivateAgentVersion2MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAgentVersion2>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAgentVersion2>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['activateAgentVersion2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAgentVersion2>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return activateAgentVersion2(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAgentVersion2MutationResult = NonNullable<Awaited<ReturnType<typeof activateAgentVersion2>>>;

export type ActivateAgentVersion2MutationError = void;

/**
 * @summary Activate Agent Version
 */
export const useActivateAgentVersion2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateAgentVersion2>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateAgentVersion2>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getActivateAgentVersion2MutationOptions(options), queryClient);
};

/**
 * Activate a specific version of an agent.
 * @summary Activate Agent Version
 */
export const activateAgentVersion = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionActivate>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${id}/activate/`,
    method: 'PATCH',
    signal,
  });
};

export const getActivateAgentVersionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAgentVersion>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAgentVersion>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['activateAgentVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAgentVersion>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return activateAgentVersion(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAgentVersionMutationResult = NonNullable<Awaited<ReturnType<typeof activateAgentVersion>>>;

export type ActivateAgentVersionMutationError = void;

/**
 * @summary Activate Agent Version
 */
export const useActivateAgentVersion = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateAgentVersion>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateAgentVersion>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getActivateAgentVersionMutationOptions(options), queryClient);
};

/**
 * PATCH: Finalise (approve) a proposed version of a PUBLIC (global) agent —
 * sets is_finalised=True and activates it.
 *
 * Mirror of ``TenantAgentVersionFinaliseView`` for agents that live in the
 * public schema. Until this endpoint existed, the Studio's Approve action
 * had nowhere to go for global teammates: the tenant finalise route filters
 * ``agent__is_public=False`` and runs in the tenant schema, so it 404'd with
 * "Agent version not found" for every public draft (VIG-1329).
 *
 * The tenant-only review machinery (review decisions, memory/knowledge
 * sync) is intentionally absent here: public agents carry attachments via
 * ``attachment_metadata`` and have no memory primitive.
 */
export const publicVersionsFinalisePartialUpdate = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${id}/finalise/`,
    method: 'PATCH',
    signal,
  });
};

export const getPublicVersionsFinalisePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['publicVersionsFinalisePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return publicVersionsFinalisePartialUpdate(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicVersionsFinalisePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>
>;

export type PublicVersionsFinalisePartialUpdateMutationError = unknown;

export const usePublicVersionsFinalisePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicVersionsFinalisePartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getPublicVersionsFinalisePartialUpdateMutationOptions(options), queryClient);
};

/**
 * PATCH: Mark a pending draft of a PUBLIC agent as rejected.
 *
 * Mirror of ``TenantAgentVersionRejectView`` — gives reviewers a way to
 * dismiss a stale/unwanted draft on a global teammate so it stops showing
 * as "Draft pending". The version row is kept for audit.
 */
export const publicVersionsRejectPartialUpdate = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${id}/reject/`,
    method: 'PATCH',
    signal,
  });
};

export const getPublicVersionsRejectPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['publicVersionsRejectPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return publicVersionsRejectPartialUpdate(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicVersionsRejectPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>
>;

export type PublicVersionsRejectPartialUpdateMutationError = unknown;

export const usePublicVersionsRejectPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicVersionsRejectPartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getPublicVersionsRejectPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve all comments for a specific agent version.
 * @summary List Agent Comments
 */
export const listAgentComments = (agentId: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<AgentCommentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/`,
    method: 'GET',
    signal,
  });
};

export const getListAgentCommentsQueryKey = (agentId: string, versionId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/`] as const;
};

export const getListAgentCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentComments>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentCommentsQueryKey(agentId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentComments>>> = ({ signal }) =>
    listAgentComments(agentId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListAgentCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentComments>>>;
export type ListAgentCommentsQueryError = void;

export function useListAgentComments<TData = Awaited<ReturnType<typeof listAgentComments>>, TError = void>(
  agentId: string,
  versionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentComments>>,
          TError,
          Awaited<ReturnType<typeof listAgentComments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentComments<TData = Awaited<ReturnType<typeof listAgentComments>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentComments>>,
          TError,
          Awaited<ReturnType<typeof listAgentComments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentComments<TData = Awaited<ReturnType<typeof listAgentComments>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Agent Comments
 */

export function useListAgentComments<TData = Awaited<ReturnType<typeof listAgentComments>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentCommentsQueryOptions(agentId, versionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve all comments for a specific agent version.
 * @summary List Agent Comments
 */
export const listAgentComments2 = (
  agentId: string,
  versionId: string,
  agentCommentRequest: AgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentCommentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentCommentRequest,
    signal,
  });
};

export const getListAgentComments2MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAgentComments2>>,
    TError,
    { agentId: string; versionId: string; data: AgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAgentComments2>>,
  TError,
  { agentId: string; versionId: string; data: AgentCommentRequest },
  TContext
> => {
  const mutationKey = ['listAgentComments2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAgentComments2>>,
    { agentId: string; versionId: string; data: AgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, data } = props ?? {};

    return listAgentComments2(agentId, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAgentComments2MutationResult = NonNullable<Awaited<ReturnType<typeof listAgentComments2>>>;
export type ListAgentComments2MutationBody = AgentCommentRequest;
export type ListAgentComments2MutationError = void;

/**
 * @summary List Agent Comments
 */
export const useListAgentComments2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAgentComments2>>,
      TError,
      { agentId: string; versionId: string; data: AgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAgentComments2>>,
  TError,
  { agentId: string; versionId: string; data: AgentCommentRequest },
  TContext
> => {
  return useMutation(getListAgentComments2MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment2 = (agentId: string, versionId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGetAgentComment2QueryKey = (agentId: string, versionId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/${id}/`] as const;
};

export const getGetAgentComment2QueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentComment2>>,
  TError = NotFoundResponse,
>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentComment2QueryKey(agentId, versionId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentComment2>>> = ({ signal }) =>
    getAgentComment2(agentId, versionId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      agentId !== null &&
      agentId !== undefined &&
      versionId !== null &&
      versionId !== undefined &&
      id !== null &&
      id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAgentComment2QueryResult = NonNullable<Awaited<ReturnType<typeof getAgentComment2>>>;
export type GetAgentComment2QueryError = NotFoundResponse;

export function useGetAgentComment2<TData = Awaited<ReturnType<typeof getAgentComment2>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentComment2>>,
          TError,
          Awaited<ReturnType<typeof getAgentComment2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentComment2<TData = Awaited<ReturnType<typeof getAgentComment2>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentComment2>>,
          TError,
          Awaited<ReturnType<typeof getAgentComment2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentComment2<TData = Awaited<ReturnType<typeof getAgentComment2>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Agent Comment
 */

export function useGetAgentComment2<TData = Awaited<ReturnType<typeof getAgentComment2>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgentComment2QueryOptions(agentId, versionId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment4 = (
  agentId: string,
  versionId: string,
  id: string,
  agentCommentRequest: AgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: agentCommentRequest,
    signal,
  });
};

export const getGetAgentComment4MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment4>>,
    TError,
    { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment4>>,
  TError,
  { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
  TContext
> => {
  const mutationKey = ['getAgentComment4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment4>>,
    { agentId: string; versionId: string; id: string; data: AgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, id, data } = props ?? {};

    return getAgentComment4(agentId, versionId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentComment4MutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment4>>>;
export type GetAgentComment4MutationBody = AgentCommentRequest;
export type GetAgentComment4MutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment4 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment4>>,
      TError,
      { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment4>>,
  TError,
  { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
  TContext
> => {
  return useMutation(getGetAgentComment4MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment3 = (
  agentId: string,
  versionId: string,
  id: string,
  patchedAgentCommentRequest?: PatchedAgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentCommentRequest,
    signal,
  });
};

export const getGetAgentComment3MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment3>>,
    TError,
    { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment3>>,
  TError,
  { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
  TContext
> => {
  const mutationKey = ['getAgentComment3'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment3>>,
    { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, id, data } = props ?? {};

    return getAgentComment3(agentId, versionId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentComment3MutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment3>>>;
export type GetAgentComment3MutationBody = PatchedAgentCommentRequest | undefined;
export type GetAgentComment3MutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment3 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment3>>,
      TError,
      { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment3>>,
  TError,
  { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
  TContext
> => {
  return useMutation(getGetAgentComment3MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment = (agentId: string, versionId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGetAgentCommentMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment>>,
    TError,
    { agentId: string; versionId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment>>,
  TError,
  { agentId: string; versionId: string; id: string },
  TContext
> => {
  const mutationKey = ['getAgentComment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment>>,
    { agentId: string; versionId: string; id: string }
  > = (props) => {
    const { agentId, versionId, id } = props ?? {};

    return getAgentComment(agentId, versionId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentCommentMutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment>>>;

export type GetAgentCommentMutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment>>,
      TError,
      { agentId: string; versionId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment>>,
  TError,
  { agentId: string; versionId: string; id: string },
  TContext
> => {
  return useMutation(getGetAgentCommentMutationOptions(options), queryClient);
};

/**
 * No-op for public-agent training-debt dismissal.
 *
 * Mirrors the deferred-save pattern used by ``PublicAgentKnowledgeDetailView``
 * and the tenant ``AgentKnowledgeDetailView``: the editor tracks the
 * dismissal in local state and the change is committed only when the user
 * saves a new version. Mutating the active version's ``training_debt`` in
 * place would silently rewrite shared agent state and bypass version
 * history — strictly worse on a public (shared) agent than a tenant one.
 */
export const publicVersionsTrainingDebtDestroy = (
  agentId: string,
  versionId: string,
  debtId: string,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/training-debt/${debtId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getPublicVersionsTrainingDebtDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>,
    TError,
    { agentId: string; versionId: string; debtId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  const mutationKey = ['publicVersionsTrainingDebtDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>,
    { agentId: string; versionId: string; debtId: string }
  > = (props) => {
    const { agentId, versionId, debtId } = props ?? {};

    return publicVersionsTrainingDebtDestroy(agentId, versionId, debtId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicVersionsTrainingDebtDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>
>;

export type PublicVersionsTrainingDebtDestroyMutationError = unknown;

export const usePublicVersionsTrainingDebtDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>,
      TError,
      { agentId: string; versionId: string; debtId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtDestroy>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  return useMutation(getPublicVersionsTrainingDebtDestroyMutationOptions(options), queryClient);
};

/**
 * Public-agent counterpart to ``TrainingDebtFulfillView`` with the
 * deferred-save semantics every other public-agent editor action uses.
 *
 * The uploaded file is a real, persistent resource so it MUST be written
 * immediately: we create the ``UploadedFile`` + ``KnowledgeDocument`` +
 * ``KnowledgeDocumentVersion`` rows in the ``vigilantai`` schema (so the
 * file shows up in the workspace knowledge library, can be re-used, etc.).
 *
 * What we do NOT do here — by deliberate contrast to the legacy tenant
 * flow — is mutate the public agent's active version. Touching
 * ``attachment_metadata`` or ``training_debt`` directly would silently
 * rewrite the currently-live, shared agent state before the editor has
 * even clicked Save Version. Instead, the response includes the new file
 * metadata + the original ``debt_id``; the editor stages both in local
 * state and lets the next ``POST /versions/`` carry them through, which
 * keeps version history clean and consistent with how attachment
 * add/remove already works.
 */
export const publicVersionsTrainingDebtFulfillCreate = (
  agentId: string,
  versionId: string,
  debtId: string,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/${versionId}/training-debt/${debtId}/fulfill/`,
    method: 'POST',
    signal,
  });
};

export const getPublicVersionsTrainingDebtFulfillCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>,
    TError,
    { agentId: string; versionId: string; debtId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  const mutationKey = ['publicVersionsTrainingDebtFulfillCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>,
    { agentId: string; versionId: string; debtId: string }
  > = (props) => {
    const { agentId, versionId, debtId } = props ?? {};

    return publicVersionsTrainingDebtFulfillCreate(agentId, versionId, debtId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicVersionsTrainingDebtFulfillCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>
>;

export type PublicVersionsTrainingDebtFulfillCreateMutationError = unknown;

export const usePublicVersionsTrainingDebtFulfillCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>,
      TError,
      { agentId: string; versionId: string; debtId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publicVersionsTrainingDebtFulfillCreate>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  return useMutation(getPublicVersionsTrainingDebtFulfillCreateMutationOptions(options), queryClient);
};

/**
 * Structured diff between two versions of a public agent (sections, documents, memories, tools, workers).
 * @summary Compare Public Agent Versions
 */
export const comparePublicAgentVersions = (
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  signal?: AbortSignal
) => {
  return customInstance<AgentVersionCompareResponse>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getComparePublicAgentVersionsQueryKey = (agentId: string, params?: ComparePublicAgentVersionsParams) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/public/${agentId}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getComparePublicAgentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof comparePublicAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePublicAgentVersions>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getComparePublicAgentVersionsQueryKey(agentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof comparePublicAgentVersions>>> = ({ signal }) =>
    comparePublicAgentVersions(agentId, params, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof comparePublicAgentVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ComparePublicAgentVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof comparePublicAgentVersions>>>;
export type ComparePublicAgentVersionsQueryError = BadRequestResponse | void;

export function useComparePublicAgentVersions<
  TData = Awaited<ReturnType<typeof comparePublicAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePublicAgentVersions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparePublicAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof comparePublicAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComparePublicAgentVersions<
  TData = Awaited<ReturnType<typeof comparePublicAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePublicAgentVersions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparePublicAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof comparePublicAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useComparePublicAgentVersions<
  TData = Awaited<ReturnType<typeof comparePublicAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePublicAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare Public Agent Versions
 */

export function useComparePublicAgentVersions<
  TData = Awaited<ReturnType<typeof comparePublicAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: ComparePublicAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof comparePublicAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getComparePublicAgentVersionsQueryOptions(agentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific public agent by ID.
 * @summary Get Public Agent
 */
export const getPublicAgent2 = (id: string, signal?: AbortSignal) => {
  return customInstance<Agent>({ url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/`, method: 'GET', signal });
};

export const getGetPublicAgent2QueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${id}/`] as const;
};

export const getGetPublicAgent2QueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicAgent2>>,
  TError = NotFoundResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgent2>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicAgent2QueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgent2>>> = ({ signal }) =>
    getPublicAgent2(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicAgent2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicAgent2QueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAgent2>>>;
export type GetPublicAgent2QueryError = NotFoundResponse;

export function useGetPublicAgent2<TData = Awaited<ReturnType<typeof getPublicAgent2>>, TError = NotFoundResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgent2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAgent2>>,
          TError,
          Awaited<ReturnType<typeof getPublicAgent2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAgent2<TData = Awaited<ReturnType<typeof getPublicAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgent2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAgent2>>,
          TError,
          Awaited<ReturnType<typeof getPublicAgent2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAgent2<TData = Awaited<ReturnType<typeof getPublicAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgent2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Public Agent
 */

export function useGetPublicAgent2<TData = Awaited<ReturnType<typeof getPublicAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgent2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicAgent2QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific public agent by ID.
 * @summary Get Public Agent
 */
export const getPublicAgent4 = (id: string, agentRequest?: AgentRequest, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: agentRequest,
    signal,
  });
};

export const getGetPublicAgent4MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPublicAgent4>>,
    TError,
    { id: string; data?: AgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPublicAgent4>>,
  TError,
  { id: string; data?: AgentRequest },
  TContext
> => {
  const mutationKey = ['getPublicAgent4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPublicAgent4>>,
    { id: string; data?: AgentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return getPublicAgent4(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPublicAgent4MutationResult = NonNullable<Awaited<ReturnType<typeof getPublicAgent4>>>;
export type GetPublicAgent4MutationBody = AgentRequest | undefined;
export type GetPublicAgent4MutationError = NotFoundResponse;

/**
 * @summary Get Public Agent
 */
export const useGetPublicAgent4 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPublicAgent4>>,
      TError,
      { id: string; data?: AgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getPublicAgent4>>,
  TError,
  { id: string; data?: AgentRequest },
  TContext
> => {
  return useMutation(getGetPublicAgent4MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific public agent by ID.
 * @summary Get Public Agent
 */
export const getPublicAgent3 = (id: string, patchedAgentRequest?: PatchedAgentRequest, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentRequest,
    signal,
  });
};

export const getGetPublicAgent3MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPublicAgent3>>,
    TError,
    { id: string; data?: PatchedAgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPublicAgent3>>,
  TError,
  { id: string; data?: PatchedAgentRequest },
  TContext
> => {
  const mutationKey = ['getPublicAgent3'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPublicAgent3>>,
    { id: string; data?: PatchedAgentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return getPublicAgent3(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPublicAgent3MutationResult = NonNullable<Awaited<ReturnType<typeof getPublicAgent3>>>;
export type GetPublicAgent3MutationBody = PatchedAgentRequest | undefined;
export type GetPublicAgent3MutationError = NotFoundResponse;

/**
 * @summary Get Public Agent
 */
export const useGetPublicAgent3 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPublicAgent3>>,
      TError,
      { id: string; data?: PatchedAgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getPublicAgent3>>,
  TError,
  { id: string; data?: PatchedAgentRequest },
  TContext
> => {
  return useMutation(getGetPublicAgent3MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific public agent by ID.
 * @summary Get Public Agent
 */
export const getPublicAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGetPublicAgentMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getPublicAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof getPublicAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['getPublicAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPublicAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return getPublicAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPublicAgentMutationResult = NonNullable<Awaited<ReturnType<typeof getPublicAgent>>>;

export type GetPublicAgentMutationError = NotFoundResponse;

/**
 * @summary Get Public Agent
 */
export const useGetPublicAgent = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof getPublicAgent>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getPublicAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getGetPublicAgentMutationOptions(options), queryClient);
};

/**
 * Retrieve the active content of a public agent.
 * @summary Get Public Agent Active Content
 */
export const getPublicAgentActiveContent = (id: string, signal?: AbortSignal) => {
  return customInstance<AgentActiveContent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/active-content/`,
    method: 'GET',
    signal,
  });
};

export const getGetPublicAgentActiveContentQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/public/${id}/active-content/`] as const;
};

export const getGetPublicAgentActiveContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgentActiveContent>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicAgentActiveContentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgentActiveContent>>> = ({ signal }) =>
    getPublicAgentActiveContent(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicAgentActiveContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicAgentActiveContent>>
>;
export type GetPublicAgentActiveContentQueryError = void;

export function useGetPublicAgentActiveContent<
  TData = Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgentActiveContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
          TError,
          Awaited<ReturnType<typeof getPublicAgentActiveContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAgentActiveContent<
  TData = Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgentActiveContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
          TError,
          Awaited<ReturnType<typeof getPublicAgentActiveContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicAgentActiveContent<
  TData = Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgentActiveContent>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Public Agent Active Content
 */

export function useGetPublicAgentActiveContent<
  TData = Awaited<ReturnType<typeof getPublicAgentActiveContent>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicAgentActiveContent>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicAgentActiveContentQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Archive a public agent — sets status to 'archived'. Internal system agents (compliance, routing, memory) cannot be archived.
 * @summary Archive Public Agent
 */
export const archivePublicAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/archive/`,
    method: 'PATCH',
    signal,
  });
};

export const getArchivePublicAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof archivePublicAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof archivePublicAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['archivePublicAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof archivePublicAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return archivePublicAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchivePublicAgentMutationResult = NonNullable<Awaited<ReturnType<typeof archivePublicAgent>>>;

export type ArchivePublicAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary Archive Public Agent
 */
export const useArchivePublicAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof archivePublicAgent>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof archivePublicAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getArchivePublicAgentMutationOptions(options), queryClient);
};

/**
 * Hire (approve) a proposed public agent — sets status to 'hired'. If the agent has no active version, activates the latest finalised one. Internal system agents (compliance, routing, memory) cannot be hired this way.
 * @summary Hire Public Agent
 */
export const hirePublicAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/public/${id}/hire/`,
    method: 'PATCH',
    signal,
  });
};

export const getHirePublicAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof hirePublicAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof hirePublicAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['hirePublicAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof hirePublicAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return hirePublicAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type HirePublicAgentMutationResult = NonNullable<Awaited<ReturnType<typeof hirePublicAgent>>>;

export type HirePublicAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary Hire Public Agent
 */
export const useHirePublicAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof hirePublicAgent>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof hirePublicAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getHirePublicAgentMutationOptions(options), queryClient);
};

/**
 * Search for agents across both public and tenant contexts using text query.
 * @summary Search Agents
 */
export const searchAgents = (params: SearchAgentsParams, signal?: AbortSignal) => {
  return customInstance<void>({ url: `${import.meta.env.VITE_API_URL}/api/v1/search/`, method: 'GET', params, signal });
};

export const getSearchAgentsQueryKey = (params?: SearchAgentsParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/search/`, ...(params ? [params] : [])] as const;
};

export const getSearchAgentsQueryOptions = <TData = Awaited<ReturnType<typeof searchAgents>>, TError = void>(
  params: SearchAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAgents>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAgents>>> = ({ signal }) => searchAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAgents>>>;
export type SearchAgentsQueryError = void;

export function useSearchAgents<TData = Awaited<ReturnType<typeof searchAgents>>, TError = void>(
  params: SearchAgentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAgents>>,
          TError,
          Awaited<ReturnType<typeof searchAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchAgents<TData = Awaited<ReturnType<typeof searchAgents>>, TError = void>(
  params: SearchAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAgents>>,
          TError,
          Awaited<ReturnType<typeof searchAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchAgents<TData = Awaited<ReturnType<typeof searchAgents>>, TError = void>(
  params: SearchAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Agents
 */

export function useSearchAgents<TData = Awaited<ReturnType<typeof searchAgents>>, TError = void>(
  params: SearchAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Workspace-level catalogue + minimal authoring for Skills.
 *
 * Deliberately minimal (the ticket excludes certification, marketplace and
 * sharing): enough to create a Skill, iterate on a draft, publish it, and
 * retire it. Everything about *pinning* lives on the agent-version payload,
 * not here.
 *
 * Shaped after ``agent_memories.views.MemoryViewSet``, with one structural
 * difference: a published version is immutable, so "edit" only ever applies
 * to a draft and publishing is a one-way door.
 *
 * list:
 *     Skills that are not archived, each with its pinnable-version count.
 *
 * retrieve:
 *     One Skill with its published versions (the pinnable set) inline.
 *
 * create:
 *     Create a Skill plus its first draft version.
 *
 * partial_update:
 *     Update the Skill's own metadata (name, description, is_archived).
 *
 * destroy:
 *     Hard-delete a Skill — refused while an ACTIVE agent version pins it.
 */
export const skillsList = (signal?: AbortSignal) => {
  return customInstance<SkillList[]>({ url: `${import.meta.env.VITE_API_URL}/api/v1/skills/`, method: 'GET', signal });
};

export const getSkillsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/`] as const;
};

export const getSkillsListQueryOptions = <TData = Awaited<ReturnType<typeof skillsList>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsList>>> = ({ signal }) => skillsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof skillsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SkillsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsList>>>;
export type SkillsListQueryError = unknown;

export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsList>>,
          TError,
          Awaited<ReturnType<typeof skillsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsList<TData = Awaited<ReturnType<typeof skillsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Workspace-level catalogue + minimal authoring for Skills.
 *
 * Deliberately minimal (the ticket excludes certification, marketplace and
 * sharing): enough to create a Skill, iterate on a draft, publish it, and
 * retire it. Everything about *pinning* lives on the agent-version payload,
 * not here.
 *
 * Shaped after ``agent_memories.views.MemoryViewSet``, with one structural
 * difference: a published version is immutable, so "edit" only ever applies
 * to a draft and publishing is a one-way door.
 *
 * list:
 *     Skills that are not archived, each with its pinnable-version count.
 *
 * retrieve:
 *     One Skill with its published versions (the pinnable set) inline.
 *
 * create:
 *     Create a Skill plus its first draft version.
 *
 * partial_update:
 *     Update the Skill's own metadata (name, description, is_archived).
 *
 * destroy:
 *     Hard-delete a Skill — refused while an ACTIVE agent version pins it.
 */
export const skillsCreate = (skillCreateRequest: SkillCreateRequest, signal?: AbortSignal) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: skillCreateRequest,
    signal,
  });
};

export const getSkillsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsCreate>>,
    TError,
    { data: SkillCreateRequest },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof skillsCreate>>, TError, { data: SkillCreateRequest }, TContext> => {
  const mutationKey = ['skillsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsCreate>>, { data: SkillCreateRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return skillsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsCreate>>>;
export type SkillsCreateMutationBody = SkillCreateRequest;
export type SkillsCreateMutationError = unknown;

export const useSkillsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsCreate>>,
      TError,
      { data: SkillCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof skillsCreate>>, TError, { data: SkillCreateRequest }, TContext> => {
  return useMutation(getSkillsCreateMutationOptions(options), queryClient);
};

/**
 * Workspace-level catalogue + minimal authoring for Skills.
 *
 * Deliberately minimal (the ticket excludes certification, marketplace and
 * sharing): enough to create a Skill, iterate on a draft, publish it, and
 * retire it. Everything about *pinning* lives on the agent-version payload,
 * not here.
 *
 * Shaped after ``agent_memories.views.MemoryViewSet``, with one structural
 * difference: a published version is immutable, so "edit" only ever applies
 * to a draft and publishing is a one-way door.
 *
 * list:
 *     Skills that are not archived, each with its pinnable-version count.
 *
 * retrieve:
 *     One Skill with its published versions (the pinnable set) inline.
 *
 * create:
 *     Create a Skill plus its first draft version.
 *
 * partial_update:
 *     Update the Skill's own metadata (name, description, is_archived).
 *
 * destroy:
 *     Hard-delete a Skill — refused while an ACTIVE agent version pins it.
 */
export const skillsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getSkillsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/`] as const;
};

export const getSkillsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsRetrieve>>> = ({ signal }) => skillsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof skillsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SkillsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsRetrieve>>>;
export type SkillsRetrieveQueryError = unknown;

export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsRetrieve<TData = Awaited<ReturnType<typeof skillsRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Workspace-level catalogue + minimal authoring for Skills.
 *
 * Deliberately minimal (the ticket excludes certification, marketplace and
 * sharing): enough to create a Skill, iterate on a draft, publish it, and
 * retire it. Everything about *pinning* lives on the agent-version payload,
 * not here.
 *
 * Shaped after ``agent_memories.views.MemoryViewSet``, with one structural
 * difference: a published version is immutable, so "edit" only ever applies
 * to a draft and publishing is a one-way door.
 *
 * list:
 *     Skills that are not archived, each with its pinnable-version count.
 *
 * retrieve:
 *     One Skill with its published versions (the pinnable set) inline.
 *
 * create:
 *     Create a Skill plus its first draft version.
 *
 * partial_update:
 *     Update the Skill's own metadata (name, description, is_archived).
 *
 * destroy:
 *     Hard-delete a Skill — refused while an ACTIVE agent version pins it.
 */
export const skillsPartialUpdate = (
  id: string,
  patchedSkillUpdateRequest?: PatchedSkillUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedSkillUpdateRequest,
    signal,
  });
};

export const getSkillsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsPartialUpdate>>,
    TError,
    { id: string; data?: PatchedSkillUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedSkillUpdateRequest },
  TContext
> => {
  const mutationKey = ['skillsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skillsPartialUpdate>>,
    { id: string; data?: PatchedSkillUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return skillsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsPartialUpdate>>>;
export type SkillsPartialUpdateMutationBody = PatchedSkillUpdateRequest | undefined;
export type SkillsPartialUpdateMutationError = unknown;

export const useSkillsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsPartialUpdate>>,
      TError,
      { id: string; data?: PatchedSkillUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsPartialUpdate>>,
  TError,
  { id: string; data?: PatchedSkillUpdateRequest },
  TContext
> => {
  return useMutation(getSkillsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Delete a Skill nothing references.
 *
 * The rule itself lives in ``Skill.delete`` so no route, command or shell
 * can cascade past it; this only turns its refusal into a 400 rather
 * than letting a model error surface as a 500.
 */
export const skillsDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getSkillsDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof skillsDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof skillsDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['skillsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return skillsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof skillsDestroy>>>;

export type SkillsDestroyMutationError = unknown;

export const useSkillsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof skillsDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof skillsDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getSkillsDestroyMutationOptions(options), queryClient);
};

/**
 * GET the pinnable versions, or POST a new draft.
 *
 * Both live on one action because they share a path — a separate
 * ``ListAPIView`` at the same URL would shadow the router and turn POST
 * into a 405.
 *
 * GET returns PUBLISHED versions only: it answers "what may I pin", and
 * offering a draft would only produce a 400 at pin time. The authoring
 * view that needs drafts too is ``versions/all``.
 */
export const skillsVersionsList = (id: string, signal?: AbortSignal) => {
  return customInstance<SkillVersion[] | SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getSkillsVersionsListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/`] as const;
};

export const getSkillsVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof skillsVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsVersionsList>>> = ({ signal }) =>
    skillsVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof skillsVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SkillsVersionsListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsVersionsList>>>;
export type SkillsVersionsListQueryError = unknown;

export function useSkillsVersionsList<TData = Awaited<ReturnType<typeof skillsVersionsList>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsList<TData = Awaited<ReturnType<typeof skillsVersionsList>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsList<TData = Awaited<ReturnType<typeof skillsVersionsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsVersionsList<TData = Awaited<ReturnType<typeof skillsVersionsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * GET the pinnable versions, or POST a new draft.
 *
 * Both live on one action because they share a path — a separate
 * ``ListAPIView`` at the same URL would shadow the router and turn POST
 * into a 405.
 *
 * GET returns PUBLISHED versions only: it answers "what may I pin", and
 * offering a draft would only produce a 400 at pin time. The authoring
 * view that needs drafts too is ``versions/all``.
 */
export const skillsVersionsCreate = (
  id: string,
  skillVersionCreateRequest: SkillVersionCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<SkillVersion[] | SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: skillVersionCreateRequest,
    signal,
  });
};

export const getSkillsVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsVersionsCreate>>,
    TError,
    { id: string; data: SkillVersionCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsVersionsCreate>>,
  TError,
  { id: string; data: SkillVersionCreateRequest },
  TContext
> => {
  const mutationKey = ['skillsVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skillsVersionsCreate>>,
    { id: string; data: SkillVersionCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return skillsVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsVersionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsVersionsCreate>>>;
export type SkillsVersionsCreateMutationBody = SkillVersionCreateRequest;
export type SkillsVersionsCreateMutationError = unknown;

export const useSkillsVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsVersionsCreate>>,
      TError,
      { id: string; data: SkillVersionCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsVersionsCreate>>,
  TError,
  { id: string; data: SkillVersionCreateRequest },
  TContext
> => {
  return useMutation(getSkillsVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Edit a DRAFT version. Published versions are refused.
 */
export const skillsVersionsPartialUpdate = (
  id: string,
  versionId: string,
  patchedSkillVersionUpdateRequest?: PatchedSkillVersionUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedSkillVersionUpdateRequest,
    signal,
  });
};

export const getSkillsVersionsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>,
    TError,
    { id: string; versionId: string; data?: PatchedSkillVersionUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>,
  TError,
  { id: string; versionId: string; data?: PatchedSkillVersionUpdateRequest },
  TContext
> => {
  const mutationKey = ['skillsVersionsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>,
    { id: string; versionId: string; data?: PatchedSkillVersionUpdateRequest }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return skillsVersionsPartialUpdate(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsVersionsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>
>;
export type SkillsVersionsPartialUpdateMutationBody = PatchedSkillVersionUpdateRequest | undefined;
export type SkillsVersionsPartialUpdateMutationError = unknown;

export const useSkillsVersionsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>,
      TError,
      { id: string; versionId: string; data?: PatchedSkillVersionUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsVersionsPartialUpdate>>,
  TError,
  { id: string; versionId: string; data?: PatchedSkillVersionUpdateRequest },
  TContext
> => {
  return useMutation(getSkillsVersionsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retire a published version: no new pins, existing pins keep working.
 */
export const skillsVersionsArchiveCreate = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/archive/`,
    method: 'POST',
    signal,
  });
};

export const getSkillsVersionsArchiveCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['skillsVersionsArchiveCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return skillsVersionsArchiveCreate(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsVersionsArchiveCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>
>;

export type SkillsVersionsArchiveCreateMutationError = unknown;

export const useSkillsVersionsArchiveCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsVersionsArchiveCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getSkillsVersionsArchiveCreateMutationOptions(options), queryClient);
};

/**
 * Download one version as a .skill archive.
 */
export const skillsVersionsExportRetrieve = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/export/`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getSkillsVersionsExportRetrieveQueryKey = (id: string, versionId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/export/`] as const;
};

export const getSkillsVersionsExportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsVersionsExportRetrieveQueryKey(id, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>> = ({ signal }) =>
    skillsVersionsExportRetrieve(id, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type SkillsVersionsExportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>
>;
export type SkillsVersionsExportRetrieveQueryError = unknown;

export function useSkillsVersionsExportRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsExportRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsExportRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsVersionsExportRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsExportRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsVersionsExportRetrieveQueryOptions(id, versionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Read one file from a version's folder. The version payload lists the paths; this returns the bytes for one of them.
 */
export const skillsVersionsFileRetrieve = (
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<SkillVersionFile>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/file/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSkillsVersionsFileRetrieveQueryKey = (
  id: string,
  versionId: string,
  params?: SkillsVersionsFileRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/file/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSkillsVersionsFileRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsVersionsFileRetrieveQueryKey(id, versionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>> = ({ signal }) =>
    skillsVersionsFileRetrieve(id, versionId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type SkillsVersionsFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>>;
export type SkillsVersionsFileRetrieveQueryError = unknown;

export function useSkillsVersionsFileRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsFileRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsFileRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsVersionsFileRetrieve<
  TData = Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>,
  TError = unknown,
>(
  id: string,
  versionId: string,
  params: SkillsVersionsFileRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsFileRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsVersionsFileRetrieveQueryOptions(id, versionId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Finalise a draft: it becomes pinnable and its content freezes.
 *
 * One-way: there is no unpublish, because an agent version may already be
 * pinned to it and the evidence trail asserts those bytes never changed.
 */
export const skillsVersionsPublishCreate = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<SkillDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/${versionId}/publish/`,
    method: 'POST',
    signal,
  });
};

export const getSkillsVersionsPublishCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsVersionsPublishCreate>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsVersionsPublishCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['skillsVersionsPublishCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skillsVersionsPublishCreate>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return skillsVersionsPublishCreate(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsVersionsPublishCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof skillsVersionsPublishCreate>>
>;

export type SkillsVersionsPublishCreateMutationError = unknown;

export const useSkillsVersionsPublishCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsVersionsPublishCreate>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsVersionsPublishCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getSkillsVersionsPublishCreateMutationOptions(options), queryClient);
};

/**
 * Every version including drafts — the authoring view.
 *
 * Distinct from ``/skills/<id>/versions/``, which answers "what may I
 * pin" and therefore returns published versions only.
 */
export const skillsVersionsAllList = (id: string, signal?: AbortSignal) => {
  return customInstance<SkillVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/all/`,
    method: 'GET',
    signal,
  });
};

export const getSkillsVersionsAllListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/${id}/versions/all/`] as const;
};

export const getSkillsVersionsAllListQueryOptions = <
  TData = Awaited<ReturnType<typeof skillsVersionsAllList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsAllList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsVersionsAllListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsVersionsAllList>>> = ({ signal }) =>
    skillsVersionsAllList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof skillsVersionsAllList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SkillsVersionsAllListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsVersionsAllList>>>;
export type SkillsVersionsAllListQueryError = unknown;

export function useSkillsVersionsAllList<TData = Awaited<ReturnType<typeof skillsVersionsAllList>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsAllList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsAllList>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsAllList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsAllList<TData = Awaited<ReturnType<typeof skillsVersionsAllList>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsAllList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsVersionsAllList>>,
          TError,
          Awaited<ReturnType<typeof skillsVersionsAllList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsVersionsAllList<TData = Awaited<ReturnType<typeof skillsVersionsAllList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsAllList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsVersionsAllList<TData = Awaited<ReturnType<typeof skillsVersionsAllList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsVersionsAllList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsVersionsAllListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Import a .skill archive. The folder is validated against the open format before anything is stored; a name already used in this workspace is refused rather than merged.
 */
export const skillsImportCreate = (skillImportRequest: SkillImportRequest, signal?: AbortSignal) => {
  const formData = new FormData();
  formData.append(`file`, skillImportRequest.file);

  return customInstance<SkillImportResult>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/import/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getSkillsImportCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skillsImportCreate>>,
    TError,
    { data: SkillImportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skillsImportCreate>>,
  TError,
  { data: SkillImportRequest },
  TContext
> => {
  const mutationKey = ['skillsImportCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof skillsImportCreate>>, { data: SkillImportRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return skillsImportCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkillsImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof skillsImportCreate>>>;
export type SkillsImportCreateMutationBody = SkillImportRequest;
export type SkillsImportCreateMutationError = unknown;

export const useSkillsImportCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skillsImportCreate>>,
      TError,
      { data: SkillImportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof skillsImportCreate>>,
  TError,
  { data: SkillImportRequest },
  TContext
> => {
  return useMutation(getSkillsImportCreateMutationOptions(options), queryClient);
};

/**
 * ``GET /api/v1/skills/usage-evidence/`` — evidence for an authorised run.
 *
 * Tenant isolation is structural (rows live in the caller's schema). A filter
 * is required so this cannot be used to page the workspace's entire runtime
 * history from one call.
 */
export const skillsUsageEvidenceList = (params?: SkillsUsageEvidenceListParams, signal?: AbortSignal) => {
  return customInstance<SkillUsageEvidence[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/skills/usage-evidence/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSkillsUsageEvidenceListQueryKey = (params?: SkillsUsageEvidenceListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/skills/usage-evidence/`, ...(params ? [params] : [])] as const;
};

export const getSkillsUsageEvidenceListQueryOptions = <
  TData = Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
  TError = unknown,
>(
  params?: SkillsUsageEvidenceListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUsageEvidenceList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSkillsUsageEvidenceListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsUsageEvidenceList>>> = ({ signal }) =>
    skillsUsageEvidenceList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SkillsUsageEvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof skillsUsageEvidenceList>>>;
export type SkillsUsageEvidenceListQueryError = unknown;

export function useSkillsUsageEvidenceList<
  TData = Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
  TError = unknown,
>(
  params: undefined | SkillsUsageEvidenceListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUsageEvidenceList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof skillsUsageEvidenceList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsUsageEvidenceList<
  TData = Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
  TError = unknown,
>(
  params?: SkillsUsageEvidenceListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUsageEvidenceList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof skillsUsageEvidenceList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSkillsUsageEvidenceList<
  TData = Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
  TError = unknown,
>(
  params?: SkillsUsageEvidenceListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUsageEvidenceList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSkillsUsageEvidenceList<
  TData = Awaited<ReturnType<typeof skillsUsageEvidenceList>>,
  TError = unknown,
>(
  params?: SkillsUsageEvidenceListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUsageEvidenceList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSkillsUsageEvidenceListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Manager/worker hierarchy of the workspace (nodes + edges).
 *
 * Backs the Teammate Studio "Team" column/filter and the org chart. Tenant
 * schemas only — rosters are tenant-local, so the public schema has no graph.
 * Archived teammates are omitted unless ``?include_archived=true``.
 */
export const teamGraphRetrieve = (params?: TeamGraphRetrieveParams, signal?: AbortSignal) => {
  return customInstance<TeamGraph>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/team-graph/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTeamGraphRetrieveQueryKey = (params?: TeamGraphRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/team-graph/`, ...(params ? [params] : [])] as const;
};

export const getTeamGraphRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof teamGraphRetrieve>>,
  TError = unknown,
>(
  params?: TeamGraphRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof teamGraphRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamGraphRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof teamGraphRetrieve>>> = ({ signal }) =>
    teamGraphRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof teamGraphRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TeamGraphRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof teamGraphRetrieve>>>;
export type TeamGraphRetrieveQueryError = unknown;

export function useTeamGraphRetrieve<TData = Awaited<ReturnType<typeof teamGraphRetrieve>>, TError = unknown>(
  params: undefined | TeamGraphRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof teamGraphRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamGraphRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teamGraphRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTeamGraphRetrieve<TData = Awaited<ReturnType<typeof teamGraphRetrieve>>, TError = unknown>(
  params?: TeamGraphRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof teamGraphRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teamGraphRetrieve>>,
          TError,
          Awaited<ReturnType<typeof teamGraphRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTeamGraphRetrieve<TData = Awaited<ReturnType<typeof teamGraphRetrieve>>, TError = unknown>(
  params?: TeamGraphRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof teamGraphRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTeamGraphRetrieve<TData = Awaited<ReturnType<typeof teamGraphRetrieve>>, TError = unknown>(
  params?: TeamGraphRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof teamGraphRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTeamGraphRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Bot Framework messaging endpoint.
 *
 * Path: ``POST /api/v1/teams/messages/``
 *
 * Default (``TEAMS_DELIVERY_MODE=connector``): acknowledge the Activity
 * immediately and run the chat pipeline in a background thread, posting
 * live status + the final reply through ``serviceUrl``. Holding the HTTP
 * turn open until the pipeline finishes hides progress in personal chat
 * (Teams only paints connector updates after the turn returns).
 *
 * ``TEAMS_DELIVERY_MODE=sync_only`` keeps the synchronous path (tests).
 */
export const teamsMessagesCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/teams/messages/`,
    method: 'POST',
    signal,
  });
};

export const getTeamsMessagesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof teamsMessagesCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof teamsMessagesCreate>>, TError, void, TContext> => {
  const mutationKey = ['teamsMessagesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsMessagesCreate>>, void> = () => {
    return teamsMessagesCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type TeamsMessagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teamsMessagesCreate>>>;

export type TeamsMessagesCreateMutationError = unknown;

export const useTeamsMessagesCreate = <TError = unknown, TContext = unknown>(
  options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof teamsMessagesCreate>>, TError, void, TContext> },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof teamsMessagesCreate>>, TError, void, TContext> => {
  return useMutation(getTeamsMessagesCreateMutationOptions(options), queryClient);
};

/**
 * @summary List Vigilant AI channel gates
 */
export const temporalHistoryChannelGatesList = (signal?: AbortSignal) => {
  return customInstance<ChannelGate[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/temporal-history/channel-gates/`,
    method: 'GET',
    signal,
  });
};

export const getTemporalHistoryChannelGatesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/temporal-history/channel-gates/`] as const;
};

export const getTemporalHistoryChannelGatesListQueryOptions = <
  TData = Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemporalHistoryChannelGatesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>> = ({ signal }) =>
    temporalHistoryChannelGatesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemporalHistoryChannelGatesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>
>;
export type TemporalHistoryChannelGatesListQueryError = unknown;

export function useTemporalHistoryChannelGatesList<
  TData = Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryChannelGatesList<
  TData = Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryChannelGatesList<
  TData = Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Vigilant AI channel gates
 */

export function useTemporalHistoryChannelGatesList<
  TData = Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryChannelGatesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemporalHistoryChannelGatesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Vigilant AI channel gates
 */
export const temporalHistoryChannelGatesPartialUpdate = (
  channelId: string,
  patchedChannelGateUpdateRequest?: PatchedChannelGateUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<ChannelGate>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/temporal-history/channel-gates/${channelId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedChannelGateUpdateRequest,
    signal,
  });
};

export const getTemporalHistoryChannelGatesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>,
    TError,
    { channelId: string; data?: PatchedChannelGateUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>,
  TError,
  { channelId: string; data?: PatchedChannelGateUpdateRequest },
  TContext
> => {
  const mutationKey = ['temporalHistoryChannelGatesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>,
    { channelId: string; data?: PatchedChannelGateUpdateRequest }
  > = (props) => {
    const { channelId, data } = props ?? {};

    return temporalHistoryChannelGatesPartialUpdate(channelId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemporalHistoryChannelGatesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>
>;
export type TemporalHistoryChannelGatesPartialUpdateMutationBody = PatchedChannelGateUpdateRequest | undefined;
export type TemporalHistoryChannelGatesPartialUpdateMutationError = unknown;

/**
 * @summary Update Vigilant AI channel gates
 */
export const useTemporalHistoryChannelGatesPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>,
      TError,
      { channelId: string; data?: PatchedChannelGateUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof temporalHistoryChannelGatesPartialUpdate>>,
  TError,
  { channelId: string; data?: PatchedChannelGateUpdateRequest },
  TContext
> => {
  return useMutation(getTemporalHistoryChannelGatesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Audit trail of source-platform message deletions handled by Vigilant (spec §15.3). Identifiers, scope, status and verification only — no message text.
 * @summary List source deletion requests
 */
export const temporalHistoryDeletionRequestsList = (
  params?: TemporalHistoryDeletionRequestsListParams,
  signal?: AbortSignal
) => {
  return customInstance<SourceDeletionRequest[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/temporal-history/deletion-requests/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTemporalHistoryDeletionRequestsListQueryKey = (params?: TemporalHistoryDeletionRequestsListParams) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/temporal-history/deletion-requests/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTemporalHistoryDeletionRequestsListQueryOptions = <
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
  TError = unknown,
>(
  params?: TemporalHistoryDeletionRequestsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemporalHistoryDeletionRequestsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>> = ({ signal }) =>
    temporalHistoryDeletionRequestsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemporalHistoryDeletionRequestsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>
>;
export type TemporalHistoryDeletionRequestsListQueryError = unknown;

export function useTemporalHistoryDeletionRequestsList<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
  TError = unknown,
>(
  params: undefined | TemporalHistoryDeletionRequestsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryDeletionRequestsList<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
  TError = unknown,
>(
  params?: TemporalHistoryDeletionRequestsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryDeletionRequestsList<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
  TError = unknown,
>(
  params?: TemporalHistoryDeletionRequestsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List source deletion requests
 */

export function useTemporalHistoryDeletionRequestsList<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>,
  TError = unknown,
>(
  params?: TemporalHistoryDeletionRequestsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemporalHistoryDeletionRequestsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * GET: one ledger row with processor receipts and verification. Admin only.
 * @summary Retrieve a source deletion request
 */
export const temporalHistoryDeletionRequestsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<SourceDeletionRequest>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/temporal-history/deletion-requests/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getTemporalHistoryDeletionRequestsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/temporal-history/deletion-requests/${id}/`] as const;
};

export const getTemporalHistoryDeletionRequestsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemporalHistoryDeletionRequestsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>> = ({ signal }) =>
    temporalHistoryDeletionRequestsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemporalHistoryDeletionRequestsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>
>;
export type TemporalHistoryDeletionRequestsRetrieveQueryError = unknown;

export function useTemporalHistoryDeletionRequestsRetrieve<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryDeletionRequestsRetrieve<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemporalHistoryDeletionRequestsRetrieve<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve a source deletion request
 */

export function useTemporalHistoryDeletionRequestsRetrieve<
  TData = Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof temporalHistoryDeletionRequestsRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemporalHistoryDeletionRequestsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a list of tenant-specific agents for the current workspace.
 * @summary List Tenant Agents
 */
export const listAgents = (params?: ListAgentsParams, signal?: AbortSignal) => {
  return customInstance<AgentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAgentsQueryKey = (params?: ListAgentsParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/`, ...(params ? [params] : [])] as const;
};

export const getListAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listAgents>>, TError = void>(
  params?: ListAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgents>>> = ({ signal }) => listAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgents>>>;
export type ListAgentsQueryError = void;

export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = void>(
  params: undefined | ListAgentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgents>>,
          TError,
          Awaited<ReturnType<typeof listAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = void>(
  params?: ListAgentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgents>>,
          TError,
          Awaited<ReturnType<typeof listAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = void>(
  params?: ListAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Tenant Agents
 */

export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = void>(
  params?: ListAgentsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a list of tenant-specific agents for the current workspace.
 * @summary List Tenant Agents
 */
export const listAgents2 = (agentRequest?: AgentRequest, params?: ListAgents2Params, signal?: AbortSignal) => {
  return customInstance<AgentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentRequest,
    params,
    signal,
  });
};

export const getListAgents2MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAgents2>>,
    TError,
    { data?: AgentRequest; params?: ListAgents2Params },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAgents2>>,
  TError,
  { data?: AgentRequest; params?: ListAgents2Params },
  TContext
> => {
  const mutationKey = ['listAgents2'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAgents2>>,
    { data?: AgentRequest; params?: ListAgents2Params }
  > = (props) => {
    const { data, params } = props ?? {};

    return listAgents2(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAgents2MutationResult = NonNullable<Awaited<ReturnType<typeof listAgents2>>>;
export type ListAgents2MutationBody = AgentRequest | undefined;
export type ListAgents2MutationError = void;

/**
 * @summary List Tenant Agents
 */
export const useListAgents2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAgents2>>,
      TError,
      { data?: AgentRequest; params?: ListAgents2Params },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAgents2>>,
  TError,
  { data?: AgentRequest; params?: ListAgents2Params },
  TContext
> => {
  return useMutation(getListAgents2MutationOptions(options), queryClient);
};

/**
 * Mixin to provide schema context in responses
 */
export const tenantDocumentEditsAcceptCreate = (agentId: string, editId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/document-edits/${editId}/accept/`,
    method: 'POST',
    signal,
  });
};

export const getTenantDocumentEditsAcceptCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>,
    TError,
    { agentId: string; editId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  const mutationKey = ['tenantDocumentEditsAcceptCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>,
    { agentId: string; editId: string }
  > = (props) => {
    const { agentId, editId } = props ?? {};

    return tenantDocumentEditsAcceptCreate(agentId, editId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantDocumentEditsAcceptCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>
>;

export type TenantDocumentEditsAcceptCreateMutationError = unknown;

export const useTenantDocumentEditsAcceptCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>,
      TError,
      { agentId: string; editId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantDocumentEditsAcceptCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  return useMutation(getTenantDocumentEditsAcceptCreateMutationOptions(options), queryClient);
};

/**
 * Mixin to provide schema context in responses
 */
export const tenantDocumentEditsDenyCreate = (agentId: string, editId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/document-edits/${editId}/deny/`,
    method: 'POST',
    signal,
  });
};

export const getTenantDocumentEditsDenyCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>,
    TError,
    { agentId: string; editId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  const mutationKey = ['tenantDocumentEditsDenyCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>,
    { agentId: string; editId: string }
  > = (props) => {
    const { agentId, editId } = props ?? {};

    return tenantDocumentEditsDenyCreate(agentId, editId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantDocumentEditsDenyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>
>;

export type TenantDocumentEditsDenyCreateMutationError = unknown;

export const useTenantDocumentEditsDenyCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>,
      TError,
      { agentId: string; editId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantDocumentEditsDenyCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  return useMutation(getTenantDocumentEditsDenyCreateMutationOptions(options), queryClient);
};

/**
 * Mixin to provide schema context in responses
 */
export const tenantDocumentEditsEditCreate = (agentId: string, editId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/document-edits/${editId}/edit/`,
    method: 'POST',
    signal,
  });
};

export const getTenantDocumentEditsEditCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>,
    TError,
    { agentId: string; editId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  const mutationKey = ['tenantDocumentEditsEditCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>,
    { agentId: string; editId: string }
  > = (props) => {
    const { agentId, editId } = props ?? {};

    return tenantDocumentEditsEditCreate(agentId, editId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantDocumentEditsEditCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>
>;

export type TenantDocumentEditsEditCreateMutationError = unknown;

export const useTenantDocumentEditsEditCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>,
      TError,
      { agentId: string; editId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantDocumentEditsEditCreate>>,
  TError,
  { agentId: string; editId: string },
  TContext
> => {
  return useMutation(getTenantDocumentEditsEditCreateMutationOptions(options), queryClient);
};

/**
 * List knowledge documents linked to a specific agent version.
 *
 * Accepts optional query params:
 * - ``version_id``: return links for that version instead of active
 * - ``include_global``: if 'true', append global documents in a
 *   wrapper response ``{ links: [...], global_documents: [...] }``
 *
 * When ``include_global`` is omitted, the response is the flat list
 * of links (backward compatible), with global docs filtered out.
 */
export const tenantKnowledgeRetrieve = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/`,
    method: 'GET',
    signal,
  });
};

export const getTenantKnowledgeRetrieveQueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/`] as const;
};

export const getTenantKnowledgeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantKnowledgeRetrieveQueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>> = ({ signal }) =>
    tenantKnowledgeRetrieve(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantKnowledgeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>>;
export type TenantKnowledgeRetrieveQueryError = unknown;

export function useTenantKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantKnowledgeRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantKnowledgeRetrieveQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Validate a knowledge document for linking and return its metadata.
 *
 * This endpoint does NOT create an ``AgentKnowledgeLink`` record.
 * The link is created later by the version serializer during
 * "Save Changes", which ensures the active version is never mutated
 * in-place and version history stays accurate.
 */
export const tenantKnowledgeCreate = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/`,
    method: 'POST',
    signal,
  });
};

export const getTenantKnowledgeCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantKnowledgeCreate>>,
    TError,
    { agentId: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof tenantKnowledgeCreate>>, TError, { agentId: string }, TContext> => {
  const mutationKey = ['tenantKnowledgeCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantKnowledgeCreate>>, { agentId: string }> = (
    props
  ) => {
    const { agentId } = props ?? {};

    return tenantKnowledgeCreate(agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantKnowledgeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantKnowledgeCreate>>>;

export type TenantKnowledgeCreateMutationError = unknown;

export const useTenantKnowledgeCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantKnowledgeCreate>>,
      TError,
      { agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof tenantKnowledgeCreate>>, TError, { agentId: string }, TContext> => {
  return useMutation(getTenantKnowledgeCreateMutationOptions(options), queryClient);
};

/**
 * No-op — importance toggling is handled by the version serializer.
 */
export const tenantKnowledgePartialUpdate = (agentId: string, linkId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/${linkId}/`,
    method: 'PATCH',
    signal,
  });
};

export const getTenantKnowledgePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>,
    TError,
    { agentId: string; linkId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  const mutationKey = ['tenantKnowledgePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>,
    { agentId: string; linkId: string }
  > = (props) => {
    const { agentId, linkId } = props ?? {};

    return tenantKnowledgePartialUpdate(agentId, linkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantKnowledgePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>
>;

export type TenantKnowledgePartialUpdateMutationError = unknown;

export const useTenantKnowledgePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>,
      TError,
      { agentId: string; linkId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantKnowledgePartialUpdate>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  return useMutation(getTenantKnowledgePartialUpdateMutationOptions(options), queryClient);
};

/**
 * No-op — link removal is handled by the version serializer.
 */
export const tenantKnowledgeDestroy = (agentId: string, linkId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/${linkId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getTenantKnowledgeDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantKnowledgeDestroy>>,
    TError,
    { agentId: string; linkId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantKnowledgeDestroy>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  const mutationKey = ['tenantKnowledgeDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantKnowledgeDestroy>>,
    { agentId: string; linkId: string }
  > = (props) => {
    const { agentId, linkId } = props ?? {};

    return tenantKnowledgeDestroy(agentId, linkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantKnowledgeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof tenantKnowledgeDestroy>>>;

export type TenantKnowledgeDestroyMutationError = unknown;

export const useTenantKnowledgeDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantKnowledgeDestroy>>,
      TError,
      { agentId: string; linkId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantKnowledgeDestroy>>,
  TError,
  { agentId: string; linkId: string },
  TContext
> => {
  return useMutation(getTenantKnowledgeDestroyMutationOptions(options), queryClient);
};

/**
 * List suggested documents from this agent.
 */
export const tenantKnowledgeSuggestedRetrieve = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/suggested/`,
    method: 'GET',
    signal,
  });
};

export const getTenantKnowledgeSuggestedRetrieveQueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/knowledge/suggested/`] as const;
};

export const getTenantKnowledgeSuggestedRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantKnowledgeSuggestedRetrieveQueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>> = ({ signal }) =>
    tenantKnowledgeSuggestedRetrieve(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantKnowledgeSuggestedRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>
>;
export type TenantKnowledgeSuggestedRetrieveQueryError = unknown;

export function useTenantKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantKnowledgeSuggestedRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantKnowledgeSuggestedRetrieveQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List memory links for an agent (active version by default).
 */
export const tenantMemoriesList = (agentId: string, params?: TenantMemoriesListParams, signal?: AbortSignal) => {
  return customInstance<AgentMemoryLink[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/memories/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTenantMemoriesListQueryKey = (agentId: string, params?: TenantMemoriesListParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/memories/`, ...(params ? [params] : [])] as const;
};

export const getTenantMemoriesListQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantMemoriesList>>,
  TError = unknown,
>(
  agentId: string,
  params?: TenantMemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantMemoriesList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantMemoriesListQueryKey(agentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantMemoriesList>>> = ({ signal }) =>
    tenantMemoriesList(agentId, params, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantMemoriesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantMemoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof tenantMemoriesList>>>;
export type TenantMemoriesListQueryError = unknown;

export function useTenantMemoriesList<TData = Awaited<ReturnType<typeof tenantMemoriesList>>, TError = unknown>(
  agentId: string,
  params: undefined | TenantMemoriesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantMemoriesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantMemoriesList>>,
          TError,
          Awaited<ReturnType<typeof tenantMemoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantMemoriesList<TData = Awaited<ReturnType<typeof tenantMemoriesList>>, TError = unknown>(
  agentId: string,
  params?: TenantMemoriesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantMemoriesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantMemoriesList>>,
          TError,
          Awaited<ReturnType<typeof tenantMemoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantMemoriesList<TData = Awaited<ReturnType<typeof tenantMemoriesList>>, TError = unknown>(
  agentId: string,
  params?: TenantMemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantMemoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantMemoriesList<TData = Awaited<ReturnType<typeof tenantMemoriesList>>, TError = unknown>(
  agentId: string,
  params?: TenantMemoriesListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantMemoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantMemoriesListQueryOptions(agentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Validate a memory exists and return its metadata for deferred-save staging on the frontend. Does NOT create a link row — the AgentVersion save will do that. Mirrors the AgentKnowledgeListCreateView POST contract.
 */
export const tenantMemoriesCreate = (
  agentId: string,
  agentMemoryLinkValidateRequest: AgentMemoryLinkValidateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TenantMemoriesCreate200>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/memories/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentMemoryLinkValidateRequest,
    signal,
  });
};

export const getTenantMemoriesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantMemoriesCreate>>,
    TError,
    { agentId: string; data: AgentMemoryLinkValidateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantMemoriesCreate>>,
  TError,
  { agentId: string; data: AgentMemoryLinkValidateRequest },
  TContext
> => {
  const mutationKey = ['tenantMemoriesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantMemoriesCreate>>,
    { agentId: string; data: AgentMemoryLinkValidateRequest }
  > = (props) => {
    const { agentId, data } = props ?? {};

    return tenantMemoriesCreate(agentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantMemoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantMemoriesCreate>>>;
export type TenantMemoriesCreateMutationBody = AgentMemoryLinkValidateRequest;
export type TenantMemoriesCreateMutationError = unknown;

export const useTenantMemoriesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantMemoriesCreate>>,
      TError,
      { agentId: string; data: AgentMemoryLinkValidateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantMemoriesCreate>>,
  TError,
  { agentId: string; data: AgentMemoryLinkValidateRequest },
  TContext
> => {
  return useMutation(getTenantMemoriesCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve all versions for a specific agent.
 * @summary List Agent Versions
 */
export const listAgentVersions3 = (agentId: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getListAgentVersions3QueryKey = (agentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/`] as const;
};

export const getListAgentVersions3QueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentVersions3>>,
  TError = void,
>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions3>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentVersions3QueryKey(agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentVersions3>>> = ({ signal }) =>
    listAgentVersions3(agentId, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentVersions3>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentVersions3QueryResult = NonNullable<Awaited<ReturnType<typeof listAgentVersions3>>>;
export type ListAgentVersions3QueryError = void;

export function useListAgentVersions3<TData = Awaited<ReturnType<typeof listAgentVersions3>>, TError = void>(
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions3>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentVersions3>>,
          TError,
          Awaited<ReturnType<typeof listAgentVersions3>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentVersions3<TData = Awaited<ReturnType<typeof listAgentVersions3>>, TError = void>(
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions3>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentVersions3>>,
          TError,
          Awaited<ReturnType<typeof listAgentVersions3>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentVersions3<TData = Awaited<ReturnType<typeof listAgentVersions3>>, TError = void>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions3>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Agent Versions
 */

export function useListAgentVersions3<TData = Awaited<ReturnType<typeof listAgentVersions3>>, TError = void>(
  agentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentVersions3>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentVersions3QueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve all versions for a specific agent.
 * @summary List Agent Versions
 */
export const listAgentVersions4 = (agentId: string, agentVersionRequest: AgentVersionRequest, signal?: AbortSignal) => {
  return customInstance<AgentVersionList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentVersionRequest,
    signal,
  });
};

export const getListAgentVersions4MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAgentVersions4>>,
    TError,
    { agentId: string; data: AgentVersionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAgentVersions4>>,
  TError,
  { agentId: string; data: AgentVersionRequest },
  TContext
> => {
  const mutationKey = ['listAgentVersions4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAgentVersions4>>,
    { agentId: string; data: AgentVersionRequest }
  > = (props) => {
    const { agentId, data } = props ?? {};

    return listAgentVersions4(agentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAgentVersions4MutationResult = NonNullable<Awaited<ReturnType<typeof listAgentVersions4>>>;
export type ListAgentVersions4MutationBody = AgentVersionRequest;
export type ListAgentVersions4MutationError = void;

/**
 * @summary List Agent Versions
 */
export const useListAgentVersions4 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAgentVersions4>>,
      TError,
      { agentId: string; data: AgentVersionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAgentVersions4>>,
  TError,
  { agentId: string; data: AgentVersionRequest },
  TContext
> => {
  return useMutation(getListAgentVersions4MutationOptions(options), queryClient);
};

/**
 * Delete (reject) an agent version. If it was the only version the agent is removed too; if it was active, the most recent remaining version is promoted to active.
 * @summary Delete Agent Version
 */
export const destroyAgentVersion = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getDestroyAgentVersionMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof destroyAgentVersion>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof destroyAgentVersion>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['destroyAgentVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof destroyAgentVersion>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return destroyAgentVersion(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DestroyAgentVersionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAgentVersion>>>;

export type DestroyAgentVersionMutationError = NotFoundResponse;

/**
 * @summary Delete Agent Version
 */
export const useDestroyAgentVersion = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof destroyAgentVersion>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof destroyAgentVersion>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getDestroyAgentVersionMutationOptions(options), queryClient);
};

/**
 * Activate a specific version of an agent.
 * @summary Activate Agent Version
 */
export const activateAgentVersion4 = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionActivate>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/activate/`,
    method: 'PUT',
    signal,
  });
};

export const getActivateAgentVersion4MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAgentVersion4>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAgentVersion4>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['activateAgentVersion4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAgentVersion4>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return activateAgentVersion4(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAgentVersion4MutationResult = NonNullable<Awaited<ReturnType<typeof activateAgentVersion4>>>;

export type ActivateAgentVersion4MutationError = void;

/**
 * @summary Activate Agent Version
 */
export const useActivateAgentVersion4 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateAgentVersion4>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateAgentVersion4>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getActivateAgentVersion4MutationOptions(options), queryClient);
};

/**
 * Activate a specific version of an agent.
 * @summary Activate Agent Version
 */
export const activateAgentVersion3 = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentVersionActivate>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/activate/`,
    method: 'PATCH',
    signal,
  });
};

export const getActivateAgentVersion3MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAgentVersion3>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAgentVersion3>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['activateAgentVersion3'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAgentVersion3>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return activateAgentVersion3(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAgentVersion3MutationResult = NonNullable<Awaited<ReturnType<typeof activateAgentVersion3>>>;

export type ActivateAgentVersion3MutationError = void;

/**
 * @summary Activate Agent Version
 */
export const useActivateAgentVersion3 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateAgentVersion3>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateAgentVersion3>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getActivateAgentVersion3MutationOptions(options), queryClient);
};

/**
 * PATCH: Finalise (approve) a proposed version — sets is_finalised=True and activates it.
 *
 * NOTE: intentionally NOT decorated with ``tenant_agent_version_finalise_schema``.
 * Its OpenAPI operationId is auto-derived from the ``/finalise/`` route
 * (``tenantVersionsFinalisePartialUpdate``), which the frontend depends on
 * (see ``useTeammateStudio``/``AgentBuilderPage``). The ``finaliseAgentVersion``
 * operationId was historically (and incorrectly) attached to the DELETE destroy
 * view, which made the generated ``finaliseAgentVersion`` client issue a DELETE
 * and hard-delete drafts on approve.
 */
export const tenantVersionsFinalisePartialUpdate = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/finalise/`,
    method: 'PATCH',
    signal,
  });
};

export const getTenantVersionsFinalisePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsFinalisePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return tenantVersionsFinalisePartialUpdate(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsFinalisePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>
>;

export type TenantVersionsFinalisePartialUpdateMutationError = unknown;

export const useTenantVersionsFinalisePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsFinalisePartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getTenantVersionsFinalisePartialUpdateMutationOptions(options), queryClient);
};

/**
 * PATCH: Mark a pending draft as rejected without deleting it.
 *
 * Gives reviewers a way to dismiss a stale/unwanted draft (e.g. one
 * superseded by an already-activated version) so it stops lingering as
 * "Draft" in version history. Unlike the DELETE destroy endpoint the
 * version row is kept for audit. Finalised or active versions can't be
 * rejected.
 */
export const tenantVersionsRejectPartialUpdate = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/reject/`,
    method: 'PATCH',
    signal,
  });
};

export const getTenantVersionsRejectPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsRejectPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return tenantVersionsRejectPartialUpdate(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsRejectPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>
>;

export type TenantVersionsRejectPartialUpdateMutationError = unknown;

export const useTenantVersionsRejectPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsRejectPartialUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getTenantVersionsRejectPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Persist accept/deny review decisions for a draft version (VIG-1317).
 *
 * PUT: upsert one or more decisions so they survive refresh / navigation /
 * different machines. Body::
 *
 *     {"decisions": [
 *         {"target_type": "memory", "target_id": "<uuid>", "decision": "accepted"},
 *         {"target_type": "attachment", "target_id": "42", "decision": "denied"},
 *         {"target_type": "memory", "target_id": "<uuid>", "decision": null}
 *     ]}
 *
 * ``decision: null`` clears a previously-recorded decision (undo) by writing
 * a ``cleared`` tombstone row — the target reads as undecided again, but
 * decision inheritance from older stacked drafts won't re-apply it.
 * Returns the full persisted decision map (same shape as
 * ``AgentVersionSerializer.review_decisions``) so the client can reconcile.
 */
export const tenantVersionsReviewDecisionsRetrieve = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/review-decisions/`,
    method: 'GET',
    signal,
  });
};

export const getTenantVersionsReviewDecisionsRetrieveQueryKey = (agentId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/review-decisions/`] as const;
};

export const getTenantVersionsReviewDecisionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantVersionsReviewDecisionsRetrieveQueryKey(agentId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>> = ({ signal }) =>
    tenantVersionsReviewDecisionsRetrieve(agentId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TenantVersionsReviewDecisionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>
>;
export type TenantVersionsReviewDecisionsRetrieveQueryError = unknown;

export function useTenantVersionsReviewDecisionsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsReviewDecisionsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsReviewDecisionsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantVersionsReviewDecisionsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsReviewDecisionsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantVersionsReviewDecisionsRetrieveQueryOptions(agentId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Persist accept/deny review decisions for a draft version (VIG-1317).
 *
 * PUT: upsert one or more decisions so they survive refresh / navigation /
 * different machines. Body::
 *
 *     {"decisions": [
 *         {"target_type": "memory", "target_id": "<uuid>", "decision": "accepted"},
 *         {"target_type": "attachment", "target_id": "42", "decision": "denied"},
 *         {"target_type": "memory", "target_id": "<uuid>", "decision": null}
 *     ]}
 *
 * ``decision: null`` clears a previously-recorded decision (undo) by writing
 * a ``cleared`` tombstone row — the target reads as undecided again, but
 * decision inheritance from older stacked drafts won't re-apply it.
 * Returns the full persisted decision map (same shape as
 * ``AgentVersionSerializer.review_decisions``) so the client can reconcile.
 */
export const tenantVersionsReviewDecisionsUpdate = (agentId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${id}/review-decisions/`,
    method: 'PUT',
    signal,
  });
};

export const getTenantVersionsReviewDecisionsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>,
    TError,
    { agentId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsReviewDecisionsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>,
    { agentId: string; id: string }
  > = (props) => {
    const { agentId, id } = props ?? {};

    return tenantVersionsReviewDecisionsUpdate(agentId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsReviewDecisionsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>
>;

export type TenantVersionsReviewDecisionsUpdateMutationError = unknown;

export const useTenantVersionsReviewDecisionsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>,
      TError,
      { agentId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsReviewDecisionsUpdate>>,
  TError,
  { agentId: string; id: string },
  TContext
> => {
  return useMutation(getTenantVersionsReviewDecisionsUpdateMutationOptions(options), queryClient);
};

/**
 * Toggle importance flag for an attachment by creating a new agent version.
 */
export const tenantVersionsAttachmentsToggleImportantCreate = (
  agentId: string,
  versionId: string,
  fileId: number,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/attachments/${fileId}/toggle-important/`,
    method: 'POST',
    signal,
  });
};

export const getTenantVersionsAttachmentsToggleImportantCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>,
    TError,
    { agentId: string; versionId: string; fileId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>,
  TError,
  { agentId: string; versionId: string; fileId: number },
  TContext
> => {
  const mutationKey = ['tenantVersionsAttachmentsToggleImportantCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>,
    { agentId: string; versionId: string; fileId: number }
  > = (props) => {
    const { agentId, versionId, fileId } = props ?? {};

    return tenantVersionsAttachmentsToggleImportantCreate(agentId, versionId, fileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsAttachmentsToggleImportantCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>
>;

export type TenantVersionsAttachmentsToggleImportantCreateMutationError = unknown;

export const useTenantVersionsAttachmentsToggleImportantCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>,
      TError,
      { agentId: string; versionId: string; fileId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsAttachmentsToggleImportantCreate>>,
  TError,
  { agentId: string; versionId: string; fileId: number },
  TContext
> => {
  return useMutation(getTenantVersionsAttachmentsToggleImportantCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve all comments for a specific agent version.
 * @summary List Agent Comments
 */
export const listAgentComments3 = (agentId: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<AgentCommentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/`,
    method: 'GET',
    signal,
  });
};

export const getListAgentComments3QueryKey = (agentId: string, versionId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/`] as const;
};

export const getListAgentComments3QueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentComments3>>,
  TError = void,
>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentComments3QueryKey(agentId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentComments3>>> = ({ signal }) =>
    listAgentComments3(agentId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListAgentComments3QueryResult = NonNullable<Awaited<ReturnType<typeof listAgentComments3>>>;
export type ListAgentComments3QueryError = void;

export function useListAgentComments3<TData = Awaited<ReturnType<typeof listAgentComments3>>, TError = void>(
  agentId: string,
  versionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentComments3>>,
          TError,
          Awaited<ReturnType<typeof listAgentComments3>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentComments3<TData = Awaited<ReturnType<typeof listAgentComments3>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentComments3>>,
          TError,
          Awaited<ReturnType<typeof listAgentComments3>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentComments3<TData = Awaited<ReturnType<typeof listAgentComments3>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Agent Comments
 */

export function useListAgentComments3<TData = Awaited<ReturnType<typeof listAgentComments3>>, TError = void>(
  agentId: string,
  versionId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentComments3>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentComments3QueryOptions(agentId, versionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve all comments for a specific agent version.
 * @summary List Agent Comments
 */
export const listAgentComments4 = (
  agentId: string,
  versionId: string,
  agentCommentRequest: AgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentCommentList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentCommentRequest,
    signal,
  });
};

export const getListAgentComments4MutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAgentComments4>>,
    TError,
    { agentId: string; versionId: string; data: AgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAgentComments4>>,
  TError,
  { agentId: string; versionId: string; data: AgentCommentRequest },
  TContext
> => {
  const mutationKey = ['listAgentComments4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAgentComments4>>,
    { agentId: string; versionId: string; data: AgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, data } = props ?? {};

    return listAgentComments4(agentId, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAgentComments4MutationResult = NonNullable<Awaited<ReturnType<typeof listAgentComments4>>>;
export type ListAgentComments4MutationBody = AgentCommentRequest;
export type ListAgentComments4MutationError = void;

/**
 * @summary List Agent Comments
 */
export const useListAgentComments4 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAgentComments4>>,
      TError,
      { agentId: string; versionId: string; data: AgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAgentComments4>>,
  TError,
  { agentId: string; versionId: string; data: AgentCommentRequest },
  TContext
> => {
  return useMutation(getListAgentComments4MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment6 = (agentId: string, versionId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGetAgentComment6QueryKey = (agentId: string, versionId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/${id}/`] as const;
};

export const getGetAgentComment6QueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentComment6>>,
  TError = NotFoundResponse,
>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentComment6QueryKey(agentId, versionId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentComment6>>> = ({ signal }) =>
    getAgentComment6(agentId, versionId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      agentId !== null &&
      agentId !== undefined &&
      versionId !== null &&
      versionId !== undefined &&
      id !== null &&
      id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAgentComment6QueryResult = NonNullable<Awaited<ReturnType<typeof getAgentComment6>>>;
export type GetAgentComment6QueryError = NotFoundResponse;

export function useGetAgentComment6<TData = Awaited<ReturnType<typeof getAgentComment6>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentComment6>>,
          TError,
          Awaited<ReturnType<typeof getAgentComment6>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentComment6<TData = Awaited<ReturnType<typeof getAgentComment6>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentComment6>>,
          TError,
          Awaited<ReturnType<typeof getAgentComment6>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgentComment6<TData = Awaited<ReturnType<typeof getAgentComment6>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Agent Comment
 */

export function useGetAgentComment6<TData = Awaited<ReturnType<typeof getAgentComment6>>, TError = NotFoundResponse>(
  agentId: string,
  versionId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentComment6>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgentComment6QueryOptions(agentId, versionId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment8 = (
  agentId: string,
  versionId: string,
  id: string,
  agentCommentRequest: AgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: agentCommentRequest,
    signal,
  });
};

export const getGetAgentComment8MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment8>>,
    TError,
    { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment8>>,
  TError,
  { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
  TContext
> => {
  const mutationKey = ['getAgentComment8'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment8>>,
    { agentId: string; versionId: string; id: string; data: AgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, id, data } = props ?? {};

    return getAgentComment8(agentId, versionId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentComment8MutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment8>>>;
export type GetAgentComment8MutationBody = AgentCommentRequest;
export type GetAgentComment8MutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment8 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment8>>,
      TError,
      { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment8>>,
  TError,
  { agentId: string; versionId: string; id: string; data: AgentCommentRequest },
  TContext
> => {
  return useMutation(getGetAgentComment8MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment7 = (
  agentId: string,
  versionId: string,
  id: string,
  patchedAgentCommentRequest?: PatchedAgentCommentRequest,
  signal?: AbortSignal
) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentCommentRequest,
    signal,
  });
};

export const getGetAgentComment7MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment7>>,
    TError,
    { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment7>>,
  TError,
  { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
  TContext
> => {
  const mutationKey = ['getAgentComment7'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment7>>,
    { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest }
  > = (props) => {
    const { agentId, versionId, id, data } = props ?? {};

    return getAgentComment7(agentId, versionId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentComment7MutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment7>>>;
export type GetAgentComment7MutationBody = PatchedAgentCommentRequest | undefined;
export type GetAgentComment7MutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment7 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment7>>,
      TError,
      { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment7>>,
  TError,
  { agentId: string; versionId: string; id: string; data?: PatchedAgentCommentRequest },
  TContext
> => {
  return useMutation(getGetAgentComment7MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific comment by ID.
 * @summary Get Agent Comment
 */
export const getAgentComment5 = (agentId: string, versionId: string, id: string, signal?: AbortSignal) => {
  return customInstance<AgentComment>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/comments/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGetAgentComment5MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgentComment5>>,
    TError,
    { agentId: string; versionId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgentComment5>>,
  TError,
  { agentId: string; versionId: string; id: string },
  TContext
> => {
  const mutationKey = ['getAgentComment5'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgentComment5>>,
    { agentId: string; versionId: string; id: string }
  > = (props) => {
    const { agentId, versionId, id } = props ?? {};

    return getAgentComment5(agentId, versionId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentComment5MutationResult = NonNullable<Awaited<ReturnType<typeof getAgentComment5>>>;

export type GetAgentComment5MutationError = NotFoundResponse;

/**
 * @summary Get Agent Comment
 */
export const useGetAgentComment5 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgentComment5>>,
      TError,
      { agentId: string; versionId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgentComment5>>,
  TError,
  { agentId: string; versionId: string; id: string },
  TContext
> => {
  return useMutation(getGetAgentComment5MutationOptions(options), queryClient);
};

/**
 * GET: any workspace member can list (read-only UI for non-admins).
 */
export const tenantVersionsDocumentEditsRetrieve = (agentId: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/document-edits/`,
    method: 'GET',
    signal,
  });
};

export const getTenantVersionsDocumentEditsRetrieveQueryKey = (agentId: string, versionId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/document-edits/`] as const;
};

export const getTenantVersionsDocumentEditsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantVersionsDocumentEditsRetrieveQueryKey(agentId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>> = ({ signal }) =>
    tenantVersionsDocumentEditsRetrieve(agentId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TenantVersionsDocumentEditsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>
>;
export type TenantVersionsDocumentEditsRetrieveQueryError = unknown;

export function useTenantVersionsDocumentEditsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  versionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsDocumentEditsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsDocumentEditsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantVersionsDocumentEditsRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  versionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsDocumentEditsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantVersionsDocumentEditsRetrieveQueryOptions(agentId, versionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * No-op for tenant-agent training-debt dismissal.
 *
 * Mirrors ``PublicTrainingDebtDismissView`` and the deferred-save pattern
 * used by ``AgentKnowledgeDetailView.delete``: the editor tracks the
 * dismissal in local state and the change is committed only when the
 * user saves a new version. Mutating the active version's
 * ``training_debt`` here would silently rewrite agent state before the
 * user has clicked Save Version.
 */
export const tenantVersionsTrainingDebtDestroy = (
  agentId: string,
  versionId: string,
  debtId: string,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/training-debt/${debtId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getTenantVersionsTrainingDebtDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>,
    TError,
    { agentId: string; versionId: string; debtId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsTrainingDebtDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>,
    { agentId: string; versionId: string; debtId: string }
  > = (props) => {
    const { agentId, versionId, debtId } = props ?? {};

    return tenantVersionsTrainingDebtDestroy(agentId, versionId, debtId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsTrainingDebtDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>
>;

export type TenantVersionsTrainingDebtDestroyMutationError = unknown;

export const useTenantVersionsTrainingDebtDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>,
      TError,
      { agentId: string; versionId: string; debtId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtDestroy>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  return useMutation(getTenantVersionsTrainingDebtDestroyMutationOptions(options), queryClient);
};

/**
 * POST: Fulfill a training debt item by uploading a file.
 *
 * Deferred-save semantics (mirrors ``PublicTrainingDebtFulfillView``):
 * the uploaded file IS persisted immediately as ``UploadedFile`` /
 * ``KnowledgeDocument`` / ``KnowledgeDocumentVersion`` rows because the
 * knowledge library is shared state and the file has to physically exist
 * somewhere — but the active agent version is NOT mutated here. No
 * ``AgentKnowledgeLink`` is created, no debt item is removed. Instead the
 * response carries the file metadata + ``debt_id`` back to the editor,
 * which stages the file as a pending attachment and the dismissal in
 * local state. Both are committed when the user clicks Save Version, at
 * which point the regular version-create flow links the file and the
 * serializer writes the trimmed ``training_debt`` list.
 */
export const tenantVersionsTrainingDebtFulfillCreate = (
  agentId: string,
  versionId: string,
  debtId: string,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/${versionId}/training-debt/${debtId}/fulfill/`,
    method: 'POST',
    signal,
  });
};

export const getTenantVersionsTrainingDebtFulfillCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>,
    TError,
    { agentId: string; versionId: string; debtId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsTrainingDebtFulfillCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>,
    { agentId: string; versionId: string; debtId: string }
  > = (props) => {
    const { agentId, versionId, debtId } = props ?? {};

    return tenantVersionsTrainingDebtFulfillCreate(agentId, versionId, debtId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsTrainingDebtFulfillCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>
>;

export type TenantVersionsTrainingDebtFulfillCreateMutationError = unknown;

export const useTenantVersionsTrainingDebtFulfillCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>,
      TError,
      { agentId: string; versionId: string; debtId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsTrainingDebtFulfillCreate>>,
  TError,
  { agentId: string; versionId: string; debtId: string },
  TContext
> => {
  return useMutation(getTenantVersionsTrainingDebtFulfillCreateMutationOptions(options), queryClient);
};

/**
 * Structured diff between two versions of a tenant agent (sections, documents, memories, tools, workers).
 * @summary Compare Agent Versions
 */
export const compareAgentVersions = (agentId: string, params: CompareAgentVersionsParams, signal?: AbortSignal) => {
  return customInstance<AgentVersionCompareResponse>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getCompareAgentVersionsQueryKey = (agentId: string, params?: CompareAgentVersionsParams) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCompareAgentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof compareAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: CompareAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAgentVersions>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompareAgentVersionsQueryKey(agentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof compareAgentVersions>>> = ({ signal }) =>
    compareAgentVersions(agentId, params, signal);

  return { queryKey, queryFn, enabled: agentId !== null && agentId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof compareAgentVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CompareAgentVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof compareAgentVersions>>>;
export type CompareAgentVersionsQueryError = BadRequestResponse | void;

export function useCompareAgentVersions<
  TData = Awaited<ReturnType<typeof compareAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: CompareAgentVersionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAgentVersions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof compareAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCompareAgentVersions<
  TData = Awaited<ReturnType<typeof compareAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: CompareAgentVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAgentVersions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareAgentVersions>>,
          TError,
          Awaited<ReturnType<typeof compareAgentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCompareAgentVersions<
  TData = Awaited<ReturnType<typeof compareAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: CompareAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare Agent Versions
 */

export function useCompareAgentVersions<
  TData = Awaited<ReturnType<typeof compareAgentVersions>>,
  TError = BadRequestResponse | void,
>(
  agentId: string,
  params: CompareAgentVersionsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof compareAgentVersions>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCompareAgentVersionsQueryOptions(agentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * POST: start an async prompt-generation + version-create job.
 */
export const tenantVersionsGenerateCreate = (agentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/generate/`,
    method: 'POST',
    signal,
  });
};

export const getTenantVersionsGenerateCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>,
    TError,
    { agentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>,
  TError,
  { agentId: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsGenerateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>, { agentId: string }> = (
    props
  ) => {
    const { agentId } = props ?? {};

    return tenantVersionsGenerateCreate(agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>
>;

export type TenantVersionsGenerateCreateMutationError = unknown;

export const useTenantVersionsGenerateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>,
      TError,
      { agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsGenerateCreate>>,
  TError,
  { agentId: string },
  TContext
> => {
  return useMutation(getTenantVersionsGenerateCreateMutationOptions(options), queryClient);
};

/**
 * GET: poll a single generation job (also used as a WS fallback).
 */
export const tenantVersionsGenerateRetrieve = (agentId: string, jobId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/generate/${jobId}/`,
    method: 'GET',
    signal,
  });
};

export const getTenantVersionsGenerateRetrieveQueryKey = (agentId: string, jobId: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/generate/${jobId}/`] as const;
};

export const getTenantVersionsGenerateRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantVersionsGenerateRetrieveQueryKey(agentId, jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>> = ({ signal }) =>
    tenantVersionsGenerateRetrieve(agentId, jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined && jobId !== null && jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TenantVersionsGenerateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>
>;
export type TenantVersionsGenerateRetrieveQueryError = unknown;

export function useTenantVersionsGenerateRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  jobId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsGenerateRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionsGenerateRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantVersionsGenerateRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>,
  TError = unknown,
>(
  agentId: string,
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionsGenerateRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantVersionsGenerateRetrieveQueryOptions(agentId, jobId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * POST: resolve a compliance-BLOCKED generation job.
 *
 * Body: ``{"decision": "accept_changes" | "override_submit"}``
 *
 * Gives Teammate Studio the recovery path the Slack gate already has. Without
 * it a flagged save is terminal: no version is created and the admin loses the
 * draft with no way to acknowledge a false positive or apply the compliance
 * agent's own suggested fix. Both decisions persist the version and record the
 * override (with the original verdict) on the job for audit.
 */
export const tenantVersionsGenerateResolveCreate = (agentId: string, jobId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${agentId}/versions/generate/${jobId}/resolve/`,
    method: 'POST',
    signal,
  });
};

export const getTenantVersionsGenerateResolveCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>,
    TError,
    { agentId: string; jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>,
  TError,
  { agentId: string; jobId: string },
  TContext
> => {
  const mutationKey = ['tenantVersionsGenerateResolveCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>,
    { agentId: string; jobId: string }
  > = (props) => {
    const { agentId, jobId } = props ?? {};

    return tenantVersionsGenerateResolveCreate(agentId, jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantVersionsGenerateResolveCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>
>;

export type TenantVersionsGenerateResolveCreateMutationError = unknown;

export const useTenantVersionsGenerateResolveCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>,
      TError,
      { agentId: string; jobId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantVersionsGenerateResolveCreate>>,
  TError,
  { agentId: string; jobId: string },
  TContext
> => {
  return useMutation(getTenantVersionsGenerateResolveCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific tenant agent by ID.
 * @summary Get Tenant Agent
 */
export const getAgent2 = (id: string, signal?: AbortSignal) => {
  return customInstance<Agent>({ url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/`, method: 'GET', signal });
};

export const getGetAgent2QueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/`] as const;
};

export const getGetAgent2QueryOptions = <TData = Awaited<ReturnType<typeof getAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgent2>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgent2QueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgent2>>> = ({ signal }) => getAgent2(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgent2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAgent2QueryResult = NonNullable<Awaited<ReturnType<typeof getAgent2>>>;
export type GetAgent2QueryError = NotFoundResponse;

export function useGetAgent2<TData = Awaited<ReturnType<typeof getAgent2>>, TError = NotFoundResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgent2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAgent2>>, TError, Awaited<ReturnType<typeof getAgent2>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgent2<TData = Awaited<ReturnType<typeof getAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgent2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgent2>>,
          TError,
          Awaited<ReturnType<typeof getAgent2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgent2<TData = Awaited<ReturnType<typeof getAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgent2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Tenant Agent
 */

export function useGetAgent2<TData = Awaited<ReturnType<typeof getAgent2>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgent2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgent2QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific tenant agent by ID.
 * @summary Get Tenant Agent
 */
export const getAgent4 = (id: string, agentRequest?: AgentRequest, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: agentRequest,
    signal,
  });
};

export const getGetAgent4MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgent4>>,
    TError,
    { id: string; data?: AgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgent4>>,
  TError,
  { id: string; data?: AgentRequest },
  TContext
> => {
  const mutationKey = ['getAgent4'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAgent4>>, { id: string; data?: AgentRequest }> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return getAgent4(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgent4MutationResult = NonNullable<Awaited<ReturnType<typeof getAgent4>>>;
export type GetAgent4MutationBody = AgentRequest | undefined;
export type GetAgent4MutationError = NotFoundResponse;

/**
 * @summary Get Tenant Agent
 */
export const useGetAgent4 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgent4>>,
      TError,
      { id: string; data?: AgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getAgent4>>, TError, { id: string; data?: AgentRequest }, TContext> => {
  return useMutation(getGetAgent4MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific tenant agent by ID.
 * @summary Get Tenant Agent
 */
export const getAgent3 = (id: string, patchedAgentRequest?: PatchedAgentRequest, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAgentRequest,
    signal,
  });
};

export const getGetAgent3MutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAgent3>>,
    TError,
    { id: string; data?: PatchedAgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAgent3>>,
  TError,
  { id: string; data?: PatchedAgentRequest },
  TContext
> => {
  const mutationKey = ['getAgent3'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAgent3>>,
    { id: string; data?: PatchedAgentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return getAgent3(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgent3MutationResult = NonNullable<Awaited<ReturnType<typeof getAgent3>>>;
export type GetAgent3MutationBody = PatchedAgentRequest | undefined;
export type GetAgent3MutationError = NotFoundResponse;

/**
 * @summary Get Tenant Agent
 */
export const useGetAgent3 = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAgent3>>,
      TError,
      { id: string; data?: PatchedAgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAgent3>>,
  TError,
  { id: string; data?: PatchedAgentRequest },
  TContext
> => {
  return useMutation(getGetAgent3MutationOptions(options), queryClient);
};

/**
 * Retrieve a specific tenant agent by ID.
 * @summary Get Tenant Agent
 */
export const getAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<Agent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGetAgentMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof getAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['getAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return getAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAgentMutationResult = NonNullable<Awaited<ReturnType<typeof getAgent>>>;

export type GetAgentMutationError = NotFoundResponse;

/**
 * @summary Get Tenant Agent
 */
export const useGetAgent = <TError = NotFoundResponse, TContext = unknown>(
  options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof getAgent>>, TError, { id: string }, TContext> },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getGetAgentMutationOptions(options), queryClient);
};

/**
 * API view for getting the active content of a tenant agent.
 * GET: Returns the active version content of a tenant agent
 */
export const tenantActiveContentRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<AgentActiveContent>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/active-content/`,
    method: 'GET',
    signal,
  });
};

export const getTenantActiveContentRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/active-content/`] as const;
};

export const getTenantActiveContentRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantActiveContentRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>> = ({ signal }) =>
    tenantActiveContentRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantActiveContentRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantActiveContentRetrieve>>
>;
export type TenantActiveContentRetrieveQueryError = unknown;

export function useTenantActiveContentRetrieve<
  TData = Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantActiveContentRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantActiveContentRetrieve<
  TData = Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantActiveContentRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantActiveContentRetrieve<
  TData = Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantActiveContentRetrieve<
  TData = Awaited<ReturnType<typeof tenantActiveContentRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantActiveContentRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantActiveContentRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Archive an agent — sets status to 'archived'.
 * @summary Archive Agent
 */
export const archiveAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/archive/`,
    method: 'PATCH',
    signal,
  });
};

export const getArchiveAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof archiveAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof archiveAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['archiveAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return archiveAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveAgentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAgent>>>;

export type ArchiveAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary Archive Agent
 */
export const useArchiveAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof archiveAgent>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof archiveAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getArchiveAgentMutationOptions(options), queryClient);
};

/**
 * End an agent's probation — sets status to 'hired' and clears channel restriction.
 * @summary End Agent Probation
 */
export const endProbationAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/end-probation/`,
    method: 'PATCH',
    signal,
  });
};

export const getEndProbationAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof endProbationAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof endProbationAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['endProbationAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof endProbationAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return endProbationAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndProbationAgentMutationResult = NonNullable<Awaited<ReturnType<typeof endProbationAgent>>>;

export type EndProbationAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary End Agent Probation
 */
export const useEndProbationAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof endProbationAgent>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof endProbationAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getEndProbationAgentMutationOptions(options), queryClient);
};

/**
 * Hire (approve) a proposed agent — sets status to 'hired'. If the agent has no active version, activates the latest finalised one.
 * @summary Hire Agent
 */
export const hireAgent = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/hire/`,
    method: 'PATCH',
    signal,
  });
};

export const getHireAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof hireAgent>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof hireAgent>>, TError, { id: string }, TContext> => {
  const mutationKey = ['hireAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireAgent>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return hireAgent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type HireAgentMutationResult = NonNullable<Awaited<ReturnType<typeof hireAgent>>>;

export type HireAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary Hire Agent
 */
export const useHireAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof hireAgent>>, TError, { id: string }, TContext> },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof hireAgent>>, TError, { id: string }, TContext> => {
  return useMutation(getHireAgentMutationOptions(options), queryClient);
};

/**
 * Place an agent on probation — restricts it to a single Slack channel. Also used to change the probation channel of an agent already on probation, or to return a hired agent to probation. Requires channel_id (and optionally channel_name) in the request body.
 * @summary Place Agent on Probation
 */
export const probationAgent = (id: string, probationAgentBody?: ProbationAgentBody, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/${id}/probation/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: probationAgentBody,
    signal,
  });
};

export const getProbationAgentMutationOptions = <
  TError = BadRequestResponse | NotFoundResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof probationAgent>>,
    TError,
    { id: string; data?: ProbationAgentBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof probationAgent>>,
  TError,
  { id: string; data?: ProbationAgentBody },
  TContext
> => {
  const mutationKey = ['probationAgent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof probationAgent>>,
    { id: string; data?: ProbationAgentBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return probationAgent(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProbationAgentMutationResult = NonNullable<Awaited<ReturnType<typeof probationAgent>>>;
export type ProbationAgentMutationBody = ProbationAgentBody | undefined;
export type ProbationAgentMutationError = BadRequestResponse | NotFoundResponse;

/**
 * @summary Place Agent on Probation
 */
export const useProbationAgent = <TError = BadRequestResponse | NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof probationAgent>>,
      TError,
      { id: string; data?: ProbationAgentBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof probationAgent>>,
  TError,
  { id: string; data?: ProbationAgentBody },
  TContext
> => {
  return useMutation(getProbationAgentMutationOptions(options), queryClient);
};

/**
 * Run a targeted LLM improvement on a SINGLE Teammate Studio text field (VIG-1309). The model receives the teammate's other ontology fields and summaries of its attached knowledge documents as read-only background context, but its output replaces only the targeted field. Nothing is persisted — the caller presents the result as a before/after diff for the user to accept, edit, or reject in the Studio UI.
 * @summary Enhance Ontology Field
 */
export const enhanceOntologyField = (enhanceOntologyFieldBody?: EnhanceOntologyFieldBody, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/enhance-field/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: enhanceOntologyFieldBody,
    signal,
  });
};

export const getEnhanceOntologyFieldMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enhanceOntologyField>>,
    TError,
    { data?: EnhanceOntologyFieldBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enhanceOntologyField>>,
  TError,
  { data?: EnhanceOntologyFieldBody },
  TContext
> => {
  const mutationKey = ['enhanceOntologyField'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enhanceOntologyField>>,
    { data?: EnhanceOntologyFieldBody }
  > = (props) => {
    const { data } = props ?? {};

    return enhanceOntologyField(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnhanceOntologyFieldMutationResult = NonNullable<Awaited<ReturnType<typeof enhanceOntologyField>>>;
export type EnhanceOntologyFieldMutationBody = EnhanceOntologyFieldBody | undefined;
export type EnhanceOntologyFieldMutationError = void;

/**
 * @summary Enhance Ontology Field
 */
export const useEnhanceOntologyField = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enhanceOntologyField>>,
      TError,
      { data?: EnhanceOntologyFieldBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enhanceOntologyField>>,
  TError,
  { data?: EnhanceOntologyFieldBody },
  TContext
> => {
  return useMutation(getEnhanceOntologyFieldMutationOptions(options), queryClient);
};

/**
 * Render a system prompt from structured Teammate Studio fields by deterministic programmatic stitching — no LLM transforms the compiled output, so field content lands in the prompt character-for-character (VIG-1309). Also returns a pre-creation compliance verdict and a version-over-version changelog. When `agent_id` is provided and the agent has at least one existing version, that latest existing version (by `created_at`, regardless of `is_active`) is used as the changelog baseline. Callers must forward the returned `changelog` in the subsequent POST to the version create endpoint so it is persisted on the new AgentVersion row.
 * @summary Generate System Prompt
 */
export const generateSystemPrompt = (generateSystemPromptBody?: GenerateSystemPromptBody, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/generate-prompt/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateSystemPromptBody,
    signal,
  });
};

export const getGenerateSystemPromptMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSystemPrompt>>,
    TError,
    { data?: GenerateSystemPromptBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSystemPrompt>>,
  TError,
  { data?: GenerateSystemPromptBody },
  TContext
> => {
  const mutationKey = ['generateSystemPrompt'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSystemPrompt>>,
    { data?: GenerateSystemPromptBody }
  > = (props) => {
    const { data } = props ?? {};

    return generateSystemPrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSystemPromptMutationResult = NonNullable<Awaited<ReturnType<typeof generateSystemPrompt>>>;
export type GenerateSystemPromptMutationBody = GenerateSystemPromptBody | undefined;
export type GenerateSystemPromptMutationError = void;

/**
 * @summary Generate System Prompt
 */
export const useGenerateSystemPrompt = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateSystemPrompt>>,
      TError,
      { data?: GenerateSystemPromptBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateSystemPrompt>>,
  TError,
  { data?: GenerateSystemPromptBody },
  TContext
> => {
  return useMutation(getGenerateSystemPromptMutationOptions(options), queryClient);
};

/**
 * GET: list in-flight generation jobs for the current workspace.
 *
 * Lets the client re-attach to a running generation after a page refresh or
 * navigation. Only ``pending``/``generating`` jobs are returned — terminal
 * results are delivered live over the WebSocket (or via the status endpoint
 * fallback).
 */
export const tenantVersionGenerationsActiveRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/tenant/version-generations/active/`,
    method: 'GET',
    signal,
  });
};

export const getTenantVersionGenerationsActiveRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/tenant/version-generations/active/`] as const;
};

export const getTenantVersionGenerationsActiveRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTenantVersionGenerationsActiveRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>> = ({ signal }) =>
    tenantVersionGenerationsActiveRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantVersionGenerationsActiveRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>
>;
export type TenantVersionGenerationsActiveRetrieveQueryError = unknown;

export function useTenantVersionGenerationsActiveRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionGenerationsActiveRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTenantVersionGenerationsActiveRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTenantVersionGenerationsActiveRetrieve<
  TData = Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantVersionGenerationsActiveRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTenantVersionGenerationsActiveRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Aggregated token usage across all workspaces: totals, daily trend, and call-type/model breakdowns. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] Platform Token Usage Summary
 */
export const tokenUsageAdminSummaryRetrieve = (params?: TokenUsageAdminSummaryRetrieveParams, signal?: AbortSignal) => {
  return customInstance<TokenUsageSummary>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/summary/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTokenUsageAdminSummaryRetrieveQueryKey = (params?: TokenUsageAdminSummaryRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/summary/`, ...(params ? [params] : [])] as const;
};

export const getTokenUsageAdminSummaryRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminSummaryRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTokenUsageAdminSummaryRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>> = ({ signal }) =>
    tokenUsageAdminSummaryRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TokenUsageAdminSummaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>
>;
export type TokenUsageAdminSummaryRetrieveQueryError = unknown;

export function useTokenUsageAdminSummaryRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
  TError = unknown,
>(
  params: undefined | TokenUsageAdminSummaryRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminSummaryRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminSummaryRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminSummaryRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminSummaryRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Admin] Platform Token Usage Summary
 */

export function useTokenUsageAdminSummaryRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminSummaryRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminSummaryRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTokenUsageAdminSummaryRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Token usage totals per workspace, sorted by total tokens. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] Token Usage per Workspace
 */
export const tokenUsageAdminWorkspacesRetrieve = (
  params?: TokenUsageAdminWorkspacesRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<TokenUsageWorkspaces>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTokenUsageAdminWorkspacesRetrieveQueryKey = (params?: TokenUsageAdminWorkspacesRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/`, ...(params ? [params] : [])] as const;
};

export const getTokenUsageAdminWorkspacesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminWorkspacesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTokenUsageAdminWorkspacesRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>> = ({ signal }) =>
    tokenUsageAdminWorkspacesRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TokenUsageAdminWorkspacesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>
>;
export type TokenUsageAdminWorkspacesRetrieveQueryError = unknown;

export function useTokenUsageAdminWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
  TError = unknown,
>(
  params: undefined | TokenUsageAdminWorkspacesRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminWorkspacesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminWorkspacesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Admin] Token Usage per Workspace
 */

export function useTokenUsageAdminWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageAdminWorkspacesRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTokenUsageAdminWorkspacesRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Token usage for a single agent within a workspace: totals, a daily trend split by model, and call-type/model breakdowns. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] Agent Token Usage Breakdown
 */
export const tokenUsageAdminWorkspacesAgentsBreakdownRetrieve = (
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<AgentBreakdown>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/${workspaceId}/agents/${agentId}/breakdown/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryKey = (
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/${workspaceId}/agents/${agentId}/breakdown/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryKey(workspaceId, agentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>> = ({
    signal,
  }) => tokenUsageAdminWorkspacesAgentsBreakdownRetrieve(workspaceId, agentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined && agentId !== null && agentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>
>;
export type TokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryError = unknown;

export function useTokenUsageAdminWorkspacesAgentsBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  agentId: string,
  params: undefined | TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesAgentsBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesAgentsBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Admin] Agent Token Usage Breakdown
 */

export function useTokenUsageAdminWorkspacesAgentsBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  agentId: string,
  params?: TokenUsageAdminWorkspacesAgentsBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesAgentsBreakdownRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTokenUsageAdminWorkspacesAgentsBreakdownRetrieveQueryOptions(
    workspaceId,
    agentId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Near-real-time drill-down for one workspace from its detail records: totals, daily trend, and call-type/model/agent breakdowns. Only accessible from the vigilantai workspace by admin users.
 * @summary [Admin] Workspace Token Usage Breakdown
 */
export const tokenUsageAdminWorkspacesBreakdownRetrieve = (
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceBreakdown>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/${workspaceId}/breakdown/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTokenUsageAdminWorkspacesBreakdownRetrieveQueryKey = (
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/token-usage/admin/workspaces/${workspaceId}/breakdown/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getTokenUsageAdminWorkspacesBreakdownRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTokenUsageAdminWorkspacesBreakdownRetrieveQueryKey(workspaceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>> = ({ signal }) =>
    tokenUsageAdminWorkspacesBreakdownRetrieve(workspaceId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TokenUsageAdminWorkspacesBreakdownRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>
>;
export type TokenUsageAdminWorkspacesBreakdownRetrieveQueryError = unknown;

export function useTokenUsageAdminWorkspacesBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  params: undefined | TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageAdminWorkspacesBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Admin] Workspace Token Usage Breakdown
 */

export function useTokenUsageAdminWorkspacesBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: TokenUsageAdminWorkspacesBreakdownRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tokenUsageAdminWorkspacesBreakdownRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTokenUsageAdminWorkspacesBreakdownRetrieveQueryOptions(workspaceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Estimated LLM cost for the selected workspace, including period comparison, month-end projection, daily trend, and user/teammate/capability/model breakdowns. Requires the usage analytics feature and workspace admin role.
 * @summary Workspace Usage Analytics
 */
export const tokenUsageCostAnalyticsRetrieve = (
  params?: TokenUsageCostAnalyticsRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<ClientCostAnalytics>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/token-usage/cost-analytics/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTokenUsageCostAnalyticsRetrieveQueryKey = (params?: TokenUsageCostAnalyticsRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/token-usage/cost-analytics/`, ...(params ? [params] : [])] as const;
};

export const getTokenUsageCostAnalyticsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageCostAnalyticsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTokenUsageCostAnalyticsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>> = ({ signal }) =>
    tokenUsageCostAnalyticsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TokenUsageCostAnalyticsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>
>;
export type TokenUsageCostAnalyticsRetrieveQueryError = unknown;

export function useTokenUsageCostAnalyticsRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
  TError = unknown,
>(
  params: undefined | TokenUsageCostAnalyticsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageCostAnalyticsRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageCostAnalyticsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTokenUsageCostAnalyticsRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageCostAnalyticsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Workspace Usage Analytics
 */

export function useTokenUsageCostAnalyticsRetrieve<
  TData = Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>,
  TError = unknown,
>(
  params?: TokenUsageCostAnalyticsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tokenUsageCostAnalyticsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTokenUsageCostAnalyticsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersList = (signal?: AbortSignal) => {
  return customInstance<TriggerList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/`] as const;
};

export const getTriggersListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersList>>> = ({ signal }) => triggersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersListQueryResult = NonNullable<Awaited<ReturnType<typeof triggersList>>>;
export type TriggersListQueryError = unknown;

export function useTriggersList<TData = Awaited<ReturnType<typeof triggersList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersList>>,
          TError,
          Awaited<ReturnType<typeof triggersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersList<TData = Awaited<ReturnType<typeof triggersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersList>>,
          TError,
          Awaited<ReturnType<typeof triggersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersList<TData = Awaited<ReturnType<typeof triggersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersList<TData = Awaited<ReturnType<typeof triggersList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersCreate = (triggerCreateRequest: TriggerCreateRequest, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerCreateRequest,
    signal,
  });
};

export const getTriggersCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersCreate>>,
    TError,
    { data: TriggerCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersCreate>>,
  TError,
  { data: TriggerCreateRequest },
  TContext
> => {
  const mutationKey = ['triggersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersCreate>>, { data: TriggerCreateRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return triggersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersCreate>>>;
export type TriggersCreateMutationBody = TriggerCreateRequest;
export type TriggersCreateMutationError = unknown;

export const useTriggersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersCreate>>,
      TError,
      { data: TriggerCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersCreate>>, TError, { data: TriggerCreateRequest }, TContext> => {
  return useMutation(getTriggersCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/`] as const;
};

export const getTriggersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof triggersRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersRetrieve>>> = ({ signal }) =>
    triggersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof triggersRetrieve>>>;
export type TriggersRetrieveQueryError = unknown;

export function useTriggersRetrieve<TData = Awaited<ReturnType<typeof triggersRetrieve>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRetrieve<TData = Awaited<ReturnType<typeof triggersRetrieve>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRetrieve<TData = Awaited<ReturnType<typeof triggersRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersRetrieve<TData = Awaited<ReturnType<typeof triggersRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersPartialUpdate = (
  id: string,
  patchedTriggerUpdateRequest?: PatchedTriggerUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedTriggerUpdateRequest,
    signal,
  });
};

export const getTriggersPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersPartialUpdate>>,
    TError,
    { id: string; data?: PatchedTriggerUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedTriggerUpdateRequest },
  TContext
> => {
  const mutationKey = ['triggersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersPartialUpdate>>,
    { id: string; data?: PatchedTriggerUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return triggersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersPartialUpdate>>>;
export type TriggersPartialUpdateMutationBody = PatchedTriggerUpdateRequest | undefined;
export type TriggersPartialUpdateMutationError = unknown;

export const useTriggersPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersPartialUpdate>>,
      TError,
      { id: string; data?: PatchedTriggerUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedTriggerUpdateRequest },
  TContext
> => {
  return useMutation(getTriggersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getTriggersDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggersDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['triggersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return triggersDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof triggersDestroy>>>;

export type TriggersDestroyMutationError = unknown;

export const useTriggersDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getTriggersDestroyMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersApiKeysList = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerAPIKeyList[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/api-keys/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersApiKeysListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/api-keys/`] as const;
};

export const getTriggersApiKeysListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersApiKeysList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersApiKeysList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersApiKeysListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersApiKeysList>>> = ({ signal }) =>
    triggersApiKeysList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersApiKeysList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersApiKeysListQueryResult = NonNullable<Awaited<ReturnType<typeof triggersApiKeysList>>>;
export type TriggersApiKeysListQueryError = unknown;

export function useTriggersApiKeysList<TData = Awaited<ReturnType<typeof triggersApiKeysList>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersApiKeysList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersApiKeysList>>,
          TError,
          Awaited<ReturnType<typeof triggersApiKeysList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersApiKeysList<TData = Awaited<ReturnType<typeof triggersApiKeysList>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersApiKeysList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersApiKeysList>>,
          TError,
          Awaited<ReturnType<typeof triggersApiKeysList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersApiKeysList<TData = Awaited<ReturnType<typeof triggersApiKeysList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersApiKeysList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersApiKeysList<TData = Awaited<ReturnType<typeof triggersApiKeysList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersApiKeysList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersApiKeysListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersApiKeysCreate = (
  id: string,
  triggerAPIKeyCreateRequest?: TriggerAPIKeyCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerAPIKeyCreateResponse>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/api-keys/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerAPIKeyCreateRequest,
    signal,
  });
};

export const getTriggersApiKeysCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersApiKeysCreate>>,
    TError,
    { id: string; data?: TriggerAPIKeyCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersApiKeysCreate>>,
  TError,
  { id: string; data?: TriggerAPIKeyCreateRequest },
  TContext
> => {
  const mutationKey = ['triggersApiKeysCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersApiKeysCreate>>,
    { id: string; data?: TriggerAPIKeyCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return triggersApiKeysCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersApiKeysCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersApiKeysCreate>>>;
export type TriggersApiKeysCreateMutationBody = TriggerAPIKeyCreateRequest | undefined;
export type TriggersApiKeysCreateMutationError = unknown;

export const useTriggersApiKeysCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersApiKeysCreate>>,
      TError,
      { id: string; data?: TriggerAPIKeyCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersApiKeysCreate>>,
  TError,
  { id: string; data?: TriggerAPIKeyCreateRequest },
  TContext
> => {
  return useMutation(getTriggersApiKeysCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersArchiveCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/archive/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersArchiveCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersArchiveCreate>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggersArchiveCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['triggersArchiveCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersArchiveCreate>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return triggersArchiveCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersArchiveCreate>>>;

export type TriggersArchiveCreateMutationError = unknown;

export const useTriggersArchiveCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersArchiveCreate>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersArchiveCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getTriggersArchiveCreateMutationOptions(options), queryClient);
};

/**
 * Stage a new inbound handle on a draft trigger version.
 *
 * The live address (registry + ``Trigger.email_handle``) only changes when
 * that version is published — same save → publish lifecycle as every other
 * trigger field.
 */
export const triggersEmailAddressPartialUpdate = (
  id: string,
  patchedTriggerEmailAddressUpdateRequest?: PatchedTriggerEmailAddressUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/email-address/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedTriggerEmailAddressUpdateRequest,
    signal,
  });
};

export const getTriggersEmailAddressPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>,
    TError,
    { id: string; data?: PatchedTriggerEmailAddressUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>,
  TError,
  { id: string; data?: PatchedTriggerEmailAddressUpdateRequest },
  TContext
> => {
  const mutationKey = ['triggersEmailAddressPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>,
    { id: string; data?: PatchedTriggerEmailAddressUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return triggersEmailAddressPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersEmailAddressPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>
>;
export type TriggersEmailAddressPartialUpdateMutationBody = PatchedTriggerEmailAddressUpdateRequest | undefined;
export type TriggersEmailAddressPartialUpdateMutationError = unknown;

export const useTriggersEmailAddressPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>,
      TError,
      { id: string; data?: PatchedTriggerEmailAddressUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersEmailAddressPartialUpdate>>,
  TError,
  { id: string; data?: PatchedTriggerEmailAddressUpdateRequest },
  TContext
> => {
  return useMutation(getTriggersEmailAddressPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersPauseCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/pause/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersPauseCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersPauseCreate>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggersPauseCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['triggersPauseCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersPauseCreate>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return triggersPauseCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersPauseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersPauseCreate>>>;

export type TriggersPauseCreateMutationError = unknown;

export const useTriggersPauseCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersPauseCreate>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersPauseCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getTriggersPauseCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersResumeCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/resume/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersResumeCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersResumeCreate>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggersResumeCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['triggersResumeCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersResumeCreate>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return triggersResumeCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersResumeCreate>>>;

export type TriggersResumeCreateMutationError = unknown;

export const useTriggersResumeCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersResumeCreate>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersResumeCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getTriggersResumeCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersRunsList = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerRun[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/runs/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersRunsListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/runs/`] as const;
};

export const getTriggersRunsListQueryOptions = <TData = Awaited<ReturnType<typeof triggersRunsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersRunsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersRunsList>>> = ({ signal }) =>
    triggersRunsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersRunsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof triggersRunsList>>>;
export type TriggersRunsListQueryError = unknown;

export function useTriggersRunsList<TData = Awaited<ReturnType<typeof triggersRunsList>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRunsList>>,
          TError,
          Awaited<ReturnType<typeof triggersRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRunsList<TData = Awaited<ReturnType<typeof triggersRunsList>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRunsList>>,
          TError,
          Awaited<ReturnType<typeof triggersRunsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRunsList<TData = Awaited<ReturnType<typeof triggersRunsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersRunsList<TData = Awaited<ReturnType<typeof triggersRunsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersRunsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersUnarchiveCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/unarchive/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersUnarchiveCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof triggersUnarchiveCreate>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof triggersUnarchiveCreate>>, TError, { id: string }, TContext> => {
  const mutationKey = ['triggersUnarchiveCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggersUnarchiveCreate>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return triggersUnarchiveCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersUnarchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersUnarchiveCreate>>>;

export type TriggersUnarchiveCreateMutationError = unknown;

export const useTriggersUnarchiveCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersUnarchiveCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof triggersUnarchiveCreate>>, TError, { id: string }, TContext> => {
  return useMutation(getTriggersUnarchiveCreateMutationOptions(options), queryClient);
};

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersVersionsList = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersVersionsListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/versions/`] as const;
};

export const getTriggersVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersVersionsList>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersVersionsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersVersionsList>>> = ({ signal }) =>
    triggersVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersVersionsListQueryResult = NonNullable<Awaited<ReturnType<typeof triggersVersionsList>>>;
export type TriggersVersionsListQueryError = unknown;

export function useTriggersVersionsList<TData = Awaited<ReturnType<typeof triggersVersionsList>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersVersionsList>>,
          TError,
          Awaited<ReturnType<typeof triggersVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersVersionsList<TData = Awaited<ReturnType<typeof triggersVersionsList>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersVersionsList>>,
          TError,
          Awaited<ReturnType<typeof triggersVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersVersionsList<TData = Awaited<ReturnType<typeof triggersVersionsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersVersionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersVersionsList<TData = Awaited<ReturnType<typeof triggersVersionsList>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersVersionsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Tenant-scoped trigger management surface.
 *
 * Phase 2 exposes the URL contract and read serializers. Mutation behavior is
 * intentionally deferred to the relevant implementation phases so we do not
 * create partial trigger records that bypass version lifecycle rules.
 */
export const triggersVersionsCreate = (
  id: string,
  triggerVersionCreateRequest?: TriggerVersionCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerVersion>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerVersionCreateRequest,
    signal,
  });
};

export const getTriggersVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersVersionsCreate>>,
    TError,
    { id: string; data?: TriggerVersionCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersVersionsCreate>>,
  TError,
  { id: string; data?: TriggerVersionCreateRequest },
  TContext
> => {
  const mutationKey = ['triggersVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersVersionsCreate>>,
    { id: string; data?: TriggerVersionCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return triggersVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersVersionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersVersionsCreate>>>;
export type TriggersVersionsCreateMutationBody = TriggerVersionCreateRequest | undefined;
export type TriggersVersionsCreateMutationError = unknown;

export const useTriggersVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersVersionsCreate>>,
      TError,
      { id: string; data?: TriggerVersionCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersVersionsCreate>>,
  TError,
  { id: string; data?: TriggerVersionCreateRequest },
  TContext
> => {
  return useMutation(getTriggersVersionsCreateMutationOptions(options), queryClient);
};

export const triggersApiKeysRevokeCreate = (triggerId: string, keyId: string, signal?: AbortSignal) => {
  return customInstance<TriggerAPIKeyList>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${triggerId}/api-keys/${keyId}/revoke/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersApiKeysRevokeCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>,
    TError,
    { triggerId: string; keyId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>,
  TError,
  { triggerId: string; keyId: string },
  TContext
> => {
  const mutationKey = ['triggersApiKeysRevokeCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>,
    { triggerId: string; keyId: string }
  > = (props) => {
    const { triggerId, keyId } = props ?? {};

    return triggersApiKeysRevokeCreate(triggerId, keyId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersApiKeysRevokeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>
>;

export type TriggersApiKeysRevokeCreateMutationError = unknown;

export const useTriggersApiKeysRevokeCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>,
      TError,
      { triggerId: string; keyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersApiKeysRevokeCreate>>,
  TError,
  { triggerId: string; keyId: string },
  TContext
> => {
  return useMutation(getTriggersApiKeysRevokeCreateMutationOptions(options), queryClient);
};

export const triggersApiKeysRotateCreate = (
  triggerId: string,
  keyId: string,
  triggerAPIKeyCreateRequest?: TriggerAPIKeyCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerAPIKeyCreateResponse>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${triggerId}/api-keys/${keyId}/rotate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerAPIKeyCreateRequest,
    signal,
  });
};

export const getTriggersApiKeysRotateCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>,
    TError,
    { triggerId: string; keyId: string; data?: TriggerAPIKeyCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>,
  TError,
  { triggerId: string; keyId: string; data?: TriggerAPIKeyCreateRequest },
  TContext
> => {
  const mutationKey = ['triggersApiKeysRotateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>,
    { triggerId: string; keyId: string; data?: TriggerAPIKeyCreateRequest }
  > = (props) => {
    const { triggerId, keyId, data } = props ?? {};

    return triggersApiKeysRotateCreate(triggerId, keyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersApiKeysRotateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>
>;
export type TriggersApiKeysRotateCreateMutationBody = TriggerAPIKeyCreateRequest | undefined;
export type TriggersApiKeysRotateCreateMutationError = unknown;

export const useTriggersApiKeysRotateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>,
      TError,
      { triggerId: string; keyId: string; data?: TriggerAPIKeyCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersApiKeysRotateCreate>>,
  TError,
  { triggerId: string; keyId: string; data?: TriggerAPIKeyCreateRequest },
  TContext
> => {
  return useMutation(getTriggersApiKeysRotateCreateMutationOptions(options), queryClient);
};

export const triggersTestCreate = (
  triggerId: string,
  triggerTestExecutionRequestRequest?: TriggerTestExecutionRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerRun>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${triggerId}/test/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerTestExecutionRequestRequest,
    signal,
  });
};

export const getTriggersTestCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersTestCreate>>,
    TError,
    { triggerId: string; data?: TriggerTestExecutionRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersTestCreate>>,
  TError,
  { triggerId: string; data?: TriggerTestExecutionRequestRequest },
  TContext
> => {
  const mutationKey = ['triggersTestCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersTestCreate>>,
    { triggerId: string; data?: TriggerTestExecutionRequestRequest }
  > = (props) => {
    const { triggerId, data } = props ?? {};

    return triggersTestCreate(triggerId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersTestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof triggersTestCreate>>>;
export type TriggersTestCreateMutationBody = TriggerTestExecutionRequestRequest | undefined;
export type TriggersTestCreateMutationError = unknown;

export const useTriggersTestCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersTestCreate>>,
      TError,
      { triggerId: string; data?: TriggerTestExecutionRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersTestCreate>>,
  TError,
  { triggerId: string; data?: TriggerTestExecutionRequestRequest },
  TContext
> => {
  return useMutation(getTriggersTestCreateMutationOptions(options), queryClient);
};

export const triggersVersionsPublishCreate = (triggerId: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<TriggerDetail>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/${triggerId}/versions/${versionId}/publish/`,
    method: 'POST',
    signal,
  });
};

export const getTriggersVersionsPublishCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersVersionsPublishCreate>>,
    TError,
    { triggerId: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersVersionsPublishCreate>>,
  TError,
  { triggerId: string; versionId: string },
  TContext
> => {
  const mutationKey = ['triggersVersionsPublishCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersVersionsPublishCreate>>,
    { triggerId: string; versionId: string }
  > = (props) => {
    const { triggerId, versionId } = props ?? {};

    return triggersVersionsPublishCreate(triggerId, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersVersionsPublishCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggersVersionsPublishCreate>>
>;

export type TriggersVersionsPublishCreateMutationError = unknown;

export const useTriggersVersionsPublishCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersVersionsPublishCreate>>,
      TError,
      { triggerId: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersVersionsPublishCreate>>,
  TError,
  { triggerId: string; versionId: string },
  TContext
> => {
  return useMutation(getTriggersVersionsPublishCreateMutationOptions(options), queryClient);
};

/**
 * Expose the inbound email domain and workspace suffix (non-secret).
 *
 * Each trigger's own address is on the trigger payload; this endpoint says
 * whether the environment can receive mail at all and which immutable suffix
 * the workspace owns, so the UI can render it as fixed text next to the
 * editable part.
 */
export const triggersEmailConfigRetrieve = (signal?: AbortSignal) => {
  return customInstance<TriggerEmailConfig>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/email-config/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersEmailConfigRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/email-config/`] as const;
};

export const getTriggersEmailConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersEmailConfigRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>> = ({ signal }) =>
    triggersEmailConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersEmailConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>
>;
export type TriggersEmailConfigRetrieveQueryError = unknown;

export function useTriggersEmailConfigRetrieve<
  TData = Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersEmailConfigRetrieve<
  TData = Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersEmailConfigRetrieve<
  TData = Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersEmailConfigRetrieve<
  TData = Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersEmailConfigRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersEmailConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const triggersPlatformsList = (signal?: AbortSignal) => {
  return customInstance<TriggerPlatform[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersPlatformsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/`] as const;
};

export const getTriggersPlatformsListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersPlatformsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersPlatformsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersPlatformsList>>> = ({ signal }) =>
    triggersPlatformsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersPlatformsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersPlatformsListQueryResult = NonNullable<Awaited<ReturnType<typeof triggersPlatformsList>>>;
export type TriggersPlatformsListQueryError = unknown;

export function useTriggersPlatformsList<TData = Awaited<ReturnType<typeof triggersPlatformsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsList<TData = Awaited<ReturnType<typeof triggersPlatformsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsList<TData = Awaited<ReturnType<typeof triggersPlatformsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersPlatformsList<TData = Awaited<ReturnType<typeof triggersPlatformsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersPlatformsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const triggersPlatformsDestinationsList = (platform: string, signal?: AbortSignal) => {
  return customInstance<TriggerDestination[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersPlatformsDestinationsListQueryKey = (platform: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/`] as const;
};

export const getTriggersPlatformsDestinationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersPlatformsDestinationsListQueryKey(platform);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>> = ({ signal }) =>
    triggersPlatformsDestinationsList(platform, signal);

  return {
    queryKey,
    queryFn,
    enabled: platform !== null && platform !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TriggersPlatformsDestinationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>
>;
export type TriggersPlatformsDestinationsListQueryError = unknown;

export function useTriggersPlatformsDestinationsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
  TError = unknown,
>(
  platform: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersPlatformsDestinationsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersPlatformsDestinationsListQueryOptions(platform, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const triggersPlatformsDestinationsEligibleAgentsList = (
  platform: string,
  destinationRef: string,
  signal?: AbortSignal
) => {
  return customInstance<TriggerEligibleAgent[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/${destinationRef}/eligible-agents/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersPlatformsDestinationsEligibleAgentsListQueryKey = (
  platform: string,
  destinationRef: string
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/${destinationRef}/eligible-agents/`,
  ] as const;
};

export const getTriggersPlatformsDestinationsEligibleAgentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTriggersPlatformsDestinationsEligibleAgentsListQueryKey(platform, destinationRef);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>> = ({
    signal,
  }) => triggersPlatformsDestinationsEligibleAgentsList(platform, destinationRef, signal);

  return {
    queryKey,
    queryFn,
    enabled: platform !== null && platform !== undefined && destinationRef !== null && destinationRef !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TriggersPlatformsDestinationsEligibleAgentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>
>;
export type TriggersPlatformsDestinationsEligibleAgentsListQueryError = unknown;

export function useTriggersPlatformsDestinationsEligibleAgentsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsEligibleAgentsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsEligibleAgentsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersPlatformsDestinationsEligibleAgentsList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsEligibleAgentsList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersPlatformsDestinationsEligibleAgentsListQueryOptions(
    platform,
    destinationRef,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const triggersPlatformsDestinationsMentionableUsersList = (
  platform: string,
  destinationRef: string,
  signal?: AbortSignal
) => {
  return customInstance<TriggerMentionableUser[]>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/${destinationRef}/mentionable-users/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersPlatformsDestinationsMentionableUsersListQueryKey = (
  platform: string,
  destinationRef: string
) => {
  return [
    `${import.meta.env.VITE_API_URL}/api/v1/triggers/platforms/${platform}/destinations/${destinationRef}/mentionable-users/`,
  ] as const;
};

export const getTriggersPlatformsDestinationsMentionableUsersListQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTriggersPlatformsDestinationsMentionableUsersListQueryKey(platform, destinationRef);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>> = ({
    signal,
  }) => triggersPlatformsDestinationsMentionableUsersList(platform, destinationRef, signal);

  return {
    queryKey,
    queryFn,
    enabled: platform !== null && platform !== undefined && destinationRef !== null && destinationRef !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TriggersPlatformsDestinationsMentionableUsersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>
>;
export type TriggersPlatformsDestinationsMentionableUsersListQueryError = unknown;

export function useTriggersPlatformsDestinationsMentionableUsersList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsMentionableUsersList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
          TError,
          Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersPlatformsDestinationsMentionableUsersList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersPlatformsDestinationsMentionableUsersList<
  TData = Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>,
  TError = unknown,
>(
  platform: string,
  destinationRef: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof triggersPlatformsDestinationsMentionableUsersList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersPlatformsDestinationsMentionableUsersListQueryOptions(
    platform,
    destinationRef,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const triggersRunsRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<TriggerRun>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/runs/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getTriggersRunsRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/api/v1/triggers/runs/${id}/`] as const;
};

export const getTriggersRunsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof triggersRunsRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggersRunsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggersRunsRetrieve>>> = ({ signal }) =>
    triggersRunsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof triggersRunsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TriggersRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof triggersRunsRetrieve>>>;
export type TriggersRunsRetrieveQueryError = unknown;

export function useTriggersRunsRetrieve<TData = Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRunsRetrieve<TData = Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggersRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof triggersRunsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggersRunsRetrieve<TData = Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTriggersRunsRetrieve<TData = Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggersRunsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggersRunsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Receives lifecycle updates from the slack-bot after a run is dispatched.
 *
 * Slack-destined trigger runs are handed to the slack-bot, which reproduces
 * the native Slack experience. Once it finishes (or pauses on a compliance
 * review) it calls back here so Core can close out the run lifecycle. The
 * request is authenticated with the signed callback token Core embedded in
 * the dispatch payload, so a discoverable run id alone cannot spoof it.
 */
export const triggersRunsDispatchCallbackCreate = (
  runId: string,
  triggerDispatchCallbackRequest: TriggerDispatchCallbackRequest,
  signal?: AbortSignal
) => {
  return customInstance<TriggerRun>({
    url: `${import.meta.env.VITE_API_URL}/api/v1/triggers/runs/${runId}/dispatch-callback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerDispatchCallbackRequest,
    signal,
  });
};

export const getTriggersRunsDispatchCallbackCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>,
    TError,
    { runId: string; data: TriggerDispatchCallbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>,
  TError,
  { runId: string; data: TriggerDispatchCallbackRequest },
  TContext
> => {
  const mutationKey = ['triggersRunsDispatchCallbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>,
    { runId: string; data: TriggerDispatchCallbackRequest }
  > = (props) => {
    const { runId, data } = props ?? {};

    return triggersRunsDispatchCallbackCreate(runId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggersRunsDispatchCallbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>
>;
export type TriggersRunsDispatchCallbackCreateMutationBody = TriggerDispatchCallbackRequest;
export type TriggersRunsDispatchCallbackCreateMutationError = unknown;

export const useTriggersRunsDispatchCallbackCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>,
      TError,
      { runId: string; data: TriggerDispatchCallbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof triggersRunsDispatchCallbackCreate>>,
  TError,
  { runId: string; data: TriggerDispatchCallbackRequest },
  TContext
> => {
  return useMutation(getTriggersRunsDispatchCallbackCreateMutationOptions(options), queryClient);
};

/**
 * Request a password reset link to be sent to the user's email
 * @summary Forgot Password
 */
export const authForgotPasswordCreate = (forgotPasswordRequest: ForgotPasswordRequest, signal?: AbortSignal) => {
  return customInstance<AuthForgotPasswordCreate200>({
    url: `${import.meta.env.VITE_API_URL}/auth/forgot-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: forgotPasswordRequest,
    signal,
  });
};

export const getAuthForgotPasswordCreateMutationOptions = <
  TError = AuthForgotPasswordCreate400 | AuthForgotPasswordCreate500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authForgotPasswordCreate>>,
    TError,
    { data: ForgotPasswordRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authForgotPasswordCreate>>,
  TError,
  { data: ForgotPasswordRequest },
  TContext
> => {
  const mutationKey = ['authForgotPasswordCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authForgotPasswordCreate>>,
    { data: ForgotPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return authForgotPasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthForgotPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authForgotPasswordCreate>>>;
export type AuthForgotPasswordCreateMutationBody = ForgotPasswordRequest;
export type AuthForgotPasswordCreateMutationError = AuthForgotPasswordCreate400 | AuthForgotPasswordCreate500;

/**
 * @summary Forgot Password
 */
export const useAuthForgotPasswordCreate = <
  TError = AuthForgotPasswordCreate400 | AuthForgotPasswordCreate500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authForgotPasswordCreate>>,
      TError,
      { data: ForgotPasswordRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authForgotPasswordCreate>>,
  TError,
  { data: ForgotPasswordRequest },
  TContext
> => {
  return useMutation(getAuthForgotPasswordCreateMutationOptions(options), queryClient);
};

/**
 * Authenticate with Google ID token from Okta integration
 * @summary Google Login
 */
export const authGoogleCreate = (googleAuthRequest: GoogleAuthRequest, signal?: AbortSignal) => {
  return customInstance<GoogleAuthSuccessResponse>({
    url: `${import.meta.env.VITE_API_URL}/auth/google/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: googleAuthRequest,
    signal,
  });
};

export const getAuthGoogleCreateMutationOptions = <TError = AuthGoogleCreate400, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authGoogleCreate>>,
    TError,
    { data: GoogleAuthRequest },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof authGoogleCreate>>, TError, { data: GoogleAuthRequest }, TContext> => {
  const mutationKey = ['authGoogleCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authGoogleCreate>>, { data: GoogleAuthRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return authGoogleCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthGoogleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authGoogleCreate>>>;
export type AuthGoogleCreateMutationBody = GoogleAuthRequest;
export type AuthGoogleCreateMutationError = AuthGoogleCreate400;

/**
 * @summary Google Login
 */
export const useAuthGoogleCreate = <TError = AuthGoogleCreate400, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authGoogleCreate>>,
      TError,
      { data: GoogleAuthRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof authGoogleCreate>>, TError, { data: GoogleAuthRequest }, TContext> => {
  return useMutation(getAuthGoogleCreateMutationOptions(options), queryClient);
};

/**
 * Login with email and password
 * @summary Login
 */
export const authLoginCreate = (loginRequest: LoginRequest, signal?: AbortSignal) => {
  return customInstance<LoginSuccessResponse>({
    url: `${import.meta.env.VITE_API_URL}/auth/login/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: loginRequest,
    signal,
  });
};

export const getAuthLoginCreateMutationOptions = <TError = AuthLoginCreate401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authLoginCreate>>, TError, { data: LoginRequest }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authLoginCreate>>, TError, { data: LoginRequest }, TContext> => {
  const mutationKey = ['authLoginCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLoginCreate>>, { data: LoginRequest }> = (props) => {
    const { data } = props ?? {};

    return authLoginCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLoginCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authLoginCreate>>>;
export type AuthLoginCreateMutationBody = LoginRequest;
export type AuthLoginCreateMutationError = AuthLoginCreate401;

/**
 * @summary Login
 */
export const useAuthLoginCreate = <TError = AuthLoginCreate401, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authLoginCreate>>,
      TError,
      { data: LoginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof authLoginCreate>>, TError, { data: LoginRequest }, TContext> => {
  return useMutation(getAuthLoginCreateMutationOptions(options), queryClient);
};

/**
 * Invalidate the refresh token, effectively logging the user out
 * @summary User Logout
 */
export const authLogoutCreate = (authLogoutCreateBody?: AuthLogoutCreateBody, signal?: AbortSignal) => {
  return customInstance<AuthLogoutCreate200>({
    url: `${import.meta.env.VITE_API_URL}/auth/logout/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authLogoutCreateBody,
    signal,
  });
};

export const getAuthLogoutCreateMutationOptions = <TError = AuthLogoutCreate400, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogoutCreate>>,
    TError,
    { data?: AuthLogoutCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogoutCreate>>,
  TError,
  { data?: AuthLogoutCreateBody },
  TContext
> => {
  const mutationKey = ['authLogoutCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogoutCreate>>, { data?: AuthLogoutCreateBody }> = (
    props
  ) => {
    const { data } = props ?? {};

    return authLogoutCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLogoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authLogoutCreate>>>;
export type AuthLogoutCreateMutationBody = AuthLogoutCreateBody | undefined;
export type AuthLogoutCreateMutationError = AuthLogoutCreate400;

/**
 * @summary User Logout
 */
export const useAuthLogoutCreate = <TError = AuthLogoutCreate400, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authLogoutCreate>>,
      TError,
      { data?: AuthLogoutCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authLogoutCreate>>,
  TError,
  { data?: AuthLogoutCreateBody },
  TContext
> => {
  return useMutation(getAuthLogoutCreateMutationOptions(options), queryClient);
};

/**
 * Register a new user account. Can optionally create an initial workspace.
 * @summary Register New Account
 */
export const authRegisterCreate = (registerRequest: RegisterRequest, signal?: AbortSignal) => {
  return customInstance<RegisterSuccessResponse>({
    url: `${import.meta.env.VITE_API_URL}/auth/register/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: registerRequest,
    signal,
  });
};

export const getAuthRegisterCreateMutationOptions = <TError = AuthRegisterCreate400, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegisterCreate>>,
    TError,
    { data: RegisterRequest },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof authRegisterCreate>>, TError, { data: RegisterRequest }, TContext> => {
  const mutationKey = ['authRegisterCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRegisterCreate>>, { data: RegisterRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return authRegisterCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegisterCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authRegisterCreate>>>;
export type AuthRegisterCreateMutationBody = RegisterRequest;
export type AuthRegisterCreateMutationError = AuthRegisterCreate400;

/**
 * @summary Register New Account
 */
export const useAuthRegisterCreate = <TError = AuthRegisterCreate400, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegisterCreate>>,
      TError,
      { data: RegisterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof authRegisterCreate>>, TError, { data: RegisterRequest }, TContext> => {
  return useMutation(getAuthRegisterCreateMutationOptions(options), queryClient);
};

/**
 * View for managing registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistList = (signal?: AbortSignal) => {
  return customInstance<RegistrationWhitelist[]>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/`,
    method: 'GET',
    signal,
  });
};

export const getAuthRegistrationWhitelistListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/auth/registration-whitelist/`] as const;
};

export const getAuthRegistrationWhitelistListQueryOptions = <
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthRegistrationWhitelistListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authRegistrationWhitelistList>>> = ({ signal }) =>
    authRegistrationWhitelistList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthRegistrationWhitelistListQueryResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistList>>
>;
export type AuthRegistrationWhitelistListQueryError = unknown;

export function useAuthRegistrationWhitelistList<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
          TError,
          Awaited<ReturnType<typeof authRegistrationWhitelistList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthRegistrationWhitelistList<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
          TError,
          Awaited<ReturnType<typeof authRegistrationWhitelistList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthRegistrationWhitelistList<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthRegistrationWhitelistList<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthRegistrationWhitelistListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * View for managing registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistCreate = (
  registrationWhitelistRequest: RegistrationWhitelistRequest,
  signal?: AbortSignal
) => {
  return customInstance<RegistrationWhitelist>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: registrationWhitelistRequest,
    signal,
  });
};

export const getAuthRegistrationWhitelistCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>,
    TError,
    { data: RegistrationWhitelistRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>,
  TError,
  { data: RegistrationWhitelistRequest },
  TContext
> => {
  const mutationKey = ['authRegistrationWhitelistCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>,
    { data: RegistrationWhitelistRequest }
  > = (props) => {
    const { data } = props ?? {};

    return authRegistrationWhitelistCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegistrationWhitelistCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>
>;
export type AuthRegistrationWhitelistCreateMutationBody = RegistrationWhitelistRequest;
export type AuthRegistrationWhitelistCreateMutationError = unknown;

export const useAuthRegistrationWhitelistCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>,
      TError,
      { data: RegistrationWhitelistRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authRegistrationWhitelistCreate>>,
  TError,
  { data: RegistrationWhitelistRequest },
  TContext
> => {
  return useMutation(getAuthRegistrationWhitelistCreateMutationOptions(options), queryClient);
};

/**
 * View for managing individual registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<RegistrationWhitelist>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getAuthRegistrationWhitelistRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/auth/registration-whitelist/${id}/`] as const;
};

export const getAuthRegistrationWhitelistRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthRegistrationWhitelistRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>> = ({ signal }) =>
    authRegistrationWhitelistRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthRegistrationWhitelistRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>
>;
export type AuthRegistrationWhitelistRetrieveQueryError = unknown;

export function useAuthRegistrationWhitelistRetrieve<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthRegistrationWhitelistRetrieve<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthRegistrationWhitelistRetrieve<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthRegistrationWhitelistRetrieve<
  TData = Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authRegistrationWhitelistRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthRegistrationWhitelistRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * View for managing individual registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistUpdate = (
  id: number,
  registrationWhitelistRequest: RegistrationWhitelistRequest,
  signal?: AbortSignal
) => {
  return customInstance<RegistrationWhitelist>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: registrationWhitelistRequest,
    signal,
  });
};

export const getAuthRegistrationWhitelistUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>,
    TError,
    { id: number; data: RegistrationWhitelistRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>,
  TError,
  { id: number; data: RegistrationWhitelistRequest },
  TContext
> => {
  const mutationKey = ['authRegistrationWhitelistUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>,
    { id: number; data: RegistrationWhitelistRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return authRegistrationWhitelistUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegistrationWhitelistUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>
>;
export type AuthRegistrationWhitelistUpdateMutationBody = RegistrationWhitelistRequest;
export type AuthRegistrationWhitelistUpdateMutationError = unknown;

export const useAuthRegistrationWhitelistUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>,
      TError,
      { id: number; data: RegistrationWhitelistRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authRegistrationWhitelistUpdate>>,
  TError,
  { id: number; data: RegistrationWhitelistRequest },
  TContext
> => {
  return useMutation(getAuthRegistrationWhitelistUpdateMutationOptions(options), queryClient);
};

/**
 * View for managing individual registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistPartialUpdate = (
  id: number,
  patchedRegistrationWhitelistRequest?: PatchedRegistrationWhitelistRequest,
  signal?: AbortSignal
) => {
  return customInstance<RegistrationWhitelist>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRegistrationWhitelistRequest,
    signal,
  });
};

export const getAuthRegistrationWhitelistPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>,
    TError,
    { id: number; data?: PatchedRegistrationWhitelistRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRegistrationWhitelistRequest },
  TContext
> => {
  const mutationKey = ['authRegistrationWhitelistPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>,
    { id: number; data?: PatchedRegistrationWhitelistRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return authRegistrationWhitelistPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegistrationWhitelistPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>
>;
export type AuthRegistrationWhitelistPartialUpdateMutationBody = PatchedRegistrationWhitelistRequest | undefined;
export type AuthRegistrationWhitelistPartialUpdateMutationError = unknown;

export const useAuthRegistrationWhitelistPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>,
      TError,
      { id: number; data?: PatchedRegistrationWhitelistRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authRegistrationWhitelistPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRegistrationWhitelistRequest },
  TContext
> => {
  return useMutation(getAuthRegistrationWhitelistPartialUpdateMutationOptions(options), queryClient);
};

/**
 * View for managing individual registration whitelist entries.
 *
 * This endpoint is only accessible:
 * 1. On localhost (127.0.0.1 or ::1)
 * 2. In testing environment (when DEBUG=True or SENTRY_ENABLED=False)
 *
 * Not accessible in staging or production environments.
 * No authentication required due to localhost + testing environment restrictions.
 */
export const authRegistrationWhitelistDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/auth/registration-whitelist/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getAuthRegistrationWhitelistDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['authRegistrationWhitelistDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return authRegistrationWhitelistDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegistrationWhitelistDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>
>;

export type AuthRegistrationWhitelistDestroyMutationError = unknown;

export const useAuthRegistrationWhitelistDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authRegistrationWhitelistDestroy>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAuthRegistrationWhitelistDestroyMutationOptions(options), queryClient);
};

/**
 * Reset a user's password using a valid reset token
 * @summary Reset Password
 */
export const authResetPasswordCreate = (resetPasswordRequest: ResetPasswordRequest, signal?: AbortSignal) => {
  return customInstance<AuthResetPasswordCreate200>({
    url: `${import.meta.env.VITE_API_URL}/auth/reset-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resetPasswordRequest,
    signal,
  });
};

export const getAuthResetPasswordCreateMutationOptions = <
  TError = AuthResetPasswordCreate400,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authResetPasswordCreate>>,
    TError,
    { data: ResetPasswordRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authResetPasswordCreate>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  const mutationKey = ['authResetPasswordCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authResetPasswordCreate>>,
    { data: ResetPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return authResetPasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthResetPasswordCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authResetPasswordCreate>>>;
export type AuthResetPasswordCreateMutationBody = ResetPasswordRequest;
export type AuthResetPasswordCreateMutationError = AuthResetPasswordCreate400;

/**
 * @summary Reset Password
 */
export const useAuthResetPasswordCreate = <TError = AuthResetPasswordCreate400, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authResetPasswordCreate>>,
      TError,
      { data: ResetPasswordRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authResetPasswordCreate>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  return useMutation(getAuthResetPasswordCreateMutationOptions(options), queryClient);
};

/**
 * Get authentication status and user information for the current authenticated user
 * @summary Check Authentication Status
 */
export const authStatusRetrieve = (signal?: AbortSignal) => {
  return customInstance<AuthStatusResponse>({
    url: `${import.meta.env.VITE_API_URL}/auth/status/`,
    method: 'GET',
    signal,
  });
};

export const getAuthStatusRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/auth/status/`] as const;
};

export const getAuthStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof authStatusRetrieve>>,
  TError = AuthStatusRetrieve401,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authStatusRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthStatusRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authStatusRetrieve>>> = ({ signal }) =>
    authStatusRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof authStatusRetrieve>>>;
export type AuthStatusRetrieveQueryError = AuthStatusRetrieve401;

export function useAuthStatusRetrieve<
  TData = Awaited<ReturnType<typeof authStatusRetrieve>>,
  TError = AuthStatusRetrieve401,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthStatusRetrieve<
  TData = Awaited<ReturnType<typeof authStatusRetrieve>>,
  TError = AuthStatusRetrieve401,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authStatusRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof authStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthStatusRetrieve<
  TData = Awaited<ReturnType<typeof authStatusRetrieve>>,
  TError = AuthStatusRetrieve401,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authStatusRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check Authentication Status
 */

export function useAuthStatusRetrieve<
  TData = Awaited<ReturnType<typeof authStatusRetrieve>>,
  TError = AuthStatusRetrieve401,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authStatusRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthStatusRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Obtain a new access token using a refresh token
 * @summary Refresh JWT Token
 */
export const authTokenRefreshCreate = (
  authTokenRefreshCreateBody?: AuthTokenRefreshCreateBody,
  signal?: AbortSignal
) => {
  return customInstance<AuthTokenRefreshCreate200>({
    url: `${import.meta.env.VITE_API_URL}/auth/token/refresh/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authTokenRefreshCreateBody,
    signal,
  });
};

export const getAuthTokenRefreshCreateMutationOptions = <
  TError = AuthTokenRefreshCreate401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authTokenRefreshCreate>>,
    TError,
    { data?: AuthTokenRefreshCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authTokenRefreshCreate>>,
  TError,
  { data?: AuthTokenRefreshCreateBody },
  TContext
> => {
  const mutationKey = ['authTokenRefreshCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authTokenRefreshCreate>>,
    { data?: AuthTokenRefreshCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return authTokenRefreshCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthTokenRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof authTokenRefreshCreate>>>;
export type AuthTokenRefreshCreateMutationBody = AuthTokenRefreshCreateBody | undefined;
export type AuthTokenRefreshCreateMutationError = AuthTokenRefreshCreate401;

/**
 * @summary Refresh JWT Token
 */
export const useAuthTokenRefreshCreate = <TError = AuthTokenRefreshCreate401, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authTokenRefreshCreate>>,
      TError,
      { data?: AuthTokenRefreshCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authTokenRefreshCreate>>,
  TError,
  { data?: AuthTokenRefreshCreateBody },
  TContext
> => {
  return useMutation(getAuthTokenRefreshCreateMutationOptions(options), queryClient);
};

/**
 * Get the current prompt template used by the filtering system
 * @summary Get Prompt Template
 */
export const chatPromptRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `${import.meta.env.VITE_API_URL}/chat/prompt/`, method: 'GET', signal });
};

export const getChatPromptRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/chat/prompt/`] as const;
};

export const getChatPromptRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatPromptRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatPromptRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChatPromptRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof chatPromptRetrieve>>> = ({ signal }) =>
    chatPromptRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatPromptRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatPromptRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof chatPromptRetrieve>>>;
export type ChatPromptRetrieveQueryError = unknown;

export function useChatPromptRetrieve<TData = Awaited<ReturnType<typeof chatPromptRetrieve>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatPromptRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatPromptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatPromptRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatPromptRetrieve<TData = Awaited<ReturnType<typeof chatPromptRetrieve>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatPromptRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatPromptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatPromptRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatPromptRetrieve<TData = Awaited<ReturnType<typeof chatPromptRetrieve>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatPromptRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Prompt Template
 */

export function useChatPromptRetrieve<TData = Awaited<ReturnType<typeof chatPromptRetrieve>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatPromptRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChatPromptRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Deprecated Slack compatibility wrapper for compliance decisions.
 *
 * Keep this route working for existing Slack compliance cards. The view
 * resolves the Slack tenant and maps the request to the generic platform
 * compliance decision service.
 *
 * Serializes concurrent button clicks for the same `linked_user_message_id`
 * using `SELECT FOR UPDATE`, so exactly one caller receives
 * `should_continue=True` once every required decision has been recorded.
 * Authenticated via the same X-API-Slack-Token header used by
 * /chat/slack/simple/; tenant resolved from `slack_team_id` in the body.
 *
 * Request body:
 *     {
 *         "kind": "prompt" | "attachment",
 *         "value": "accept_changes" | "override_submit" |
 *                  "approve" | "deny" | "use_original",
 *         "file_id": "<str>",                 # required for kind='attachment'
 *         "prompt_required": <bool>,          # seed, honored only on first touch
 *         "required_attachment_ids": [<str>,...], # seed, honored only on first touch
 *         "slack_team_id": "<str>"            # required for tenant routing
 *     }
 *
 * Response:
 *     {
 *         "should_continue": <bool>,
 *         "already_completed": <bool>,
 *         "prompt_decision": <str|null>,
 *         "attachment_decisions": {<file_id>: <decision>, ...},
 *         "missing": {"prompt": <bool>, "attachments": [<file_id>, ...]}
 *     }
 */
export const chatSlackComplianceDecisionsCreate = (linkedUserMessageId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/compliance/decisions/${linkedUserMessageId}/`,
    method: 'POST',
    signal,
  });
};

export const getChatSlackComplianceDecisionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>,
    TError,
    { linkedUserMessageId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>,
  TError,
  { linkedUserMessageId: string },
  TContext
> => {
  const mutationKey = ['chatSlackComplianceDecisionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>,
    { linkedUserMessageId: string }
  > = (props) => {
    const { linkedUserMessageId } = props ?? {};

    return chatSlackComplianceDecisionsCreate(linkedUserMessageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackComplianceDecisionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>
>;

export type ChatSlackComplianceDecisionsCreateMutationError = unknown;

export const useChatSlackComplianceDecisionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>,
      TError,
      { linkedUserMessageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatSlackComplianceDecisionsCreate>>,
  TError,
  { linkedUserMessageId: string },
  TContext
> => {
  return useMutation(getChatSlackComplianceDecisionsCreateMutationOptions(options), queryClient);
};

/**
 * Get a list of slack conversations for a specific channel
 * @summary List Slack Conversations
 */
export const chatSlackConversationsList = (params: ChatSlackConversationsListParams, signal?: AbortSignal) => {
  return customInstance<SlackConversation[]>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/conversations/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getChatSlackConversationsListQueryKey = (params?: ChatSlackConversationsListParams) => {
  return [`${import.meta.env.VITE_API_URL}/chat/slack/conversations/`, ...(params ? [params] : [])] as const;
};

export const getChatSlackConversationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof chatSlackConversationsList>>,
  TError = void,
>(
  params: ChatSlackConversationsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChatSlackConversationsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof chatSlackConversationsList>>> = ({ signal }) =>
    chatSlackConversationsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatSlackConversationsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatSlackConversationsListQueryResult = NonNullable<Awaited<ReturnType<typeof chatSlackConversationsList>>>;
export type ChatSlackConversationsListQueryError = void;

export function useChatSlackConversationsList<
  TData = Awaited<ReturnType<typeof chatSlackConversationsList>>,
  TError = void,
>(
  params: ChatSlackConversationsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatSlackConversationsList>>,
          TError,
          Awaited<ReturnType<typeof chatSlackConversationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatSlackConversationsList<
  TData = Awaited<ReturnType<typeof chatSlackConversationsList>>,
  TError = void,
>(
  params: ChatSlackConversationsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatSlackConversationsList>>,
          TError,
          Awaited<ReturnType<typeof chatSlackConversationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatSlackConversationsList<
  TData = Awaited<ReturnType<typeof chatSlackConversationsList>>,
  TError = void,
>(
  params: ChatSlackConversationsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Slack Conversations
 */

export function useChatSlackConversationsList<
  TData = Awaited<ReturnType<typeof chatSlackConversationsList>>,
  TError = void,
>(
  params: ChatSlackConversationsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChatSlackConversationsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get details of a specific Slack conversation
 * @summary Get Slack Conversation Details
 */
export const chatSlackConversationsRetrieve = (conversationId: string, signal?: AbortSignal) => {
  return customInstance<Conversation>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/conversations/${conversationId}/`,
    method: 'GET',
    signal,
  });
};

export const getChatSlackConversationsRetrieveQueryKey = (conversationId: string) => {
  return [`${import.meta.env.VITE_API_URL}/chat/slack/conversations/${conversationId}/`] as const;
};

export const getChatSlackConversationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
  TError = BadRequestResponse | void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChatSlackConversationsRetrieveQueryKey(conversationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>> = ({ signal }) =>
    chatSlackConversationsRetrieve(conversationId, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ChatSlackConversationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>
>;
export type ChatSlackConversationsRetrieveQueryError = BadRequestResponse | void;

export function useChatSlackConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
  TError = BadRequestResponse | void,
>(
  conversationId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatSlackConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
  TError = BadRequestResponse | void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatSlackConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
  TError = BadRequestResponse | void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Slack Conversation Details
 */

export function useChatSlackConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>,
  TError = BadRequestResponse | void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatSlackConversationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChatSlackConversationsRetrieveQueryOptions(conversationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get details of a specific Slack conversation
 * @summary Get Slack Conversation Details
 */
export const chatSlackConversationsUpdate = (
  conversationId: string,
  slackConversationRequest: SlackConversationRequest,
  signal?: AbortSignal
) => {
  return customInstance<Conversation>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/conversations/${conversationId}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: slackConversationRequest,
    signal,
  });
};

export const getChatSlackConversationsUpdateMutationOptions = <
  TError = BadRequestResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatSlackConversationsUpdate>>,
    TError,
    { conversationId: string; data: SlackConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatSlackConversationsUpdate>>,
  TError,
  { conversationId: string; data: SlackConversationRequest },
  TContext
> => {
  const mutationKey = ['chatSlackConversationsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatSlackConversationsUpdate>>,
    { conversationId: string; data: SlackConversationRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return chatSlackConversationsUpdate(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackConversationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackConversationsUpdate>>
>;
export type ChatSlackConversationsUpdateMutationBody = SlackConversationRequest;
export type ChatSlackConversationsUpdateMutationError = BadRequestResponse | void;

/**
 * @summary Get Slack Conversation Details
 */
export const useChatSlackConversationsUpdate = <TError = BadRequestResponse | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatSlackConversationsUpdate>>,
      TError,
      { conversationId: string; data: SlackConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatSlackConversationsUpdate>>,
  TError,
  { conversationId: string; data: SlackConversationRequest },
  TContext
> => {
  return useMutation(getChatSlackConversationsUpdateMutationOptions(options), queryClient);
};

/**
 * Get details of a specific Slack conversation
 * @summary Get Slack Conversation Details
 */
export const chatSlackConversationsDestroy = (conversationId: string, signal?: AbortSignal) => {
  return customInstance<Conversation>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/conversations/${conversationId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getChatSlackConversationsDestroyMutationOptions = <
  TError = BadRequestResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatSlackConversationsDestroy>>,
    TError,
    { conversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatSlackConversationsDestroy>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ['chatSlackConversationsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatSlackConversationsDestroy>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return chatSlackConversationsDestroy(conversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackConversationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackConversationsDestroy>>
>;

export type ChatSlackConversationsDestroyMutationError = BadRequestResponse | void;

/**
 * @summary Get Slack Conversation Details
 */
export const useChatSlackConversationsDestroy = <TError = BadRequestResponse | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatSlackConversationsDestroy>>,
      TError,
      { conversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatSlackConversationsDestroy>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(getChatSlackConversationsDestroyMutationOptions(options), queryClient);
};

/**
 * Deprecated Slack compatibility wrapper for message delivery events.
 *
 * Resolves the Slack tenant and maps the payload to generic delivery persistence.
 */
export const chatSlackMessageDeliveryCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/message-delivery/`,
    method: 'POST',
    signal,
  });
};

export const getChatSlackMessageDeliveryCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>, TError, void, TContext> => {
  const mutationKey = ['chatSlackMessageDeliveryCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>, void> = () => {
    return chatSlackMessageDeliveryCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackMessageDeliveryCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>
>;

export type ChatSlackMessageDeliveryCreateMutationError = unknown;

export const useChatSlackMessageDeliveryCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof chatSlackMessageDeliveryCreate>>, TError, void, TContext> => {
  return useMutation(getChatSlackMessageDeliveryCreateMutationOptions(options), queryClient);
};

/**
 * Deprecated Slack compatibility wrapper for reaction events.
 *
 * Resolves the Slack tenant and maps the payload to generic reaction persistence.
 */
export const chatSlackMessageReactionsCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/message-reactions/`,
    method: 'POST',
    signal,
  });
};

export const getChatSlackMessageReactionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>, TError, void, TContext> => {
  const mutationKey = ['chatSlackMessageReactionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>, void> = () => {
    return chatSlackMessageReactionsCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackMessageReactionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>
>;

export type ChatSlackMessageReactionsCreateMutationError = unknown;

export const useChatSlackMessageReactionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof chatSlackMessageReactionsCreate>>, TError, void, TContext> => {
  return useMutation(getChatSlackMessageReactionsCreateMutationOptions(options), queryClient);
};

/**
 * Send a message to the AI assistant from Slack
 * @summary Slack Chat with AI Assistant
 */
export const chatSlackSimpleCreate = (
  slackSimpleChatRequestRequest: SlackSimpleChatRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/slack/simple/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackSimpleChatRequestRequest,
    signal,
  });
};

export const getChatSlackSimpleCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatSlackSimpleCreate>>,
    TError,
    { data: SlackSimpleChatRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatSlackSimpleCreate>>,
  TError,
  { data: SlackSimpleChatRequestRequest },
  TContext
> => {
  const mutationKey = ['chatSlackSimpleCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatSlackSimpleCreate>>,
    { data: SlackSimpleChatRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chatSlackSimpleCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatSlackSimpleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof chatSlackSimpleCreate>>>;
export type ChatSlackSimpleCreateMutationBody = SlackSimpleChatRequestRequest;
export type ChatSlackSimpleCreateMutationError = void;

/**
 * @summary Slack Chat with AI Assistant
 */
export const useChatSlackSimpleCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatSlackSimpleCreate>>,
      TError,
      { data: SlackSimpleChatRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatSlackSimpleCreate>>,
  TError,
  { data: SlackSimpleChatRequestRequest },
  TContext
> => {
  return useMutation(getChatSlackSimpleCreateMutationOptions(options), queryClient);
};

/**
 * Get a list of web conversations for the authenticated user
 * @summary List Web Conversations
 */
export const chatWebConversationsList = (signal?: AbortSignal) => {
  return customInstance<Conversation[]>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/conversations/`,
    method: 'GET',
    signal,
  });
};

export const getChatWebConversationsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/chat/web/conversations/`] as const;
};

export const getChatWebConversationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof chatWebConversationsList>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChatWebConversationsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof chatWebConversationsList>>> = ({ signal }) =>
    chatWebConversationsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatWebConversationsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatWebConversationsListQueryResult = NonNullable<Awaited<ReturnType<typeof chatWebConversationsList>>>;
export type ChatWebConversationsListQueryError = void;

export function useChatWebConversationsList<
  TData = Awaited<ReturnType<typeof chatWebConversationsList>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatWebConversationsList>>,
          TError,
          Awaited<ReturnType<typeof chatWebConversationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatWebConversationsList<
  TData = Awaited<ReturnType<typeof chatWebConversationsList>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatWebConversationsList>>,
          TError,
          Awaited<ReturnType<typeof chatWebConversationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatWebConversationsList<
  TData = Awaited<ReturnType<typeof chatWebConversationsList>>,
  TError = void,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Web Conversations
 */

export function useChatWebConversationsList<
  TData = Awaited<ReturnType<typeof chatWebConversationsList>>,
  TError = void,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChatWebConversationsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new web conversation for the authenticated user
 * @summary Create Web Conversation
 */
export const chatWebConversationsCreate = (conversationRequest?: ConversationRequest, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/conversations/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationRequest,
    signal,
  });
};

export const getChatWebConversationsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebConversationsCreate>>,
    TError,
    { data?: ConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebConversationsCreate>>,
  TError,
  { data?: ConversationRequest },
  TContext
> => {
  const mutationKey = ['chatWebConversationsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebConversationsCreate>>,
    { data?: ConversationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chatWebConversationsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebConversationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatWebConversationsCreate>>
>;
export type ChatWebConversationsCreateMutationBody = ConversationRequest | undefined;
export type ChatWebConversationsCreateMutationError = void;

/**
 * @summary Create Web Conversation
 */
export const useChatWebConversationsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebConversationsCreate>>,
      TError,
      { data?: ConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebConversationsCreate>>,
  TError,
  { data?: ConversationRequest },
  TContext
> => {
  return useMutation(getChatWebConversationsCreateMutationOptions(options), queryClient);
};

/**
 * Get details of a specific web conversation
 * @summary Get Web Conversation Details
 */
export const chatWebConversationsRetrieve = (conversationId: string, signal?: AbortSignal) => {
  return customInstance<Conversation>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/conversations/${conversationId}/`,
    method: 'GET',
    signal,
  });
};

export const getChatWebConversationsRetrieveQueryKey = (conversationId: string) => {
  return [`${import.meta.env.VITE_API_URL}/chat/web/conversations/${conversationId}/`] as const;
};

export const getChatWebConversationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
  TError = void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChatWebConversationsRetrieveQueryKey(conversationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>> = ({ signal }) =>
    chatWebConversationsRetrieve(conversationId, signal);

  return {
    queryKey,
    queryFn,
    enabled: conversationId !== null && conversationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ChatWebConversationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatWebConversationsRetrieve>>
>;
export type ChatWebConversationsRetrieveQueryError = void;

export function useChatWebConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
  TError = void,
>(
  conversationId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatWebConversationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatWebConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
  TError = void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof chatWebConversationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChatWebConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
  TError = void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Web Conversation Details
 */

export function useChatWebConversationsRetrieve<
  TData = Awaited<ReturnType<typeof chatWebConversationsRetrieve>>,
  TError = void,
>(
  conversationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof chatWebConversationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChatWebConversationsRetrieveQueryOptions(conversationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update a web conversation
 * @summary Update Web Conversation
 */
export const chatWebConversationsUpdate = (
  conversationId: string,
  conversationRequest?: ConversationRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/conversations/${conversationId}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: conversationRequest,
    signal,
  });
};

export const getChatWebConversationsUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebConversationsUpdate>>,
    TError,
    { conversationId: string; data?: ConversationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebConversationsUpdate>>,
  TError,
  { conversationId: string; data?: ConversationRequest },
  TContext
> => {
  const mutationKey = ['chatWebConversationsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebConversationsUpdate>>,
    { conversationId: string; data?: ConversationRequest }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return chatWebConversationsUpdate(conversationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebConversationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatWebConversationsUpdate>>
>;
export type ChatWebConversationsUpdateMutationBody = ConversationRequest | undefined;
export type ChatWebConversationsUpdateMutationError = void;

/**
 * @summary Update Web Conversation
 */
export const useChatWebConversationsUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebConversationsUpdate>>,
      TError,
      { conversationId: string; data?: ConversationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebConversationsUpdate>>,
  TError,
  { conversationId: string; data?: ConversationRequest },
  TContext
> => {
  return useMutation(getChatWebConversationsUpdateMutationOptions(options), queryClient);
};

/**
 * Delete a web conversation
 * @summary Delete Web Conversation
 */
export const chatWebConversationsDestroy = (conversationId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/conversations/${conversationId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getChatWebConversationsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebConversationsDestroy>>,
    TError,
    { conversationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebConversationsDestroy>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ['chatWebConversationsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebConversationsDestroy>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return chatWebConversationsDestroy(conversationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebConversationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatWebConversationsDestroy>>
>;

export type ChatWebConversationsDestroyMutationError = void;

/**
 * @summary Delete Web Conversation
 */
export const useChatWebConversationsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebConversationsDestroy>>,
      TError,
      { conversationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebConversationsDestroy>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(getChatWebConversationsDestroyMutationOptions(options), queryClient);
};

/**
 * Send a message to the Document Conversion Agent and receive its reply.
 * @summary Document Conversion Chat
 */
export const chatWebDocSimpleCreate = (
  webChatMessageRequestRequest: WebChatMessageRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<Message>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/doc_simple/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: webChatMessageRequestRequest,
    signal,
  });
};

export const getChatWebDocSimpleCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebDocSimpleCreate>>,
    TError,
    { data: WebChatMessageRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebDocSimpleCreate>>,
  TError,
  { data: WebChatMessageRequestRequest },
  TContext
> => {
  const mutationKey = ['chatWebDocSimpleCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebDocSimpleCreate>>,
    { data: WebChatMessageRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chatWebDocSimpleCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebDocSimpleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof chatWebDocSimpleCreate>>>;
export type ChatWebDocSimpleCreateMutationBody = WebChatMessageRequestRequest;
export type ChatWebDocSimpleCreateMutationError = unknown;

/**
 * @summary Document Conversion Chat
 */
export const useChatWebDocSimpleCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebDocSimpleCreate>>,
      TError,
      { data: WebChatMessageRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebDocSimpleCreate>>,
  TError,
  { data: WebChatMessageRequestRequest },
  TContext
> => {
  return useMutation(getChatWebDocSimpleCreateMutationOptions(options), queryClient);
};

/**
 * Record one decision for a gated message in an accessible web conversation.
 */
export const chatWebComplianceDecisionsCreate = (
  linkedUserMessageId: string,
  webComplianceDecisionRequestRequest: WebComplianceDecisionRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<WebComplianceDecisionResponse>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/compliance/decisions/${linkedUserMessageId}/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: webComplianceDecisionRequestRequest,
    signal,
  });
};

export const getChatWebComplianceDecisionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>,
    TError,
    { linkedUserMessageId: string; data: WebComplianceDecisionRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>,
  TError,
  { linkedUserMessageId: string; data: WebComplianceDecisionRequestRequest },
  TContext
> => {
  const mutationKey = ['chatWebComplianceDecisionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>,
    { linkedUserMessageId: string; data: WebComplianceDecisionRequestRequest }
  > = (props) => {
    const { linkedUserMessageId, data } = props ?? {};

    return chatWebComplianceDecisionsCreate(linkedUserMessageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebComplianceDecisionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>
>;
export type ChatWebComplianceDecisionsCreateMutationBody = WebComplianceDecisionRequestRequest;
export type ChatWebComplianceDecisionsCreateMutationError = unknown;

export const useChatWebComplianceDecisionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>,
      TError,
      { linkedUserMessageId: string; data: WebComplianceDecisionRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebComplianceDecisionsCreate>>,
  TError,
  { linkedUserMessageId: string; data: WebComplianceDecisionRequestRequest },
  TContext
> => {
  return useMutation(getChatWebComplianceDecisionsCreateMutationOptions(options), queryClient);
};

/**
 * Send a message and get a response from the AI assistant
 * @summary Simple Chat
 */
export const chatWebSimpleCreate = (
  webChatMessageRequestRequest: WebChatMessageRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<Message>({
    url: `${import.meta.env.VITE_API_URL}/chat/web/simple/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: webChatMessageRequestRequest,
    signal,
  });
};

export const getChatWebSimpleCreateMutationOptions = <TError = BadRequestResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatWebSimpleCreate>>,
    TError,
    { data: WebChatMessageRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatWebSimpleCreate>>,
  TError,
  { data: WebChatMessageRequestRequest },
  TContext
> => {
  const mutationKey = ['chatWebSimpleCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatWebSimpleCreate>>,
    { data: WebChatMessageRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return chatWebSimpleCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatWebSimpleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof chatWebSimpleCreate>>>;
export type ChatWebSimpleCreateMutationBody = WebChatMessageRequestRequest;
export type ChatWebSimpleCreateMutationError = BadRequestResponse;

/**
 * @summary Simple Chat
 */
export const useChatWebSimpleCreate = <TError = BadRequestResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatWebSimpleCreate>>,
      TError,
      { data: WebChatMessageRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof chatWebSimpleCreate>>,
  TError,
  { data: WebChatMessageRequestRequest },
  TContext
> => {
  return useMutation(getChatWebSimpleCreateMutationOptions(options), queryClient);
};

/**
 * Returns dashboard data including metrics and violation trend data for the last 7 days
 * @summary Get Dashboard Data
 */
export const dashboardDataRetrieve = (signal?: AbortSignal) => {
  return customInstance<DashboardData>({
    url: `${import.meta.env.VITE_API_URL}/dashboard/data/`,
    method: 'GET',
    signal,
  });
};

export const getDashboardDataRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/dashboard/data/`] as const;
};

export const getDashboardDataRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardDataRetrieve>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardDataRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardDataRetrieve>>> = ({ signal }) =>
    dashboardDataRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardDataRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DashboardDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardDataRetrieve>>>;
export type DashboardDataRetrieveQueryError = void;

export function useDashboardDataRetrieve<TData = Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardDataRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDashboardDataRetrieve<TData = Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardDataRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDashboardDataRetrieve<TData = Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Dashboard Data
 */

export function useDashboardDataRetrieve<TData = Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardDataRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDashboardDataRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List all documents in the current tenant
 * @summary List Documents
 */
export const documentsList = (signal?: AbortSignal) => {
  return customInstance<Document[]>({ url: `${import.meta.env.VITE_API_URL}/documents/`, method: 'GET', signal });
};

export const getDocumentsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/documents/`] as const;
};

export const getDocumentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof documentsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsList>>> = ({ signal }) => documentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof documentsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentsListQueryResult = NonNullable<Awaited<ReturnType<typeof documentsList>>>;
export type DocumentsListQueryError = unknown;

export function useDocumentsList<TData = Awaited<ReturnType<typeof documentsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsList>>,
          TError,
          Awaited<ReturnType<typeof documentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsList<TData = Awaited<ReturnType<typeof documentsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsList>>,
          TError,
          Awaited<ReturnType<typeof documentsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsList<TData = Awaited<ReturnType<typeof documentsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Documents
 */

export function useDocumentsList<TData = Awaited<ReturnType<typeof documentsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a single document by ID
 * @summary Get Document
 */
export const documentsRetrieve = (documentId: string, signal?: AbortSignal) => {
  return customInstance<Document>({
    url: `${import.meta.env.VITE_API_URL}/documents/${documentId}/`,
    method: 'GET',
    signal,
  });
};

export const getDocumentsRetrieveQueryKey = (documentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/documents/${documentId}/`] as const;
};

export const getDocumentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsRetrieve>>, TError = void>(
  documentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsRetrieveQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsRetrieve>>> = ({ signal }) =>
    documentsRetrieve(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: documentId !== null && documentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DocumentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsRetrieve>>>;
export type DocumentsRetrieveQueryError = void;

export function useDocumentsRetrieve<TData = Awaited<ReturnType<typeof documentsRetrieve>>, TError = void>(
  documentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsRetrieve<TData = Awaited<ReturnType<typeof documentsRetrieve>>, TError = void>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsRetrieve<TData = Awaited<ReturnType<typeof documentsRetrieve>>, TError = void>(
  documentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Document
 */

export function useDocumentsRetrieve<TData = Awaited<ReturnType<typeof documentsRetrieve>>, TError = void>(
  documentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentsRetrieveQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a single document by ID
 * @summary Get Document
 */
export const documentsDestroy = (documentId: string, signal?: AbortSignal) => {
  return customInstance<Document>({
    url: `${import.meta.env.VITE_API_URL}/documents/${documentId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getDocumentsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof documentsDestroy>>, TError, { documentId: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof documentsDestroy>>, TError, { documentId: string }, TContext> => {
  const mutationKey = ['documentsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsDestroy>>, { documentId: string }> = (
    props
  ) => {
    const { documentId } = props ?? {};

    return documentsDestroy(documentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof documentsDestroy>>>;

export type DocumentsDestroyMutationError = void;

/**
 * @summary Get Document
 */
export const useDocumentsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentsDestroy>>,
      TError,
      { documentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof documentsDestroy>>, TError, { documentId: string }, TContext> => {
  return useMutation(getDocumentsDestroyMutationOptions(options), queryClient);
};

/**
 * Fetch extracted markdown and changelog data for a document in review
 * @summary Get Extracted Data
 */
export const documentsExtractedDataRetrieve = (documentId: string, signal?: AbortSignal) => {
  return customInstance<Document>({
    url: `${import.meta.env.VITE_API_URL}/documents/${documentId}/extracted_data/`,
    method: 'GET',
    signal,
  });
};

export const getDocumentsExtractedDataRetrieveQueryKey = (documentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/documents/${documentId}/extracted_data/`] as const;
};

export const getDocumentsExtractedDataRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsExtractedDataRetrieveQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>> = ({ signal }) =>
    documentsExtractedDataRetrieve(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: documentId !== null && documentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DocumentsExtractedDataRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>
>;
export type DocumentsExtractedDataRetrieveQueryError = void;

export function useDocumentsExtractedDataRetrieve<
  TData = Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
  TError = void,
>(
  documentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsExtractedDataRetrieve<
  TData = Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsExtractedDataRetrieve<
  TData = Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Extracted Data
 */

export function useDocumentsExtractedDataRetrieve<
  TData = Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsExtractedDataRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentsExtractedDataRetrieveQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Generate guardrail changeset from document conversation
 * @summary Generate Changes
 */
export const documentsGenerateChangesCreate = (documentId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/documents/${documentId}/generate_changes/`,
    method: 'POST',
    signal,
  });
};

export const getDocumentsGenerateChangesCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentsGenerateChangesCreate>>,
    TError,
    { documentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentsGenerateChangesCreate>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationKey = ['documentsGenerateChangesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentsGenerateChangesCreate>>,
    { documentId: string }
  > = (props) => {
    const { documentId } = props ?? {};

    return documentsGenerateChangesCreate(documentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentsGenerateChangesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentsGenerateChangesCreate>>
>;

export type DocumentsGenerateChangesCreateMutationError = void;

/**
 * @summary Generate Changes
 */
export const useDocumentsGenerateChangesCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentsGenerateChangesCreate>>,
      TError,
      { documentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof documentsGenerateChangesCreate>>,
  TError,
  { documentId: string },
  TContext
> => {
  return useMutation(getDocumentsGenerateChangesCreateMutationOptions(options), queryClient);
};

/**
 * Fetch the most recent GuardrailChangeSet for the specified document
 * @summary Get Latest ChangeSet
 */
export const documentsLatestChangesetRetrieve = (documentId: string, signal?: AbortSignal) => {
  return customInstance<GuardrailChangeSet>({
    url: `${import.meta.env.VITE_API_URL}/documents/${documentId}/latest_changeset/`,
    method: 'GET',
    signal,
  });
};

export const getDocumentsLatestChangesetRetrieveQueryKey = (documentId: string) => {
  return [`${import.meta.env.VITE_API_URL}/documents/${documentId}/latest_changeset/`] as const;
};

export const getDocumentsLatestChangesetRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsLatestChangesetRetrieveQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>> = ({ signal }) =>
    documentsLatestChangesetRetrieve(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: documentId !== null && documentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DocumentsLatestChangesetRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>
>;
export type DocumentsLatestChangesetRetrieveQueryError = void;

export function useDocumentsLatestChangesetRetrieve<
  TData = Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
  TError = void,
>(
  documentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsLatestChangesetRetrieve<
  TData = Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsLatestChangesetRetrieve<
  TData = Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Latest ChangeSet
 */

export function useDocumentsLatestChangesetRetrieve<
  TData = Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLatestChangesetRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentsLatestChangesetRetrieveQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a single GuardrailChangeSet including all its changes
 * @summary Get ChangeSet Details
 */
export const documentsChangesetsRetrieve = (changesetId: string, signal?: AbortSignal) => {
  return customInstance<GuardrailChangeSet>({
    url: `${import.meta.env.VITE_API_URL}/documents/changesets/${changesetId}/`,
    method: 'GET',
    signal,
  });
};

export const getDocumentsChangesetsRetrieveQueryKey = (changesetId: string) => {
  return [`${import.meta.env.VITE_API_URL}/documents/changesets/${changesetId}/`] as const;
};

export const getDocumentsChangesetsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
  TError = void,
>(
  changesetId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsChangesetsRetrieveQueryKey(changesetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>> = ({ signal }) =>
    documentsChangesetsRetrieve(changesetId, signal);

  return {
    queryKey,
    queryFn,
    enabled: changesetId !== null && changesetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DocumentsChangesetsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof documentsChangesetsRetrieve>>
>;
export type DocumentsChangesetsRetrieveQueryError = void;

export function useDocumentsChangesetsRetrieve<
  TData = Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
  TError = void,
>(
  changesetId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsChangesetsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsChangesetsRetrieve<
  TData = Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
  TError = void,
>(
  changesetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsChangesetsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsChangesetsRetrieve<
  TData = Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
  TError = void,
>(
  changesetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get ChangeSet Details
 */

export function useDocumentsChangesetsRetrieve<
  TData = Awaited<ReturnType<typeof documentsChangesetsRetrieve>>,
  TError = void,
>(
  changesetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsChangesetsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDocumentsChangesetsRetrieveQueryOptions(changesetId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Approve or reject multiple GuardrailChange rows and optionally apply them
 * @summary Approve/Reject Changes
 */
export const documentsChangesetsDecisionsCreate = (
  changesetId: string,
  guardrailBatchDecisionRequest: GuardrailBatchDecisionRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/documents/changesets/${changesetId}/decisions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailBatchDecisionRequest,
    signal,
  });
};

export const getDocumentsChangesetsDecisionsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>,
    TError,
    { changesetId: string; data: GuardrailBatchDecisionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>,
  TError,
  { changesetId: string; data: GuardrailBatchDecisionRequest },
  TContext
> => {
  const mutationKey = ['documentsChangesetsDecisionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>,
    { changesetId: string; data: GuardrailBatchDecisionRequest }
  > = (props) => {
    const { changesetId, data } = props ?? {};

    return documentsChangesetsDecisionsCreate(changesetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentsChangesetsDecisionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>
>;
export type DocumentsChangesetsDecisionsCreateMutationBody = GuardrailBatchDecisionRequest;
export type DocumentsChangesetsDecisionsCreateMutationError = void;

/**
 * @summary Approve/Reject Changes
 */
export const useDocumentsChangesetsDecisionsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>,
      TError,
      { changesetId: string; data: GuardrailBatchDecisionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof documentsChangesetsDecisionsCreate>>,
  TError,
  { changesetId: string; data: GuardrailBatchDecisionRequest },
  TContext
> => {
  return useMutation(getDocumentsChangesetsDecisionsCreateMutationOptions(options), queryClient);
};

/**
 * Upload a file, create a Document, and extract markdown
 * @summary Upload Document
 */
export const documentsUploadCreate = (
  documentUploadRequestRequest: DocumentUploadRequestRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`file`, documentUploadRequestRequest.file);
  if (documentUploadRequestRequest.name !== undefined) {
    formData.append(`name`, documentUploadRequestRequest.name);
  }
  if (documentUploadRequestRequest.category !== undefined) {
    formData.append(`category`, documentUploadRequestRequest.category);
  }

  return customInstance<Document>({
    url: `${import.meta.env.VITE_API_URL}/documents/upload/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getDocumentsUploadCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof documentsUploadCreate>>,
    TError,
    { data: DocumentUploadRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof documentsUploadCreate>>,
  TError,
  { data: DocumentUploadRequestRequest },
  TContext
> => {
  const mutationKey = ['documentsUploadCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof documentsUploadCreate>>,
    { data: DocumentUploadRequestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return documentsUploadCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsUploadCreate>>>;
export type DocumentsUploadCreateMutationBody = DocumentUploadRequestRequest;
export type DocumentsUploadCreateMutationError = void;

/**
 * @summary Upload Document
 */
export const useDocumentsUploadCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof documentsUploadCreate>>,
      TError,
      { data: DocumentUploadRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof documentsUploadCreate>>,
  TError,
  { data: DocumentUploadRequestRequest },
  TContext
> => {
  return useMutation(getDocumentsUploadCreateMutationOptions(options), queryClient);
};

/**
 * List all knowledge documents in the workspace.
 */
export const filesKnowledgeList = (params?: FilesKnowledgeListParams, signal?: AbortSignal) => {
  return customInstance<KnowledgeDocumentList[]>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFilesKnowledgeListQueryKey = (params?: FilesKnowledgeListParams) => {
  return [`${import.meta.env.VITE_API_URL}/files/knowledge/`, ...(params ? [params] : [])] as const;
};

export const getFilesKnowledgeListQueryOptions = <
  TData = Awaited<ReturnType<typeof filesKnowledgeList>>,
  TError = unknown,
>(
  params?: FilesKnowledgeListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesKnowledgeListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesKnowledgeList>>> = ({ signal }) =>
    filesKnowledgeList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesKnowledgeList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesKnowledgeListQueryResult = NonNullable<Awaited<ReturnType<typeof filesKnowledgeList>>>;
export type FilesKnowledgeListQueryError = unknown;

export function useFilesKnowledgeList<TData = Awaited<ReturnType<typeof filesKnowledgeList>>, TError = unknown>(
  params: undefined | FilesKnowledgeListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeList<TData = Awaited<ReturnType<typeof filesKnowledgeList>>, TError = unknown>(
  params?: FilesKnowledgeListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeList<TData = Awaited<ReturnType<typeof filesKnowledgeList>>, TError = unknown>(
  params?: FilesKnowledgeListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesKnowledgeList<TData = Awaited<ReturnType<typeof filesKnowledgeList>>, TError = unknown>(
  params?: FilesKnowledgeListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesKnowledgeListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new knowledge document with initial file upload.
 */
export const filesKnowledgeCreate = (
  knowledgeDocumentCreateRequest: KnowledgeDocumentCreateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`name`, knowledgeDocumentCreateRequest.name);
  if (knowledgeDocumentCreateRequest.description !== undefined) {
    formData.append(`description`, knowledgeDocumentCreateRequest.description);
  }
  if (knowledgeDocumentCreateRequest.file !== undefined) {
    formData.append(`file`, knowledgeDocumentCreateRequest.file);
  }
  if (knowledgeDocumentCreateRequest.version_note !== undefined) {
    formData.append(`version_note`, knowledgeDocumentCreateRequest.version_note);
  }
  if (knowledgeDocumentCreateRequest.extract_text !== undefined) {
    formData.append(`extract_text`, knowledgeDocumentCreateRequest.extract_text.toString());
  }
  if (knowledgeDocumentCreateRequest.creation_type !== undefined) {
    formData.append(`creation_type`, knowledgeDocumentCreateRequest.creation_type);
  }

  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeCreate>>,
    TError,
    { data: KnowledgeDocumentCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeCreate>>,
  TError,
  { data: KnowledgeDocumentCreateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeCreate>>,
    { data: KnowledgeDocumentCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return filesKnowledgeCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof filesKnowledgeCreate>>>;
export type FilesKnowledgeCreateMutationBody = KnowledgeDocumentCreateRequest;
export type FilesKnowledgeCreateMutationError = unknown;

export const useFilesKnowledgeCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeCreate>>,
      TError,
      { data: KnowledgeDocumentCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeCreate>>,
  TError,
  { data: KnowledgeDocumentCreateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeCreateMutationOptions(options), queryClient);
};

/**
 * Get a knowledge document with full version history.
 */
export const filesKnowledgeRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getFilesKnowledgeRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/files/knowledge/${id}/`] as const;
};

export const getFilesKnowledgeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof filesKnowledgeRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesKnowledgeRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>> = ({ signal }) =>
    filesKnowledgeRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesKnowledgeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesKnowledgeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>>;
export type FilesKnowledgeRetrieveQueryError = unknown;

export function useFilesKnowledgeRetrieve<TData = Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeRetrieve<TData = Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeRetrieve<TData = Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesKnowledgeRetrieve<TData = Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError = unknown>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesKnowledgeRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Workspace-wide knowledge document management.
 *
 * list:
 *     List all knowledge documents in the workspace.
 *     Returns documents ordered by last update, with version count and current file metadata.
 *
 * create:
 *     Create a new knowledge document with an initial file upload, or create a
 *     blank markdown document with creation_type='markdown'.
 *
 * retrieve:
 *     Get a knowledge document with full version history.
 *
 * partial_update:
 *     Update document metadata (name, description, is_archived).
 *
 * destroy:
 *     Permanently delete a document and clean up related data.
 */
export const filesKnowledgeUpdate = (
  id: string,
  knowledgeDocumentUpdateRequest: KnowledgeDocumentUpdateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`name`, knowledgeDocumentUpdateRequest.name);
  if (knowledgeDocumentUpdateRequest.description !== undefined) {
    formData.append(`description`, knowledgeDocumentUpdateRequest.description);
  }
  if (knowledgeDocumentUpdateRequest.is_archived !== undefined) {
    formData.append(`is_archived`, knowledgeDocumentUpdateRequest.is_archived.toString());
  }
  if (knowledgeDocumentUpdateRequest.is_global !== undefined) {
    formData.append(`is_global`, knowledgeDocumentUpdateRequest.is_global.toString());
  }
  if (knowledgeDocumentUpdateRequest.global_is_important !== undefined) {
    formData.append(`global_is_important`, knowledgeDocumentUpdateRequest.global_is_important.toString());
  }

  return customInstance<KnowledgeDocumentUpdate>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeUpdate>>,
    TError,
    { id: string; data: KnowledgeDocumentUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeUpdate>>,
  TError,
  { id: string; data: KnowledgeDocumentUpdateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeUpdate>>,
    { id: string; data: KnowledgeDocumentUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgeUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof filesKnowledgeUpdate>>>;
export type FilesKnowledgeUpdateMutationBody = KnowledgeDocumentUpdateRequest;
export type FilesKnowledgeUpdateMutationError = unknown;

export const useFilesKnowledgeUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeUpdate>>,
      TError,
      { id: string; data: KnowledgeDocumentUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeUpdate>>,
  TError,
  { id: string; data: KnowledgeDocumentUpdateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeUpdateMutationOptions(options), queryClient);
};

/**
 * Update document metadata.
 */
export const filesKnowledgePartialUpdate = (
  id: string,
  patchedKnowledgeDocumentUpdateRequest?: PatchedKnowledgeDocumentUpdateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (patchedKnowledgeDocumentUpdateRequest?.name !== undefined) {
    formData.append(`name`, patchedKnowledgeDocumentUpdateRequest.name);
  }
  if (patchedKnowledgeDocumentUpdateRequest?.description !== undefined) {
    formData.append(`description`, patchedKnowledgeDocumentUpdateRequest.description);
  }
  if (patchedKnowledgeDocumentUpdateRequest?.is_archived !== undefined) {
    formData.append(`is_archived`, patchedKnowledgeDocumentUpdateRequest.is_archived.toString());
  }
  if (patchedKnowledgeDocumentUpdateRequest?.is_global !== undefined) {
    formData.append(`is_global`, patchedKnowledgeDocumentUpdateRequest.is_global.toString());
  }
  if (patchedKnowledgeDocumentUpdateRequest?.global_is_important !== undefined) {
    formData.append(`global_is_important`, patchedKnowledgeDocumentUpdateRequest.global_is_important.toString());
  }

  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>,
    TError,
    { id: string; data?: PatchedKnowledgeDocumentUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>,
  TError,
  { id: string; data?: PatchedKnowledgeDocumentUpdateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>,
    { id: string; data?: PatchedKnowledgeDocumentUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgePartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>
>;
export type FilesKnowledgePartialUpdateMutationBody = PatchedKnowledgeDocumentUpdateRequest | undefined;
export type FilesKnowledgePartialUpdateMutationError = unknown;

export const useFilesKnowledgePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>,
      TError,
      { id: string; data?: PatchedKnowledgeDocumentUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgePartialUpdate>>,
  TError,
  { id: string; data?: PatchedKnowledgeDocumentUpdateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgePartialUpdateMutationOptions(options), queryClient);
};

/**
 * Hard delete a document, unlinking from agents and cleaning up ES.
 */
export const filesKnowledgeDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getFilesKnowledgeDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof filesKnowledgeDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof filesKnowledgeDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['filesKnowledgeDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesKnowledgeDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return filesKnowledgeDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof filesKnowledgeDestroy>>>;

export type FilesKnowledgeDestroyMutationError = unknown;

export const useFilesKnowledgeDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof filesKnowledgeDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof filesKnowledgeDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getFilesKnowledgeDestroyMutationOptions(options), queryClient);
};

/**
 * Propagate a document version to selected agents. Creates new agent versions with the specified document version swapped in.
 */
export const filesKnowledgePropagateCreate = (
  id: string,
  knowledgeDocumentPropagateRequest: KnowledgeDocumentPropagateRequest,
  signal?: AbortSignal
) => {
  return customInstance<FilesKnowledgePropagateCreate200>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/propagate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: knowledgeDocumentPropagateRequest,
    signal,
  });
};

export const getFilesKnowledgePropagateCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>,
    TError,
    { id: string; data: KnowledgeDocumentPropagateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>,
  TError,
  { id: string; data: KnowledgeDocumentPropagateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgePropagateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>,
    { id: string; data: KnowledgeDocumentPropagateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgePropagateCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgePropagateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>
>;
export type FilesKnowledgePropagateCreateMutationBody = KnowledgeDocumentPropagateRequest;
export type FilesKnowledgePropagateCreateMutationError = unknown;

export const useFilesKnowledgePropagateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>,
      TError,
      { id: string; data: KnowledgeDocumentPropagateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgePropagateCreate>>,
  TError,
  { id: string; data: KnowledgeDocumentPropagateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgePropagateCreateMutationOptions(options), queryClient);
};

/**
 * Toggle global availability for a document. Global documents are automatically available to all agents.
 */
export const filesKnowledgeToggleGlobalCreate = (id: string, signal?: AbortSignal) => {
  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/toggle-global/`,
    method: 'POST',
    signal,
  });
};

export const getFilesKnowledgeToggleGlobalCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['filesKnowledgeToggleGlobalCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return filesKnowledgeToggleGlobalCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeToggleGlobalCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>
>;

export type FilesKnowledgeToggleGlobalCreateMutationError = unknown;

export const useFilesKnowledgeToggleGlobalCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeToggleGlobalCreate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getFilesKnowledgeToggleGlobalCreateMutationOptions(options), queryClient);
};

/**
 * Upload a new version to an existing document.
 */
export const filesKnowledgeVersionsCreate = (
  id: string,
  knowledgeDocumentVersionCreateRequest: KnowledgeDocumentVersionCreateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`file`, knowledgeDocumentVersionCreateRequest.file);
  if (knowledgeDocumentVersionCreateRequest.version_note !== undefined) {
    formData.append(`version_note`, knowledgeDocumentVersionCreateRequest.version_note);
  }
  if (knowledgeDocumentVersionCreateRequest.extract_text !== undefined) {
    formData.append(`extract_text`, knowledgeDocumentVersionCreateRequest.extract_text.toString());
  }

  return customInstance<KnowledgeDocumentVersion>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>,
    TError,
    { id: string; data: KnowledgeDocumentVersionCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>,
  TError,
  { id: string; data: KnowledgeDocumentVersionCreateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>,
    { id: string; data: KnowledgeDocumentVersionCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgeVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeVersionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>
>;
export type FilesKnowledgeVersionsCreateMutationBody = KnowledgeDocumentVersionCreateRequest;
export type FilesKnowledgeVersionsCreateMutationError = unknown;

export const useFilesKnowledgeVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>,
      TError,
      { id: string; data: KnowledgeDocumentVersionCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeVersionsCreate>>,
  TError,
  { id: string; data: KnowledgeDocumentVersionCreateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Workspace-admin override of a document version's compliance disposition. `approve` sets the backing file to ALLOW (visible to teammates), including override of BLOCK. `deny` sets it to REMOVED (hidden). `accept_amendment` promotes the filter's amended copy when present. `rationale` is required when overriding the filter (restore BLOCK/REMOVED, or keep original on AMEND); optional when confirming WARN, denying, or accepting the amended copy. Returns the refreshed document detail including the decision timeline.
 */
export const filesKnowledgeVersionsComplianceDecisionCreate = (
  id: string,
  versionId: string,
  knowledgeVersionComplianceDecisionRequest: KnowledgeVersionComplianceDecisionRequest,
  signal?: AbortSignal
) => {
  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/versions/${versionId}/compliance-decision/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: knowledgeVersionComplianceDecisionRequest,
    signal,
  });
};

export const getFilesKnowledgeVersionsComplianceDecisionCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>,
    TError,
    { id: string; versionId: string; data: KnowledgeVersionComplianceDecisionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>,
  TError,
  { id: string; versionId: string; data: KnowledgeVersionComplianceDecisionRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeVersionsComplianceDecisionCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>,
    { id: string; versionId: string; data: KnowledgeVersionComplianceDecisionRequest }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return filesKnowledgeVersionsComplianceDecisionCreate(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeVersionsComplianceDecisionCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>
>;
export type FilesKnowledgeVersionsComplianceDecisionCreateMutationBody = KnowledgeVersionComplianceDecisionRequest;
export type FilesKnowledgeVersionsComplianceDecisionCreateMutationError = unknown;

export const useFilesKnowledgeVersionsComplianceDecisionCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>,
      TError,
      { id: string; versionId: string; data: KnowledgeVersionComplianceDecisionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeVersionsComplianceDecisionCreate>>,
  TError,
  { id: string; versionId: string; data: KnowledgeVersionComplianceDecisionRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeVersionsComplianceDecisionCreateMutationOptions(options), queryClient);
};

/**
 * Set a specific version as the current (Active) version. Only versions with compliance_status ALLOW (or never gated) may be activated.
 */
export const filesKnowledgeVersionsSetCurrentCreate = (id: string, versionId: string, signal?: AbortSignal) => {
  return customInstance<KnowledgeDocumentDetail>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/versions/${versionId}/set-current/`,
    method: 'POST',
    signal,
  });
};

export const getFilesKnowledgeVersionsSetCurrentCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['filesKnowledgeVersionsSetCurrentCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return filesKnowledgeVersionsSetCurrentCreate(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeVersionsSetCurrentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>
>;

export type FilesKnowledgeVersionsSetCurrentCreateMutationError = unknown;

export const useFilesKnowledgeVersionsSetCurrentCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeVersionsSetCurrentCreate>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getFilesKnowledgeVersionsSetCurrentCreateMutationOptions(options), queryClient);
};

/**
 * List all versions of a document.
 */
export const filesKnowledgeVersionsListList = (id: string, signal?: AbortSignal) => {
  return customInstance<KnowledgeDocumentVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/${id}/versions/list/`,
    method: 'GET',
    signal,
  });
};

export const getFilesKnowledgeVersionsListListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/files/knowledge/${id}/versions/list/`] as const;
};

export const getFilesKnowledgeVersionsListListQueryOptions = <
  TData = Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesKnowledgeVersionsListListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>> = ({ signal }) =>
    filesKnowledgeVersionsListList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesKnowledgeVersionsListListQueryResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>
>;
export type FilesKnowledgeVersionsListListQueryError = unknown;

export function useFilesKnowledgeVersionsListList<
  TData = Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeVersionsListList<
  TData = Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeVersionsListList<
  TData = Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesKnowledgeVersionsListList<
  TData = Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeVersionsListList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesKnowledgeVersionsListListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List all suggested documents.
 */
export const filesKnowledgeSuggestedList = (params?: FilesKnowledgeSuggestedListParams, signal?: AbortSignal) => {
  return customInstance<SuggestedDocument[]>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/suggested/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFilesKnowledgeSuggestedListQueryKey = (params?: FilesKnowledgeSuggestedListParams) => {
  return [`${import.meta.env.VITE_API_URL}/files/knowledge/suggested/`, ...(params ? [params] : [])] as const;
};

export const getFilesKnowledgeSuggestedListQueryOptions = <
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
  TError = unknown,
>(
  params?: FilesKnowledgeSuggestedListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesKnowledgeSuggestedListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>> = ({ signal }) =>
    filesKnowledgeSuggestedList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesKnowledgeSuggestedListQueryResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>
>;
export type FilesKnowledgeSuggestedListQueryError = unknown;

export function useFilesKnowledgeSuggestedList<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
  TError = unknown,
>(
  params: undefined | FilesKnowledgeSuggestedListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeSuggestedList<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
  TError = unknown,
>(
  params?: FilesKnowledgeSuggestedListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeSuggestedList<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
  TError = unknown,
>(
  params?: FilesKnowledgeSuggestedListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesKnowledgeSuggestedList<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>,
  TError = unknown,
>(
  params?: FilesKnowledgeSuggestedListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesKnowledgeSuggestedListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new document suggestion.
 */
export const filesKnowledgeSuggestedCreate = (
  suggestedDocumentCreateRequest: SuggestedDocumentCreateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`name`, suggestedDocumentCreateRequest.name);
  formData.append(`description`, suggestedDocumentCreateRequest.description);
  formData.append(`suggested_by_agent`, suggestedDocumentCreateRequest.suggested_by_agent);

  return customInstance<SuggestedDocument>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/suggested/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeSuggestedCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>,
    TError,
    { data: SuggestedDocumentCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>,
  TError,
  { data: SuggestedDocumentCreateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeSuggestedCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>,
    { data: SuggestedDocumentCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return filesKnowledgeSuggestedCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeSuggestedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>
>;
export type FilesKnowledgeSuggestedCreateMutationBody = SuggestedDocumentCreateRequest;
export type FilesKnowledgeSuggestedCreateMutationError = unknown;

export const useFilesKnowledgeSuggestedCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>,
      TError,
      { data: SuggestedDocumentCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedCreate>>,
  TError,
  { data: SuggestedDocumentCreateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeSuggestedCreateMutationOptions(options), queryClient);
};

/**
 * AI-suggested documents management.
 *
 * list:
 *     List all suggestions, optionally filtered by status.
 *
 * create:
 *     Create a new suggestion (typically called by agents).
 *
 * partial_update:
 *     Update suggestion status (dismiss).
 *
 * fulfill:
 *     Fulfill a suggestion by uploading a file or linking an existing document.
 */
export const filesKnowledgeSuggestedRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<SuggestedDocument>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/suggested/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getFilesKnowledgeSuggestedRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/files/knowledge/suggested/${id}/`] as const;
};

export const getFilesKnowledgeSuggestedRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesKnowledgeSuggestedRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>> = ({ signal }) =>
    filesKnowledgeSuggestedRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesKnowledgeSuggestedRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>
>;
export type FilesKnowledgeSuggestedRetrieveQueryError = unknown;

export function useFilesKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesKnowledgeSuggestedRetrieve<
  TData = Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesKnowledgeSuggestedRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesKnowledgeSuggestedRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update suggestion status (e.g., dismiss).
 */
export const filesKnowledgeSuggestedPartialUpdate = (
  id: string,
  patchedSuggestedDocumentUpdateRequest?: PatchedSuggestedDocumentUpdateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (patchedSuggestedDocumentUpdateRequest?.status !== undefined) {
    formData.append(`status`, patchedSuggestedDocumentUpdateRequest.status);
  }

  return customInstance<SuggestedDocument>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/suggested/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeSuggestedPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>,
    TError,
    { id: string; data?: PatchedSuggestedDocumentUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>,
  TError,
  { id: string; data?: PatchedSuggestedDocumentUpdateRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeSuggestedPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>,
    { id: string; data?: PatchedSuggestedDocumentUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgeSuggestedPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeSuggestedPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>
>;
export type FilesKnowledgeSuggestedPartialUpdateMutationBody = PatchedSuggestedDocumentUpdateRequest | undefined;
export type FilesKnowledgeSuggestedPartialUpdateMutationError = unknown;

export const useFilesKnowledgeSuggestedPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>,
      TError,
      { id: string; data?: PatchedSuggestedDocumentUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedPartialUpdate>>,
  TError,
  { id: string; data?: PatchedSuggestedDocumentUpdateRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeSuggestedPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Fulfill a suggestion by uploading a file or linking an existing document.
 */
export const filesKnowledgeSuggestedFulfillCreate = (
  id: string,
  suggestedDocumentFulfillRequest?: SuggestedDocumentFulfillRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (
    suggestedDocumentFulfillRequest?.document_id !== undefined &&
    suggestedDocumentFulfillRequest.document_id !== null
  ) {
    formData.append(`document_id`, suggestedDocumentFulfillRequest.document_id);
  }
  if (suggestedDocumentFulfillRequest?.file !== undefined) {
    formData.append(`file`, suggestedDocumentFulfillRequest.file);
  }
  if (suggestedDocumentFulfillRequest?.name !== undefined) {
    formData.append(`name`, suggestedDocumentFulfillRequest.name);
  }
  if (suggestedDocumentFulfillRequest?.extract_text !== undefined) {
    formData.append(`extract_text`, suggestedDocumentFulfillRequest.extract_text.toString());
  }

  return customInstance<SuggestedDocument>({
    url: `${import.meta.env.VITE_API_URL}/files/knowledge/suggested/${id}/fulfill/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesKnowledgeSuggestedFulfillCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>,
    TError,
    { id: string; data?: SuggestedDocumentFulfillRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>,
  TError,
  { id: string; data?: SuggestedDocumentFulfillRequest },
  TContext
> => {
  const mutationKey = ['filesKnowledgeSuggestedFulfillCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>,
    { id: string; data?: SuggestedDocumentFulfillRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return filesKnowledgeSuggestedFulfillCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesKnowledgeSuggestedFulfillCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>
>;
export type FilesKnowledgeSuggestedFulfillCreateMutationBody = SuggestedDocumentFulfillRequest | undefined;
export type FilesKnowledgeSuggestedFulfillCreateMutationError = unknown;

export const useFilesKnowledgeSuggestedFulfillCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>,
      TError,
      { id: string; data?: SuggestedDocumentFulfillRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesKnowledgeSuggestedFulfillCreate>>,
  TError,
  { id: string; data?: SuggestedDocumentFulfillRequest },
  TContext
> => {
  return useMutation(getFilesKnowledgeSuggestedFulfillCreateMutationOptions(options), queryClient);
};

/**
 * Allows listing and uploading files in the current tenant.
 *
 * Eval Studio files (run outputs and scenario input fixtures) are excluded
 * from every action via ``workspace_visible()`` so they never appear in
 * workspace listings, downloads, or pickers.
 */
export const filesUploadsList = (signal?: AbortSignal) => {
  return customInstance<UploadedFile[]>({
    url: `${import.meta.env.VITE_API_URL}/files/uploads/`,
    method: 'GET',
    signal,
  });
};

export const getFilesUploadsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/files/uploads/`] as const;
};

export const getFilesUploadsListQueryOptions = <
  TData = Awaited<ReturnType<typeof filesUploadsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesUploadsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesUploadsList>>> = ({ signal }) => filesUploadsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesUploadsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesUploadsListQueryResult = NonNullable<Awaited<ReturnType<typeof filesUploadsList>>>;
export type FilesUploadsListQueryError = unknown;

export function useFilesUploadsList<TData = Awaited<ReturnType<typeof filesUploadsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesUploadsList>>,
          TError,
          Awaited<ReturnType<typeof filesUploadsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesUploadsList<TData = Awaited<ReturnType<typeof filesUploadsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesUploadsList>>,
          TError,
          Awaited<ReturnType<typeof filesUploadsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesUploadsList<TData = Awaited<ReturnType<typeof filesUploadsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesUploadsList<TData = Awaited<ReturnType<typeof filesUploadsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesUploadsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Upload a file. Optionally set `extract_text=true` to run text/markdown extraction and store it in `text_content`.
 */
export const filesUploadsCreate = (uploadedFileRequest: UploadedFileRequest, signal?: AbortSignal) => {
  const formData = new FormData();
  formData.append(`file`, uploadedFileRequest.file);
  if (uploadedFileRequest.external_permalink !== undefined && uploadedFileRequest.external_permalink !== null) {
    formData.append(`external_permalink`, uploadedFileRequest.external_permalink);
  }
  if (uploadedFileRequest.extract_text !== undefined) {
    formData.append(`extract_text`, uploadedFileRequest.extract_text.toString());
  }
  if (uploadedFileRequest.agent_id !== undefined && uploadedFileRequest.agent_id !== null) {
    formData.append(`agent_id`, uploadedFileRequest.agent_id);
  }
  if (uploadedFileRequest.eval_scenario_id !== undefined && uploadedFileRequest.eval_scenario_id !== null) {
    formData.append(`eval_scenario_id`, uploadedFileRequest.eval_scenario_id);
  }

  return customInstance<UploadedFile>({
    url: `${import.meta.env.VITE_API_URL}/files/uploads/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getFilesUploadsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filesUploadsCreate>>,
    TError,
    { data: UploadedFileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filesUploadsCreate>>,
  TError,
  { data: UploadedFileRequest },
  TContext
> => {
  const mutationKey = ['filesUploadsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesUploadsCreate>>, { data: UploadedFileRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return filesUploadsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesUploadsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof filesUploadsCreate>>>;
export type FilesUploadsCreateMutationBody = UploadedFileRequest;
export type FilesUploadsCreateMutationError = unknown;

export const useFilesUploadsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof filesUploadsCreate>>,
      TError,
      { data: UploadedFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof filesUploadsCreate>>,
  TError,
  { data: UploadedFileRequest },
  TContext
> => {
  return useMutation(getFilesUploadsCreateMutationOptions(options), queryClient);
};

/**
 * Download a file by ID. Returns the file content with appropriate headers. Use ?metadata=true to get JSON metadata instead.
 */
export const filesUploadsRetrieve = (id: number, params?: FilesUploadsRetrieveParams, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `${import.meta.env.VITE_API_URL}/files/uploads/${id}/`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getFilesUploadsRetrieveQueryKey = (id: number, params?: FilesUploadsRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/files/uploads/${id}/`, ...(params ? [params] : [])] as const;
};

export const getFilesUploadsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof filesUploadsRetrieve>>,
  TError = FilesUploadsRetrieve404,
>(
  id: number,
  params?: FilesUploadsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesUploadsRetrieveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof filesUploadsRetrieve>>> = ({ signal }) =>
    filesUploadsRetrieve(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesUploadsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesUploadsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof filesUploadsRetrieve>>>;
export type FilesUploadsRetrieveQueryError = FilesUploadsRetrieve404;

export function useFilesUploadsRetrieve<
  TData = Awaited<ReturnType<typeof filesUploadsRetrieve>>,
  TError = FilesUploadsRetrieve404,
>(
  id: number,
  params: undefined | FilesUploadsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesUploadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesUploadsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesUploadsRetrieve<
  TData = Awaited<ReturnType<typeof filesUploadsRetrieve>>,
  TError = FilesUploadsRetrieve404,
>(
  id: number,
  params?: FilesUploadsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesUploadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof filesUploadsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFilesUploadsRetrieve<
  TData = Awaited<ReturnType<typeof filesUploadsRetrieve>>,
  TError = FilesUploadsRetrieve404,
>(
  id: number,
  params?: FilesUploadsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFilesUploadsRetrieve<
  TData = Awaited<ReturnType<typeof filesUploadsRetrieve>>,
  TError = FilesUploadsRetrieve404,
>(
  id: number,
  params?: FilesUploadsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof filesUploadsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFilesUploadsRetrieveQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Allows listing and uploading files in the current tenant.
 *
 * Eval Studio files (run outputs and scenario input fixtures) are excluded
 * from every action via ``workspace_visible()`` so they never appear in
 * workspace listings, downloads, or pickers.
 */
export const filesUploadsDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/files/uploads/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getFilesUploadsDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof filesUploadsDestroy>>, TError, { id: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof filesUploadsDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['filesUploadsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesUploadsDestroy>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return filesUploadsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilesUploadsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof filesUploadsDestroy>>>;

export type FilesUploadsDestroyMutationError = unknown;

export const useFilesUploadsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof filesUploadsDestroy>>, TError, { id: number }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof filesUploadsDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getFilesUploadsDestroyMutationOptions(options), queryClient);
};

/**
 * Returns a list of all categories with counts of rulesets and guardrails
 * @summary List Categories
 */
export const guardrailsCategoriesList = (signal?: AbortSignal) => {
  return customInstance<Category[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsCategoriesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/categories/`] as const;
};

export const getGuardrailsCategoriesListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsCategoriesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsCategoriesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsCategoriesList>>> = ({ signal }) =>
    guardrailsCategoriesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsCategoriesList>>>;
export type GuardrailsCategoriesListQueryError = unknown;

export function useGuardrailsCategoriesList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Categories
 */

export function useGuardrailsCategoriesList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsCategoriesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new category
 * @summary Create Category
 */
export const guardrailsCategoriesCreate = (categoryRequest: CategoryRequest, signal?: AbortSignal) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: categoryRequest,
    signal,
  });
};

export const getGuardrailsCategoriesCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesCreate>>,
    TError,
    { data: CategoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesCreate>>,
  TError,
  { data: CategoryRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesCreate>>,
    { data: CategoryRequest }
  > = (props) => {
    const { data } = props ?? {};

    return guardrailsCategoriesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesCreate>>
>;
export type GuardrailsCategoriesCreateMutationBody = CategoryRequest;
export type GuardrailsCategoriesCreateMutationError = void;

/**
 * @summary Create Category
 */
export const useGuardrailsCategoriesCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesCreate>>,
      TError,
      { data: CategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesCreate>>,
  TError,
  { data: CategoryRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific category by ID
 * @summary Get Category
 */
export const guardrailsCategoriesRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsCategoriesRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/`] as const;
};

export const getGuardrailsCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsCategoriesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>> = ({ signal }) =>
    guardrailsCategoriesRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>
>;
export type GuardrailsCategoriesRetrieveQueryError = void;

export function useGuardrailsCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Category
 */

export function useGuardrailsCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsCategoriesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update a category by ID
 * @summary Update Category
 */
export const guardrailsCategoriesUpdate = (id: number, categoryRequest: CategoryRequest, signal?: AbortSignal) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: categoryRequest,
    signal,
  });
};

export const getGuardrailsCategoriesUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>,
    TError,
    { id: number; data: CategoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>,
  TError,
  { id: number; data: CategoryRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>,
    { id: number; data: CategoryRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>
>;
export type GuardrailsCategoriesUpdateMutationBody = CategoryRequest;
export type GuardrailsCategoriesUpdateMutationError = void;

/**
 * @summary Update Category
 */
export const useGuardrailsCategoriesUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>,
      TError,
      { id: number; data: CategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesUpdate>>,
  TError,
  { id: number; data: CategoryRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesUpdateMutationOptions(options), queryClient);
};

/**
 * Partially update a category by ID
 * @summary Partial Update Category
 */
export const guardrailsCategoriesPartialUpdate = (
  id: number,
  patchedCategoryRequest?: PatchedCategoryRequest,
  signal?: AbortSignal
) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedCategoryRequest,
    signal,
  });
};

export const getGuardrailsCategoriesPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>,
    TError,
    { id: number; data?: PatchedCategoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>,
  TError,
  { id: number; data?: PatchedCategoryRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>,
    { id: number; data?: PatchedCategoryRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>
>;
export type GuardrailsCategoriesPartialUpdateMutationBody = PatchedCategoryRequest | undefined;
export type GuardrailsCategoriesPartialUpdateMutationError = void;

/**
 * @summary Partial Update Category
 */
export const useGuardrailsCategoriesPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>,
      TError,
      { id: number; data?: PatchedCategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesPartialUpdate>>,
  TError,
  { id: number; data?: PatchedCategoryRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Delete a category by ID
 * @summary Delete Category
 */
export const guardrailsCategoriesDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsCategoriesDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['guardrailsCategoriesDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return guardrailsCategoriesDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>
>;

export type GuardrailsCategoriesDestroyMutationError = void;

/**
 * @summary Delete Category
 */
export const useGuardrailsCategoriesDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof guardrailsCategoriesDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getGuardrailsCategoriesDestroyMutationOptions(options), queryClient);
};

/**
 * Rollback category to a previous version. Can either activate existing version or create new bump. Supports parent-only (metadata) or entire tree rollback.
 * @summary Rollback Category
 */
export const guardrailsCategoriesRollbackCreate = (
  id: number,
  guardrailsCategoriesRollbackCreateBody?: GuardrailsCategoriesRollbackCreateBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/rollback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailsCategoriesRollbackCreateBody,
    signal,
  });
};

export const getGuardrailsCategoriesRollbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>,
    TError,
    { id: number; data?: GuardrailsCategoriesRollbackCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsCategoriesRollbackCreateBody },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesRollbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>,
    { id: number; data?: GuardrailsCategoriesRollbackCreateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesRollbackCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesRollbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>
>;
export type GuardrailsCategoriesRollbackCreateMutationBody = GuardrailsCategoriesRollbackCreateBody | undefined;
export type GuardrailsCategoriesRollbackCreateMutationError = void;

/**
 * @summary Rollback Category
 */
export const useGuardrailsCategoriesRollbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>,
      TError,
      { id: number; data?: GuardrailsCategoriesRollbackCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsCategoriesRollbackCreateBody },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesRollbackCreateMutationOptions(options), queryClient);
};

/**
 * List all RuleSets for a given Category ID
 * @summary List RuleSets in a Category
 */
export const guardrailsCategoriesRulesetsList = (id: number, signal?: AbortSignal) => {
  return customInstance<RuleSet[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/rulesets/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsCategoriesRulesetsListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/rulesets/`] as const;
};

export const getGuardrailsCategoriesRulesetsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsCategoriesRulesetsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>> = ({ signal }) =>
    guardrailsCategoriesRulesetsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsCategoriesRulesetsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>
>;
export type GuardrailsCategoriesRulesetsListQueryError = void;

export function useGuardrailsCategoriesRulesetsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesRulesetsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesRulesetsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List RuleSets in a Category
 */

export function useGuardrailsCategoriesRulesetsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesRulesetsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsCategoriesRulesetsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new RuleSet for a given Category ID
 * @summary Create RuleSet in a Category
 */
export const guardrailsCategoriesRulesetsCreate = (
  id: number,
  categoryRuleSetCreateRequest: CategoryRuleSetCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/rulesets/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: categoryRuleSetCreateRequest,
    signal,
  });
};

export const getGuardrailsCategoriesRulesetsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>,
    TError,
    { id: number; data: CategoryRuleSetCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>,
  TError,
  { id: number; data: CategoryRuleSetCreateRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesRulesetsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>,
    { id: number; data: CategoryRuleSetCreateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesRulesetsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesRulesetsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>
>;
export type GuardrailsCategoriesRulesetsCreateMutationBody = CategoryRuleSetCreateRequest;
export type GuardrailsCategoriesRulesetsCreateMutationError = void;

/**
 * @summary Create RuleSet in a Category
 */
export const useGuardrailsCategoriesRulesetsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>,
      TError,
      { id: number; data: CategoryRuleSetCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesRulesetsCreate>>,
  TError,
  { id: number; data: CategoryRuleSetCreateRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesRulesetsCreateMutationOptions(options), queryClient);
};

/**
 * Update only the is_enabled field for a Category
 * @summary Set Category enabled/disabled
 */
export const guardrailsCategoriesSetEnabledPartialUpdate = (
  id: number,
  patchedIsEnabledUpdateRequest?: PatchedIsEnabledUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/set-enabled/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedIsEnabledUpdateRequest,
    signal,
  });
};

export const getGuardrailsCategoriesSetEnabledPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>,
    TError,
    { id: number; data?: PatchedIsEnabledUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesSetEnabledPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>,
    { id: number; data?: PatchedIsEnabledUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesSetEnabledPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesSetEnabledPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>
>;
export type GuardrailsCategoriesSetEnabledPartialUpdateMutationBody = PatchedIsEnabledUpdateRequest | undefined;
export type GuardrailsCategoriesSetEnabledPartialUpdateMutationError = void;

/**
 * @summary Set Category enabled/disabled
 */
export const useGuardrailsCategoriesSetEnabledPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>,
      TError,
      { id: number; data?: PatchedIsEnabledUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesSetEnabledPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Get all versions for a specific category
 * @summary List Category Versions
 */
export const guardrailsCategoriesVersionsList = (id: number, signal?: AbortSignal) => {
  return customInstance<CategoryVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsCategoriesVersionsListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/`] as const;
};

export const getGuardrailsCategoriesVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsCategoriesVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>> = ({ signal }) =>
    guardrailsCategoriesVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsCategoriesVersionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>
>;
export type GuardrailsCategoriesVersionsListQueryError = void;

export function useGuardrailsCategoriesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Category Versions
 */

export function useGuardrailsCategoriesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsCategoriesVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new version snapshot of this category
 */
export const guardrailsCategoriesVersionsCreate = (
  id: number,
  categoryRequest: CategoryRequest,
  signal?: AbortSignal
) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: categoryRequest,
    signal,
  });
};

export const getGuardrailsCategoriesVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>,
    TError,
    { id: number; data: CategoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>,
  TError,
  { id: number; data: CategoryRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>,
    { id: number; data: CategoryRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsCategoriesVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesVersionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>
>;
export type GuardrailsCategoriesVersionsCreateMutationBody = CategoryRequest;
export type GuardrailsCategoriesVersionsCreateMutationError = unknown;

export const useGuardrailsCategoriesVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>,
      TError,
      { id: number; data: CategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsCreate>>,
  TError,
  { id: number; data: CategoryRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Activate a specific version of this category - applies snapshot to live fields
 */
export const guardrailsCategoriesVersionsActivatePartialUpdate = (
  id: number,
  versionId: string,
  patchedCategoryRequest?: PatchedCategoryRequest,
  signal?: AbortSignal
) => {
  return customInstance<Category>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/${versionId}/activate/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedCategoryRequest,
    signal,
  });
};

export const getGuardrailsCategoriesVersionsActivatePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>,
    TError,
    { id: number; versionId: string; data?: PatchedCategoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>,
  TError,
  { id: number; versionId: string; data?: PatchedCategoryRequest },
  TContext
> => {
  const mutationKey = ['guardrailsCategoriesVersionsActivatePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>,
    { id: number; versionId: string; data?: PatchedCategoryRequest }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return guardrailsCategoriesVersionsActivatePartialUpdate(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsCategoriesVersionsActivatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>
>;
export type GuardrailsCategoriesVersionsActivatePartialUpdateMutationBody = PatchedCategoryRequest | undefined;
export type GuardrailsCategoriesVersionsActivatePartialUpdateMutationError = unknown;

export const useGuardrailsCategoriesVersionsActivatePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>,
      TError,
      { id: number; versionId: string; data?: PatchedCategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsActivatePartialUpdate>>,
  TError,
  { id: number; versionId: string; data?: PatchedCategoryRequest },
  TContext
> => {
  return useMutation(getGuardrailsCategoriesVersionsActivatePartialUpdateMutationOptions(options), queryClient);
};

/**
 * Compare two versions of a category to see what changed
 * @summary Compare Category Versions
 */
export const guardrailsCategoriesVersionsCompareRetrieve = (
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<VersionDiff>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGuardrailsCategoriesVersionsCompareRetrieveQueryKey = (
  id: number,
  params?: GuardrailsCategoriesVersionsCompareRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/guardrails/categories/${id}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGuardrailsCategoriesVersionsCompareRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsCategoriesVersionsCompareRetrieveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>> = ({
    signal,
  }) => guardrailsCategoriesVersionsCompareRetrieve(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsCategoriesVersionsCompareRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>
>;
export type GuardrailsCategoriesVersionsCompareRetrieveQueryError = void;

export function useGuardrailsCategoriesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsCategoriesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare Category Versions
 */

export function useGuardrailsCategoriesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsCategoriesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsCategoriesVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsCategoriesVersionsCompareRetrieveQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesList = (signal?: AbortSignal) => {
  return customInstance<Example[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsExamplesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/examples/`] as const;
};

export const getGuardrailsExamplesListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsExamplesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsExamplesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsExamplesList>>> = ({ signal }) =>
    guardrailsExamplesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsExamplesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsExamplesListQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsExamplesList>>>;
export type GuardrailsExamplesListQueryError = unknown;

export function useGuardrailsExamplesList<TData = Awaited<ReturnType<typeof guardrailsExamplesList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesList<TData = Awaited<ReturnType<typeof guardrailsExamplesList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesList<TData = Awaited<ReturnType<typeof guardrailsExamplesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsExamplesList<TData = Awaited<ReturnType<typeof guardrailsExamplesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsExamplesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesCreate = (exampleRequest: ExampleRequest, signal?: AbortSignal) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: exampleRequest,
    signal,
  });
};

export const getGuardrailsExamplesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesCreate>>,
    TError,
    { data: ExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesCreate>>,
  TError,
  { data: ExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsExamplesCreate>>, { data: ExampleRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return guardrailsExamplesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof guardrailsExamplesCreate>>>;
export type GuardrailsExamplesCreateMutationBody = ExampleRequest;
export type GuardrailsExamplesCreateMutationError = unknown;

export const useGuardrailsExamplesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesCreate>>,
      TError,
      { data: ExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesCreate>>,
  TError,
  { data: ExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsExamplesCreateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsExamplesRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/`] as const;
};

export const getGuardrailsExamplesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsExamplesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>> = ({ signal }) =>
    guardrailsExamplesRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsExamplesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>>;
export type GuardrailsExamplesRetrieveQueryError = unknown;

export function useGuardrailsExamplesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsExamplesRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsExamplesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesUpdate = (id: number, exampleRequest: ExampleRequest, signal?: AbortSignal) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: exampleRequest,
    signal,
  });
};

export const getGuardrailsExamplesUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesUpdate>>,
    TError,
    { id: number; data: ExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesUpdate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsExamplesUpdate>>,
    { id: number; data: ExampleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsExamplesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof guardrailsExamplesUpdate>>>;
export type GuardrailsExamplesUpdateMutationBody = ExampleRequest;
export type GuardrailsExamplesUpdateMutationError = unknown;

export const useGuardrailsExamplesUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesUpdate>>,
      TError,
      { id: number; data: ExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesUpdate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsExamplesUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesPartialUpdate = (
  id: number,
  patchedExampleRequest?: PatchedExampleRequest,
  signal?: AbortSignal
) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedExampleRequest,
    signal,
  });
};

export const getGuardrailsExamplesPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>,
    TError,
    { id: number; data?: PatchedExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>,
  TError,
  { id: number; data?: PatchedExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>,
    { id: number; data?: PatchedExampleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsExamplesPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>
>;
export type GuardrailsExamplesPartialUpdateMutationBody = PatchedExampleRequest | undefined;
export type GuardrailsExamplesPartialUpdateMutationError = unknown;

export const useGuardrailsExamplesPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>,
      TError,
      { id: number; data?: PatchedExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesPartialUpdate>>,
  TError,
  { id: number; data?: PatchedExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsExamplesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Example model.
 */
export const guardrailsExamplesDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsExamplesDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof guardrailsExamplesDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['guardrailsExamplesDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsExamplesDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return guardrailsExamplesDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesDestroy>>
>;

export type GuardrailsExamplesDestroyMutationError = unknown;

export const useGuardrailsExamplesDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof guardrailsExamplesDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getGuardrailsExamplesDestroyMutationOptions(options), queryClient);
};

/**
 * Rollback example to a previous version
 * @summary Rollback Example
 */
export const guardrailsExamplesRollbackCreate = (
  id: number,
  guardrailsExamplesRollbackCreateBody?: GuardrailsExamplesRollbackCreateBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/rollback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailsExamplesRollbackCreateBody,
    signal,
  });
};

export const getGuardrailsExamplesRollbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>,
    TError,
    { id: number; data?: GuardrailsExamplesRollbackCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsExamplesRollbackCreateBody },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesRollbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>,
    { id: number; data?: GuardrailsExamplesRollbackCreateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsExamplesRollbackCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesRollbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>
>;
export type GuardrailsExamplesRollbackCreateMutationBody = GuardrailsExamplesRollbackCreateBody | undefined;
export type GuardrailsExamplesRollbackCreateMutationError = void;

/**
 * @summary Rollback Example
 */
export const useGuardrailsExamplesRollbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>,
      TError,
      { id: number; data?: GuardrailsExamplesRollbackCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsExamplesRollbackCreateBody },
  TContext
> => {
  return useMutation(getGuardrailsExamplesRollbackCreateMutationOptions(options), queryClient);
};

/**
 * Update only the is_enabled field for an Example
 * @summary Set Example enabled/disabled
 */
export const guardrailsExamplesSetEnabledPartialUpdate = (
  id: number,
  patchedIsEnabledUpdateRequest?: PatchedIsEnabledUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/set-enabled/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedIsEnabledUpdateRequest,
    signal,
  });
};

export const getGuardrailsExamplesSetEnabledPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>,
    TError,
    { id: number; data?: PatchedIsEnabledUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesSetEnabledPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>,
    { id: number; data?: PatchedIsEnabledUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsExamplesSetEnabledPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesSetEnabledPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>
>;
export type GuardrailsExamplesSetEnabledPartialUpdateMutationBody = PatchedIsEnabledUpdateRequest | undefined;
export type GuardrailsExamplesSetEnabledPartialUpdateMutationError = void;

/**
 * @summary Set Example enabled/disabled
 */
export const useGuardrailsExamplesSetEnabledPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>,
      TError,
      { id: number; data?: PatchedIsEnabledUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  return useMutation(getGuardrailsExamplesSetEnabledPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Get all versions for a specific example
 * @summary List Example Versions
 */
export const guardrailsExamplesVersionsList = (id: number, signal?: AbortSignal) => {
  return customInstance<ExampleVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsExamplesVersionsListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/versions/`] as const;
};

export const getGuardrailsExamplesVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsExamplesVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>> = ({ signal }) =>
    guardrailsExamplesVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsExamplesVersionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>
>;
export type GuardrailsExamplesVersionsListQueryError = void;

export function useGuardrailsExamplesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Example Versions
 */

export function useGuardrailsExamplesVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsExamplesVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new version snapshot of this example
 */
export const guardrailsExamplesVersionsCreate = (id: number, exampleRequest: ExampleRequest, signal?: AbortSignal) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: exampleRequest,
    signal,
  });
};

export const getGuardrailsExamplesVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>,
    TError,
    { id: number; data: ExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsExamplesVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>,
    { id: number; data: ExampleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsExamplesVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsExamplesVersionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>
>;
export type GuardrailsExamplesVersionsCreateMutationBody = ExampleRequest;
export type GuardrailsExamplesVersionsCreateMutationError = unknown;

export const useGuardrailsExamplesVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>,
      TError,
      { id: number; data: ExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsExamplesVersionsCreate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsExamplesVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Compare two versions of an example to see what changed
 * @summary Compare Example Versions
 */
export const guardrailsExamplesVersionsCompareRetrieve = (
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<VersionDiff>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGuardrailsExamplesVersionsCompareRetrieveQueryKey = (
  id: number,
  params?: GuardrailsExamplesVersionsCompareRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/guardrails/examples/${id}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGuardrailsExamplesVersionsCompareRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsExamplesVersionsCompareRetrieveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>> = ({ signal }) =>
    guardrailsExamplesVersionsCompareRetrieve(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsExamplesVersionsCompareRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>
>;
export type GuardrailsExamplesVersionsCompareRetrieveQueryError = void;

export function useGuardrailsExamplesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsExamplesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare Example Versions
 */

export function useGuardrailsExamplesVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsExamplesVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsExamplesVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsExamplesVersionsCompareRetrieveQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsList = (signal?: AbortSignal) => {
  return customInstance<Guardrail[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsGuardrailsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/guardrails/`] as const;
};

export const getGuardrailsGuardrailsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsGuardrailsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsGuardrailsList>>> = ({ signal }) =>
    guardrailsGuardrailsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsGuardrailsListQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsGuardrailsList>>>;
export type GuardrailsGuardrailsListQueryError = unknown;

export function useGuardrailsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsGuardrailsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsCreate = (guardrailRequest: GuardrailRequest, signal?: AbortSignal) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailRequest,
    signal,
  });
};

export const getGuardrailsGuardrailsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>,
    TError,
    { data: GuardrailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>,
  TError,
  { data: GuardrailRequest },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>,
    { data: GuardrailRequest }
  > = (props) => {
    const { data } = props ?? {};

    return guardrailsGuardrailsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>
>;
export type GuardrailsGuardrailsCreateMutationBody = GuardrailRequest;
export type GuardrailsGuardrailsCreateMutationError = unknown;

export const useGuardrailsGuardrailsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>,
      TError,
      { data: GuardrailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsCreate>>,
  TError,
  { data: GuardrailRequest },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsCreateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsGuardrailsRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/`] as const;
};

export const getGuardrailsGuardrailsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsGuardrailsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>> = ({ signal }) =>
    guardrailsGuardrailsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsGuardrailsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>
>;
export type GuardrailsGuardrailsRetrieveQueryError = unknown;

export function useGuardrailsGuardrailsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsGuardrailsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsGuardrailsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsUpdate = (id: number, guardrailRequest: GuardrailRequest, signal?: AbortSignal) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailRequest,
    signal,
  });
};

export const getGuardrailsGuardrailsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>,
    TError,
    { id: number; data: GuardrailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>,
  TError,
  { id: number; data: GuardrailRequest },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>,
    { id: number; data: GuardrailRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsGuardrailsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>
>;
export type GuardrailsGuardrailsUpdateMutationBody = GuardrailRequest;
export type GuardrailsGuardrailsUpdateMutationError = unknown;

export const useGuardrailsGuardrailsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>,
      TError,
      { id: number; data: GuardrailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsUpdate>>,
  TError,
  { id: number; data: GuardrailRequest },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsPartialUpdate = (
  id: number,
  patchedGuardrailRequest?: PatchedGuardrailRequest,
  signal?: AbortSignal
) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedGuardrailRequest,
    signal,
  });
};

export const getGuardrailsGuardrailsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>,
    TError,
    { id: number; data?: PatchedGuardrailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedGuardrailRequest },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>,
    { id: number; data?: PatchedGuardrailRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsGuardrailsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>
>;
export type GuardrailsGuardrailsPartialUpdateMutationBody = PatchedGuardrailRequest | undefined;
export type GuardrailsGuardrailsPartialUpdateMutationError = unknown;

export const useGuardrailsGuardrailsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>,
      TError,
      { id: number; data?: PatchedGuardrailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedGuardrailRequest },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Guardrail model.
 */
export const guardrailsGuardrailsDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsGuardrailsDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['guardrailsGuardrailsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return guardrailsGuardrailsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>
>;

export type GuardrailsGuardrailsDestroyMutationError = unknown;

export const useGuardrailsGuardrailsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof guardrailsGuardrailsDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getGuardrailsGuardrailsDestroyMutationOptions(options), queryClient);
};

/**
 * Rollback guardrail to a previous version. Use version_major=0 to uncreate the guardrail (mark as non-existent without deletion).
 * @summary Rollback Guardrail
 */
export const guardrailsGuardrailsRollbackCreate = (
  id: number,
  guardrailsGuardrailsRollbackCreateBody?: GuardrailsGuardrailsRollbackCreateBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/rollback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailsGuardrailsRollbackCreateBody,
    signal,
  });
};

export const getGuardrailsGuardrailsRollbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>,
    TError,
    { id: number; data?: GuardrailsGuardrailsRollbackCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsGuardrailsRollbackCreateBody },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsRollbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>,
    { id: number; data?: GuardrailsGuardrailsRollbackCreateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsGuardrailsRollbackCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsRollbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>
>;
export type GuardrailsGuardrailsRollbackCreateMutationBody = GuardrailsGuardrailsRollbackCreateBody | undefined;
export type GuardrailsGuardrailsRollbackCreateMutationError = void;

/**
 * @summary Rollback Guardrail
 */
export const useGuardrailsGuardrailsRollbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>,
      TError,
      { id: number; data?: GuardrailsGuardrailsRollbackCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsGuardrailsRollbackCreateBody },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsRollbackCreateMutationOptions(options), queryClient);
};

/**
 * Update only the is_enabled field for a Guardrail
 * @summary Set Guardrail enabled/disabled
 */
export const guardrailsGuardrailsSetEnabledPartialUpdate = (
  id: number,
  patchedIsEnabledUpdateRequest?: PatchedIsEnabledUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/set-enabled/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedIsEnabledUpdateRequest,
    signal,
  });
};

export const getGuardrailsGuardrailsSetEnabledPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>,
    TError,
    { id: number; data?: PatchedIsEnabledUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsSetEnabledPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>,
    { id: number; data?: PatchedIsEnabledUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsGuardrailsSetEnabledPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsSetEnabledPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>
>;
export type GuardrailsGuardrailsSetEnabledPartialUpdateMutationBody = PatchedIsEnabledUpdateRequest | undefined;
export type GuardrailsGuardrailsSetEnabledPartialUpdateMutationError = void;

/**
 * @summary Set Guardrail enabled/disabled
 */
export const useGuardrailsGuardrailsSetEnabledPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>,
      TError,
      { id: number; data?: PatchedIsEnabledUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsSetEnabledPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Get all versions for a specific guardrail
 * @summary List Guardrail Versions
 */
export const guardrailsGuardrailsVersionsList = (id: string, signal?: AbortSignal) => {
  return customInstance<GuardrailVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsGuardrailsVersionsListQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/versions/`] as const;
};

export const getGuardrailsGuardrailsVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsGuardrailsVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>> = ({ signal }) =>
    guardrailsGuardrailsVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsGuardrailsVersionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>
>;
export type GuardrailsGuardrailsVersionsListQueryError = void;

export function useGuardrailsGuardrailsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Guardrail Versions
 */

export function useGuardrailsGuardrailsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsGuardrailsVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new version snapshot of this guardrail
 */
export const guardrailsGuardrailsVersionsCreate = (
  id: string,
  guardrailRequest: GuardrailRequest,
  signal?: AbortSignal
) => {
  return customInstance<Guardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailRequest,
    signal,
  });
};

export const getGuardrailsGuardrailsVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>,
    TError,
    { id: string; data: GuardrailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>,
  TError,
  { id: string; data: GuardrailRequest },
  TContext
> => {
  const mutationKey = ['guardrailsGuardrailsVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>,
    { id: string; data: GuardrailRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsGuardrailsVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsGuardrailsVersionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>
>;
export type GuardrailsGuardrailsVersionsCreateMutationBody = GuardrailRequest;
export type GuardrailsGuardrailsVersionsCreateMutationError = unknown;

export const useGuardrailsGuardrailsVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>,
      TError,
      { id: string; data: GuardrailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCreate>>,
  TError,
  { id: string; data: GuardrailRequest },
  TContext
> => {
  return useMutation(getGuardrailsGuardrailsVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Compare two versions of a guardrail to see what changed
 * @summary Compare Guardrail Versions
 */
export const guardrailsGuardrailsVersionsCompareRetrieve = (
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<VersionDiff>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGuardrailsGuardrailsVersionsCompareRetrieveQueryKey = (
  id: number,
  params?: GuardrailsGuardrailsVersionsCompareRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/guardrails/guardrails/${id}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGuardrailsGuardrailsVersionsCompareRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsGuardrailsVersionsCompareRetrieveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>> = ({
    signal,
  }) => guardrailsGuardrailsVersionsCompareRetrieve(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsGuardrailsVersionsCompareRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>
>;
export type GuardrailsGuardrailsVersionsCompareRetrieveQueryError = void;

export function useGuardrailsGuardrailsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsGuardrailsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare Guardrail Versions
 */

export function useGuardrailsGuardrailsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsGuardrailsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsGuardrailsVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsGuardrailsVersionsCompareRetrieveQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsList = (signal?: AbortSignal) => {
  return customInstance<Regulation[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRegulationsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/regulations/`] as const;
};

export const getGuardrailsRegulationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRegulationsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRegulationsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRegulationsList>>> = ({ signal }) =>
    guardrailsRegulationsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRegulationsListQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsRegulationsList>>>;
export type GuardrailsRegulationsListQueryError = unknown;

export function useGuardrailsRegulationsList<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRegulationsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRegulationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRegulationsList<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRegulationsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRegulationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRegulationsList<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsRegulationsList<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsList>>,
  TError = unknown,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRegulationsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsCreate = (regulationRequest: RegulationRequest, signal?: AbortSignal) => {
  return customInstance<Regulation>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: regulationRequest,
    signal,
  });
};

export const getGuardrailsRegulationsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsCreate>>,
    TError,
    { data: RegulationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRegulationsCreate>>,
  TError,
  { data: RegulationRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRegulationsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRegulationsCreate>>,
    { data: RegulationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return guardrailsRegulationsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRegulationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRegulationsCreate>>
>;
export type GuardrailsRegulationsCreateMutationBody = RegulationRequest;
export type GuardrailsRegulationsCreateMutationError = unknown;

export const useGuardrailsRegulationsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRegulationsCreate>>,
      TError,
      { data: RegulationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRegulationsCreate>>,
  TError,
  { data: RegulationRequest },
  TContext
> => {
  return useMutation(getGuardrailsRegulationsCreateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<Regulation>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRegulationsRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/regulations/${id}/`] as const;
};

export const getGuardrailsRegulationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRegulationsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>> = ({ signal }) =>
    guardrailsRegulationsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRegulationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>
>;
export type GuardrailsRegulationsRetrieveQueryError = unknown;

export function useGuardrailsRegulationsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRegulationsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRegulationsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsRegulationsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRegulationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRegulationsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsUpdate = (id: number, regulationRequest: RegulationRequest, signal?: AbortSignal) => {
  return customInstance<Regulation>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: regulationRequest,
    signal,
  });
};

export const getGuardrailsRegulationsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>,
    TError,
    { id: number; data: RegulationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>,
  TError,
  { id: number; data: RegulationRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRegulationsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>,
    { id: number; data: RegulationRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRegulationsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRegulationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>
>;
export type GuardrailsRegulationsUpdateMutationBody = RegulationRequest;
export type GuardrailsRegulationsUpdateMutationError = unknown;

export const useGuardrailsRegulationsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>,
      TError,
      { id: number; data: RegulationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRegulationsUpdate>>,
  TError,
  { id: number; data: RegulationRequest },
  TContext
> => {
  return useMutation(getGuardrailsRegulationsUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsPartialUpdate = (
  id: number,
  patchedRegulationRequest?: PatchedRegulationRequest,
  signal?: AbortSignal
) => {
  return customInstance<Regulation>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRegulationRequest,
    signal,
  });
};

export const getGuardrailsRegulationsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>,
    TError,
    { id: number; data?: PatchedRegulationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRegulationRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRegulationsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>,
    { id: number; data?: PatchedRegulationRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRegulationsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRegulationsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>
>;
export type GuardrailsRegulationsPartialUpdateMutationBody = PatchedRegulationRequest | undefined;
export type GuardrailsRegulationsPartialUpdateMutationError = unknown;

export const useGuardrailsRegulationsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>,
      TError,
      { id: number; data?: PatchedRegulationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRegulationsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRegulationRequest },
  TContext
> => {
  return useMutation(getGuardrailsRegulationsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on Regulation model.
 */
export const guardrailsRegulationsDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/regulations/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsRegulationsDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['guardrailsRegulationsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return guardrailsRegulationsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRegulationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>
>;

export type GuardrailsRegulationsDestroyMutationError = unknown;

export const useGuardrailsRegulationsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof guardrailsRegulationsDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getGuardrailsRegulationsDestroyMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsList = (signal?: AbortSignal) => {
  return customInstance<RuleSet[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRulesetsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/rulesets/`] as const;
};

export const getGuardrailsRulesetsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsList>>> = ({ signal }) =>
    guardrailsRulesetsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsListQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsRulesetsList>>>;
export type GuardrailsRulesetsListQueryError = unknown;

export function useGuardrailsRulesetsList<TData = Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsList<TData = Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsList<TData = Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsRulesetsList<TData = Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsCreate = (ruleSetRequest: RuleSetRequest, signal?: AbortSignal) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ruleSetRequest,
    signal,
  });
};

export const getGuardrailsRulesetsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsCreate>>,
    TError,
    { data: RuleSetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsCreate>>,
  TError,
  { data: RuleSetRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsRulesetsCreate>>, { data: RuleSetRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return guardrailsRulesetsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof guardrailsRulesetsCreate>>>;
export type GuardrailsRulesetsCreateMutationBody = RuleSetRequest;
export type GuardrailsRulesetsCreateMutationError = unknown;

export const useGuardrailsRulesetsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsCreate>>,
      TError,
      { data: RuleSetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsCreate>>,
  TError,
  { data: RuleSetRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsCreateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsRetrieve = (id: number, signal?: AbortSignal) => {
  return customInstance<RuleSetDetail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRulesetsRetrieveQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/`] as const;
};

export const getGuardrailsRulesetsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>> = ({ signal }) =>
    guardrailsRulesetsRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>>;
export type GuardrailsRulesetsRetrieveQueryError = unknown;

export function useGuardrailsRulesetsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGuardrailsRulesetsRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsUpdate = (id: number, ruleSetRequest: RuleSetRequest, signal?: AbortSignal) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: ruleSetRequest,
    signal,
  });
};

export const getGuardrailsRulesetsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>,
    TError,
    { id: number; data: RuleSetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>,
  TError,
  { id: number; data: RuleSetRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>,
    { id: number; data: RuleSetRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>>;
export type GuardrailsRulesetsUpdateMutationBody = RuleSetRequest;
export type GuardrailsRulesetsUpdateMutationError = unknown;

export const useGuardrailsRulesetsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>,
      TError,
      { id: number; data: RuleSetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsUpdate>>,
  TError,
  { id: number; data: RuleSetRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsPartialUpdate = (
  id: number,
  patchedRuleSetRequest?: PatchedRuleSetRequest,
  signal?: AbortSignal
) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRuleSetRequest,
    signal,
  });
};

export const getGuardrailsRulesetsPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>,
    TError,
    { id: number; data?: PatchedRuleSetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRuleSetRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>,
    { id: number; data?: PatchedRuleSetRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>
>;
export type GuardrailsRulesetsPartialUpdateMutationBody = PatchedRuleSetRequest | undefined;
export type GuardrailsRulesetsPartialUpdateMutationError = unknown;

export const useGuardrailsRulesetsPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>,
      TError,
      { id: number; data?: PatchedRuleSetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsPartialUpdate>>,
  TError,
  { id: number; data?: PatchedRuleSetRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsPartialUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint for CRUD operations on RuleSet model.
 */
export const guardrailsRulesetsDestroy = (id: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsRulesetsDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>, TError, { id: number }, TContext> => {
  const mutationKey = ['guardrailsRulesetsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return guardrailsRulesetsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>
>;

export type GuardrailsRulesetsDestroyMutationError = unknown;

export const useGuardrailsRulesetsDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof guardrailsRulesetsDestroy>>, TError, { id: number }, TContext> => {
  return useMutation(getGuardrailsRulesetsDestroyMutationOptions(options), queryClient);
};

/**
 * List all examples assigned to this RuleSet
 * @summary List Examples for a RuleSet
 */
export const guardrailsRulesetsExamplesList = (id: number, signal?: AbortSignal) => {
  return customInstance<Example[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRulesetsExamplesListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/`] as const;
};

export const getGuardrailsRulesetsExamplesListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsExamplesListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>> = ({ signal }) =>
    guardrailsRulesetsExamplesList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsExamplesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>
>;
export type GuardrailsRulesetsExamplesListQueryError = void;

export function useGuardrailsRulesetsExamplesList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsExamplesList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsExamplesList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Examples for a RuleSet
 */

export function useGuardrailsRulesetsExamplesList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsExamplesList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsExamplesListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new example under this RuleSet
 * @summary Create Example for a RuleSet
 */
export const guardrailsRulesetsExamplesCreate = (id: number, exampleRequest: ExampleRequest, signal?: AbortSignal) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: exampleRequest,
    signal,
  });
};

export const getGuardrailsRulesetsExamplesCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>,
    TError,
    { id: number; data: ExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsExamplesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>,
    { id: number; data: ExampleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsExamplesCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsExamplesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>
>;
export type GuardrailsRulesetsExamplesCreateMutationBody = ExampleRequest;
export type GuardrailsRulesetsExamplesCreateMutationError = void;

/**
 * @summary Create Example for a RuleSet
 */
export const useGuardrailsRulesetsExamplesCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>,
      TError,
      { id: number; data: ExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesCreate>>,
  TError,
  { id: number; data: ExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsExamplesCreateMutationOptions(options), queryClient);
};

/**
 * Update a specific example under this RuleSet
 * @summary Update an Example for a RuleSet
 */
export const guardrailsRulesetsExamplesUpdate = (
  id: number,
  examplePk: number,
  exampleRequest: ExampleRequest,
  signal?: AbortSignal
) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/${examplePk}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: exampleRequest,
    signal,
  });
};

export const getGuardrailsRulesetsExamplesUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>,
    TError,
    { id: number; examplePk: number; data: ExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>,
  TError,
  { id: number; examplePk: number; data: ExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsExamplesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>,
    { id: number; examplePk: number; data: ExampleRequest }
  > = (props) => {
    const { id, examplePk, data } = props ?? {};

    return guardrailsRulesetsExamplesUpdate(id, examplePk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsExamplesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>
>;
export type GuardrailsRulesetsExamplesUpdateMutationBody = ExampleRequest;
export type GuardrailsRulesetsExamplesUpdateMutationError = void;

/**
 * @summary Update an Example for a RuleSet
 */
export const useGuardrailsRulesetsExamplesUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>,
      TError,
      { id: number; examplePk: number; data: ExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesUpdate>>,
  TError,
  { id: number; examplePk: number; data: ExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsExamplesUpdateMutationOptions(options), queryClient);
};

/**
 * Update a specific example under this RuleSet
 * @summary Update an Example for a RuleSet
 */
export const guardrailsRulesetsExamplesPartialUpdate = (
  id: number,
  examplePk: number,
  patchedExampleRequest?: PatchedExampleRequest,
  signal?: AbortSignal
) => {
  return customInstance<Example>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/${examplePk}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedExampleRequest,
    signal,
  });
};

export const getGuardrailsRulesetsExamplesPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>,
    TError,
    { id: number; examplePk: number; data?: PatchedExampleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>,
  TError,
  { id: number; examplePk: number; data?: PatchedExampleRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsExamplesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>,
    { id: number; examplePk: number; data?: PatchedExampleRequest }
  > = (props) => {
    const { id, examplePk, data } = props ?? {};

    return guardrailsRulesetsExamplesPartialUpdate(id, examplePk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsExamplesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>
>;
export type GuardrailsRulesetsExamplesPartialUpdateMutationBody = PatchedExampleRequest | undefined;
export type GuardrailsRulesetsExamplesPartialUpdateMutationError = void;

/**
 * @summary Update an Example for a RuleSet
 */
export const useGuardrailsRulesetsExamplesPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>,
      TError,
      { id: number; examplePk: number; data?: PatchedExampleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesPartialUpdate>>,
  TError,
  { id: number; examplePk: number; data?: PatchedExampleRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsExamplesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Delete a specific example from this RuleSet
 * @summary Delete an Example from a RuleSet
 */
export const guardrailsRulesetsExamplesDestroy = (id: number, examplePk: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/examples/${examplePk}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsRulesetsExamplesDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>,
    TError,
    { id: number; examplePk: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>,
  TError,
  { id: number; examplePk: number },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsExamplesDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>,
    { id: number; examplePk: number }
  > = (props) => {
    const { id, examplePk } = props ?? {};

    return guardrailsRulesetsExamplesDestroy(id, examplePk);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsExamplesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>
>;

export type GuardrailsRulesetsExamplesDestroyMutationError = void;

/**
 * @summary Delete an Example from a RuleSet
 */
export const useGuardrailsRulesetsExamplesDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>,
      TError,
      { id: number; examplePk: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsExamplesDestroy>>,
  TError,
  { id: number; examplePk: number },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsExamplesDestroyMutationOptions(options), queryClient);
};

/**
 * List all guardrails assigned to this RuleSet
 * @summary List Guardrails for a RuleSet
 */
export const guardrailsRulesetsGuardrailsList = (id: number, signal?: AbortSignal) => {
  return customInstance<Guardrail[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/guardrails/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRulesetsGuardrailsListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/guardrails/`] as const;
};

export const getGuardrailsRulesetsGuardrailsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsGuardrailsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>> = ({ signal }) =>
    guardrailsRulesetsGuardrailsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsGuardrailsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>
>;
export type GuardrailsRulesetsGuardrailsListQueryError = unknown;

export function useGuardrailsRulesetsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Guardrails for a RuleSet
 */

export function useGuardrailsRulesetsGuardrailsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsGuardrailsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Provide either an existing `guardrail_id` to link, or full guardrail data (`guardrail_id`, `name`, etc.) to create and link in one call
 * @summary Create or link Guardrail to RuleSet
 */
export const guardrailsRulesetsGuardrailsCreate = (
  id: number,
  guardrailRequest: GuardrailRequest,
  signal?: AbortSignal
) => {
  return customInstance<RuleSetGuardrail>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/guardrails/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailRequest,
    signal,
  });
};

export const getGuardrailsRulesetsGuardrailsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>,
    TError,
    { id: number; data: GuardrailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>,
  TError,
  { id: number; data: GuardrailRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsGuardrailsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>,
    { id: number; data: GuardrailRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsGuardrailsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsGuardrailsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>
>;
export type GuardrailsRulesetsGuardrailsCreateMutationBody = GuardrailRequest;
export type GuardrailsRulesetsGuardrailsCreateMutationError = void;

/**
 * @summary Create or link Guardrail to RuleSet
 */
export const useGuardrailsRulesetsGuardrailsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>,
      TError,
      { id: number; data: GuardrailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsCreate>>,
  TError,
  { id: number; data: GuardrailRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsGuardrailsCreateMutationOptions(options), queryClient);
};

/**
 * Remove a guardrail assignment from a RuleSet
 * @summary Remove Guardrail from RuleSet
 */
export const guardrailsRulesetsGuardrailsDestroy = (id: number, guardrailPk: number, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/guardrails/${guardrailPk}/`,
    method: 'DELETE',
    signal,
  });
};

export const getGuardrailsRulesetsGuardrailsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>,
    TError,
    { id: number; guardrailPk: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>,
  TError,
  { id: number; guardrailPk: number },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsGuardrailsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>,
    { id: number; guardrailPk: number }
  > = (props) => {
    const { id, guardrailPk } = props ?? {};

    return guardrailsRulesetsGuardrailsDestroy(id, guardrailPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsGuardrailsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>
>;

export type GuardrailsRulesetsGuardrailsDestroyMutationError = void;

/**
 * @summary Remove Guardrail from RuleSet
 */
export const useGuardrailsRulesetsGuardrailsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>,
      TError,
      { id: number; guardrailPk: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsDestroy>>,
  TError,
  { id: number; guardrailPk: number },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsGuardrailsDestroyMutationOptions(options), queryClient);
};

/**
 * Change which version of a guardrail is used by this ruleset
 * @summary Set Guardrail Version for RuleSet
 */
export const guardrailsRulesetsGuardrailsSetVersionPartialUpdate = (
  id: number,
  guardrailPk: number,
  guardrailsRulesetsGuardrailsSetVersionPartialUpdateBody?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/guardrails/${guardrailPk}/set-version/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailsRulesetsGuardrailsSetVersionPartialUpdateBody,
    signal,
  });
};

export const getGuardrailsRulesetsGuardrailsSetVersionPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>,
    TError,
    { id: number; guardrailPk: number; data?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>,
  TError,
  { id: number; guardrailPk: number; data?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsGuardrailsSetVersionPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>,
    { id: number; guardrailPk: number; data?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody }
  > = (props) => {
    const { id, guardrailPk, data } = props ?? {};

    return guardrailsRulesetsGuardrailsSetVersionPartialUpdate(id, guardrailPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsGuardrailsSetVersionPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>
>;
export type GuardrailsRulesetsGuardrailsSetVersionPartialUpdateMutationBody =
  | GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody
  | undefined;
export type GuardrailsRulesetsGuardrailsSetVersionPartialUpdateMutationError = void;

/**
 * @summary Set Guardrail Version for RuleSet
 */
export const useGuardrailsRulesetsGuardrailsSetVersionPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>,
      TError,
      { id: number; guardrailPk: number; data?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsGuardrailsSetVersionPartialUpdate>>,
  TError,
  { id: number; guardrailPk: number; data?: GuardrailsRulesetsGuardrailsSetVersionPartialUpdateBody },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsGuardrailsSetVersionPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Rollback ruleset to a previous version. Can rollback entire tree (including guardrails/examples) or parent-only (metadata only).
 * @summary Rollback RuleSet
 */
export const guardrailsRulesetsRollbackCreate = (
  id: number,
  guardrailsRulesetsRollbackCreateBody?: GuardrailsRulesetsRollbackCreateBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/rollback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: guardrailsRulesetsRollbackCreateBody,
    signal,
  });
};

export const getGuardrailsRulesetsRollbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>,
    TError,
    { id: number; data?: GuardrailsRulesetsRollbackCreateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsRulesetsRollbackCreateBody },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsRollbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>,
    { id: number; data?: GuardrailsRulesetsRollbackCreateBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsRollbackCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsRollbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>
>;
export type GuardrailsRulesetsRollbackCreateMutationBody = GuardrailsRulesetsRollbackCreateBody | undefined;
export type GuardrailsRulesetsRollbackCreateMutationError = void;

/**
 * @summary Rollback RuleSet
 */
export const useGuardrailsRulesetsRollbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>,
      TError,
      { id: number; data?: GuardrailsRulesetsRollbackCreateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsRollbackCreate>>,
  TError,
  { id: number; data?: GuardrailsRulesetsRollbackCreateBody },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsRollbackCreateMutationOptions(options), queryClient);
};

/**
 * Update only the is_enabled field for a RuleSet
 * @summary Set RuleSet enabled/disabled
 */
export const guardrailsRulesetsSetEnabledPartialUpdate = (
  id: number,
  patchedIsEnabledUpdateRequest?: PatchedIsEnabledUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/set-enabled/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedIsEnabledUpdateRequest,
    signal,
  });
};

export const getGuardrailsRulesetsSetEnabledPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>,
    TError,
    { id: number; data?: PatchedIsEnabledUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsSetEnabledPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>,
    { id: number; data?: PatchedIsEnabledUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsSetEnabledPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsSetEnabledPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>
>;
export type GuardrailsRulesetsSetEnabledPartialUpdateMutationBody = PatchedIsEnabledUpdateRequest | undefined;
export type GuardrailsRulesetsSetEnabledPartialUpdateMutationError = void;

/**
 * @summary Set RuleSet enabled/disabled
 */
export const useGuardrailsRulesetsSetEnabledPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>,
      TError,
      { id: number; data?: PatchedIsEnabledUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsSetEnabledPartialUpdate>>,
  TError,
  { id: number; data?: PatchedIsEnabledUpdateRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsSetEnabledPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Get all versions for a specific ruleset
 * @summary List RuleSet Versions
 */
export const guardrailsRulesetsVersionsList = (id: number, signal?: AbortSignal) => {
  return customInstance<RuleSetVersion[]>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getGuardrailsRulesetsVersionsListQueryKey = (id: number) => {
  return [`${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/`] as const;
};

export const getGuardrailsRulesetsVersionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsVersionsListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>> = ({ signal }) =>
    guardrailsRulesetsVersionsList(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsVersionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>
>;
export type GuardrailsRulesetsVersionsListQueryError = void;

export function useGuardrailsRulesetsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List RuleSet Versions
 */

export function useGuardrailsRulesetsVersionsList<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsVersionsListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new version snapshot of this ruleset including guardrails and examples
 */
export const guardrailsRulesetsVersionsCreate = (id: number, ruleSetRequest: RuleSetRequest, signal?: AbortSignal) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ruleSetRequest,
    signal,
  });
};

export const getGuardrailsRulesetsVersionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>,
    TError,
    { id: number; data: RuleSetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>,
  TError,
  { id: number; data: RuleSetRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsVersionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>,
    { id: number; data: RuleSetRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return guardrailsRulesetsVersionsCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsVersionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>
>;
export type GuardrailsRulesetsVersionsCreateMutationBody = RuleSetRequest;
export type GuardrailsRulesetsVersionsCreateMutationError = unknown;

export const useGuardrailsRulesetsVersionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>,
      TError,
      { id: number; data: RuleSetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsCreate>>,
  TError,
  { id: number; data: RuleSetRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsVersionsCreateMutationOptions(options), queryClient);
};

/**
 * Activate a specific version of this ruleset - applies snapshot to live fields (metadata only)
 */
export const guardrailsRulesetsVersionsActivatePartialUpdate = (
  id: number,
  versionId: string,
  patchedRuleSetRequest?: PatchedRuleSetRequest,
  signal?: AbortSignal
) => {
  return customInstance<RuleSet>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/${versionId}/activate/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRuleSetRequest,
    signal,
  });
};

export const getGuardrailsRulesetsVersionsActivatePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>,
    TError,
    { id: number; versionId: string; data?: PatchedRuleSetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>,
  TError,
  { id: number; versionId: string; data?: PatchedRuleSetRequest },
  TContext
> => {
  const mutationKey = ['guardrailsRulesetsVersionsActivatePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>,
    { id: number; versionId: string; data?: PatchedRuleSetRequest }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return guardrailsRulesetsVersionsActivatePartialUpdate(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuardrailsRulesetsVersionsActivatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>
>;
export type GuardrailsRulesetsVersionsActivatePartialUpdateMutationBody = PatchedRuleSetRequest | undefined;
export type GuardrailsRulesetsVersionsActivatePartialUpdateMutationError = unknown;

export const useGuardrailsRulesetsVersionsActivatePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>,
      TError,
      { id: number; versionId: string; data?: PatchedRuleSetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsActivatePartialUpdate>>,
  TError,
  { id: number; versionId: string; data?: PatchedRuleSetRequest },
  TContext
> => {
  return useMutation(getGuardrailsRulesetsVersionsActivatePartialUpdateMutationOptions(options), queryClient);
};

/**
 * Compare two versions of a ruleset to see what changed
 * @summary Compare RuleSet Versions
 */
export const guardrailsRulesetsVersionsCompareRetrieve = (
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<VersionDiff>({
    url: `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/compare/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGuardrailsRulesetsVersionsCompareRetrieveQueryKey = (
  id: number,
  params?: GuardrailsRulesetsVersionsCompareRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/guardrails/rulesets/${id}/versions/compare/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGuardrailsRulesetsVersionsCompareRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuardrailsRulesetsVersionsCompareRetrieveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>> = ({ signal }) =>
    guardrailsRulesetsVersionsCompareRetrieve(id, params, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GuardrailsRulesetsVersionsCompareRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>
>;
export type GuardrailsRulesetsVersionsCompareRetrieveQueryError = void;

export function useGuardrailsRulesetsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
          TError,
          Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGuardrailsRulesetsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Compare RuleSet Versions
 */

export function useGuardrailsRulesetsVersionsCompareRetrieve<
  TData = Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>,
  TError = void,
>(
  id: number,
  params: GuardrailsRulesetsVersionsCompareRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof guardrailsRulesetsVersionsCompareRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGuardrailsRulesetsVersionsCompareRetrieveQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List logs from the current workspace's MongoDB collection with filtering
 * and pagination.
 *
 * Uses **promoted top-level fields** for all filtering and sorting so that
 * every query is backed by a compound index.  The ``logs[]`` array is
 * excluded — use the detail endpoint to fetch the complete document.
 */
export const observabilityLogsRetrieve = (params?: ObservabilityLogsRetrieveParams, signal?: AbortSignal) => {
  return customInstance<ObservabilityLogsRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsRetrieveQueryKey = (params?: ObservabilityLogsRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/observability/logs/`, ...(params ? [params] : [])] as const;
};

export const getObservabilityLogsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsRetrieve>>> = ({ signal }) =>
    observabilityLogsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof observabilityLogsRetrieve>>>;
export type ObservabilityLogsRetrieveQueryError = unknown;

export function useObservabilityLogsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
  TError = unknown,
>(
  params: undefined | ObservabilityLogsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsRetrieveParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a single log document by its MongoDB ``_id``.
 *
 * Returns the full document including the ``logs[]`` array with all
 * metadata — used when the user expands / clicks a row in the frontend.
 *
 * Pass ``?stable=1`` when the caller knows the parent doc is finalized
 * (completed eval run / historical User Activity). That enables a
 * workspace-scoped Redis cache (default 1h) so re-opens skip Mongo.
 */
export const observabilityLogsRetrieve2 = (
  logId: string,
  params?: ObservabilityLogsRetrieve2Params,
  signal?: AbortSignal
) => {
  return customInstance<ObservabilityLogsRetrieve2200>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsRetrieve2QueryKey = (logId: string, params?: ObservabilityLogsRetrieve2Params) => {
  return [`${import.meta.env.VITE_API_URL}/observability/logs/${logId}/`, ...(params ? [params] : [])] as const;
};

export const getObservabilityLogsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsRetrieve2Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsRetrieve2QueryKey(logId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>> = ({ signal }) =>
    observabilityLogsRetrieve2(logId, params, signal);

  return { queryKey, queryFn, enabled: logId !== null && logId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsRetrieve2QueryResult = NonNullable<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>>;
export type ObservabilityLogsRetrieve2QueryError = unknown;

export function useObservabilityLogsRetrieve2<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
  TError = unknown,
>(
  logId: string,
  params: undefined | ObservabilityLogsRetrieve2Params,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsRetrieve2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsRetrieve2<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsRetrieve2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsRetrieve2>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsRetrieve2<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsRetrieve2Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsRetrieve2<
  TData = Awaited<ReturnType<typeof observabilityLogsRetrieve2>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsRetrieve2Params,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsRetrieve2>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsRetrieve2QueryOptions(logId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return the manager → worker activity (delegations, steps, outputs) of one turn.
 */
export const observabilityLogsExecutionRetrieve = (
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<ExecutionProjection>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsExecutionRetrieveQueryKey = (
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getObservabilityLogsExecutionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsExecutionRetrieveQueryKey(logId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>> = ({ signal }) =>
    observabilityLogsExecutionRetrieve(logId, params, signal);

  return { queryKey, queryFn, enabled: logId !== null && logId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsExecutionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>
>;
export type ObservabilityLogsExecutionRetrieveQueryError = unknown;

export function useObservabilityLogsExecutionRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params: undefined | ObservabilityLogsExecutionRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsExecutionRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsExecutionRetrieveQueryOptions(logId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return the manager's "How I worked" timeline of one turn and its wake reviews.
 */
export const observabilityLogsExecutionManagerRetrieve = (
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<ManagerActivity>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/manager/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsExecutionManagerRetrieveQueryKey = (
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/manager/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getObservabilityLogsExecutionManagerRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsExecutionManagerRetrieveQueryKey(logId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>> = ({ signal }) =>
    observabilityLogsExecutionManagerRetrieve(logId, params, signal);

  return { queryKey, queryFn, enabled: logId !== null && logId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsExecutionManagerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>
>;
export type ObservabilityLogsExecutionManagerRetrieveQueryError = unknown;

export function useObservabilityLogsExecutionManagerRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params: undefined | ObservabilityLogsExecutionManagerRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionManagerRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionManagerRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsExecutionManagerRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>,
  TError = unknown,
>(
  logId: string,
  params?: ObservabilityLogsExecutionManagerRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionManagerRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsExecutionManagerRetrieveQueryOptions(logId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return every message of one worker task of a turn, untruncated and paginated.
 */
export const observabilityLogsExecutionTasksTranscriptRetrieve = (
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<ExecutionTaskTranscript>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/tasks/${taskId}/transcript/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsExecutionTasksTranscriptRetrieveQueryKey = (
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams
) => {
  return [
    `${import.meta.env.VITE_API_URL}/observability/logs/${logId}/execution/tasks/${taskId}/transcript/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getObservabilityLogsExecutionTasksTranscriptRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
  TError = unknown,
>(
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getObservabilityLogsExecutionTasksTranscriptRetrieveQueryKey(logId, taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>> = ({
    signal,
  }) => observabilityLogsExecutionTasksTranscriptRetrieve(logId, taskId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: logId !== null && logId !== undefined && taskId !== null && taskId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ObservabilityLogsExecutionTasksTranscriptRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>
>;
export type ObservabilityLogsExecutionTasksTranscriptRetrieveQueryError = unknown;

export function useObservabilityLogsExecutionTasksTranscriptRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
  TError = unknown,
>(
  logId: string,
  taskId: string,
  params: undefined | ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionTasksTranscriptRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
  TError = unknown,
>(
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsExecutionTasksTranscriptRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
  TError = unknown,
>(
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsExecutionTasksTranscriptRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>,
  TError = unknown,
>(
  logId: string,
  taskId: string,
  params?: ObservabilityLogsExecutionTasksTranscriptRetrieveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsExecutionTasksTranscriptRetrieve>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsExecutionTasksTranscriptRetrieveQueryOptions(logId, taskId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve multiple log documents by MongoDB ``_id`` in one request.
 *
 * Used by Eval Studio Flow Chart / Chat Preview so multi-turn runs do not
 * issue N parallel detail GETs. Response payloads are identical to the
 * single-detail endpoint (full ``logs[].metadata`` preserved).
 *
 * With ``?stable=1``, each id is served from a workspace-scoped Redis cache
 * when present; only cache misses hit Mongo.
 */
export const observabilityLogsBatchRetrieve = (params: ObservabilityLogsBatchRetrieveParams, signal?: AbortSignal) => {
  return customInstance<ObservabilityLogsBatchRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/batch/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsBatchRetrieveQueryKey = (params?: ObservabilityLogsBatchRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/observability/logs/batch/`, ...(params ? [params] : [])] as const;
};

export const getObservabilityLogsBatchRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
  TError = unknown,
>(
  params: ObservabilityLogsBatchRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsBatchRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>> = ({ signal }) =>
    observabilityLogsBatchRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsBatchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>
>;
export type ObservabilityLogsBatchRetrieveQueryError = unknown;

export function useObservabilityLogsBatchRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
  TError = unknown,
>(
  params: ObservabilityLogsBatchRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsBatchRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
  TError = unknown,
>(
  params: ObservabilityLogsBatchRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsBatchRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
  TError = unknown,
>(
  params: ObservabilityLogsBatchRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsBatchRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>,
  TError = unknown,
>(
  params: ObservabilityLogsBatchRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsBatchRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsBatchRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get distinct Slack channels from the Conversation table (PostgreSQL).
 * Fast alternative to querying MongoDB for channel names.
 */
export const observabilityLogsChannelsRetrieve = (
  params?: ObservabilityLogsChannelsRetrieveParams,
  signal?: AbortSignal
) => {
  return customInstance<ObservabilityLogsChannelsRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/channels/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsChannelsRetrieveQueryKey = (params?: ObservabilityLogsChannelsRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/observability/logs/channels/`, ...(params ? [params] : [])] as const;
};

export const getObservabilityLogsChannelsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsChannelsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsChannelsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>> = ({ signal }) =>
    observabilityLogsChannelsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsChannelsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>
>;
export type ObservabilityLogsChannelsRetrieveQueryError = unknown;

export function useObservabilityLogsChannelsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
  TError = unknown,
>(
  params: undefined | ObservabilityLogsChannelsRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsChannelsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsChannelsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsChannelsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsChannelsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsChannelsRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsChannelsRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsChannelsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsChannelsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get distinct users from the activity logs using promoted user_email field.
 */
export const observabilityLogsUsersRetrieve = (params?: ObservabilityLogsUsersRetrieveParams, signal?: AbortSignal) => {
  return customInstance<ObservabilityLogsUsersRetrieve200>({
    url: `${import.meta.env.VITE_API_URL}/observability/logs/users/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getObservabilityLogsUsersRetrieveQueryKey = (params?: ObservabilityLogsUsersRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/observability/logs/users/`, ...(params ? [params] : [])] as const;
};

export const getObservabilityLogsUsersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsUsersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getObservabilityLogsUsersRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>> = ({ signal }) =>
    observabilityLogsUsersRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ObservabilityLogsUsersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>
>;
export type ObservabilityLogsUsersRetrieveQueryError = unknown;

export function useObservabilityLogsUsersRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
  TError = unknown,
>(
  params: undefined | ObservabilityLogsUsersRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsUsersRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsUsersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useObservabilityLogsUsersRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsUsersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useObservabilityLogsUsersRetrieve<
  TData = Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>,
  TError = unknown,
>(
  params?: ObservabilityLogsUsersRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof observabilityLogsUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getObservabilityLogsUsersRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all users
 * @summary List Users
 */
export const usersList = (signal?: AbortSignal) => {
  return customInstance<User[]>({ url: `${import.meta.env.VITE_API_URL}/users/`, method: 'GET', signal });
};

export const getUsersListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/users/`] as const;
};

export const getUsersListQueryOptions = <
  TData = Awaited<ReturnType<typeof usersList>>,
  TError = BadRequestResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersList>>> = ({ signal }) => usersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersListQueryResult = NonNullable<Awaited<ReturnType<typeof usersList>>>;
export type UsersListQueryError = BadRequestResponse;

export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = BadRequestResponse>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof usersList>>, TError, Awaited<ReturnType<typeof usersList>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = BadRequestResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersList>>,
          TError,
          Awaited<ReturnType<typeof usersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = BadRequestResponse>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Users
 */

export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = BadRequestResponse>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all users
 * @summary List Users
 */
export const usersCreate = (userCreateRequest: UserCreateRequest, signal?: AbortSignal) => {
  return customInstance<User[]>({
    url: `${import.meta.env.VITE_API_URL}/users/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: userCreateRequest,
    signal,
  });
};

export const getUsersCreateMutationOptions = <TError = BadRequestResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersCreate>>, TError, { data: UserCreateRequest }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof usersCreate>>, TError, { data: UserCreateRequest }, TContext> => {
  const mutationKey = ['usersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreate>>, { data: UserCreateRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return usersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreate>>>;
export type UsersCreateMutationBody = UserCreateRequest;
export type UsersCreateMutationError = BadRequestResponse;

/**
 * @summary List Users
 */
export const useUsersCreate = <TError = BadRequestResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersCreate>>,
      TError,
      { data: UserCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof usersCreate>>, TError, { data: UserCreateRequest }, TContext> => {
  return useMutation(getUsersCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific user by ID
 * @summary Get User
 */
export const usersRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<User>({ url: `${import.meta.env.VITE_API_URL}/users/${id}/`, method: 'GET', signal });
};

export const getUsersRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/users/${id}/`] as const;
};

export const getUsersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof usersRetrieve>>,
  TError = NotFoundResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRetrieve>>> = ({ signal }) => usersRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRetrieve>>>;
export type UsersRetrieveQueryError = NotFoundResponse;

export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = NotFoundResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = NotFoundResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User
 */

export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = NotFoundResponse>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific user by ID
 * @summary Get User
 */
export const usersUpdate = (id: string, userUpdateRequest: UserUpdateRequest, signal?: AbortSignal) => {
  return customInstance<User>({
    url: `${import.meta.env.VITE_API_URL}/users/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: userUpdateRequest,
    signal,
  });
};

export const getUsersUpdateMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersUpdate>>,
    TError,
    { id: string; data: UserUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersUpdate>>,
  TError,
  { id: string; data: UserUpdateRequest },
  TContext
> => {
  const mutationKey = ['usersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersUpdate>>,
    { id: string; data: UserUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return usersUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdate>>>;
export type UsersUpdateMutationBody = UserUpdateRequest;
export type UsersUpdateMutationError = NotFoundResponse;

/**
 * @summary Get User
 */
export const useUsersUpdate = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersUpdate>>,
      TError,
      { id: string; data: UserUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersUpdate>>,
  TError,
  { id: string; data: UserUpdateRequest },
  TContext
> => {
  return useMutation(getUsersUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific user by ID
 * @summary Get User
 */
export const usersPartialUpdate = (
  id: string,
  patchedUserUpdateRequest?: PatchedUserUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<User>({
    url: `${import.meta.env.VITE_API_URL}/users/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedUserUpdateRequest,
    signal,
  });
};

export const getUsersPartialUpdateMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersPartialUpdate>>,
    TError,
    { id: string; data?: PatchedUserUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedUserUpdateRequest },
  TContext
> => {
  const mutationKey = ['usersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersPartialUpdate>>,
    { id: string; data?: PatchedUserUpdateRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return usersPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersPartialUpdate>>>;
export type UsersPartialUpdateMutationBody = PatchedUserUpdateRequest | undefined;
export type UsersPartialUpdateMutationError = NotFoundResponse;

/**
 * @summary Get User
 */
export const useUsersPartialUpdate = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersPartialUpdate>>,
      TError,
      { id: string; data?: PatchedUserUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersPartialUpdate>>,
  TError,
  { id: string; data?: PatchedUserUpdateRequest },
  TContext
> => {
  return useMutation(getUsersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific user by ID
 * @summary Get User
 */
export const usersDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<User>({ url: `${import.meta.env.VITE_API_URL}/users/${id}/`, method: 'DELETE', signal });
};

export const getUsersDestroyMutationOptions = <TError = NotFoundResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof usersDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['usersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return usersDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof usersDestroy>>>;

export type UsersDestroyMutationError = NotFoundResponse;

/**
 * @summary Get User
 */
export const useUsersDestroy = <TError = NotFoundResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof usersDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getUsersDestroyMutationOptions(options), queryClient);
};

/**
 * Get the currently authenticated user's profile information, plus whether they can create new workspaces.
 * @summary Current User
 */
export const usersMeRetrieve = (signal?: AbortSignal) => {
  return customInstance<CurrentUserResponse>({
    url: `${import.meta.env.VITE_API_URL}/users/me/`,
    method: 'GET',
    signal,
  });
};

export const getUsersMeRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/users/me/`] as const;
};

export const getUsersMeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof usersMeRetrieve>>,
  TError = BadRequestResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersMeRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersMeRetrieve>>> = ({ signal }) => usersMeRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersMeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersMeRetrieve>>>;
export type UsersMeRetrieveQueryError = BadRequestResponse;

export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = BadRequestResponse>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersMeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = BadRequestResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersMeRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = BadRequestResponse>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Current User
 */

export function useUsersMeRetrieve<TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = BadRequestResponse>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersMeRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Upload or update the avatar image for the current user
 * @summary Update User Avatar
 */
export const usersMeAvatarUpdate = (usersMeAvatarUpdateBody?: UsersMeAvatarUpdateBody, signal?: AbortSignal) => {
  const formData = new FormData();
  if (usersMeAvatarUpdateBody?.avatar !== undefined) {
    formData.append(`avatar`, usersMeAvatarUpdateBody.avatar);
  }

  return customInstance<User>({
    url: `${import.meta.env.VITE_API_URL}/users/me/avatar/`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getUsersMeAvatarUpdateMutationOptions = <
  TError = BadRequestResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeAvatarUpdate>>,
    TError,
    { data?: UsersMeAvatarUpdateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersMeAvatarUpdate>>,
  TError,
  { data?: UsersMeAvatarUpdateBody },
  TContext
> => {
  const mutationKey = ['usersMeAvatarUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersMeAvatarUpdate>>,
    { data?: UsersMeAvatarUpdateBody }
  > = (props) => {
    const { data } = props ?? {};

    return usersMeAvatarUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersMeAvatarUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersMeAvatarUpdate>>>;
export type UsersMeAvatarUpdateMutationBody = UsersMeAvatarUpdateBody | undefined;
export type UsersMeAvatarUpdateMutationError = BadRequestResponse | void;

/**
 * @summary Update User Avatar
 */
export const useUsersMeAvatarUpdate = <TError = BadRequestResponse | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersMeAvatarUpdate>>,
      TError,
      { data?: UsersMeAvatarUpdateBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersMeAvatarUpdate>>,
  TError,
  { data?: UsersMeAvatarUpdateBody },
  TContext
> => {
  return useMutation(getUsersMeAvatarUpdateMutationOptions(options), queryClient);
};

/**
 * Change the current user's password. The new password must be different from the current password.
 * @summary Change Password
 */
export const usersMeChangePasswordCreate = (passwordChangeRequest: PasswordChangeRequest, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/users/me/change-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordChangeRequest,
    signal,
  });
};

export const getUsersMeChangePasswordCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeChangePasswordCreate>>,
    TError,
    { data: PasswordChangeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersMeChangePasswordCreate>>,
  TError,
  { data: PasswordChangeRequest },
  TContext
> => {
  const mutationKey = ['usersMeChangePasswordCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersMeChangePasswordCreate>>,
    { data: PasswordChangeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return usersMeChangePasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersMeChangePasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersMeChangePasswordCreate>>
>;
export type UsersMeChangePasswordCreateMutationBody = PasswordChangeRequest;
export type UsersMeChangePasswordCreateMutationError = void;

/**
 * @summary Change Password
 */
export const useUsersMeChangePasswordCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersMeChangePasswordCreate>>,
      TError,
      { data: PasswordChangeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersMeChangePasswordCreate>>,
  TError,
  { data: PasswordChangeRequest },
  TContext
> => {
  return useMutation(getUsersMeChangePasswordCreateMutationOptions(options), queryClient);
};

/**
 * Returns a list of all workspaces that the user is a member of
 * @summary List Workspaces
 */
export const workspacesList = (signal?: AbortSignal) => {
  return customInstance<Workspace[]>({ url: `${import.meta.env.VITE_API_URL}/workspaces/`, method: 'GET', signal });
};

export const getWorkspacesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/`] as const;
};

export const getWorkspacesListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesList>>> = ({ signal }) => workspacesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesList>>>;
export type WorkspacesListQueryError = unknown;

export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workspaces
 */

export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all workspaces that the user is a member of
 * @summary List Workspaces
 */
export const workspacesCreate = (workspaceRequest: WorkspaceRequest, signal?: AbortSignal) => {
  return customInstance<Workspace[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: workspaceRequest,
    signal,
  });
};

export const getWorkspacesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesCreate>>,
    TError,
    { data: WorkspaceRequest },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, { data: WorkspaceRequest }, TContext> => {
  const mutationKey = ['workspacesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesCreate>>, { data: WorkspaceRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return workspacesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesCreate>>>;
export type WorkspacesCreateMutationBody = WorkspaceRequest;
export type WorkspacesCreateMutationError = unknown;

/**
 * @summary List Workspaces
 */
export const useWorkspacesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesCreate>>,
      TError,
      { data: WorkspaceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof workspacesCreate>>, TError, { data: WorkspaceRequest }, TContext> => {
  return useMutation(getWorkspacesCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific workspace with details
 * @summary Get Workspace
 */
export const workspacesRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceDetail>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${id}/`] as const;
};

export const getWorkspacesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesRetrieve>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesRetrieve>>> = ({ signal }) =>
    workspacesRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesRetrieve>>>;
export type WorkspacesRetrieveQueryError = void;

export function useWorkspacesRetrieve<TData = Awaited<ReturnType<typeof workspacesRetrieve>>, TError = void>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRetrieve<TData = Awaited<ReturnType<typeof workspacesRetrieve>>, TError = void>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRetrieve<TData = Awaited<ReturnType<typeof workspacesRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace
 */

export function useWorkspacesRetrieve<TData = Awaited<ReturnType<typeof workspacesRetrieve>>, TError = void>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific workspace with details
 * @summary Get Workspace
 */
export const workspacesUpdate = (id: string, workspaceRequest: WorkspaceRequest, signal?: AbortSignal) => {
  return customInstance<WorkspaceDetail>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: workspaceRequest,
    signal,
  });
};

export const getWorkspacesUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesUpdate>>,
    TError,
    { id: string; data: WorkspaceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesUpdate>>,
  TError,
  { id: string; data: WorkspaceRequest },
  TContext
> => {
  const mutationKey = ['workspacesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesUpdate>>,
    { id: string; data: WorkspaceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return workspacesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesUpdate>>>;
export type WorkspacesUpdateMutationBody = WorkspaceRequest;
export type WorkspacesUpdateMutationError = void;

/**
 * @summary Get Workspace
 */
export const useWorkspacesUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesUpdate>>,
      TError,
      { id: string; data: WorkspaceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesUpdate>>,
  TError,
  { id: string; data: WorkspaceRequest },
  TContext
> => {
  return useMutation(getWorkspacesUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific workspace with details
 * @summary Get Workspace
 */
export const workspacesPartialUpdate = (
  id: string,
  patchedWorkspaceRequest?: PatchedWorkspaceRequest,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceDetail>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedWorkspaceRequest,
    signal,
  });
};

export const getWorkspacesPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesPartialUpdate>>,
    TError,
    { id: string; data?: PatchedWorkspaceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesPartialUpdate>>,
  TError,
  { id: string; data?: PatchedWorkspaceRequest },
  TContext
> => {
  const mutationKey = ['workspacesPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesPartialUpdate>>,
    { id: string; data?: PatchedWorkspaceRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return workspacesPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesPartialUpdate>>>;
export type WorkspacesPartialUpdateMutationBody = PatchedWorkspaceRequest | undefined;
export type WorkspacesPartialUpdateMutationError = void;

/**
 * @summary Get Workspace
 */
export const useWorkspacesPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesPartialUpdate>>,
      TError,
      { id: string; data?: PatchedWorkspaceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesPartialUpdate>>,
  TError,
  { id: string; data?: PatchedWorkspaceRequest },
  TContext
> => {
  return useMutation(getWorkspacesPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve a specific workspace with details
 * @summary Get Workspace
 */
export const workspacesDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceDetail>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof workspacesDestroy>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof workspacesDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['workspacesDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesDestroy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return workspacesDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesDestroy>>>;

export type WorkspacesDestroyMutationError = void;

/**
 * @summary Get Workspace
 */
export const useWorkspacesDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof workspacesDestroy>>, TError, { id: string }, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof workspacesDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getWorkspacesDestroyMutationOptions(options), queryClient);
};

/**
 * Returns a list of all pending invitations for a workspace (admin only)
 * @summary List Workspace Invitations
 */
export const workspacesInvitationsList = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceInvitation[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesInvitationsListQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/`] as const;
};

export const getWorkspacesInvitationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesInvitationsList>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesInvitationsListQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesInvitationsList>>> = ({ signal }) =>
    workspacesInvitationsList(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesInvitationsListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesInvitationsList>>>;
export type WorkspacesInvitationsListQueryError = void;

export function useWorkspacesInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesInvitationsList>>,
  TError = void,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof workspacesInvitationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesInvitationsList>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof workspacesInvitationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesInvitationsList>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workspace Invitations
 */

export function useWorkspacesInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesInvitationsList>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesInvitationsListQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all pending invitations for a workspace (admin only)
 * @summary List Workspace Invitations
 */
export const workspacesInvitationsCreate = (
  workspaceId: string,
  workspaceInvitationRequest: WorkspaceInvitationRequest,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceInvitation[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: workspaceInvitationRequest,
    signal,
  });
};

export const getWorkspacesInvitationsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesInvitationsCreate>>,
    TError,
    { workspaceId: string; data: WorkspaceInvitationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesInvitationsCreate>>,
  TError,
  { workspaceId: string; data: WorkspaceInvitationRequest },
  TContext
> => {
  const mutationKey = ['workspacesInvitationsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesInvitationsCreate>>,
    { workspaceId: string; data: WorkspaceInvitationRequest }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return workspacesInvitationsCreate(workspaceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesInvitationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsCreate>>
>;
export type WorkspacesInvitationsCreateMutationBody = WorkspaceInvitationRequest;
export type WorkspacesInvitationsCreateMutationError = void;

/**
 * @summary List Workspace Invitations
 */
export const useWorkspacesInvitationsCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesInvitationsCreate>>,
      TError,
      { workspaceId: string; data: WorkspaceInvitationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesInvitationsCreate>>,
  TError,
  { workspaceId: string; data: WorkspaceInvitationRequest },
  TContext
> => {
  return useMutation(getWorkspacesInvitationsCreateMutationOptions(options), queryClient);
};

/**
 * Get details about a specific invitation (admin only)
 * @summary Get Workspace Invitation
 */
export const workspacesInvitationsRetrieve = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceInvitation>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesInvitationsRetrieveQueryKey = (workspaceId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/${id}/`] as const;
};

export const getWorkspacesInvitationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesInvitationsRetrieveQueryKey(workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>> = ({ signal }) =>
    workspacesInvitationsRetrieve(workspaceId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesInvitationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>
>;
export type WorkspacesInvitationsRetrieveQueryError = void;

export function useWorkspacesInvitationsRetrieve<
  TData = Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesInvitationsRetrieve<
  TData = Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesInvitationsRetrieve<
  TData = Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace Invitation
 */

export function useWorkspacesInvitationsRetrieve<
  TData = Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesInvitationsRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesInvitationsRetrieveQueryOptions(workspaceId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get details about a specific invitation (admin only)
 * @summary Get Workspace Invitation
 */
export const workspacesInvitationsDestroy = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceInvitation>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/invitations/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesInvitationsDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesInvitationsDestroy>>,
    TError,
    { workspaceId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesInvitationsDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['workspacesInvitationsDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesInvitationsDestroy>>,
    { workspaceId: string; id: string }
  > = (props) => {
    const { workspaceId, id } = props ?? {};

    return workspacesInvitationsDestroy(workspaceId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesInvitationsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsDestroy>>
>;

export type WorkspacesInvitationsDestroyMutationError = void;

/**
 * @summary Get Workspace Invitation
 */
export const useWorkspacesInvitationsDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesInvitationsDestroy>>,
      TError,
      { workspaceId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesInvitationsDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  return useMutation(getWorkspacesInvitationsDestroyMutationOptions(options), queryClient);
};

/**
 * Returns a list of all members in a workspace
 * @summary List Workspace Members
 */
export const workspacesMembersList = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceMember[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesMembersListQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/`] as const;
};

export const getWorkspacesMembersListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesMembersList>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesMembersListQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesMembersList>>> = ({ signal }) =>
    workspacesMembersList(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesMembersList>>>;
export type WorkspacesMembersListQueryError = void;

export function useWorkspacesMembersList<TData = Awaited<ReturnType<typeof workspacesMembersList>>, TError = void>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMembersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesMembersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMembersList<TData = Awaited<ReturnType<typeof workspacesMembersList>>, TError = void>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMembersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesMembersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMembersList<TData = Awaited<ReturnType<typeof workspacesMembersList>>, TError = void>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workspace Members
 */

export function useWorkspacesMembersList<TData = Awaited<ReturnType<typeof workspacesMembersList>>, TError = void>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesMembersListQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all members in a workspace
 * @summary List Workspace Members
 */
export const workspacesMembersCreate = (
  workspaceId: string,
  workspaceMemberRequest: WorkspaceMemberRequest,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceMember[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: workspaceMemberRequest,
    signal,
  });
};

export const getWorkspacesMembersCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesMembersCreate>>,
    TError,
    { workspaceId: string; data: WorkspaceMemberRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesMembersCreate>>,
  TError,
  { workspaceId: string; data: WorkspaceMemberRequest },
  TContext
> => {
  const mutationKey = ['workspacesMembersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesMembersCreate>>,
    { workspaceId: string; data: WorkspaceMemberRequest }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return workspacesMembersCreate(workspaceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesMembersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesMembersCreate>>>;
export type WorkspacesMembersCreateMutationBody = WorkspaceMemberRequest;
export type WorkspacesMembersCreateMutationError = void;

/**
 * @summary List Workspace Members
 */
export const useWorkspacesMembersCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesMembersCreate>>,
      TError,
      { workspaceId: string; data: WorkspaceMemberRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesMembersCreate>>,
  TError,
  { workspaceId: string; data: WorkspaceMemberRequest },
  TContext
> => {
  return useMutation(getWorkspacesMembersCreateMutationOptions(options), queryClient);
};

/**
 * Get details about a specific member of the workspace
 * @summary Get Workspace Member
 */
export const workspacesMembersRetrieve = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceMember>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesMembersRetrieveQueryKey = (workspaceId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/`] as const;
};

export const getWorkspacesMembersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesMembersRetrieveQueryKey(workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesMembersRetrieve>>> = ({ signal }) =>
    workspacesMembersRetrieve(workspaceId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesMembersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesMembersRetrieve>>>;
export type WorkspacesMembersRetrieveQueryError = void;

export function useWorkspacesMembersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesMembersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMembersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesMembersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMembersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace Member
 */

export function useWorkspacesMembersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMembersRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMembersRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesMembersRetrieveQueryOptions(workspaceId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get details about a specific member of the workspace
 * @summary Get Workspace Member
 */
export const workspacesMembersUpdate = (
  workspaceId: string,
  id: string,
  workspaceMemberRequest: WorkspaceMemberRequest,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceMember>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: workspaceMemberRequest,
    signal,
  });
};

export const getWorkspacesMembersUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesMembersUpdate>>,
    TError,
    { workspaceId: string; id: string; data: WorkspaceMemberRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesMembersUpdate>>,
  TError,
  { workspaceId: string; id: string; data: WorkspaceMemberRequest },
  TContext
> => {
  const mutationKey = ['workspacesMembersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesMembersUpdate>>,
    { workspaceId: string; id: string; data: WorkspaceMemberRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesMembersUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesMembersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesMembersUpdate>>>;
export type WorkspacesMembersUpdateMutationBody = WorkspaceMemberRequest;
export type WorkspacesMembersUpdateMutationError = void;

/**
 * @summary Get Workspace Member
 */
export const useWorkspacesMembersUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesMembersUpdate>>,
      TError,
      { workspaceId: string; id: string; data: WorkspaceMemberRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesMembersUpdate>>,
  TError,
  { workspaceId: string; id: string; data: WorkspaceMemberRequest },
  TContext
> => {
  return useMutation(getWorkspacesMembersUpdateMutationOptions(options), queryClient);
};

/**
 * Get details about a specific member of the workspace
 * @summary Get Workspace Member
 */
export const workspacesMembersPartialUpdate = (
  workspaceId: string,
  id: string,
  patchedWorkspaceMemberRequest?: PatchedWorkspaceMemberRequest,
  signal?: AbortSignal
) => {
  return customInstance<WorkspaceMember>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedWorkspaceMemberRequest,
    signal,
  });
};

export const getWorkspacesMembersPartialUpdateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>,
    TError,
    { workspaceId: string; id: string; data?: PatchedWorkspaceMemberRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedWorkspaceMemberRequest },
  TContext
> => {
  const mutationKey = ['workspacesMembersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>,
    { workspaceId: string; id: string; data?: PatchedWorkspaceMemberRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesMembersPartialUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesMembersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>
>;
export type WorkspacesMembersPartialUpdateMutationBody = PatchedWorkspaceMemberRequest | undefined;
export type WorkspacesMembersPartialUpdateMutationError = void;

/**
 * @summary Get Workspace Member
 */
export const useWorkspacesMembersPartialUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>,
      TError,
      { workspaceId: string; id: string; data?: PatchedWorkspaceMemberRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesMembersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedWorkspaceMemberRequest },
  TContext
> => {
  return useMutation(getWorkspacesMembersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Get details about a specific member of the workspace
 * @summary Get Workspace Member
 */
export const workspacesMembersDestroy = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceMember>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesMembersDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesMembersDestroy>>,
    TError,
    { workspaceId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesMembersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['workspacesMembersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesMembersDestroy>>,
    { workspaceId: string; id: string }
  > = (props) => {
    const { workspaceId, id } = props ?? {};

    return workspacesMembersDestroy(workspaceId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesMembersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesMembersDestroy>>>;

export type WorkspacesMembersDestroyMutationError = void;

/**
 * @summary Get Workspace Member
 */
export const useWorkspacesMembersDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesMembersDestroy>>,
      TError,
      { workspaceId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesMembersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  return useMutation(getWorkspacesMembersDestroyMutationOptions(options), queryClient);
};

/**
 * Admin action: email a workspace member a password setup / reset link.
 *
 * Members added via Slack Bot User Management or the "Add Member" flow get an
 * account with an unusable password and no registration email, so they cannot
 * log into the Studio. This lets a workspace admin send them the link — a
 * registration/setup email if they have never set a password, otherwise a
 * password-reset email — without the remove-and-re-invite workaround.
 */
export const workspacesMembersSendSetupEmailCreate = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/members/${id}/send-setup-email/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesMembersSendSetupEmailCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>,
    TError,
    { workspaceId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['workspacesMembersSendSetupEmailCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>,
    { workspaceId: string; id: string }
  > = (props) => {
    const { workspaceId, id } = props ?? {};

    return workspacesMembersSendSetupEmailCreate(workspaceId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesMembersSendSetupEmailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>
>;

export type WorkspacesMembersSendSetupEmailCreateMutationError = unknown;

export const useWorkspacesMembersSendSetupEmailCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>,
      TError,
      { workspaceId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesMembersSendSetupEmailCreate>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  return useMutation(getWorkspacesMembersSendSetupEmailCreateMutationOptions(options), queryClient);
};

/**
 * Get the current progress of workspace seeding and setup. Useful for polling when WebSockets aren't available.
 * @summary Get Workspace Setup Progress
 */
export const workspacesProgressRetrieve = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/progress/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesProgressRetrieveQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/progress/`] as const;
};

export const getWorkspacesProgressRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesProgressRetrieveQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesProgressRetrieve>>> = ({ signal }) =>
    workspacesProgressRetrieve(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesProgressRetrieve>>>;
export type WorkspacesProgressRetrieveQueryError = void;

export function useWorkspacesProgressRetrieve<
  TData = Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesProgressRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesProgressRetrieve<
  TData = Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesProgressRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesProgressRetrieve<
  TData = Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace Setup Progress
 */

export function useWorkspacesProgressRetrieve<
  TData = Awaited<ReturnType<typeof workspacesProgressRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesProgressRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesProgressRetrieveQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Disconnect and remove Slack integration for a workspace
 * @summary Disconnect Slack Integration
 */
export const workspacesSlackDisconnectDestroy = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/disconnect/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesSlackDisconnectDestroyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesSlackDisconnectDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesSlackDisconnectDestroy(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackDisconnectDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>
>;

export type WorkspacesSlackDisconnectDestroyMutationError = void;

/**
 * @summary Disconnect Slack Integration
 */
export const useWorkspacesSlackDisconnectDestroy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackDisconnectDestroy>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesSlackDisconnectDestroyMutationOptions(options), queryClient);
};

/**
 * Get the current Slack integration status for a workspace
 * @summary Get Slack OAuth Status
 */
export const workspacesSlackStatusRetrieve = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<SlackOAuthStatus>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/status/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesSlackStatusRetrieveQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/status/`] as const;
};

export const getWorkspacesSlackStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesSlackStatusRetrieveQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>> = ({ signal }) =>
    workspacesSlackStatusRetrieve(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesSlackStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>
>;
export type WorkspacesSlackStatusRetrieveQueryError = void;

export function useWorkspacesSlackStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Slack OAuth Status
 */

export function useWorkspacesSlackStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesSlackStatusRetrieveQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List all Slack users in a workspace or create a new one
 */
export const workspacesSlackUsersList = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<SlackUser[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesSlackUsersListQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/`] as const;
};

export const getWorkspacesSlackUsersListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesSlackUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesSlackUsersListQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesSlackUsersList>>> = ({ signal }) =>
    workspacesSlackUsersList(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesSlackUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesSlackUsersList>>>;
export type WorkspacesSlackUsersListQueryError = unknown;

export function useWorkspacesSlackUsersList<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackUsersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackUsersList<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackUsersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackUsersList<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useWorkspacesSlackUsersList<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesSlackUsersListQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List all Slack users in a workspace or create a new one
 */
export const workspacesSlackUsersCreate = (
  workspaceId: string,
  slackUserRequest: SlackUserRequest,
  signal?: AbortSignal
) => {
  return customInstance<SlackUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackUserRequest,
    signal,
  });
};

export const getWorkspacesSlackUsersCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersCreate>>,
    TError,
    { workspaceId: string; data: SlackUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersCreate>>,
  TError,
  { workspaceId: string; data: SlackUserRequest },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersCreate>>,
    { workspaceId: string; data: SlackUserRequest }
  > = (props) => {
    const { workspaceId, data } = props ?? {};

    return workspacesSlackUsersCreate(workspaceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersCreate>>
>;
export type WorkspacesSlackUsersCreateMutationBody = SlackUserRequest;
export type WorkspacesSlackUsersCreateMutationError = unknown;

export const useWorkspacesSlackUsersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersCreate>>,
      TError,
      { workspaceId: string; data: SlackUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersCreate>>,
  TError,
  { workspaceId: string; data: SlackUserRequest },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersCreateMutationOptions(options), queryClient);
};

/**
 * Retrieve, update or delete a Slack user
 */
export const workspacesSlackUsersRetrieve = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<SlackUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesSlackUsersRetrieveQueryKey = (workspaceId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${id}/`] as const;
};

export const getWorkspacesSlackUsersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesSlackUsersRetrieveQueryKey(workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>> = ({ signal }) =>
    workspacesSlackUsersRetrieve(workspaceId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesSlackUsersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>
>;
export type WorkspacesSlackUsersRetrieveQueryError = unknown;

export function useWorkspacesSlackUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useWorkspacesSlackUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesSlackUsersRetrieveQueryOptions(workspaceId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve, update or delete a Slack user
 */
export const workspacesSlackUsersUpdate = (
  workspaceId: string,
  id: string,
  slackUserRequest: SlackUserRequest,
  signal?: AbortSignal
) => {
  return customInstance<SlackUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: slackUserRequest,
    signal,
  });
};

export const getWorkspacesSlackUsersUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>,
    TError,
    { workspaceId: string; id: string; data: SlackUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>,
  TError,
  { workspaceId: string; id: string; data: SlackUserRequest },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>,
    { workspaceId: string; id: string; data: SlackUserRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesSlackUsersUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>
>;
export type WorkspacesSlackUsersUpdateMutationBody = SlackUserRequest;
export type WorkspacesSlackUsersUpdateMutationError = unknown;

export const useWorkspacesSlackUsersUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>,
      TError,
      { workspaceId: string; id: string; data: SlackUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersUpdate>>,
  TError,
  { workspaceId: string; id: string; data: SlackUserRequest },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve, update or delete a Slack user
 */
export const workspacesSlackUsersPartialUpdate = (
  workspaceId: string,
  id: string,
  patchedSlackUserRequest?: PatchedSlackUserRequest,
  signal?: AbortSignal
) => {
  return customInstance<SlackUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedSlackUserRequest,
    signal,
  });
};

export const getWorkspacesSlackUsersPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>,
    TError,
    { workspaceId: string; id: string; data?: PatchedSlackUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedSlackUserRequest },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>,
    { workspaceId: string; id: string; data?: PatchedSlackUserRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesSlackUsersPartialUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>
>;
export type WorkspacesSlackUsersPartialUpdateMutationBody = PatchedSlackUserRequest | undefined;
export type WorkspacesSlackUsersPartialUpdateMutationError = unknown;

export const useWorkspacesSlackUsersPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>,
      TError,
      { workspaceId: string; id: string; data?: PatchedSlackUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedSlackUserRequest },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Retrieve, update or delete a Slack user
 */
export const workspacesSlackUsersDestroy = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesSlackUsersDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>,
    TError,
    { workspaceId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>,
    { workspaceId: string; id: string }
  > = (props) => {
    const { workspaceId, id } = props ?? {};

    return workspacesSlackUsersDestroy(workspaceId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>
>;

export type WorkspacesSlackUsersDestroyMutationError = unknown;

export const useWorkspacesSlackUsersDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>,
      TError,
      { workspaceId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersDestroyMutationOptions(options), queryClient);
};

/**
 * Sync Slack user information from Slack API
 */
export const workspacesSlackUsersSyncCreate = (workspaceId: string, userId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/${userId}/sync/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesSlackUsersSyncCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>,
    TError,
    { workspaceId: string; userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>,
  TError,
  { workspaceId: string; userId: string },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersSyncCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>,
    { workspaceId: string; userId: string }
  > = (props) => {
    const { workspaceId, userId } = props ?? {};

    return workspacesSlackUsersSyncCreate(workspaceId, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersSyncCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>
>;

export type WorkspacesSlackUsersSyncCreateMutationError = unknown;

export const useWorkspacesSlackUsersSyncCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>,
      TError,
      { workspaceId: string; userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersSyncCreate>>,
  TError,
  { workspaceId: string; userId: string },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersSyncCreateMutationOptions(options), queryClient);
};

/**
 * Bulk invite multiple Slack users by email
 */
export const workspacesSlackUsersBulkInviteCreate = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/bulk-invite/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesSlackUsersBulkInviteCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersBulkInviteCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesSlackUsersBulkInviteCreate(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersBulkInviteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>
>;

export type WorkspacesSlackUsersBulkInviteCreateMutationError = unknown;

export const useWorkspacesSlackUsersBulkInviteCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersBulkInviteCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersBulkInviteCreateMutationOptions(options), queryClient);
};

/**
 * Invite a Slack user by email
 */
export const workspacesSlackUsersInviteCreate = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/slack/users/invite/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesSlackUsersInviteCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesSlackUsersInviteCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesSlackUsersInviteCreate(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackUsersInviteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>
>;

export type WorkspacesSlackUsersInviteCreateMutationError = unknown;

export const useWorkspacesSlackUsersInviteCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackUsersInviteCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesSlackUsersInviteCreateMutationOptions(options), queryClient);
};

export const workspacesTeamsDisconnectDestroy = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<TeamsIntegrationStatus>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/disconnect/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesTeamsDisconnectDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesTeamsDisconnectDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesTeamsDisconnectDestroy(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsDisconnectDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>
>;

export type WorkspacesTeamsDisconnectDestroyMutationError = unknown;

export const useWorkspacesTeamsDisconnectDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsDisconnectDestroy>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesTeamsDisconnectDestroyMutationOptions(options), queryClient);
};

export const workspacesTeamsGraphConsentInitiateCreate = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<TeamsGraphConsentInitiate>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/graph/consent/initiate/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesTeamsGraphConsentInitiateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesTeamsGraphConsentInitiateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesTeamsGraphConsentInitiateCreate(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsGraphConsentInitiateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>
>;

export type WorkspacesTeamsGraphConsentInitiateCreateMutationError = unknown;

export const useWorkspacesTeamsGraphConsentInitiateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsGraphConsentInitiateCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesTeamsGraphConsentInitiateCreateMutationOptions(options), queryClient);
};

export const workspacesTeamsGraphVerifyCreate = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<TeamsIntegrationStatus>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/graph/verify/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesTeamsGraphVerifyCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesTeamsGraphVerifyCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesTeamsGraphVerifyCreate(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsGraphVerifyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>
>;

export type WorkspacesTeamsGraphVerifyCreateMutationError = unknown;

export const useWorkspacesTeamsGraphVerifyCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsGraphVerifyCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesTeamsGraphVerifyCreateMutationOptions(options), queryClient);
};

/**
 * Generate and download the workspace Teams app ZIP (unique manifest.id).
 */
export const workspacesTeamsPackageCreate = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/package/`,
    method: 'POST',
    responseType: 'blob',
    signal,
  });
};

export const getWorkspacesTeamsPackageCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>,
    TError,
    { workspaceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  const mutationKey = ['workspacesTeamsPackageCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>,
    { workspaceId: string }
  > = (props) => {
    const { workspaceId } = props ?? {};

    return workspacesTeamsPackageCreate(workspaceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsPackageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>
>;

export type WorkspacesTeamsPackageCreateMutationError = unknown;

export const useWorkspacesTeamsPackageCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>,
      TError,
      { workspaceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsPackageCreate>>,
  TError,
  { workspaceId: string },
  TContext
> => {
  return useMutation(getWorkspacesTeamsPackageCreateMutationOptions(options), queryClient);
};

export const workspacesTeamsStatusRetrieve = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<TeamsIntegrationStatus>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/status/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesTeamsStatusRetrieveQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/status/`] as const;
};

export const getWorkspacesTeamsStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesTeamsStatusRetrieveQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>> = ({ signal }) =>
    workspacesTeamsStatusRetrieve(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesTeamsStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>
>;
export type WorkspacesTeamsStatusRetrieveQueryError = unknown;

export function useWorkspacesTeamsStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useWorkspacesTeamsStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesTeamsStatusRetrieveQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * List integration users who have interacted with the Teams bot in this workspace. Does not create Users or WorkspaceMembers.
 * @summary List Teams bot users
 */
export const workspacesTeamsUsersList = (workspaceId: string, signal?: AbortSignal) => {
  return customInstance<TeamsUser[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesTeamsUsersListQueryKey = (workspaceId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/`] as const;
};

export const getWorkspacesTeamsUsersListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesTeamsUsersListQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesTeamsUsersList>>> = ({ signal }) =>
    workspacesTeamsUsersList(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesTeamsUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesTeamsUsersList>>>;
export type WorkspacesTeamsUsersListQueryError = unknown;

export function useWorkspacesTeamsUsersList<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsUsersList<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsUsersList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsUsersList<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Teams bot users
 */

export function useWorkspacesTeamsUsersList<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersList>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesTeamsUsersListQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Retrieve a Teams bot user
 */
export const workspacesTeamsUsersRetrieve = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<TeamsUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesTeamsUsersRetrieveQueryKey = (workspaceId: string, id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/${id}/`] as const;
};

export const getWorkspacesTeamsUsersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesTeamsUsersRetrieveQueryKey(workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>> = ({ signal }) =>
    workspacesTeamsUsersRetrieve(workspaceId, id, signal);

  return {
    queryKey,
    queryFn,
    enabled: workspaceId !== null && workspaceId !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WorkspacesTeamsUsersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>
>;
export type WorkspacesTeamsUsersRetrieveQueryError = unknown;

export function useWorkspacesTeamsUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesTeamsUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve a Teams bot user
 */

export function useWorkspacesTeamsUsersRetrieve<
  TData = Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>,
  TError = unknown,
>(
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesTeamsUsersRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesTeamsUsersRetrieveQueryOptions(workspaceId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update a Teams bot user
 */
export const workspacesTeamsUsersUpdate = (
  workspaceId: string,
  id: string,
  teamsUserRequest?: TeamsUserRequest,
  signal?: AbortSignal
) => {
  return customInstance<TeamsUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: teamsUserRequest,
    signal,
  });
};

export const getWorkspacesTeamsUsersUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>,
    TError,
    { workspaceId: string; id: string; data?: TeamsUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: TeamsUserRequest },
  TContext
> => {
  const mutationKey = ['workspacesTeamsUsersUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>,
    { workspaceId: string; id: string; data?: TeamsUserRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesTeamsUsersUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsUsersUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>
>;
export type WorkspacesTeamsUsersUpdateMutationBody = TeamsUserRequest | undefined;
export type WorkspacesTeamsUsersUpdateMutationError = unknown;

/**
 * @summary Update a Teams bot user
 */
export const useWorkspacesTeamsUsersUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>,
      TError,
      { workspaceId: string; id: string; data?: TeamsUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsUsersUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: TeamsUserRequest },
  TContext
> => {
  return useMutation(getWorkspacesTeamsUsersUpdateMutationOptions(options), queryClient);
};

/**
 * Typically used to activate or deactivate bot access.
 * @summary Partially update a Teams bot user
 */
export const workspacesTeamsUsersPartialUpdate = (
  workspaceId: string,
  id: string,
  patchedTeamsUserRequest?: PatchedTeamsUserRequest,
  signal?: AbortSignal
) => {
  return customInstance<TeamsUser>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedTeamsUserRequest,
    signal,
  });
};

export const getWorkspacesTeamsUsersPartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>,
    TError,
    { workspaceId: string; id: string; data?: PatchedTeamsUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedTeamsUserRequest },
  TContext
> => {
  const mutationKey = ['workspacesTeamsUsersPartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>,
    { workspaceId: string; id: string; data?: PatchedTeamsUserRequest }
  > = (props) => {
    const { workspaceId, id, data } = props ?? {};

    return workspacesTeamsUsersPartialUpdate(workspaceId, id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsUsersPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>
>;
export type WorkspacesTeamsUsersPartialUpdateMutationBody = PatchedTeamsUserRequest | undefined;
export type WorkspacesTeamsUsersPartialUpdateMutationError = unknown;

/**
 * @summary Partially update a Teams bot user
 */
export const useWorkspacesTeamsUsersPartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>,
      TError,
      { workspaceId: string; id: string; data?: PatchedTeamsUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsUsersPartialUpdate>>,
  TError,
  { workspaceId: string; id: string; data?: PatchedTeamsUserRequest },
  TContext
> => {
  return useMutation(getWorkspacesTeamsUsersPartialUpdateMutationOptions(options), queryClient);
};

/**
 * Deletes the TeamsUser row. Does not delete Vigilant accounts.
 * @summary Remove a Teams bot user
 */
export const workspacesTeamsUsersDestroy = (workspaceId: string, id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/${workspaceId}/teams/users/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesTeamsUsersDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>,
    TError,
    { workspaceId: string; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  const mutationKey = ['workspacesTeamsUsersDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>,
    { workspaceId: string; id: string }
  > = (props) => {
    const { workspaceId, id } = props ?? {};

    return workspacesTeamsUsersDestroy(workspaceId, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesTeamsUsersDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>
>;

export type WorkspacesTeamsUsersDestroyMutationError = unknown;

/**
 * @summary Remove a Teams bot user
 */
export const useWorkspacesTeamsUsersDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>,
      TError,
      { workspaceId: string; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesTeamsUsersDestroy>>,
  TError,
  { workspaceId: string; id: string },
  TContext
> => {
  return useMutation(getWorkspacesTeamsUsersDestroyMutationOptions(options), queryClient);
};

/**
 * Return every workspace in the system. Used by admin tools like developer logs.
 * @summary All Workspaces
 */
export const workspacesAllList = (signal?: AbortSignal) => {
  return customInstance<Workspace[]>({ url: `${import.meta.env.VITE_API_URL}/workspaces/all/`, method: 'GET', signal });
};

export const getWorkspacesAllListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/all/`] as const;
};

export const getWorkspacesAllListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesAllList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesAllList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesAllListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesAllList>>> = ({ signal }) =>
    workspacesAllList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesAllList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesAllListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesAllList>>>;
export type WorkspacesAllListQueryError = unknown;

export function useWorkspacesAllList<TData = Awaited<ReturnType<typeof workspacesAllList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesAllList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesAllList>>,
          TError,
          Awaited<ReturnType<typeof workspacesAllList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesAllList<TData = Awaited<ReturnType<typeof workspacesAllList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesAllList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesAllList>>,
          TError,
          Awaited<ReturnType<typeof workspacesAllList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesAllList<TData = Awaited<ReturnType<typeof workspacesAllList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesAllList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All Workspaces
 */

export function useWorkspacesAllList<TData = Awaited<ReturnType<typeof workspacesAllList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesAllList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesAllListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieve a specific workspace by its slug instead of ID
 * @summary Get Workspace by Slug
 */
export const workspacesBySlugRetrieve = (slug: string, signal?: AbortSignal) => {
  return customInstance<WorkspaceDetail>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/by-slug/${slug}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesBySlugRetrieveQueryKey = (slug: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/by-slug/${slug}/`] as const;
};

export const getWorkspacesBySlugRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
  TError = void,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesBySlugRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>> = ({ signal }) =>
    workspacesBySlugRetrieve(slug, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesBySlugRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>>;
export type WorkspacesBySlugRetrieveQueryError = void;

export function useWorkspacesBySlugRetrieve<
  TData = Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
  TError = void,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesBySlugRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesBySlugRetrieve<
  TData = Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesBySlugRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesBySlugRetrieve<
  TData = Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
  TError = void,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace by Slug
 */

export function useWorkspacesBySlugRetrieve<
  TData = Awaited<ReturnType<typeof workspacesBySlugRetrieve>>,
  TError = void,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesBySlugRetrieve>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesBySlugRetrieveQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get workspace creation status and ID by task ID
 */
export const workspacesCreationStatusRetrieve = (taskId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/creation-status/${taskId}/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesCreationStatusRetrieveQueryKey = (taskId: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/creation-status/${taskId}/`] as const;
};

export const getWorkspacesCreationStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
  TError = unknown,
>(
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesCreationStatusRetrieveQueryKey(taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>> = ({ signal }) =>
    workspacesCreationStatusRetrieve(taskId, signal);

  return { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesCreationStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>
>;
export type WorkspacesCreationStatusRetrieveQueryError = unknown;

export function useWorkspacesCreationStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
  TError = unknown,
>(
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesCreationStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
  TError = unknown,
>(
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesCreationStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
  TError = unknown,
>(
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useWorkspacesCreationStatusRetrieve<
  TData = Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>,
  TError = unknown,
>(
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreationStatusRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesCreationStatusRetrieveQueryOptions(taskId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Resend a pending invitation to a user (admin only)
 * @summary Resend Workspace Invitation
 */
export const workspacesInvitationsResendCreate = (invitationId: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/invitations/${invitationId}/resend/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesInvitationsResendCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>,
    TError,
    { invitationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>,
  TError,
  { invitationId: string },
  TContext
> => {
  const mutationKey = ['workspacesInvitationsResendCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>,
    { invitationId: string }
  > = (props) => {
    const { invitationId } = props ?? {};

    return workspacesInvitationsResendCreate(invitationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesInvitationsResendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>
>;

export type WorkspacesInvitationsResendCreateMutationError = void;

/**
 * @summary Resend Workspace Invitation
 */
export const useWorkspacesInvitationsResendCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>,
      TError,
      { invitationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesInvitationsResendCreate>>,
  TError,
  { invitationId: string },
  TContext
> => {
  return useMutation(getWorkspacesInvitationsResendCreateMutationOptions(options), queryClient);
};

/**
 * Accept a workspace invitation using a valid token
 * @summary Accept Workspace Invitation
 */
export const workspacesInvitationsAcceptCreate = (token: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/invitations/${token}/accept/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesInvitationsAcceptCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>,
    TError,
    { token: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['workspacesInvitationsAcceptCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return workspacesInvitationsAcceptCreate(token);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesInvitationsAcceptCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>
>;

export type WorkspacesInvitationsAcceptCreateMutationError = void;

/**
 * @summary Accept Workspace Invitation
 */
export const useWorkspacesInvitationsAcceptCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>,
      TError,
      { token: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesInvitationsAcceptCreate>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getWorkspacesInvitationsAcceptCreateMutationOptions(options), queryClient);
};

/**
 * Decline a workspace invitation using a valid token
 * @summary Decline Workspace Invitation
 */
export const workspacesInvitationsDeclineCreate = (token: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/invitations/${token}/decline/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesInvitationsDeclineCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>,
    TError,
    { token: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['workspacesInvitationsDeclineCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return workspacesInvitationsDeclineCreate(token);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesInvitationsDeclineCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>
>;

export type WorkspacesInvitationsDeclineCreateMutationError = void;

/**
 * @summary Decline Workspace Invitation
 */
export const useWorkspacesInvitationsDeclineCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>,
      TError,
      { token: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesInvitationsDeclineCreate>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getWorkspacesInvitationsDeclineCreateMutationOptions(options), queryClient);
};

/**
 * Get all pending workspace invitations for the current user's email
 * @summary My Pending Invitations
 */
export const workspacesMyInvitationsList = (signal?: AbortSignal) => {
  return customInstance<WorkspaceInvitation[]>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/my-invitations/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesMyInvitationsListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/my-invitations/`] as const;
};

export const getWorkspacesMyInvitationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyInvitationsList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesMyInvitationsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesMyInvitationsList>>> = ({ signal }) =>
    workspacesMyInvitationsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesMyInvitationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesMyInvitationsList>>
>;
export type WorkspacesMyInvitationsListQueryError = unknown;

export function useWorkspacesMyInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyInvitationsList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof workspacesMyInvitationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMyInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyInvitationsList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof workspacesMyInvitationsList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMyInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyInvitationsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary My Pending Invitations
 */

export function useWorkspacesMyInvitationsList<
  TData = Awaited<ReturnType<typeof workspacesMyInvitationsList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyInvitationsList>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesMyInvitationsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get all workspaces the current user is a member of
 * @summary My Workspaces
 */
export const workspacesMyWorkspacesRetrieve = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/my-workspaces/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesMyWorkspacesRetrieveQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/my-workspaces/`] as const;
};

export const getWorkspacesMyWorkspacesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesMyWorkspacesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>> = ({ signal }) =>
    workspacesMyWorkspacesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesMyWorkspacesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>
>;
export type WorkspacesMyWorkspacesRetrieveQueryError = unknown;

export function useWorkspacesMyWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMyWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesMyWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary My Workspaces
 */

export function useWorkspacesMyWorkspacesRetrieve<
  TData = Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesMyWorkspacesRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesMyWorkspacesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all available workspace roles (e.g., admin, member).
 * @summary List Workspace Roles
 */
export const workspacesRolesList = (signal?: AbortSignal) => {
  return customInstance<Role[]>({ url: `${import.meta.env.VITE_API_URL}/workspaces/roles/`, method: 'GET', signal });
};

export const getWorkspacesRolesListQueryKey = () => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/roles/`] as const;
};

export const getWorkspacesRolesListQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesRolesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesRolesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesRolesList>>> = ({ signal }) =>
    workspacesRolesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesRolesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesRolesListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesRolesList>>>;
export type WorkspacesRolesListQueryError = unknown;

export function useWorkspacesRolesList<TData = Awaited<ReturnType<typeof workspacesRolesList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRolesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesRolesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRolesList<TData = Awaited<ReturnType<typeof workspacesRolesList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRolesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesRolesList>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRolesList<TData = Awaited<ReturnType<typeof workspacesRolesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workspace Roles
 */

export function useWorkspacesRolesList<TData = Awaited<ReturnType<typeof workspacesRolesList>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesList>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesRolesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint to delete custom roles.
 */
export const workspacesRolesDeleteDestroy = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/delete/`,
    method: 'DELETE',
    signal,
  });
};

export const getWorkspacesRolesDeleteDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['workspacesRolesDeleteDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>, { id: string }> = (
    props
  ) => {
    const { id } = props ?? {};

    return workspacesRolesDeleteDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesRolesDeleteDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>
>;

export type WorkspacesRolesDeleteDestroyMutationError = unknown;

export const useWorkspacesRolesDeleteDestroy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof workspacesRolesDeleteDestroy>>, TError, { id: string }, TContext> => {
  return useMutation(getWorkspacesRolesDeleteDestroyMutationOptions(options), queryClient);
};

/**
 * Apply replacement/null strategies for references to a role and delete it safely.
 * @summary Resolve references and delete Role
 */
export const workspacesRolesResolveDeleteCreate = (
  id: string,
  roleResolveDeleteRequestRequest?: RoleResolveDeleteRequestRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/resolve-delete/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: roleResolveDeleteRequestRequest,
    signal,
  });
};

export const getWorkspacesRolesResolveDeleteCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>,
    TError,
    { id: string; data?: RoleResolveDeleteRequestRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>,
  TError,
  { id: string; data?: RoleResolveDeleteRequestRequest },
  TContext
> => {
  const mutationKey = ['workspacesRolesResolveDeleteCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>,
    { id: string; data?: RoleResolveDeleteRequestRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return workspacesRolesResolveDeleteCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesRolesResolveDeleteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>
>;
export type WorkspacesRolesResolveDeleteCreateMutationBody = RoleResolveDeleteRequestRequest | undefined;
export type WorkspacesRolesResolveDeleteCreateMutationError = void;

/**
 * @summary Resolve references and delete Role
 */
export const useWorkspacesRolesResolveDeleteCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>,
      TError,
      { id: string; data?: RoleResolveDeleteRequestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesRolesResolveDeleteCreate>>,
  TError,
  { id: string; data?: RoleResolveDeleteRequestRequest },
  TContext
> => {
  return useMutation(getWorkspacesRolesResolveDeleteCreateMutationOptions(options), queryClient);
};

/**
 * API endpoint to update custom roles.
 */
export const workspacesRolesUpdateUpdate = (id: string, roleRequest: RoleRequest, signal?: AbortSignal) => {
  return customInstance<Role>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/update/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: roleRequest,
    signal,
  });
};

export const getWorkspacesRolesUpdateUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>,
    TError,
    { id: string; data: RoleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>,
  TError,
  { id: string; data: RoleRequest },
  TContext
> => {
  const mutationKey = ['workspacesRolesUpdateUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>,
    { id: string; data: RoleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return workspacesRolesUpdateUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesRolesUpdateUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>
>;
export type WorkspacesRolesUpdateUpdateMutationBody = RoleRequest;
export type WorkspacesRolesUpdateUpdateMutationError = unknown;

export const useWorkspacesRolesUpdateUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>,
      TError,
      { id: string; data: RoleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesRolesUpdateUpdate>>,
  TError,
  { id: string; data: RoleRequest },
  TContext
> => {
  return useMutation(getWorkspacesRolesUpdateUpdateMutationOptions(options), queryClient);
};

/**
 * API endpoint to update custom roles.
 */
export const workspacesRolesUpdatePartialUpdate = (
  id: string,
  patchedRoleRequest?: PatchedRoleRequest,
  signal?: AbortSignal
) => {
  return customInstance<Role>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/update/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRoleRequest,
    signal,
  });
};

export const getWorkspacesRolesUpdatePartialUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>,
    TError,
    { id: string; data?: PatchedRoleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>,
  TError,
  { id: string; data?: PatchedRoleRequest },
  TContext
> => {
  const mutationKey = ['workspacesRolesUpdatePartialUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>,
    { id: string; data?: PatchedRoleRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return workspacesRolesUpdatePartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesRolesUpdatePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>
>;
export type WorkspacesRolesUpdatePartialUpdateMutationBody = PatchedRoleRequest | undefined;
export type WorkspacesRolesUpdatePartialUpdateMutationError = unknown;

export const useWorkspacesRolesUpdatePartialUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>,
      TError,
      { id: string; data?: PatchedRoleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesRolesUpdatePartialUpdate>>,
  TError,
  { id: string; data?: PatchedRoleRequest },
  TContext
> => {
  return useMutation(getWorkspacesRolesUpdatePartialUpdateMutationOptions(options), queryClient);
};

/**
 * Report where a role is referenced in the current workspace to assist safe deletion.
 * @summary Get Role Usage
 */
export const workspacesRolesUsageRetrieve = (id: string, signal?: AbortSignal) => {
  return customInstance<RoleUsageResponse>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/usage/`,
    method: 'GET',
    signal,
  });
};

export const getWorkspacesRolesUsageRetrieveQueryKey = (id: string) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/roles/${id}/usage/`] as const;
};

export const getWorkspacesRolesUsageRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesRolesUsageRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>> = ({ signal }) =>
    workspacesRolesUsageRetrieve(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesRolesUsageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>
>;
export type WorkspacesRolesUsageRetrieveQueryError = void;

export function useWorkspacesRolesUsageRetrieve<
  TData = Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRolesUsageRetrieve<
  TData = Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesRolesUsageRetrieve<
  TData = Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Role Usage
 */

export function useWorkspacesRolesUsageRetrieve<
  TData = Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRolesUsageRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesRolesUsageRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * API endpoint to create custom roles for a workspace.
 */
export const workspacesRolesCreateCreate = (roleRequest: RoleRequest, signal?: AbortSignal) => {
  return customInstance<Role>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/roles/create/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: roleRequest,
    signal,
  });
};

export const getWorkspacesRolesCreateCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesRolesCreateCreate>>,
    TError,
    { data: RoleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesRolesCreateCreate>>,
  TError,
  { data: RoleRequest },
  TContext
> => {
  const mutationKey = ['workspacesRolesCreateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesRolesCreateCreate>>, { data: RoleRequest }> = (
    props
  ) => {
    const { data } = props ?? {};

    return workspacesRolesCreateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesRolesCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesRolesCreateCreate>>
>;
export type WorkspacesRolesCreateCreateMutationBody = RoleRequest;
export type WorkspacesRolesCreateCreateMutationError = unknown;

export const useWorkspacesRolesCreateCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesRolesCreateCreate>>,
      TError,
      { data: RoleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesRolesCreateCreate>>,
  TError,
  { data: RoleRequest },
  TContext
> => {
  return useMutation(getWorkspacesRolesCreateCreateMutationOptions(options), queryClient);
};

/**
 * Check if a Slack user is authorized to use the bot
 * This endpoint is called by the Slack bot to verify user permissions
 */
export const workspacesSlackAuthCheckCreate = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/slack/auth-check/`,
    method: 'POST',
    signal,
  });
};

export const getWorkspacesSlackAuthCheckCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>, TError, void, TContext> => {
  const mutationKey = ['workspacesSlackAuthCheckCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>, void> = () => {
    return workspacesSlackAuthCheckCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackAuthCheckCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>
>;

export type WorkspacesSlackAuthCheckCreateMutationError = unknown;

export const useWorkspacesSlackAuthCheckCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>, TError, void, TContext>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof workspacesSlackAuthCheckCreate>>, TError, void, TContext> => {
  return useMutation(getWorkspacesSlackAuthCheckCreateMutationOptions(options), queryClient);
};

/**
 * Get Slack bot configuration for a specific team (used by Slack bot)
 * @summary Get Slack Configuration
 */
export const workspacesSlackConfigRetrieve = (params: WorkspacesSlackConfigRetrieveParams, signal?: AbortSignal) => {
  return customInstance<SlackConfig>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/slack/config/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getWorkspacesSlackConfigRetrieveQueryKey = (params?: WorkspacesSlackConfigRetrieveParams) => {
  return [`${import.meta.env.VITE_API_URL}/workspaces/slack/config/`, ...(params ? [params] : [])] as const;
};

export const getWorkspacesSlackConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
  TError = void,
>(
  params: WorkspacesSlackConfigRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkspacesSlackConfigRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>> = ({ signal }) =>
    workspacesSlackConfigRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspacesSlackConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>
>;
export type WorkspacesSlackConfigRetrieveQueryError = void;

export function useWorkspacesSlackConfigRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
  TError = void,
>(
  params: WorkspacesSlackConfigRetrieveParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackConfigRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
  TError = void,
>(
  params: WorkspacesSlackConfigRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkspacesSlackConfigRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
  TError = void,
>(
  params: WorkspacesSlackConfigRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Slack Configuration
 */

export function useWorkspacesSlackConfigRetrieve<
  TData = Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>,
  TError = void,
>(
  params: WorkspacesSlackConfigRetrieveParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesSlackConfigRetrieve>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkspacesSlackConfigRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Process the OAuth callback from Slack and store credentials
 * @summary Handle Slack OAuth Callback
 */
export const workspacesSlackOauthCallbackCreate = (
  slackOAuthCallbackRequest: SlackOAuthCallbackRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/slack/oauth/callback/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackOAuthCallbackRequest,
    signal,
  });
};

export const getWorkspacesSlackOauthCallbackCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>,
    TError,
    { data: SlackOAuthCallbackRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>,
  TError,
  { data: SlackOAuthCallbackRequest },
  TContext
> => {
  const mutationKey = ['workspacesSlackOauthCallbackCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>,
    { data: SlackOAuthCallbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return workspacesSlackOauthCallbackCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackOauthCallbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>
>;
export type WorkspacesSlackOauthCallbackCreateMutationBody = SlackOAuthCallbackRequest;
export type WorkspacesSlackOauthCallbackCreateMutationError = void;

/**
 * @summary Handle Slack OAuth Callback
 */
export const useWorkspacesSlackOauthCallbackCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>,
      TError,
      { data: SlackOAuthCallbackRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackOauthCallbackCreate>>,
  TError,
  { data: SlackOAuthCallbackRequest },
  TContext
> => {
  return useMutation(getWorkspacesSlackOauthCallbackCreateMutationOptions(options), queryClient);
};

/**
 * Start the OAuth flow to connect a Slack workspace
 * @summary Initiate Slack OAuth
 */
export const workspacesSlackOauthInitiateCreate = (
  slackOAuthInitiateRequest: SlackOAuthInitiateRequest,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `${import.meta.env.VITE_API_URL}/workspaces/slack/oauth/initiate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackOAuthInitiateRequest,
    signal,
  });
};

export const getWorkspacesSlackOauthInitiateCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>,
    TError,
    { data: SlackOAuthInitiateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>,
  TError,
  { data: SlackOAuthInitiateRequest },
  TContext
> => {
  const mutationKey = ['workspacesSlackOauthInitiateCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>,
    { data: SlackOAuthInitiateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return workspacesSlackOauthInitiateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspacesSlackOauthInitiateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>
>;
export type WorkspacesSlackOauthInitiateCreateMutationBody = SlackOAuthInitiateRequest;
export type WorkspacesSlackOauthInitiateCreateMutationError = void;

/**
 * @summary Initiate Slack OAuth
 */
export const useWorkspacesSlackOauthInitiateCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>,
      TError,
      { data: SlackOAuthInitiateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof workspacesSlackOauthInitiateCreate>>,
  TError,
  { data: SlackOAuthInitiateRequest },
  TContext
> => {
  return useMutation(getWorkspacesSlackOauthInitiateCreateMutationOptions(options), queryClient);
};
